{
  "level": "mt11",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt11",
    "objects": "AREAS.E3:mt11.e3",
    "mesh": "TREES.E3:mt11.e3"
  },
  "spawn_point": {
    "position": [
      -356.8601354803332,
      -2137.9368459054363,
      90.72640991210938
    ],
    "facing_rad": 0.0,
    "look_point": [
      -356.8601354803332,
      -2037.9368459054363,
      90.72640991210938
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4205.05908203125,
      -3518.638427734375,
      66.72640991210938
    ],
    "bbox_max": [
      196.0666046142578,
      -1905.1326904296875,
      1479.6412353515625
    ],
    "vertex_count": 2679,
    "vertices": [
      [
        -4205.05908203125,
        -2619.064208984375,
        1400.2432861328125
      ],
      [
        -3714.02392578125,
        -2323.554931640625,
        1179.126953125
      ],
      [
        -4000.395751953125,
        -3169.967041015625,
        1401.26220703125
      ],
      [
        -3953.776123046875,
        -3271.534912109375,
        1398.1876220703125
      ],
      [
        -4204.98828125,
        -2619.663330078125,
        1400.3001708984375
      ],
      [
        -4000.395751953125,
        -3169.967041015625,
        1401.26220703125
      ],
      [
        -3790.39453125,
        -2416.412353515625,
        1220.0
      ],
      [
        -3902.9365234375,
        -2462.454833984375,
        1267.6805419921875
      ],
      [
        -3902.9365234375,
        -2462.454833984375,
        1267.6805419921875
      ],
      [
        -4205.05908203125,
        -2619.064208984375,
        1400.243408203125
      ],
      [
        -3685.231201171875,
        -2364.646728515625,
        1174.237060546875
      ],
      [
        -3714.02392578125,
        -2323.554931640625,
        1179.126953125
      ],
      [
        -3685.231201171875,
        -2364.646728515625,
        1174.237060546875
      ],
      [
        -3699.87890625,
        -2376.406982421875,
        1181.2401123046875
      ],
      [
        -3699.87890625,
        -2376.406982421875,
        1181.2401123046875
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.5367431640625
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.5367431640625
      ],
      [
        -3288.09619140625,
        -2864.23095703125,
        735.013427734375
      ],
      [
        -3452.950927734375,
        -2668.90283203125,
        984.034423828125
      ],
      [
        -3662.39306640625,
        -2424.958984375,
        1174.1900634765625
      ],
      [
        -3662.39306640625,
        -2424.958984375,
        1174.1900634765625
      ],
      [
        -3452.950927734375,
        -2668.90283203125,
        984.034423828125
      ],
      [
        -3547.5966796875,
        -2561.07373046875,
        1150.8623046875
      ],
      [
        -3070.88916015625,
        -3126.308349609375,
        1053.9906005859375
      ],
      [
        -659.8515014648438,
        -2403.476806640625,
        68.94024658203125
      ],
      [
        -694.7417602539062,
        -2341.75634765625,
        73.2170639038086
      ],
      [
        -704.1276245117188,
        -2329.093994140625,
        74.912353515625
      ],
      [
        -736.9667358398438,
        -2295.76318359375,
        82.36070251464844
      ],
      [
        -736.9667358398438,
        -2295.76318359375,
        82.3607177734375
      ],
      [
        -739.388427734375,
        -2289.004638671875,
        82.31546020507812
      ],
      [
        -699.4265747070312,
        -2333.46923828125,
        73.79135131835938
      ],
      [
        -704.1276245117188,
        -2329.093994140625,
        74.91236877441406
      ],
      [
        -699.1730346679688,
        -2333.705078125,
        73.73089599609375
      ],
      [
        -694.7417602539062,
        -2341.75634765625,
        73.21707153320312
      ],
      [
        -699.1730346679688,
        -2333.705078125,
        73.73089599609375
      ],
      [
        -659.8515014648438,
        -2403.476806640625,
        68.94023895263672
      ],
      [
        -645.88818359375,
        -2424.544921875,
        66.72640991210938
      ],
      [
        -3970.672607421875,
        -3262.108154296875,
        1433.9573974609375
      ],
      [
        -3699.20947265625,
        -2378.998046875,
        1181.5616455078125
      ],
      [
        -3970.672607421875,
        -3262.108154296875,
        1433.9573974609375
      ],
      [
        -3963.71728515625,
        -3278.162353515625,
        1434.638916015625
      ],
      [
        -3697.77392578125,
        -2384.5537109375,
        1182.2510986328125
      ],
      [
        -3697.77392578125,
        -2384.5537109375,
        1182.2510986328125
      ],
      [
        -3702.43359375,
        -2378.32275390625,
        1210.5433349609375
      ],
      [
        -3702.43359375,
        -2378.32275390625,
        1210.5433349609375
      ],
      [
        -3703.786865234375,
        -2376.991455078125,
        1220.0
      ],
      [
        -3698.14501953125,
        -2382.568603515625,
        1181.455322265625
      ],
      [
        -3698.34423828125,
        -2382.34619140625,
        1181.9771728515625
      ],
      [
        -542.7431030273438,
        -2638.905517578125,
        475.2273254394531
      ],
      [
        -529.8307495117188,
        -2692.434326171875,
        874.0250244140625
      ],
      [
        -542.2257690429688,
        -2659.7041015625,
        872.3767700195312
      ],
      [
        -488.8430480957031,
        -2803.202880859375,
        879.7427368164062
      ],
      [
        -529.8307495117188,
        -2692.434326171875,
        874.0250244140625
      ],
      [
        -689.266845703125,
        -2391.343994140625,
        865.4605712890625
      ],
      [
        -703.939208984375,
        -2371.302734375,
        865.4804077148438
      ],
      [
        -994.6154174804688,
        -2086.769287109375,
        406.1564636230469
      ],
      [
        -761.552978515625,
        -2318.2919921875,
        639.4187622070312
      ],
      [
        -756.295654296875,
        -2323.13134765625,
        639.4253540039062
      ],
      [
        -719.7451171875,
        -2356.77197265625,
        639.421142578125
      ],
      [
        -756.295654296875,
        -2323.13134765625,
        639.4253540039062
      ],
      [
        -719.7451171875,
        -2356.77197265625,
        639.421142578125
      ],
      [
        -719.7263793945312,
        -2356.79296875,
        639.4711303710938
      ],
      [
        -765.402587890625,
        -2315.43408203125,
        648.81787109375
      ],
      [
        -766.3020629882812,
        -2314.824462890625,
        651.81005859375
      ],
      [
        -766.3020629882812,
        -2314.824462890625,
        651.81005859375
      ],
      [
        -768.4712524414062,
        -2314.45263671875,
        674.0901489257812
      ],
      [
        -758.3292846679688,
        -2324.705810546875,
        686.684326171875
      ],
      [
        -759.2192993164062,
        -2323.744140625,
        684.730224609375
      ],
      [
        -768.4713134765625,
        -2314.45263671875,
        674.0901489257812
      ],
      [
        -759.2192993164062,
        -2323.744140625,
        684.730224609375
      ],
      [
        -761.552978515625,
        -2318.2919921875,
        639.4187622070312
      ],
      [
        -765.4025268554688,
        -2315.43408203125,
        648.81787109375
      ],
      [
        -716.3812866210938,
        -2360.521240234375,
        648.3790283203125
      ],
      [
        -718.8178100585938,
        -2360.14501953125,
        673.9669189453125
      ],
      [
        -860.583251953125,
        -2509.036865234375,
        641.796875
      ],
      [
        -881.0743408203125,
        -2529.48095703125,
        646.73974609375
      ],
      [
        -881.0743408203125,
        -2529.48095703125,
        646.73974609375
      ],
      [
        -915.7357788085938,
        -2564.302001953125,
        652.96875
      ],
      [
        -716.3812866210938,
        -2360.521240234375,
        648.3790283203125
      ],
      [
        -713.2835083007812,
        -2363.59228515625,
        866.0255737304688
      ],
      [
        -703.939208984375,
        -2371.302734375,
        865.4804077148438
      ],
      [
        -714.7833862304688,
        -2350.402099609375,
        639.3530883789062
      ],
      [
        -714.5018920898438,
        -2350.78662109375,
        639.3538208007812
      ],
      [
        -754.6287231445312,
        -2317.40283203125,
        639.3803100585938
      ],
      [
        -758.4019775390625,
        -2314.277587890625,
        639.3778686523438
      ],
      [
        -754.6287231445312,
        -2317.40283203125,
        639.3803100585938
      ],
      [
        -758.4019775390625,
        -2314.277587890625,
        639.3778686523438
      ],
      [
        -761.555908203125,
        -2318.289794921875,
        639.4259643554688
      ],
      [
        -758.4041137695312,
        -2314.276123046875,
        639.3829345703125
      ],
      [
        -711.3695678710938,
        -2355.322998046875,
        648.9346923828125
      ],
      [
        -763.1380004882812,
        -2310.982421875,
        651.2776489257812
      ],
      [
        -765.279052734375,
        -2310.43701171875,
        674.5700073242188
      ],
      [
        -765.279052734375,
        -2310.43701171875,
        674.5700073242188
      ],
      [
        -754.98779296875,
        -2319.55615234375,
        685.8677978515625
      ],
      [
        -754.6053466796875,
        -2319.914306640625,
        686.6563720703125
      ],
      [
        -754.98779296875,
        -2319.55615234375,
        685.8677978515625
      ],
      [
        -714.5018920898438,
        -2350.78662109375,
        639.3538208007812
      ],
      [
        -711.3695678710938,
        -2355.322998046875,
        648.9346923828125
      ],
      [
        -762.50537109375,
        -2311.39697265625,
        649.1970825195312
      ],
      [
        -762.5053100585938,
        -2311.396728515625,
        649.1970825195312
      ],
      [
        -763.1380004882812,
        -2310.982421875,
        651.2776489257812
      ],
      [
        -743.80419921875,
        -2328.31640625,
        866.7424926757812
      ],
      [
        -756.9921875,
        -2314.733154296875,
        867.2271728515625
      ],
      [
        -713.2835083007812,
        -2363.59228515625,
        866.0255126953125
      ],
      [
        -720.4447631835938,
        -2352.376220703125,
        865.884033203125
      ],
      [
        -926.8214111328125,
        -2137.733642578125,
        583.9189453125
      ],
      [
        -924.068359375,
        -2143.761474609375,
        682.6480712890625
      ],
      [
        -926.8214111328125,
        -2137.733642578125,
        583.9189453125
      ],
      [
        -924.7866821289062,
        -2135.580078125,
        467.370361328125
      ],
      [
        -734.5917358398438,
        -2333.9970703125,
        639.3666381835938
      ],
      [
        -753.7207641601562,
        -2314.28271484375,
        639.3557739257812
      ],
      [
        -756.310791015625,
        -2311.613525390625,
        639.3507080078125
      ],
      [
        -753.7207641601562,
        -2314.28271484375,
        639.3557739257812
      ],
      [
        -756.310791015625,
        -2311.613525390625,
        639.3507080078125
      ],
      [
        -758.4041137695312,
        -2314.276123046875,
        639.3829345703125
      ],
      [
        -760.3703002929688,
        -2307.621826171875,
        650.8119506835938
      ],
      [
        -762.0160522460938,
        -2306.33251953125,
        675.0604858398438
      ],
      [
        -762.0160522460938,
        -2306.33251953125,
        675.0604858398438
      ],
      [
        -760.0313720703125,
        -2307.949462890625,
        649.5208740234375
      ],
      [
        -760.0313110351562,
        -2307.949462890625,
        649.5208740234375
      ],
      [
        -760.3703002929688,
        -2307.621826171875,
        650.8119506835938
      ],
      [
        -924.068359375,
        -2143.761474609375,
        682.6480712890625
      ],
      [
        -925.69384765625,
        -2144.2890625,
        741.552734375
      ],
      [
        -728.7424926757812,
        -2339.38037109375,
        865.7201538085938
      ],
      [
        -743.80419921875,
        -2328.31640625,
        866.7424926757812
      ],
      [
        -728.7424926757812,
        -2339.38037109375,
        865.7201538085938
      ],
      [
        -756.9921875,
        -2314.733154296875,
        867.2271728515625
      ],
      [
        -760.50927734375,
        -2303.75732421875,
        866.58154296875
      ],
      [
        -758.6404418945312,
        -2301.78271484375,
        759.6312255859375
      ],
      [
        -755.9369506835938,
        -2302.220703125,
        650.1961669921875
      ],
      [
        -765.0918579101562,
        -2295.123779296875,
        742.3956298828125
      ],
      [
        -757.0103149414062,
        -2300.06005859375,
        666.3358764648438
      ],
      [
        -755.9306640625,
        -2302.23095703125,
        650.0648803710938
      ],
      [
        -755.9369506835938,
        -2302.220703125,
        650.1961669921875
      ],
      [
        -759.273681640625,
        -2308.695556640625,
        647.44970703125
      ],
      [
        -755.9295654296875,
        -2302.23388671875,
        650.0578002929688
      ],
      [
        -755.9295654296875,
        -2302.23388671875,
        650.0578002929688
      ],
      [
        -755.9306640625,
        -2302.23095703125,
        650.0648803710938
      ],
      [
        -761.9382934570312,
        -2306.4140625,
        675.1514892578125
      ],
      [
        -758.6404418945312,
        -2301.78271484375,
        759.6312255859375
      ],
      [
        -765.0918579101562,
        -2295.123779296875,
        742.3956298828125
      ],
      [
        -753.7212524414062,
        -2308.314453125,
        639.3170776367188
      ],
      [
        -750.8490600585938,
        -2317.2421875,
        639.357421875
      ],
      [
        -752.8091430664062,
        -2311.149658203125,
        639.3311767578125
      ],
      [
        -753.7212524414062,
        -2308.314453125,
        639.3170776367188
      ],
      [
        -752.8091430664062,
        -2311.149658203125,
        639.3311767578125
      ],
      [
        -742.0281372070312,
        -2313.18505859375,
        639.28125
      ],
      [
        -756.3975830078125,
        -2299.9072265625,
        645.4570922851562
      ],
      [
        -756.9557495117188,
        -2300.09326171875,
        665.8224487304688
      ],
      [
        -756.9557495117188,
        -2300.09326171875,
        665.8224487304688
      ],
      [
        -755.6077270507812,
        -2303.119873046875,
        648.4926147460938
      ],
      [
        -756.3975830078125,
        -2299.9072265625,
        645.4570922851562
      ],
      [
        -487.7523498535156,
        -2803.54736328125,
        879.6206665039062
      ],
      [
        -488.8430480957031,
        -2803.202880859375,
        879.7427978515625
      ],
      [
        -458.31414794921875,
        -2812.84814453125,
        876.3236083984375
      ],
      [
        -450.5662841796875,
        -2811.09033203125,
        558.68603515625
      ],
      [
        -984.291259765625,
        -2165.07177734375,
        884.4805297851562
      ],
      [
        -954.936279296875,
        -2157.806640625,
        879.4498291015625
      ],
      [
        -928.2157592773438,
        -2145.107666015625,
        832.9412231445312
      ],
      [
        -924.2988891601562,
        -2150.224365234375,
        874.1994018554688
      ],
      [
        -928.2157592773438,
        -2145.107666015625,
        832.941162109375
      ],
      [
        -550.1892700195312,
        -2618.961181640625,
        468.4744567871094
      ],
      [
        -548.7310791015625,
        -2642.526123046875,
        871.51171875
      ],
      [
        -451.7450866699219,
        -2814.923583984375,
        875.587890625
      ],
      [
        -443.48846435546875,
        -2813.421875,
        565.0746459960938
      ],
      [
        -579.789306640625,
        -2560.513427734375,
        867.3816528320312
      ],
      [
        -401.5820617675781,
        -2830.772216796875,
        869.9696655273438
      ],
      [
        -394.7469177246094,
        -2829.477783203125,
        609.0699462890625
      ],
      [
        -585.7559204101562,
        -2544.7578125,
        866.5881958007812
      ],
      [
        -585.7559204101562,
        -2544.7578125,
        866.5881958007812
      ],
      [
        -642.5033569335938,
        -2459.815673828125,
        865.8818359375
      ],
      [
        -678.7124633789062,
        -2405.76025390625,
        865.4462890625
      ],
      [
        -642.5032958984375,
        -2459.815673828125,
        865.8818359375
      ],
      [
        -678.7124633789062,
        -2405.76025390625,
        865.4462890625
      ],
      [
        -704.3489990234375,
        -2348.25,
        630.2252807617188
      ],
      [
        -704.5856323242188,
        -2348.42529296875,
        641.6248779296875
      ],
      [
        -708.7366943359375,
        -2344.52734375,
        641.6248779296875
      ],
      [
        -704.5856323242188,
        -2348.42529296875,
        641.6248779296875
      ],
      [
        -24.536930084228516,
        -3165.64599609375,
        850.4774169921875
      ],
      [
        161.8573760986328,
        -3463.04833984375,
        854.7364501953125
      ],
      [
        -55.04106140136719,
        -3144.068603515625,
        852.6356201171875
      ],
      [
        -233.4002685546875,
        -3018.20361328125,
        865.2860107421875
      ],
      [
        196.0666046142578,
        -3518.638427734375,
        855.624267578125
      ],
      [
        161.8573760986328,
        -3463.04833984375,
        854.7364501953125
      ],
      [
        -24.536930084228516,
        -3165.64599609375,
        850.4774780273438
      ],
      [
        -55.04105758666992,
        -3144.068603515625,
        852.6356201171875
      ],
      [
        -392.1393737792969,
        -2833.755615234375,
        868.912109375
      ],
      [
        -352.2469787597656,
        -2848.093017578125,
        864.626953125
      ],
      [
        -392.1393737792969,
        -2833.755615234375,
        868.912109375
      ],
      [
        -326.8922119140625,
        -2904.17919921875,
        866.8536376953125
      ],
      [
        -352.2469787597656,
        -2848.093017578125,
        864.626953125
      ],
      [
        -318.19537353515625,
        -2926.5478515625,
        867.947265625
      ],
      [
        -326.8922119140625,
        -2904.17919921875,
        866.8536376953125
      ],
      [
        -315.3895263671875,
        -2929.62353515625,
        867.8637084960938
      ],
      [
        -318.19537353515625,
        -2926.5478515625,
        867.947265625
      ],
      [
        -257.3710632324219,
        -2993.223876953125,
        866.1363525390625
      ],
      [
        -233.4002685546875,
        -3018.20361328125,
        865.2859497070312
      ],
      [
        -257.3710632324219,
        -2993.223876953125,
        866.1363525390625
      ],
      [
        -909.4484252929688,
        -2152.20458984375,
        872.2504272460938
      ],
      [
        -919.112548828125,
        -2148.940673828125,
        873.3106079101562
      ],
      [
        -903.4149169921875,
        -2151.04931640625,
        697.4168701171875
      ],
      [
        -757.1561889648438,
        -2299.6904296875,
        668.8338012695312
      ],
      [
        -765.2636108398438,
        -2294.6083984375,
        745.6580810546875
      ],
      [
        -919.1124877929688,
        -2148.940673828125,
        873.3106079101562
      ],
      [
        -756.52685546875,
        -2299.30322265625,
        644.2452392578125
      ],
      [
        -757.1561889648438,
        -2299.6904296875,
        668.8338012695312
      ],
      [
        -754.571533203125,
        -2301.549560546875,
        643.3828735351562
      ],
      [
        -756.52685546875,
        -2299.30322265625,
        644.2452392578125
      ],
      [
        -754.3570556640625,
        -2301.44482421875,
        642.3101806640625
      ],
      [
        -765.2636108398438,
        -2294.6083984375,
        745.6580810546875
      ],
      [
        -760.5296630859375,
        -2299.832763671875,
        754.5840454101562
      ],
      [
        -904.4052734375,
        -2147.172119140625,
        629.1983032226562
      ],
      [
        -899.52685546875,
        -2144.3037109375,
        441.74444580078125
      ],
      [
        -904.4052734375,
        -2147.172119140625,
        629.1983032226562
      ],
      [
        -903.4149169921875,
        -2151.04931640625,
        697.4168701171875
      ],
      [
        -770.2017211914062,
        -2273.4775390625,
        864.7988891601562
      ],
      [
        -773.5365600585938,
        -2261.221435546875,
        863.9918212890625
      ],
      [
        -770.2017211914062,
        -2273.4775390625,
        864.7988891601562
      ],
      [
        -771.5575561523438,
        -2275.722412109375,
        865.232421875
      ],
      [
        -881.6675415039062,
        -2161.587646484375,
        869.2028198242188
      ],
      [
        -768.5449829101562,
        -2279.56591796875,
        865.1997680664062
      ],
      [
        -771.5575561523438,
        -2275.722412109375,
        865.232421875
      ],
      [
        -759.466064453125,
        -2300.9306640625,
        757.425537109375
      ],
      [
        -768.0648193359375,
        -2280.178466796875,
        865.194580078125
      ],
      [
        -768.0648193359375,
        -2280.178466796875,
        865.194580078125
      ],
      [
        -753.871826171875,
        -2300.73193359375,
        638.5557861328125
      ],
      [
        -752.4913940429688,
        -2299.746337890625,
        630.2252807617188
      ],
      [
        -752.50732421875,
        -2299.7578125,
        630.8724975585938
      ],
      [
        -752.7722778320312,
        -2299.947021484375,
        641.6248779296875
      ],
      [
        -752.7722778320312,
        -2299.947021484375,
        641.6248779296875
      ],
      [
        -751.1085205078125,
        -2304.58740234375,
        641.6248779296875
      ],
      [
        -856.5706787109375,
        -2170.06396484375,
        866.44970703125
      ],
      [
        -774.0728149414062,
        -2259.71875,
        863.911376953125
      ],
      [
        -808.619384765625,
        -2222.050537109375,
        864.9612426757812
      ],
      [
        -856.1751708984375,
        -2170.197509765625,
        866.4063110351562
      ],
      [
        -855.3778076171875,
        -2170.466796875,
        866.31884765625
      ],
      [
        -808.619384765625,
        -2222.050537109375,
        864.9612426757812
      ],
      [
        -855.3778076171875,
        -2170.466796875,
        866.31884765625
      ],
      [
        -773.8917236328125,
        -2259.916259765625,
        863.9058837890625
      ],
      [
        -773.8917236328125,
        -2259.916259765625,
        863.9058837890625
      ],
      [
        -600.7137451171875,
        -2191.3798828125,
        639.2813110351562
      ],
      [
        -752.7145385742188,
        -2299.90576171875,
        639.28125
      ],
      [
        -704.5369873046875,
        -2348.38916015625,
        639.2811889648438
      ],
      [
        -560.1396484375,
        -2241.306640625,
        639.28125
      ],
      [
        -283.0,
        -1979.0,
        639.2814331054688
      ],
      [
        -283.0,
        -1987.0,
        639.2814331054688
      ],
      [
        -283.0,
        -1987.0,
        639.2814331054688
      ],
      [
        -275.0,
        -1987.0,
        639.2814331054688
      ],
      [
        -275.0,
        -1987.0,
        639.2814331054688
      ],
      [
        -275.0,
        -1979.0,
        639.2814331054688
      ],
      [
        -283.0,
        -1979.0,
        639.2814331054688
      ],
      [
        -275.0,
        -1979.0,
        639.2814331054688
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        623.6862182617188
      ],
      [
        -105.300048828125,
        -2181.199951171875,
        622.6664428710938
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        621.3796997070312
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        619.46630859375
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        623.762939453125
      ],
      [
        -105.2154541015625,
        -2059.421630859375,
        624.7360229492188
      ],
      [
        -105.2154541015625,
        -2059.421630859375,
        618.412841796875
      ],
      [
        -90.278564453125,
        -2044.573974609375,
        622.0775756835938
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        623.762939453125
      ],
      [
        -75.278564453125,
        -2059.573974609375,
        620.3923950195312
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        619.113525390625
      ],
      [
        -79.672119140625,
        -2048.967529296875,
        620.6815185546875
      ],
      [
        -90.278564453125,
        -2044.573974609375,
        622.0775756835938
      ],
      [
        -66.12939453125,
        -2138.030517578125,
        618.63818359375
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        620.4703369140625
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.461181640625
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.0650024414062
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        618.5244140625
      ],
      [
        -92.5,
        -2071.60009765625,
        623.2898559570312
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        623.3185424804688
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        622.0928955078125
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        623.4249877929688
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        620.4703369140625
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        622.0928955078125
      ],
      [
        -92.5,
        -2138.245849609375,
        622.3040161132812
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        618.5244140625
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        622.3348388671875
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        623.3673095703125
      ],
      [
        -91.25299072265625,
        -2080.781494140625,
        623.4108276367188
      ],
      [
        -89.30126953125,
        -2081.89990234375,
        623.1181030273438
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        623.3673095703125
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        622.4420776367188
      ],
      [
        -91.18179321289062,
        -2128.540283203125,
        622.4413452148438
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        622.4420776367188
      ],
      [
        -89.30126953125,
        -2127.946044921875,
        622.1928100585938
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.461181640625
      ],
      [
        -105.22237396240234,
        -2069.38525390625,
        618.412841796875
      ],
      [
        -105.22237396240234,
        -2069.38525390625,
        625.0650024414062
      ],
      [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        623.4249877929688
      ],
      [
        -105.2717514038086,
        -2140.4697265625,
        624.0093994140625
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        624.7501831054688
      ],
      [
        -109.34033203125,
        -2064.5546875,
        625.504150390625
      ],
      [
        -109.34033203125,
        -2064.5546875,
        625.504150390625
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.3372802734375
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.3372802734375
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        624.4166259765625
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        623.6862182617188
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        624.2633666992188
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        624.4166259765625
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        624.2633666992188
      ],
      [
        -195.0,
        -1979.0,
        635.1311645507812
      ],
      [
        -195.0,
        -1987.0,
        635.39453125
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        624.7501831054688
      ],
      [
        -192.28419494628906,
        -1987.0,
        635.0
      ],
      [
        -195.0,
        -1987.0,
        635.39453125
      ],
      [
        -195.0,
        -1979.0,
        635.1311645507812
      ],
      [
        -194.09686279296875,
        -1979.0,
        635.0
      ],
      [
        -417.7513732910156,
        -2063.322021484375,
        641.6248779296875
      ],
      [
        -510.4124755859375,
        -2130.041748046875,
        641.6248779296875
      ],
      [
        -599.7044677734375,
        -2193.9814453125,
        641.6248779296875
      ],
      [
        -514.9536743164062,
        -2132.99560546875,
        641.6248779296875
      ],
      [
        -598.208740234375,
        -2195.306396484375,
        639.2813110351562
      ],
      [
        -599.2575073242188,
        -2193.659912109375,
        641.6248779296875
      ],
      [
        -510.4124755859375,
        -2130.041748046875,
        641.6248779296875
      ],
      [
        -514.9536743164062,
        -2132.99560546875,
        641.6248779296875
      ],
      [
        -599.1027221679688,
        -2193.90234375,
        641.6248779296875
      ],
      [
        -413.5885009765625,
        -2063.05908203125,
        639.4384155273438
      ],
      [
        -413.4871520996094,
        -2061.216064453125,
        641.6248779296875
      ],
      [
        -407.5297546386719,
        -2058.7177734375,
        641.6248779296875
      ],
      [
        -417.7513732910156,
        -2063.322021484375,
        641.6248779296875
      ],
      [
        -413.4871520996094,
        -2061.216064453125,
        641.6248779296875
      ],
      [
        -415.853271484375,
        -2064.681640625,
        639.28125
      ],
      [
        -415.51983642578125,
        -2064.44287109375,
        639.3070678710938
      ],
      [
        -413.5885009765625,
        -2063.05908203125,
        639.4384155273438
      ],
      [
        -415.51983642578125,
        -2064.44287109375,
        639.3070678710938
      ],
      [
        -635.3164672851562,
        -2162.76806640625,
        697.0984497070312
      ],
      [
        -633.0643310546875,
        -2161.42333984375,
        696.8292236328125
      ],
      [
        -581.8072509765625,
        -2131.190673828125,
        690.3377685546875
      ],
      [
        -438.2563171386719,
        -2050.9775390625,
        672.068359375
      ],
      [
        -489.5420837402344,
        -2082.13818359375,
        678.5450439453125
      ],
      [
        -489.5420837402344,
        -2082.13818359375,
        678.5450439453125
      ],
      [
        -581.8072509765625,
        -2131.190673828125,
        690.3377685546875
      ],
      [
        -387.0029602050781,
        -2031.0792236328125,
        664.73583984375
      ],
      [
        -356.5550231933594,
        -2022.1925048828125,
        660.0204467773438
      ],
      [
        -438.2563171386719,
        -2050.9775390625,
        672.068359375
      ],
      [
        -410.68280029296875,
        -2040.0169677734375,
        668.4697875976562
      ],
      [
        -387.0029296875,
        -2031.0792236328125,
        664.73583984375
      ],
      [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      [
        -520.8991088867188,
        -2206.279052734375,
        641.6248779296875
      ],
      [
        -381.4368591308594,
        -2108.78369140625,
        639.28125
      ],
      [
        -383.8894958496094,
        -2105.640869140625,
        639.28125
      ],
      [
        -353.9037780761719,
        -2083.615234375,
        641.6248779296875
      ],
      [
        -351.55548095703125,
        -2086.624267578125,
        641.6248779296875
      ],
      [
        -360.30859375,
        -2091.77294921875,
        640.9903564453125
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.346923828125
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.346923828125
      ],
      [
        -351.3531799316406,
        -2086.47412109375,
        639.9999389648438
      ],
      [
        -351.3531799316406,
        -2086.47412109375,
        641.6248779296875
      ],
      [
        -351.6673278808594,
        -2086.480224609375,
        641.6248779296875
      ],
      [
        -393.0628967285156,
        -2117.405517578125,
        640.0736083984375
      ],
      [
        -393.0747985839844,
        -2117.414306640625,
        640.0751953125
      ],
      [
        -393.0747985839844,
        -2117.414306640625,
        640.0751953125
      ],
      [
        -400.4471740722656,
        -2122.88134765625,
        641.0570678710938
      ],
      [
        -392.548828125,
        -2117.024169921875,
        640.0
      ],
      [
        -392.0283203125,
        -2116.63818359375,
        639.9358520507812
      ],
      [
        -427.68328857421875,
        -2137.808837890625,
        640.1384887695312
      ],
      [
        -419.45074462890625,
        -2134.6982421875,
        641.6248779296875
      ],
      [
        -427.0797424316406,
        -2139.177734375,
        641.6248779296875
      ],
      [
        -429.8460693359375,
        -2139.3974609375,
        640.4133911132812
      ],
      [
        -424.541748046875,
        -2135.501220703125,
        639.7391967773438
      ],
      [
        -402.5533142089844,
        -2124.443359375,
        641.3375854492188
      ],
      [
        -404.71063232421875,
        -2126.043212890625,
        641.6248779296875
      ],
      [
        -419.45074462890625,
        -2134.6982421875,
        641.6248779296875
      ],
      [
        -427.68328857421875,
        -2137.808837890625,
        640.1384887695312
      ],
      [
        -422.3837890625,
        -2133.916259765625,
        639.4649047851562
      ],
      [
        -424.5417785644531,
        -2135.501220703125,
        639.7391967773438
      ],
      [
        -392.0283203125,
        -2116.63818359375,
        639.9358520507812
      ],
      [
        -422.3837890625,
        -2133.916259765625,
        639.4649047851562
      ],
      [
        -420.93878173828125,
        -2132.854736328125,
        639.28125
      ],
      [
        -387.1133728027344,
        -2112.993408203125,
        639.28125
      ],
      [
        -429.8460693359375,
        -2139.3974609375,
        640.4133911132812
      ],
      [
        -427.0797424316406,
        -2139.177734375,
        641.6248779296875
      ],
      [
        -431.2630920410156,
        -2141.63427734375,
        641.6248779296875
      ],
      [
        -431.74652099609375,
        -2140.79345703125,
        640.6549072265625
      ],
      [
        -449.04296875,
        -2153.498291015625,
        641.6248779296875
      ],
      [
        -431.74652099609375,
        -2140.79345703125,
        640.6549072265625
      ],
      [
        -431.2630920410156,
        -2141.63427734375,
        641.6248779296875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.0430297851562
      ],
      [
        -400.4471740722656,
        -2122.88134765625,
        639.9999389648438
      ],
      [
        -400.4470520019531,
        -2122.88134765625,
        641.056884765625
      ],
      [
        -402.55328369140625,
        -2124.443359375,
        639.9999389648438
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.0430297851562
      ],
      [
        -402.55328369140625,
        -2124.443359375,
        641.33740234375
      ],
      [
        -561.891357421875,
        -2238.921875,
        641.6248779296875
      ],
      [
        -561.7347412109375,
        -2240.273681640625,
        641.6248779296875
      ],
      [
        -561.334716796875,
        -2239.679443359375,
        641.6248779296875
      ],
      [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      [
        -397.4329833984375,
        -2120.646240234375,
        640.1744995117188
      ],
      [
        -400.4471130371094,
        -2122.88134765625,
        640.4600830078125
      ],
      [
        -393.0747985839844,
        -2117.414306640625,
        640.0
      ],
      [
        -392.548828125,
        -2117.024169921875,
        640.0
      ],
      [
        -393.0747985839844,
        -2117.414306640625,
        640.0
      ],
      [
        -393.0628967285156,
        -2117.405517578125,
        640.0736083984375
      ],
      [
        -360.30859375,
        -2091.77294921875,
        641.6248779296875
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.6248779296875
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.6248779296875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.6248779296875
      ],
      [
        -400.4469909667969,
        -2122.88134765625,
        641.6248779296875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.6248779296875
      ],
      [
        -402.55328369140625,
        -2124.443359375,
        641.6248779296875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.6248779296875
      ],
      [
        -314.135009765625,
        -2131.402587890625,
        641.6248779296875
      ],
      [
        -394.21533203125,
        -2118.445556640625,
        639.9999389648438
      ],
      [
        -375.7421569824219,
        -2107.23681640625,
        639.9999389648438
      ],
      [
        -372.2735290527344,
        -2101.98828125,
        639.9999389648438
      ],
      [
        -371.0722961425781,
        -2103.527587890625,
        639.9999389648438
      ],
      [
        -371.07244873046875,
        -2103.527587890625,
        639.9999389648438
      ],
      [
        -376.2414855957031,
        -2108.90625,
        640.96044921875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.1424560546875
      ],
      [
        -392.44219970703125,
        -2118.259765625,
        640.62548828125
      ],
      [
        -400.4471130371094,
        -2122.88134765625,
        640.4599609375
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.1424560546875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        641.6248779296875
      ],
      [
        -365.99072265625,
        -2103.6318359375,
        641.6248779296875
      ],
      [
        -406.736328125,
        -2129.89404296875,
        641.6248779296875
      ],
      [
        -402.55328369140625,
        -2124.443359375,
        640.65966796875
      ],
      [
        -404.525634765625,
        -2127.013427734375,
        641.6248779296875
      ],
      [
        -392.44219970703125,
        -2118.259765625,
        640.62548828125
      ],
      [
        -391.2690734863281,
        -2119.8916015625,
        641.6248779296875
      ],
      [
        -391.6632080078125,
        -2119.208984375,
        641.6248779296875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        641.6248779296875
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.4857177734375
      ],
      [
        -358.75,
        -2099.238525390625,
        641.6248779296875
      ],
      [
        -345.839111328125,
        -2091.35302734375,
        639.9999389648438
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.6248779296875
      ],
      [
        -345.8052673339844,
        -2091.38427734375,
        641.6248779296875
      ],
      [
        -345.83905029296875,
        -2091.35302734375,
        641.5885009765625
      ],
      [
        -347.3155822753906,
        -2089.988525390625,
        639.9999389648438
      ],
      [
        -392.9297180175781,
        -2117.66552734375,
        640.0
      ],
      [
        -392.44219970703125,
        -2118.259765625,
        640.6255493164062
      ],
      [
        -348.6988830566406,
        -2090.284423828125,
        641.6248779296875
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.6248779296875
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.6248779296875
      ],
      [
        -371.9428405761719,
        -2106.424560546875,
        641.6248779296875
      ],
      [
        -369.19476318359375,
        -2104.516357421875,
        641.6248779296875
      ],
      [
        -359.0240783691406,
        -2097.4541015625,
        641.6248779296875
      ],
      [
        -364.7442626953125,
        -2101.426025390625,
        641.6248779296875
      ],
      [
        -364.7442626953125,
        -2101.426025390625,
        641.6248779296875
      ],
      [
        -369.19476318359375,
        -2104.516357421875,
        641.6248779296875
      ],
      [
        -376.28759765625,
        -2108.932861328125,
        641.2645874023438
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.6248779296875
      ],
      [
        -371.94342041015625,
        -2106.4248046875,
        641.6248779296875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.6248779296875
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.6248779296875
      ],
      [
        -376.3421936035156,
        -2108.96435546875,
        641.6248779296875
      ],
      [
        -392.2690734863281,
        -2118.15966796875,
        641.6248779296875
      ],
      [
        -392.2690734863281,
        -2118.15966796875,
        641.6248779296875
      ],
      [
        -403.0185852050781,
        -2125.049560546875,
        641.6248779296875
      ],
      [
        -539.6183471679688,
        -2288.8349609375,
        679.6005249023438
      ],
      [
        -506.88580322265625,
        -2234.2978515625,
        676.8448486328125
      ],
      [
        -506.88580322265625,
        -2234.2978515625,
        676.8448486328125
      ],
      [
        -481.6022033691406,
        -2177.4140625,
        643.8072509765625
      ],
      [
        -479.8501892089844,
        -2209.492431640625,
        673.8994750976562
      ],
      [
        -479.8501892089844,
        -2209.492431640625,
        673.8994750976562
      ],
      [
        -481.6022033691406,
        -2177.4140625,
        643.8072509765625
      ],
      [
        -475.89971923828125,
        -2173.225341796875,
        643.1309814453125
      ],
      [
        -436.0340270996094,
        -2177.475341796875,
        668.8554077148438
      ],
      [
        -292.9984130859375,
        -2065.633544921875,
        645.7384643554688
      ],
      [
        -250.93359375,
        -2070.21044921875,
        645.7384643554688
      ],
      [
        -299.1501770019531,
        -2076.648193359375,
        652.2869262695312
      ],
      [
        -299.1034240722656,
        -2076.33544921875,
        652.1087646484375
      ],
      [
        -344.92059326171875,
        -2092.46240234375,
        641.6248779296875
      ],
      [
        -314.135009765625,
        -2131.402587890625,
        653.261962890625
      ],
      [
        -335.95623779296875,
        -2103.80126953125,
        656.8388061523438
      ],
      [
        -362.6966247558594,
        -2103.197998046875,
        641.6248779296875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        642.8467407226562
      ],
      [
        -406.736328125,
        -2129.89404296875,
        641.7142333984375
      ],
      [
        -406.5956115722656,
        -2129.710693359375,
        641.6248779296875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        642.8467407226562
      ],
      [
        -359.34197998046875,
        -2101.172119140625,
        641.6248779296875
      ],
      [
        -326.5126953125,
        -2098.354736328125,
        655.6403198242188
      ],
      [
        -329.4198913574219,
        -2095.089111328125,
        652.5119018554688
      ],
      [
        -299.1034240722656,
        -2076.33544921875,
        652.1087646484375
      ],
      [
        -299.1501770019531,
        -2076.648193359375,
        652.2869262695312
      ],
      [
        -335.46014404296875,
        -2104.4287109375,
        656.7574462890625
      ],
      [
        -337.21307373046875,
        -2102.21142578125,
        654.705810546875
      ],
      [
        -329.4198913574219,
        -2095.089111328125,
        652.5119018554688
      ],
      [
        -326.5126953125,
        -2098.354736328125,
        655.6403198242188
      ],
      [
        -250.93359375,
        -2070.21044921875,
        645.7384643554688
      ],
      [
        -292.9984130859375,
        -2065.633544921875,
        645.7384643554688
      ],
      [
        -268.6907958984375,
        -2050.953125,
        645.7384643554688
      ],
      [
        -250.4770965576172,
        -2067.064453125,
        645.7384643554688
      ],
      [
        -254.21792602539062,
        -2042.298095703125,
        645.8165893554688
      ],
      [
        -249.7219696044922,
        -2060.55908203125,
        645.7645874023438
      ],
      [
        -250.4770965576172,
        -2067.064453125,
        645.7384643554688
      ],
      [
        -268.6907958984375,
        -2050.953125,
        645.7384643554688
      ],
      [
        -436.0340270996094,
        -2177.475341796875,
        668.8554077148438
      ],
      [
        -475.8996887207031,
        -2173.225341796875,
        643.1309814453125
      ],
      [
        -418.6674499511719,
        -2163.538818359375,
        666.8973388671875
      ],
      [
        -299.1072082519531,
        -2058.38330078125,
        645.7384643554688
      ],
      [
        -336.9632263183594,
        -2079.83544921875,
        642.5633544921875
      ],
      [
        -299.1072082519531,
        -2058.38330078125,
        645.7384643554688
      ],
      [
        -276.9815673828125,
        -2043.6192626953125,
        645.7384643554688
      ],
      [
        -347.17852783203125,
        -2090.115234375,
        641.6248779296875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.7095947265625
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.7095947265625
      ],
      [
        -344.845703125,
        -2092.55712890625,
        641.7520141601562
      ],
      [
        -257.122314453125,
        -2030.5015869140625,
        645.8502197265625
      ],
      [
        -276.9815673828125,
        -2043.6192626953125,
        645.7384643554688
      ],
      [
        -293.274658203125,
        -2066.11767578125,
        646.0267333984375
      ],
      [
        -405.97332763671875,
        -2135.688232421875,
        649.3045654296875
      ],
      [
        -409.74249267578125,
        -2137.800537109375,
        649.217529296875
      ],
      [
        -409.74249267578125,
        -2137.800537109375,
        649.217529296875
      ],
      [
        -427.6852722167969,
        -2147.856201171875,
        648.8035888671875
      ],
      [
        -345.69329833984375,
        -2091.48779296875,
        641.7091064453125
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.7198486328125
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.7198486328125
      ],
      [
        -338.43505859375,
        -2100.665771484375,
        652.6318969726562
      ],
      [
        -339.98199462890625,
        -2098.708984375,
        650.8302612304688
      ],
      [
        -366.7017822265625,
        -2103.7255859375,
        641.6248779296875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        644.3175659179688
      ],
      [
        -406.736328125,
        -2129.89404296875,
        643.92041015625
      ],
      [
        -403.0187072753906,
        -2125.0498046875,
        641.6248779296875
      ],
      [
        -392.01971435546875,
        -2118.591552734375,
        641.6248779296875
      ],
      [
        -391.0085754394531,
        -2119.7412109375,
        643.128662109375
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        644.3175659179688
      ],
      [
        -358.68206787109375,
        -2099.0166015625,
        641.6248779296875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        644.1882934570312
      ],
      [
        -406.736328125,
        -2129.89404296875,
        645.3958740234375
      ],
      [
        -402.07666015625,
        -2123.822265625,
        643.0118408203125
      ],
      [
        -405.7651062011719,
        -2128.62841796875,
        644.9672241210938
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        645.9818725585938
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        644.0260620117188
      ],
      [
        -344.6956787109375,
        -2092.7470703125,
        645.3406982421875
      ],
      [
        -344.8224182128906,
        -2092.92724609375,
        645.4060668945312
      ],
      [
        -347.2979431152344,
        -2089.455322265625,
        641.7266235351562
      ],
      [
        -347.7262268066406,
        -2089.609130859375,
        641.6248779296875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        643.9666137695312
      ],
      [
        -348.3791809082031,
        -2089.005615234375,
        641.6248779296875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        644.1882934570312
      ],
      [
        -347.660400390625,
        -2089.669677734375,
        641.7003173828125
      ],
      [
        -349.2779235839844,
        -2089.54248046875,
        641.6248779296875
      ],
      [
        -348.3093566894531,
        -2089.070068359375,
        641.6913452148438
      ],
      [
        -347.29803466796875,
        -2089.455322265625,
        641.7266235351562
      ],
      [
        -347.79913330078125,
        -2088.8212890625,
        641.726318359375
      ],
      [
        -376.6501770019531,
        -2109.14208984375,
        643.656982421875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        643.772216796875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        643.0118408203125
      ],
      [
        -391.9501953125,
        -2117.9755859375,
        643.4658203125
      ],
      [
        -396.8349609375,
        -2120.7958984375,
        643.40478515625
      ],
      [
        -367.435791015625,
        -2103.822265625,
        643.772216796875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        645.9818725585938
      ],
      [
        -391.9501953125,
        -2117.9755859375,
        643.4658203125
      ],
      [
        -390.6972961425781,
        -2119.5615234375,
        644.9256591796875
      ],
      [
        -358.7217712402344,
        -2098.791015625,
        642.7213134765625
      ],
      [
        -398.3269348144531,
        -2148.872802734375,
        664.5492553710938
      ],
      [
        -418.6674499511719,
        -2163.538818359375,
        666.8973388671875
      ],
      [
        -338.49566650390625,
        -2100.589111328125,
        653.20458984375
      ],
      [
        -330.7852783203125,
        -2093.555419921875,
        651.0426025390625
      ],
      [
        -339.98199462890625,
        -2098.708984375,
        650.8302612304688
      ],
      [
        -337.2131042480469,
        -2102.21142578125,
        654.7056884765625
      ],
      [
        -338.4957275390625,
        -2100.5888671875,
        653.2045288085938
      ],
      [
        -336.19610595703125,
        -2103.497802734375,
        656.8781127929688
      ],
      [
        -344.6959533691406,
        -2092.74658203125,
        645.3402709960938
      ],
      [
        -338.4957275390625,
        -2100.5888671875,
        653.2045288085938
      ],
      [
        -341.9147033691406,
        -2096.264404296875,
        649.2028198242188
      ],
      [
        -336.3678283691406,
        -2103.280517578125,
        656.90625
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        647.4326782226562
      ],
      [
        -339.48736572265625,
        -2099.334716796875,
        657.4176025390625
      ],
      [
        -367.435791015625,
        -2103.822265625,
        645.6093139648438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        648.9979248046875
      ],
      [
        -376.83917236328125,
        -2109.251220703125,
        644.9041137695312
      ],
      [
        -367.435791015625,
        -2103.822265625,
        645.6093139648438
      ],
      [
        -391.8966369628906,
        -2117.944580078125,
        643.7750244140625
      ],
      [
        -391.8966369628906,
        -2117.944580078125,
        643.7750244140625
      ],
      [
        -390.5455322265625,
        -2119.473876953125,
        645.8018188476562
      ],
      [
        -406.736328125,
        -2129.89404296875,
        645.4821166992188
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        648.9979248046875
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        646.4585571289062
      ],
      [
        -350.0618591308594,
        -2087.45068359375,
        641.6248779296875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        647.4326782226562
      ],
      [
        -348.3093566894531,
        -2089.070068359375,
        641.6913452148438
      ],
      [
        -350.61993408203125,
        -2087.822998046875,
        641.6248779296875
      ],
      [
        -350.02972412109375,
        -2087.480224609375,
        641.66748046875
      ],
      [
        -347.79913330078125,
        -2088.8212890625,
        641.726318359375
      ],
      [
        -349.2276611328125,
        -2087.014404296875,
        641.7254028320312
      ],
      [
        -342.9916076660156,
        -2083.39306640625,
        642.1755981445312
      ],
      [
        -336.9632263183594,
        -2079.83544921875,
        642.5633544921875
      ],
      [
        -342.99163818359375,
        -2083.39306640625,
        642.1755981445312
      ],
      [
        -302.2524108886719,
        -2045.675537109375,
        645.7384643554688
      ],
      [
        -331.83782958984375,
        -2067.406982421875,
        643.1666259765625
      ],
      [
        -265.7866516113281,
        -2018.8902587890625,
        645.8646240234375
      ],
      [
        -259.83294677734375,
        -2019.491943359375,
        645.881591796875
      ],
      [
        -287.17596435546875,
        -2034.6014404296875,
        645.7384643554688
      ],
      [
        -302.2524108886719,
        -2045.675537109375,
        645.7384643554688
      ],
      [
        -287.17596435546875,
        -2034.6014404296875,
        645.7384643554688
      ],
      [
        -259.83294677734375,
        -2019.491943359375,
        645.881591796875
      ],
      [
        -265.7866516113281,
        -2018.8902587890625,
        645.8646240234375
      ],
      [
        -265.1526794433594,
        -2018.424560546875,
        646.6192016601562
      ],
      [
        -331.83782958984375,
        -2067.406982421875,
        643.1666259765625
      ],
      [
        -350.817626953125,
        -2081.348388671875,
        641.8660888671875
      ],
      [
        -350.8175964355469,
        -2081.348388671875,
        641.8660888671875
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.6522827148438
      ],
      [
        -350.02978515625,
        -2087.48046875,
        641.6674194335938
      ],
      [
        -351.6669921875,
        -2086.47998046875,
        641.6248779296875
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.6522827148438
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.70263671875
      ],
      [
        -349.98590087890625,
        -2087.52099609375,
        641.7257080078125
      ],
      [
        -352.7531433105469,
        -2086.500732421875,
        641.6248779296875
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.70263671875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        659.3778076171875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        660.167236328125
      ],
      [
        -364.9534606933594,
        -2103.495361328125,
        660.8609619140625
      ],
      [
        -384.5960693359375,
        -2113.729736328125,
        655.9999389648438
      ],
      [
        -378.26910400390625,
        -2110.076904296875,
        657.2453002929688
      ],
      [
        -378.26910400390625,
        -2110.076904296875,
        657.2453002929688
      ],
      [
        -367.435791015625,
        -2103.822265625,
        659.3778076171875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        652.55908203125
      ],
      [
        -389.9620056152344,
        -2116.827880859375,
        654.9437255859375
      ],
      [
        -406.736328125,
        -2129.89404296875,
        654.6817626953125
      ],
      [
        -402.07666015625,
        -2123.822265625,
        652.55908203125
      ],
      [
        -389.9620056152344,
        -2116.827880859375,
        654.9437255859375
      ],
      [
        -389.3301696777344,
        -2117.49951171875,
        655.9999389648438
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        658.4334716796875
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        655.4558715820312
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        658.4334716796875
      ],
      [
        -348.8742370605469,
        -2088.548095703125,
        658.9343872070312
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        651.2236328125
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        655.4558715820312
      ],
      [
        -360.30859375,
        -2091.77294921875,
        653.6477661132812
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        651.2236938476562
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        650.9999389648438
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        650.9999389648438
      ],
      [
        -359.2476501464844,
        -2092.43212890625,
        654.9999389648438
      ],
      [
        -359.342529296875,
        -2092.0322265625,
        654.572509765625
      ],
      [
        -357.809326171875,
        -2098.495361328125,
        659.9719848632812
      ],
      [
        -357.9346923828125,
        -2097.967041015625,
        659.9999389648438
      ],
      [
        -358.1379089355469,
        -2097.1103515625,
        659.9999389648438
      ],
      [
        -359.2476501464844,
        -2092.43212890625,
        654.9999389648438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        660.167236328125
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        660.0818481445312
      ],
      [
        -358.1206359863281,
        -2097.18310546875,
        654.9999389648438
      ],
      [
        -359.2476501464844,
        -2092.43212890625,
        654.9999389648438
      ],
      [
        -360.0203857421875,
        -2093.047607421875,
        654.9999389648438
      ],
      [
        -377.2195129394531,
        -2109.470947265625,
        662.4396362304688
      ],
      [
        -391.6904602050781,
        -2117.82568359375,
        664.2759399414062
      ],
      [
        -377.2195129394531,
        -2109.470947265625,
        662.4396362304688
      ],
      [
        -367.435791015625,
        -2103.822265625,
        661.1981811523438
      ],
      [
        -402.07666015625,
        -2123.822265625,
        665.5938720703125
      ],
      [
        -391.6904602050781,
        -2117.82568359375,
        664.2759399414062
      ],
      [
        -406.736328125,
        -2129.89404296875,
        666.1172485351562
      ],
      [
        -402.07666015625,
        -2123.822265625,
        665.5939331054688
      ],
      [
        -367.435791015625,
        -2103.822265625,
        661.1981811523438
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        660.1241455078125
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        659.28759765625
      ],
      [
        -360.30859375,
        -2091.77294921875,
        660.4531860351562
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        660.1242065429688
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        659.28759765625
      ],
      [
        -271.35888671875,
        -2017.1793212890625,
        647.479736328125
      ],
      [
        -283.0,
        -1979.0,
        647.9141235351562
      ],
      [
        -275.0,
        -1979.0,
        646.7520751953125
      ],
      [
        -283.0,
        -1979.0,
        647.9141235351562
      ],
      [
        -283.0,
        -1981.056396484375,
        647.9818115234375
      ],
      [
        -283.0,
        -1987.0,
        647.8088989257812
      ],
      [
        -275.0,
        -1987.0,
        647.015380859375
      ],
      [
        -275.0,
        -1979.0,
        646.7520751953125
      ],
      [
        -283.0,
        -1987.0,
        647.8088989257812
      ],
      [
        -281.0845947265625,
        -1987.0,
        647.8992309570312
      ],
      [
        -275.0,
        -1987.0,
        647.015380859375
      ],
      [
        -294.30517578125,
        -2039.8380126953125,
        645.7384643554688
      ],
      [
        -304.0990295410156,
        -2038.2144775390625,
        645.7384643554688
      ],
      [
        -326.17449951171875,
        -2053.674072265625,
        643.8331909179688
      ],
      [
        -304.0990295410156,
        -2038.2144775390625,
        645.7384643554688
      ],
      [
        -298.20367431640625,
        -2033.52001953125,
        645.7384643554688
      ],
      [
        -274.051025390625,
        -2016.63916015625,
        647.85302734375
      ],
      [
        -275.1498107910156,
        -2016.9088134765625,
        647.308837890625
      ],
      [
        -312.8653259277344,
        -2009.4410400390625,
        653.2543334960938
      ],
      [
        -283.0,
        -1987.0,
        648.1774291992188
      ],
      [
        -283.0,
        -1987.0,
        648.1774291992188
      ],
      [
        -276.39306640625,
        -2016.169189453125,
        648.1777954101562
      ],
      [
        -300.8400573730469,
        -2011.2637939453125,
        651.5675659179688
      ],
      [
        -312.8653259277344,
        -2009.4410400390625,
        653.2543334960938
      ],
      [
        -300.8400573730469,
        -2011.263671875,
        651.5675659179688
      ],
      [
        26.906936645507812,
        -2132.77880859375,
        606.0013427734375
      ],
      [
        -538.70947265625,
        -2290.83056640625,
        681.1611328125
      ],
      [
        -505.5889892578125,
        -2234.22900390625,
        677.71142578125
      ],
      [
        -479.80810546875,
        -2210.26318359375,
        674.6224365234375
      ],
      [
        -435.57171630859375,
        -2177.524658203125,
        669.1537475585938
      ],
      [
        -505.5889892578125,
        -2234.22900390625,
        677.71142578125
      ],
      [
        -479.80810546875,
        -2210.26318359375,
        674.6224365234375
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        623.95703125
      ],
      [
        -105.300048828125,
        -2181.199951171875,
        623.3385620117188
      ],
      [
        -66.12939453125,
        -2138.030517578125,
        618.7809448242188
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        620.623779296875
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        622.1810302734375
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        623.5617065429688
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        620.623779296875
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        622.1810302734375
      ],
      [
        -92.5,
        -2138.245849609375,
        622.4288940429688
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        622.3347778320312
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        622.4317016601562
      ],
      [
        -91.47808074951172,
        -2130.7216796875,
        622.4104614257812
      ],
      [
        -91.48384094238281,
        -2130.76416015625,
        622.4384765625
      ],
      [
        -105.2717514038086,
        -2140.4697265625,
        624.0093994140625
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        623.5617065429688
      ],
      [
        -105.2717514038086,
        -2140.4697265625,
        624.153076171875
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        624.61962890625
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        623.95703125
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        624.4100341796875
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        624.61962890625
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        624.4100341796875
      ],
      [
        -398.3159484863281,
        -2148.8896484375,
        664.5693359375
      ],
      [
        -418.5774230957031,
        -2163.6953125,
        667.0780029296875
      ],
      [
        -435.57171630859375,
        -2177.524658203125,
        669.1537475585938
      ],
      [
        -418.5774230957031,
        -2163.6953125,
        667.0780029296875
      ],
      [
        -635.32763671875,
        -2162.75830078125,
        697.1158447265625
      ],
      [
        27.273828506469727,
        -2132.59033203125,
        605.9542846679688
      ],
      [
        26.906936645507812,
        -2132.77880859375,
        606.0013427734375
      ],
      [
        27.273826599121094,
        -2132.59033203125,
        605.9542846679688
      ],
      [
        149.87228393554688,
        -2063.799072265625,
        590.357177734375
      ],
      [
        -313.8014221191406,
        -2007.820556640625,
        655.6990966796875
      ],
      [
        -386.3614501953125,
        -2030.3492431640625,
        665.295654296875
      ],
      [
        -283.0,
        -1979.0,
        652.0123291015625
      ],
      [
        -275.0,
        -1979.0,
        650.9043579101562
      ],
      [
        -275.0,
        -1987.0,
        650.7435913085938
      ],
      [
        -275.0,
        -1979.0,
        650.9043579101562
      ],
      [
        -283.0,
        -1979.0,
        652.0123291015625
      ],
      [
        -283.0,
        -1987.0,
        651.8516235351562
      ],
      [
        -283.0,
        -1987.0,
        651.8515625
      ],
      [
        -275.0,
        -1987.0,
        650.7435913085938
      ],
      [
        -245.12753295898438,
        -2020.9781494140625,
        645.923583984375
      ],
      [
        -297.8909912109375,
        -2010.245361328125,
        653.4468383789062
      ],
      [
        -79.672119140625,
        -2048.967529296875,
        622.4462890625
      ],
      [
        -90.278564453125,
        -2044.573974609375,
        624.0034790039062
      ],
      [
        -90.278564453125,
        -2044.573974609375,
        624.0034790039062
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        625.3842163085938
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        625.3842163085938
      ],
      [
        -101.40145874023438,
        -2050.2138671875,
        625.4306640625
      ],
      [
        -101.80957794189453,
        -2051.198974609375,
        623.9706420898438
      ],
      [
        -195.0,
        -1979.0,
        639.8246459960938
      ],
      [
        -195.0,
        -1987.0,
        639.6638793945312
      ],
      [
        -187.0,
        -1987.0,
        638.555908203125
      ],
      [
        -187.0,
        -1979.0,
        638.7166748046875
      ],
      [
        -195.0,
        -1979.0,
        639.8246459960938
      ],
      [
        -187.0,
        -1979.0,
        638.7166748046875
      ],
      [
        -195.0,
        -1987.0,
        639.6639404296875
      ],
      [
        -187.0,
        -1987.0,
        638.555908203125
      ],
      [
        -245.1275177001953,
        -2020.9781494140625,
        645.923583984375
      ],
      [
        -75.278564453125,
        -2059.573974609375,
        621.6246337890625
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        619.9622802734375
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        622.0199584960938
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        620.1115112304688
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        625.7794799804688
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        625.7794799804688
      ],
      [
        -109.34033203125,
        -2064.5546875,
        626.241943359375
      ],
      [
        -109.34033203125,
        -2064.5546875,
        626.241943359375
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        626.0529174804688
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        625.423095703125
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.9579467773438
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.4006958007812
      ],
      [
        -92.5,
        -2071.60009765625,
        623.7680053710938
      ],
      [
        -92.20443725585938,
        -2073.7763671875,
        623.683349609375
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        623.3185424804688
      ],
      [
        -108.0561294555664,
        -2067.21044921875,
        626.0107421875
      ],
      [
        -108.0561294555664,
        -2067.21044921875,
        625.405029296875
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.9579467773438
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.8526000976562
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.8526000976562
      ],
      [
        -91.76782989501953,
        -2076.990966796875,
        623.5582885742188
      ],
      [
        -91.75545501708984,
        -2077.08203125,
        623.362060546875
      ],
      [
        -386.3614196777344,
        -2030.3492431640625,
        665.295654296875
      ],
      [
        -313.8014221191406,
        -2007.820556640625,
        655.6990966796875
      ],
      [
        -297.8909912109375,
        -2010.2452392578125,
        653.4468383789062
      ],
      [
        149.87228393554688,
        -2063.799072265625,
        590.357177734375
      ],
      [
        -195.0,
        -1979.0,
        705.9292602539062
      ],
      [
        -187.0,
        -1979.0,
        705.8253784179688
      ],
      [
        -283.0,
        -1979.0,
        690.0587158203125
      ],
      [
        -275.0,
        -1979.0,
        692.4945678710938
      ],
      [
        -187.0,
        -1987.0,
        700.22021484375
      ],
      [
        -187.0,
        -1979.0,
        705.8253784179688
      ],
      [
        -195.0,
        -1979.0,
        705.9292602539062
      ],
      [
        -195.0,
        -1987.0,
        700.3240966796875
      ],
      [
        -195.0,
        -1987.0,
        700.3240966796875
      ],
      [
        -187.0,
        -1987.0,
        700.22021484375
      ],
      [
        -275.0,
        -1987.0,
        681.0655517578125
      ],
      [
        -275.0,
        -1979.0,
        692.49462890625
      ],
      [
        -283.0,
        -1979.0,
        690.0587768554688
      ],
      [
        -283.0,
        -1987.0,
        678.6299438476562
      ],
      [
        -283.0,
        -1987.0,
        678.6298828125
      ],
      [
        -275.0,
        -1987.0,
        681.0655517578125
      ],
      [
        -96.41828918457031,
        -2045.7427978515625,
        651.5167236328125
      ],
      [
        -98.16725158691406,
        -1998.9012451171875,
        690.36474609375
      ],
      [
        -97.80711364746094,
        -2033.12158203125,
        666.07080078125
      ],
      [
        -97.46321105957031,
        -2039.248046875,
        660.4769287109375
      ],
      [
        -79.672119140625,
        -2048.967529296875,
        650.2066040039062
      ],
      [
        -85.1344985961914,
        -2046.704833984375,
        652.7044067382812
      ],
      [
        -90.278564453125,
        -2044.573974609375,
        624.9468994140625
      ],
      [
        -90.0726547241211,
        -2044.6593017578125,
        623.9732666015625
      ],
      [
        -90.278564453125,
        -2044.573974609375,
        624.9468994140625
      ],
      [
        -92.90218353271484,
        -2045.6607666015625,
        652.7044067382812
      ],
      [
        -96.21092987060547,
        -2047.0313720703125,
        649.739013671875
      ],
      [
        -75.278564453125,
        -2059.573974609375,
        638.1934204101562
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        629.1729736328125
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        623.49072265625
      ],
      [
        -78.51063537597656,
        -2070.32080078125,
        621.8562622070312
      ],
      [
        -92.90218353271484,
        -2045.6607666015625,
        652.7044067382812
      ],
      [
        -92.74551391601562,
        -2045.5958251953125,
        652.7044067382812
      ],
      [
        -92.67390441894531,
        -2045.6531982421875,
        652.7847290039062
      ],
      [
        -85.1344985961914,
        -2046.704833984375,
        652.7044067382812
      ],
      [
        -88.0482177734375,
        -2046.2249755859375,
        653.3761596679688
      ],
      [
        -90.278564453125,
        -2045.573486328125,
        653.6278076171875
      ],
      [
        -90.278564453125,
        -2045.573486328125,
        653.6278076171875
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        645.5496826171875
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        645.5496826171875
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        629.0596923828125
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        629.0596923828125
      ],
      [
        -106.79007720947266,
        -2061.427490234375,
        625.9515991210938
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        651.9237060546875
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        642.64306640625
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        630.9340209960938
      ],
      [
        -67.10684967041016,
        -2071.697509765625,
        628.538818359375
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        628.0411987304688
      ],
      [
        -75.278564453125,
        -2059.573974609375,
        640.2147216796875
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        631.5253295898438
      ],
      [
        -98.24224853515625,
        -2047.8726806640625,
        652.7044067382812
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        651.9237060546875
      ],
      [
        -98.24224853515625,
        -2047.8726806640625,
        652.7044067382812
      ],
      [
        -92.67390441894531,
        -2045.6531982421875,
        652.7847290039062
      ],
      [
        -91.90425109863281,
        -2046.26904296875,
        653.6482543945312
      ],
      [
        -96.9736099243164,
        -2047.9700927734375,
        652.51318359375
      ],
      [
        -96.80043029785156,
        -2047.2755126953125,
        652.2024536132812
      ],
      [
        -96.92056274414062,
        -2047.3253173828125,
        652.7045288085938
      ],
      [
        -96.99676513671875,
        -2047.5574951171875,
        652.889892578125
      ],
      [
        -97.00777435302734,
        -2047.3614501953125,
        653.0689697265625
      ],
      [
        -96.9881820678711,
        -2042.2005615234375,
        656.4036254882812
      ],
      [
        -97.31201934814453,
        -2041.94140625,
        658.0177001953125
      ],
      [
        -97.29426574707031,
        -2040.298095703125,
        659.0282592773438
      ],
      [
        -97.3911361694336,
        -2040.531982421875,
        659.3046264648438
      ],
      [
        -90.278564453125,
        -2045.857666015625,
        653.890380859375
      ],
      [
        -90.278564453125,
        -2045.857666015625,
        653.890380859375
      ],
      [
        -108.26380157470703,
        -2066.781005859375,
        636.3370361328125
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        634.2090454101562
      ],
      [
        -108.26380157470703,
        -2066.781005859375,
        626.048095703125
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        632.6511840820312
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        627.8010864257812
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        623.683349609375
      ],
      [
        -92.5,
        -2071.60009765625,
        630.682861328125
      ],
      [
        -92.20441436767578,
        -2073.7763671875,
        628.6817626953125
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        632.6511840820312
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        634.2090454101562
      ],
      [
        -91.76782989501953,
        -2076.99072265625,
        623.5582885742188
      ],
      [
        -92.00621032714844,
        -2075.235595703125,
        627.3399658203125
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        642.64306640625
      ],
      [
        -109.34033203125,
        -2064.5546875,
        638.4468383789062
      ],
      [
        -109.34033203125,
        -2064.5546875,
        638.4468383789062
      ],
      [
        -243.34588623046875,
        -2065.764892578125,
        645.7661743164062
      ],
      [
        -221.4732666015625,
        -2070.297119140625,
        642.3065795898438
      ],
      [
        -316.0190124511719,
        -2003.981689453125,
        661.49072265625
      ],
      [
        -382.38507080078125,
        -2025.824462890625,
        668.7655639648438
      ],
      [
        -291.25067138671875,
        -2007.9521484375,
        657.6782836914062
      ],
      [
        -243.34588623046875,
        -2065.764892578125,
        645.7661743164062
      ],
      [
        -250.34515380859375,
        -2065.927734375,
        645.7430419921875
      ],
      [
        -316.0190124511719,
        -2003.981689453125,
        661.49072265625
      ],
      [
        -291.2506103515625,
        -2007.9520263671875,
        657.6783447265625
      ],
      [
        -382.3850402832031,
        -2025.824462890625,
        668.7655639648438
      ],
      [
        -404.3952941894531,
        -2037.5177001953125,
        667.6492309570312
      ],
      [
        -400.1608581542969,
        -2033.2711181640625,
        670.569580078125
      ],
      [
        -333.4532470703125,
        -1969.5943603515625,
        714.317626953125
      ],
      [
        -283.0,
        -1979.0,
        703.0516357421875
      ],
      [
        -283.0,
        -1987.0,
        687.8591918945312
      ],
      [
        -275.0,
        -1987.0,
        688.9048461914062
      ],
      [
        -275.0,
        -1979.0,
        704.0977172851562
      ],
      [
        -283.0,
        -1979.0,
        703.0516357421875
      ],
      [
        -275.0,
        -1979.0,
        704.0978393554688
      ],
      [
        -283.0,
        -1987.0,
        687.8591918945312
      ],
      [
        -275.0,
        -1987.0,
        688.9048461914062
      ],
      [
        -283.0,
        -1979.0,
        703.7771606445312
      ],
      [
        -283.0,
        -1987.0,
        691.26025390625
      ],
      [
        -275.0,
        -1987.0,
        692.0353393554688
      ],
      [
        -275.0,
        -1979.0,
        704.5525512695312
      ],
      [
        -283.0,
        -1987.0,
        691.26025390625
      ],
      [
        -275.0,
        -1987.0,
        692.0353393554688
      ],
      [
        -283.0,
        -1979.0,
        703.7771606445312
      ],
      [
        -275.0,
        -1979.0,
        704.55224609375
      ],
      [
        -341.9966735839844,
        -1974.9398193359375,
        710.683349609375
      ],
      [
        -283.0,
        -1979.0,
        707.0723266601562
      ],
      [
        -283.0,
        -1987.0,
        701.4671630859375
      ],
      [
        -275.0,
        -1987.0,
        701.3633422851562
      ],
      [
        -275.0,
        -1979.0,
        706.9683227539062
      ],
      [
        -283.0,
        -1987.0,
        701.4671630859375
      ],
      [
        -275.0,
        -1987.0,
        701.3633422851562
      ],
      [
        -283.0,
        -1979.0,
        707.0723266601562
      ],
      [
        -275.0,
        -1979.0,
        706.9683227539062
      ],
      [
        -335.9169616699219,
        -1970.38037109375,
        713.7989501953125
      ],
      [
        -333.4532470703125,
        -1969.5943603515625,
        714.317626953125
      ],
      [
        -336.5265808105469,
        -1970.9891357421875,
        713.3803100585938
      ],
      [
        -337.3861389160156,
        -1971.60986328125,
        712.95654296875
      ],
      [
        -337.3861389160156,
        -1971.60986328125,
        712.95654296875
      ],
      [
        -341.9967041015625,
        -1974.9398193359375,
        710.683349609375
      ],
      [
        -336.5265808105469,
        -1970.9891357421875,
        713.3803100585938
      ],
      [
        -336.3163146972656,
        -1970.7791748046875,
        713.5247192382812
      ],
      [
        -336.3163146972656,
        -1970.7791748046875,
        713.5247192382812
      ],
      [
        -336.2024841308594,
        -1970.6654052734375,
        713.6029052734375
      ],
      [
        -335.9169616699219,
        -1970.38037109375,
        713.7988891601562
      ],
      [
        -336.2024841308594,
        -1970.6654052734375,
        713.6029052734375
      ],
      [
        -220.87794494628906,
        -1974.3787841796875,
        718.9976196289062
      ],
      [
        -324.65264892578125,
        -1955.786376953125,
        741.6904296875
      ],
      [
        -226.5302734375,
        -1974.1220703125,
        719.6976928710938
      ],
      [
        -226.5302734375,
        -1974.1220703125,
        719.6976928710938
      ],
      [
        -220.87794494628906,
        -1974.3787841796875,
        718.9976196289062
      ],
      [
        -286.0,
        -1933.4263916015625,
        754.0
      ],
      [
        -272.0,
        -1931.6163330078125,
        754.0
      ],
      [
        -442.0,
        -1928.0,
        772.1456298828125
      ],
      [
        -433.9729309082031,
        -1935.358154296875,
        766.1931762695312
      ],
      [
        -433.8529357910156,
        -1935.4681396484375,
        766.0
      ],
      [
        -286.0,
        -1933.4263916015625,
        754.0
      ],
      [
        -286.0,
        -1920.0,
        757.1981201171875
      ],
      [
        -286.0,
        -1927.76171875,
        758.0160522460938
      ],
      [
        -272.0,
        -1928.68359375,
        756.0791625976562
      ],
      [
        -272.0,
        -1920.0,
        755.1640625
      ],
      [
        -272.0,
        -1931.6163330078125,
        754.0
      ],
      [
        -348.0,
        -1923.67822265625,
        766.5938110351562
      ],
      [
        -348.0,
        -1918.043212890625,
        766.0
      ],
      [
        -348.0,
        -1924.5157470703125,
        766.0
      ],
      [
        -195.0,
        -1979.0,
        707.2992553710938
      ],
      [
        -187.0,
        -1979.0,
        706.1907348632812
      ],
      [
        -195.0,
        -1979.0,
        707.2992553710938
      ],
      [
        -195.0,
        -1980.298828125,
        705.019287109375
      ],
      [
        -187.0,
        -1979.0,
        706.1907348632812
      ],
      [
        -187.0,
        -1979.346435546875,
        705.5827026367188
      ],
      [
        -375.72515869140625,
        -1990.4632568359375,
        712.218017578125
      ],
      [
        -367.8601379394531,
        -2000.8775634765625,
        692.8462524414062
      ],
      [
        -433.71240234375,
        -1935.596923828125,
        766.0
      ],
      [
        -350.2874755859375,
        -1966.357421875,
        736.5457153320312
      ],
      [
        -358.3291015625,
        -1971.7314453125,
        733.4728393554688
      ],
      [
        -358.3291015625,
        -1971.7314453125,
        733.4728393554688
      ],
      [
        -375.72515869140625,
        -1990.4632568359375,
        712.218017578125
      ],
      [
        -372.4571533203125,
        -1981.1729736328125,
        728.0740966796875
      ],
      [
        -344.83538818359375,
        -1961.27294921875,
        739.6506958007812
      ],
      [
        -341.20086669921875,
        -1960.284912109375,
        740.0180053710938
      ],
      [
        -335.49884033203125,
        -1970.2469482421875,
        713.886962890625
      ],
      [
        -350.2874755859375,
        -1966.357421875,
        736.5457153320312
      ],
      [
        -348.3854675292969,
        -1964.58349609375,
        737.6289672851562
      ],
      [
        -348.3854675292969,
        -1964.58349609375,
        737.6289672851562
      ],
      [
        -347.3650817871094,
        -1963.6319580078125,
        738.2100830078125
      ],
      [
        -344.83538818359375,
        -1961.27294921875,
        739.6506958007812
      ],
      [
        -347.3650817871094,
        -1963.6319580078125,
        738.2100830078125
      ],
      [
        -324.65264892578125,
        -1955.786376953125,
        741.6904296875
      ],
      [
        -283.0,
        -1979.0,
        719.4930419921875
      ],
      [
        -283.0,
        -1987.0,
        705.4495849609375
      ],
      [
        -275.0,
        -1987.0,
        704.3411254882812
      ],
      [
        -275.0,
        -1979.0,
        718.3843994140625
      ],
      [
        -283.0,
        -1979.0,
        719.4930419921875
      ],
      [
        -275.0,
        -1979.0,
        718.3843994140625
      ],
      [
        -283.0,
        -1987.0,
        705.4495849609375
      ],
      [
        -275.0,
        -1987.0,
        704.3411254882812
      ],
      [
        -444.48663330078125,
        -2047.226806640625,
        681.3184814453125
      ],
      [
        -420.6312561035156,
        -2015.7926025390625,
        707.94580078125
      ],
      [
        -409.8841247558594,
        -2006.1849365234375,
        713.772216796875
      ],
      [
        -409.8841247558594,
        -2006.1849365234375,
        713.772216796875
      ],
      [
        -245.07896423339844,
        -2068.60986328125,
        645.750244140625
      ],
      [
        -439.9678649902344,
        -2049.947265625,
        674.6094970703125
      ],
      [
        -447.1927490234375,
        -2056.4072265625,
        673.1968994140625
      ],
      [
        -446.5451354980469,
        -2054.210205078125,
        675.1405029296875
      ],
      [
        -245.07896423339844,
        -2068.60986328125,
        645.750244140625
      ],
      [
        -248.38270568847656,
        -2068.9169921875,
        645.7384643554688
      ],
      [
        -250.77687072753906,
        -2069.13037109375,
        645.7384643554688
      ],
      [
        -248.38270568847656,
        -2068.9169921875,
        645.7384643554688
      ],
      [
        -275.0,
        -1987.0,
        715.0101928710938
      ],
      [
        -275.0,
        -1979.0,
        720.681884765625
      ],
      [
        -283.0,
        -1979.0,
        721.415283203125
      ],
      [
        -283.0,
        -1987.0,
        715.7435913085938
      ],
      [
        -283.0,
        -1987.0,
        715.7435913085938
      ],
      [
        -275.0,
        -1987.0,
        715.0101928710938
      ],
      [
        -283.0,
        -1979.0,
        721.415283203125
      ],
      [
        -275.0,
        -1979.0,
        720.681884765625
      ],
      [
        -444.48663330078125,
        -2047.226806640625,
        681.3184814453125
      ],
      [
        -187.0,
        -1987.0,
        706.9443969726562
      ],
      [
        -187.0,
        -1979.0,
        712.6160888671875
      ],
      [
        -195.0,
        -1979.0,
        713.3493041992188
      ],
      [
        -195.0,
        -1987.0,
        707.6776123046875
      ],
      [
        -195.0,
        -1987.0,
        707.6776123046875
      ],
      [
        -187.0,
        -1987.0,
        706.9443969726562
      ],
      [
        -195.0,
        -1979.0,
        713.3493041992188
      ],
      [
        -187.0,
        -1979.0,
        712.6160888671875
      ],
      [
        -299.21417236328125,
        -2077.076416015625,
        652.5308227539062
      ],
      [
        -301.4764709472656,
        -2078.49365234375,
        652.572021484375
      ],
      [
        -299.21417236328125,
        -2077.076416015625,
        652.5308227539062
      ],
      [
        -300.9225158691406,
        -2078.300537109375,
        652.658203125
      ],
      [
        -446.5451354980469,
        -2054.210205078125,
        675.1405029296875
      ],
      [
        -465.2196960449219,
        -2067.360107421875,
        675.4734497070312
      ],
      [
        -464.254150390625,
        -2065.688232421875,
        676.5702514648438
      ],
      [
        -216.42385864257812,
        -2083.561767578125,
        641.18310546875
      ],
      [
        -219.54531860351562,
        -2083.32763671875,
        641.6351318359375
      ],
      [
        -295.3524169921875,
        -2077.643798828125,
        652.61328125
      ],
      [
        -299.313232421875,
        -2077.739501953125,
        652.908447265625
      ],
      [
        -299.313232421875,
        -2077.739501953125,
        652.908447265625
      ],
      [
        -454.30517578125,
        -2059.23974609375,
        675.7670288085938
      ],
      [
        -463.8616027832031,
        -2065.008544921875,
        677.0161743164062
      ],
      [
        -451.24322509765625,
        -2043.1591796875,
        691.3499145507812
      ],
      [
        -253.28384399414062,
        -2076.626953125,
        649.47802734375
      ],
      [
        -219.5453338623047,
        -2083.32763671875,
        641.6351318359375
      ],
      [
        -239.5581512451172,
        -2078.29150390625,
        647.0399169921875
      ],
      [
        -253.28384399414062,
        -2076.626953125,
        649.47802734375
      ],
      [
        -239.5581512451172,
        -2078.29150390625,
        647.0399169921875
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        634.9354858398438
      ],
      [
        -65.9526596069336,
        -2067.037109375,
        632.6793823242188
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        633.2328491210938
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        636.5714111328125
      ],
      [
        -98.01828002929688,
        -2071.3681640625,
        637.0621337890625
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        628.3058471679688
      ],
      [
        -92.5,
        -2071.60009765625,
        635.1734008789062
      ],
      [
        -92.20441436767578,
        -2073.7763671875,
        630.4842529296875
      ],
      [
        -92.20441436767578,
        -2073.7763671875,
        628.6817626953125
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        636.5714111328125
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        636.3084106445312
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        636.3084106445312
      ],
      [
        -107.86450958251953,
        -2067.60693359375,
        635.5545043945312
      ],
      [
        -451.24322509765625,
        -2043.1591796875,
        691.3499145507812
      ],
      [
        -97.6234130859375,
        -2050.576416015625,
        653.6791381835938
      ],
      [
        -75.278564453125,
        -2059.573974609375,
        645.2523193359375
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        635.3427734375
      ],
      [
        -66.71080017089844,
        -2066.430419921875,
        639.6060791015625
      ],
      [
        -96.99674224853516,
        -2047.5574951171875,
        652.889892578125
      ],
      [
        -91.90426635742188,
        -2046.26904296875,
        653.6482543945312
      ],
      [
        -90.46661376953125,
        -2047.419677734375,
        655.2613525390625
      ],
      [
        -97.63478088378906,
        -2049.502197265625,
        654.442138671875
      ],
      [
        -79.91655731201172,
        -2049.2119140625,
        653.0237426757812
      ],
      [
        -90.278564453125,
        -2047.364990234375,
        655.2828369140625
      ],
      [
        -90.278564453125,
        -2047.364990234375,
        655.2828369140625
      ],
      [
        -79.41132354736328,
        -2049.59716796875,
        652.7044067382812
      ],
      [
        -79.91655731201172,
        -2049.2119140625,
        653.0237426757812
      ],
      [
        -102.37580871582031,
        -2052.566162109375,
        652.7044067382812
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        648.0020141601562
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        640.0797729492188
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        641.4745483398438
      ],
      [
        -108.2637939453125,
        -2066.781005859375,
        643.1660766601562
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        641.4745483398438
      ],
      [
        -108.26383972167969,
        -2066.781005859375,
        636.3370971679688
      ],
      [
        -102.37580871582031,
        -2052.566162109375,
        652.7044067382812
      ],
      [
        -99.73934173583984,
        -2050.113525390625,
        654.2015991210938
      ],
      [
        -99.73934173583984,
        -2050.113525390625,
        654.2015991210938
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        640.0797729492188
      ],
      [
        -100.58235168457031,
        -2070.30615234375,
        639.9630126953125
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        648.0020141601562
      ],
      [
        -108.91099548339844,
        -2064.0283203125,
        645.1771240234375
      ],
      [
        -108.98356628417969,
        -2065.29248046875,
        644.2874145507812
      ],
      [
        -108.91099548339844,
        -2064.0283203125,
        645.1771240234375
      ],
      [
        -108.98380279541016,
        -2064.7919921875,
        644.642333984375
      ],
      [
        -108.98356628417969,
        -2065.29248046875,
        644.2874145507812
      ],
      [
        -108.98380279541016,
        -2064.7919921875,
        644.642333984375
      ],
      [
        -87.22331237792969,
        -1971.048828125,
        733.6969604492188
      ],
      [
        31.66730499267578,
        -2009.6890869140625,
        720.4949951171875
      ],
      [
        -126.01776885986328,
        -1956.1983642578125,
        737.7685546875
      ],
      [
        -87.22331237792969,
        -1971.048828125,
        733.6969604492188
      ],
      [
        -132.99354553222656,
        -1956.173095703125,
        738.7794189453125
      ],
      [
        -126.01776123046875,
        -1956.1983642578125,
        737.7685546875
      ],
      [
        -499.8879089355469,
        -2015.7177734375,
        798.3612670898438
      ],
      [
        -570.8470458984375,
        -2080.698974609375,
        736.9747924804688
      ],
      [
        -562.6378784179688,
        -2045.0107421875,
        810.5653076171875
      ],
      [
        -499.8879089355469,
        -2015.7177734375,
        798.3612670898438
      ],
      [
        -418.30963134765625,
        -1976.85595703125,
        782.4132080078125
      ],
      [
        -414.0,
        -1972.0,
        781.2753295898438
      ],
      [
        -414.0,
        -1950.0,
        778.9569702148438
      ],
      [
        -406.8780212402344,
        -1972.0,
        778.7999267578125
      ],
      [
        -399.82659912109375,
        -1968.051025390625,
        778.7999267578125
      ],
      [
        -412.91912841796875,
        -1950.0,
        778.7999267578125
      ],
      [
        -406.8780212402344,
        -1972.0,
        778.7999267578125
      ],
      [
        -414.0,
        -1972.0,
        781.2753295898438
      ],
      [
        -408.1163024902344,
        -1972.0,
        780.4204711914062
      ],
      [
        -406.6728515625,
        -1970.0,
        780.0
      ],
      [
        -412.0,
        -1962.6553955078125,
        780.0
      ],
      [
        -412.0,
        -1962.6553955078125,
        780.0
      ],
      [
        -412.0,
        -1970.0,
        780.7739868164062
      ],
      [
        -412.0,
        -1970.0,
        780.7739868164062
      ],
      [
        -406.67291259765625,
        -1970.0,
        780.0
      ],
      [
        -360.0,
        -1939.0,
        769.951904296875
      ],
      [
        -348.0,
        -1928.0,
        767.0492553710938
      ],
      [
        -360.0,
        -1939.0,
        769.951904296875
      ],
      [
        -369.0,
        -1939.0,
        771.2595825195312
      ],
      [
        -348.0,
        -1928.0,
        767.0492553710938
      ],
      [
        -369.0,
        -1947.25,
        772.1290283203125
      ],
      [
        -369.0,
        -1939.0,
        771.2595825195312
      ],
      [
        -369.0,
        -1947.25,
        766.0
      ],
      [
        -369.0,
        -1950.0,
        772.4188232421875
      ],
      [
        -422.5,
        -1939.0,
        779.03271484375
      ],
      [
        -422.5,
        -1950.0,
        780.1919555664062
      ],
      [
        -422.5,
        -1950.0,
        780.1919555664062
      ],
      [
        -414.0,
        -1950.0,
        778.9569091796875
      ],
      [
        -442.0,
        -1928.0,
        780.706787109375
      ],
      [
        -430.0,
        -1939.0,
        780.1223754882812
      ],
      [
        -430.0,
        -1939.0,
        780.1223754882812
      ],
      [
        -422.5,
        -1939.0,
        779.0327758789062
      ],
      [
        -418.30963134765625,
        -1976.85595703125,
        782.4132080078125
      ],
      [
        -407.9463195800781,
        -1972.7974853515625,
        780.4797973632812
      ],
      [
        -405.1982727050781,
        -1972.0,
        778.7999267578125
      ],
      [
        -399.3085632324219,
        -1968.7652587890625,
        778.7999267578125
      ],
      [
        -405.1982727050781,
        -1972.0,
        778.7999267578125
      ],
      [
        -406.2379455566406,
        -1972.0,
        780.1475830078125
      ],
      [
        31.66730499267578,
        -2009.6890869140625,
        720.4949951171875
      ],
      [
        43.42918395996094,
        -2015.640380859375,
        719.4132080078125
      ],
      [
        -223.3677520751953,
        -1955.846435546875,
        751.8756713867188
      ],
      [
        -317.3755187988281,
        -1944.3687744140625,
        764.32470703125
      ],
      [
        -240.9657440185547,
        -1954.890869140625,
        754.3318481445312
      ],
      [
        -240.9657440185547,
        -1954.890869140625,
        754.3318481445312
      ],
      [
        -223.3677520751953,
        -1955.846435546875,
        751.8756713867188
      ],
      [
        -286.0,
        -1951.9654541015625,
        754.0
      ],
      [
        -272.0,
        -1952.9293212890625,
        754.0
      ],
      [
        -272.0,
        -1950.6173095703125,
        758.3905639648438
      ],
      [
        -272.0,
        -1952.9293212890625,
        754.0
      ],
      [
        -286.0,
        -1951.9654541015625,
        754.0
      ],
      [
        -286.0,
        -1948.689453125,
        760.221435546875
      ],
      [
        -355.47674560546875,
        -1950.406005859375,
        770.4967041015625
      ],
      [
        -317.3755187988281,
        -1944.3687744140625,
        764.32470703125
      ],
      [
        -365.4501037597656,
        -1961.25390625,
        762.07080078125
      ],
      [
        -365.3388366699219,
        -1955.880615234375,
        771.4879760742188
      ],
      [
        -365.3388366699219,
        -1955.880615234375,
        771.4879760742188
      ],
      [
        -365.32745361328125,
        -1955.333251953125,
        772.447265625
      ],
      [
        -362.6562194824219,
        -1953.9971923828125,
        771.9183349609375
      ],
      [
        -355.47674560546875,
        -1950.406005859375,
        770.4967041015625
      ],
      [
        -362.6562194824219,
        -1953.9971923828125,
        771.9183349609375
      ],
      [
        -365.4501037597656,
        -1961.25390625,
        762.07080078125
      ],
      [
        -369.1580505371094,
        -1971.7943115234375,
        744.0811767578125
      ],
      [
        -369.1580505371094,
        -1971.7943115234375,
        744.0811767578125
      ],
      [
        -372.4571533203125,
        -1981.1729736328125,
        728.0740966796875
      ],
      [
        -286.0,
        -1959.5802001953125,
        754.0
      ],
      [
        -272.0,
        -1958.47509765625,
        754.0
      ],
      [
        -286.0,
        -1959.5802001953125,
        754.0
      ],
      [
        -286.0,
        -1955.6201171875,
        760.9517822265625
      ],
      [
        -272.0,
        -1955.670654296875,
        758.923095703125
      ],
      [
        -272.0,
        -1958.47509765625,
        754.0
      ],
      [
        -524.2721557617188,
        -2100.602294921875,
        682.9840087890625
      ],
      [
        -570.8470458984375,
        -2080.698974609375,
        736.9747924804688
      ],
      [
        -442.95172119140625,
        -2035.7467041015625,
        695.8450317382812
      ],
      [
        -398.94171142578125,
        -1969.27099609375,
        778.7999267578125
      ],
      [
        -372.4520263671875,
        -1958.8970947265625,
        773.8579711914062
      ],
      [
        -405.90997314453125,
        -1972.0,
        780.0999145507812
      ],
      [
        -372.4520263671875,
        -1958.8970947265625,
        773.8579711914062
      ],
      [
        -365.873291015625,
        -1955.6063232421875,
        772.5553588867188
      ],
      [
        -365.873291015625,
        -1955.6063232421875,
        772.5553588867188
      ],
      [
        -404.598876953125,
        -1972.0,
        778.7999267578125
      ],
      [
        -398.941650390625,
        -1969.2711181640625,
        778.7999267578125
      ],
      [
        -404.598876953125,
        -1972.0,
        778.7999267578125
      ],
      [
        -405.9098205566406,
        -1972.0,
        780.0999145507812
      ],
      [
        -105.77139282226562,
        -1979.2572021484375,
        737.2568969726562
      ],
      [
        -111.8211441040039,
        -2013.17724609375,
        741.7103881835938
      ],
      [
        -98.96548461914062,
        -2058.040283203125,
        665.5609741210938
      ],
      [
        -111.8211441040039,
        -2013.17724609375,
        741.7103881835938
      ],
      [
        -104.87355041503906,
        -2022.8271484375,
        741.7178955078125
      ],
      [
        -80.69474792480469,
        -2059.564208984375,
        657.7044067382812
      ],
      [
        -98.35603332519531,
        -2061.6728515625,
        657.7044067382812
      ],
      [
        -80.6580581665039,
        -2059.573974609375,
        657.6742553710938
      ],
      [
        -80.69474792480469,
        -2059.564208984375,
        657.7044067382812
      ],
      [
        -72.18734741210938,
        -2062.0478515625,
        650.2849731445312
      ],
      [
        -90.278564453125,
        -2047.570068359375,
        655.4723510742188
      ],
      [
        -98.3057632446289,
        -2051.547119140625,
        656.0746459960938
      ],
      [
        -97.63478088378906,
        -2049.502197265625,
        654.442138671875
      ],
      [
        -90.46661376953125,
        -2047.419677734375,
        655.2613525390625
      ],
      [
        -98.3057632446289,
        -2051.547119140625,
        656.0746459960938
      ],
      [
        -76.02014923095703,
        -2061.3642578125,
        652.7044067382812
      ],
      [
        -80.6580581665039,
        -2059.573974609375,
        657.6742553710938
      ],
      [
        -72.18734741210938,
        -2062.0478515625,
        650.2849731445312
      ],
      [
        -73.61585235595703,
        -2061.798583984375,
        651.1747436523438
      ],
      [
        -76.02014923095703,
        -2061.3642578125,
        652.7044067382812
      ],
      [
        -73.61585235595703,
        -2061.798583984375,
        651.1747436523438
      ],
      [
        -98.96548461914062,
        -2058.040283203125,
        665.5609741210938
      ],
      [
        -80.77708435058594,
        -2059.573974609375,
        657.7044067382812
      ],
      [
        -98.96705627441406,
        -2061.745849609375,
        657.7044067382812
      ],
      [
        -100.01698303222656,
        -2062.45703125,
        656.4622192382812
      ],
      [
        -98.96705627441406,
        -2061.745849609375,
        657.7044067382812
      ],
      [
        -300.0,
        -1974.732177734375,
        765.0
      ],
      [
        -273.67132568359375,
        -2032.0,
        765.0
      ],
      [
        -259.6756896972656,
        -2030.328857421875,
        765.0
      ],
      [
        -300.0,
        -1974.732177734375,
        765.0
      ],
      [
        -300.0,
        -2022.0,
        769.9811401367188
      ],
      [
        -273.67132568359375,
        -2032.0,
        765.0
      ],
      [
        -290.0,
        -2032.0,
        769.133544921875
      ],
      [
        -300.0,
        -2022.0,
        769.9811401367188
      ],
      [
        -290.1921691894531,
        -2031.807861328125,
        769.5896606445312
      ],
      [
        -290.0,
        -2032.0,
        769.133544921875
      ],
      [
        -323.5190734863281,
        -1975.51904296875,
        768.5
      ],
      [
        -311.5650939941406,
        -1992.0,
        768.5
      ],
      [
        -325.0,
        -1977.0,
        768.8712158203125
      ],
      [
        -325.0,
        -1987.0,
        769.9249877929688
      ],
      [
        -311.5650939941406,
        -1992.0,
        768.5
      ],
      [
        -320.0,
        -1992.0,
        769.7254638671875
      ],
      [
        -320.0,
        -1992.0,
        769.7254638671875
      ],
      [
        -325.0,
        -1987.0,
        769.9249877929688
      ],
      [
        -325.0,
        -1977.0,
        768.8712158203125
      ],
      [
        -323.5190734863281,
        -1975.51904296875,
        768.5
      ],
      [
        -396.96240234375,
        -1972.0,
        778.7999267578125
      ],
      [
        -396.96240234375,
        -1972.0,
        778.7999267578125
      ],
      [
        -272.0,
        -2013.3367919921875,
        765.0
      ],
      [
        -286.0,
        -1994.0347900390625,
        765.0
      ],
      [
        -283.0,
        -1987.0,
        754.0
      ],
      [
        -275.0,
        -1987.0,
        754.0
      ],
      [
        -275.0,
        -1979.0,
        754.0
      ],
      [
        -283.0,
        -1979.0,
        754.0
      ],
      [
        -275.0,
        -1958.7119140625,
        754.0
      ],
      [
        -283.0,
        -1959.3433837890625,
        754.0
      ],
      [
        -286.0,
        -1987.0,
        754.0
      ],
      [
        -272.0,
        -1987.0,
        754.0
      ],
      [
        -272.0,
        -2083.83984375,
        654.661865234375
      ],
      [
        -286.0,
        -2084.843505859375,
        656.0780639648438
      ],
      [
        -286.0,
        -2077.417724609375,
        651.916259765625
      ],
      [
        -272.0,
        -2077.079345703125,
        650.8728637695312
      ],
      [
        -314.93994140625,
        -2089.174072265625,
        654.2220458984375
      ],
      [
        -300.5304870605469,
        -2085.88525390625,
        657.5479736328125
      ],
      [
        -300.5304870605469,
        -2085.88525390625,
        657.5479736328125
      ],
      [
        -350.6188049316406,
        -2086.93603515625,
        667.9999389648438
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        669.1162109375
      ],
      [
        -350.6188049316406,
        -2086.93603515625,
        667.9999389648438
      ],
      [
        -346.3417663574219,
        -2090.888427734375,
        658.53662109375
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        669.1162109375
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        670.4046630859375
      ],
      [
        -357.9171447753906,
        -2087.807373046875,
        667.9999389648438
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        670.4046630859375
      ],
      [
        -357.9171447753906,
        -2087.807373046875,
        667.9999389648438
      ],
      [
        -360.2325439453125,
        -2091.646728515625,
        660.4451904296875
      ],
      [
        -195.0,
        -1987.0,
        751.0370483398438
      ],
      [
        -187.0,
        -1987.0,
        749.8746337890625
      ],
      [
        -195.0,
        -1979.0,
        750.1940307617188
      ],
      [
        -195.0,
        -1987.0,
        751.0370483398438
      ],
      [
        -187.0,
        -1987.0,
        749.8746337890625
      ],
      [
        -187.0,
        -1979.0,
        749.0316162109375
      ],
      [
        -195.0,
        -1979.0,
        750.1940307617188
      ],
      [
        -187.0,
        -1979.0,
        749.0316162109375
      ],
      [
        -260.7839660644531,
        -2083.035888671875,
        653.5272827148438
      ],
      [
        -235.58065795898438,
        -2082.7275390625,
        647.8012084960938
      ],
      [
        -218.785400390625,
        -2083.685302734375,
        641.5188598632812
      ],
      [
        -235.58065795898438,
        -2082.7275390625,
        647.8012084960938
      ],
      [
        -260.7839660644531,
        -2083.035888671875,
        653.5272827148438
      ],
      [
        -218.78538513183594,
        -2083.685302734375,
        641.5188598632812
      ],
      [
        -103.19319152832031,
        -2064.608642578125,
        652.7044067382812
      ],
      [
        -105.54733276367188,
        -2067.07861328125,
        648.0633544921875
      ],
      [
        -103.19319152832031,
        -2064.608642578125,
        652.7044067382812
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        640.3057250976562
      ],
      [
        -107.14860534667969,
        -2069.031982421875,
        644.3267211914062
      ],
      [
        -107.14860534667969,
        -2069.031982421875,
        644.3267211914062
      ],
      [
        -105.54733276367188,
        -2067.07861328125,
        648.0633544921875
      ],
      [
        -108.2637939453125,
        -2066.781005859375,
        644.2874145507812
      ],
      [
        -108.2637939453125,
        -2066.781005859375,
        643.1660766601562
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        640.3057250976562
      ],
      [
        -427.18609619140625,
        -2372.12451171875,
        825.35693359375
      ],
      [
        -415.3110656738281,
        -2348.869140625,
        821.1808471679688
      ],
      [
        -54.30730056762695,
        -2189.92578125,
        751.9800415039062
      ],
      [
        108.4993896484375,
        -2158.119384765625,
        724.9736938476562
      ],
      [
        115.1250991821289,
        -2156.200927734375,
        723.808837890625
      ],
      [
        110.78500366210938,
        -2156.85595703125,
        724.5084228515625
      ],
      [
        108.4993896484375,
        -2158.119384765625,
        724.9736938476562
      ],
      [
        110.78500366210938,
        -2156.85595703125,
        724.5084228515625
      ],
      [
        -137.87796020507812,
        -2165.193115234375,
        660.0780029296875
      ],
      [
        -133.8499755859375,
        -2167.284912109375,
        669.0949096679688
      ],
      [
        -95.86370849609375,
        -2187.012451171875,
        754.1383056640625
      ],
      [
        -84.30427551269531,
        -2188.33935546875,
        756.1712646484375
      ],
      [
        -94.33013153076172,
        -2187.80908203125,
        757.572021484375
      ],
      [
        -133.8499755859375,
        -2167.284912109375,
        669.0949096679688
      ],
      [
        -95.86370849609375,
        -2187.012451171875,
        754.1383056640625
      ],
      [
        -84.30427551269531,
        -2188.33935546875,
        756.1712646484375
      ],
      [
        -54.30730056762695,
        -2189.92578125,
        751.9800415039062
      ],
      [
        -443.2167053222656,
        -2206.14794921875,
        690.954345703125
      ],
      [
        -393.8412780761719,
        -2220.312255859375,
        760.3947143554688
      ],
      [
        -138.92935180664062,
        -2164.698486328125,
        657.9076538085938
      ],
      [
        -137.87796020507812,
        -2165.193115234375,
        660.0780029296875
      ],
      [
        -105.28976440429688,
        -2166.400146484375,
        652.7044067382812
      ],
      [
        -105.28595733642578,
        -2160.9189453125,
        623.7440795898438
      ],
      [
        -99.88549041748047,
        -2167.778076171875,
        657.7044067382812
      ],
      [
        -99.88970184326172,
        -2171.7001953125,
        677.7044067382812
      ],
      [
        -80.69756317138672,
        -2173.240966796875,
        677.7044067382812
      ],
      [
        -99.88970184326172,
        -2171.7001953125,
        677.7044067382812
      ],
      [
        -81.60009765625,
        -2169.029541015625,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2167.647705078125,
        656.5999755859375
      ],
      [
        -77.42676544189453,
        -2168.998291015625,
        654.677001953125
      ],
      [
        -75.29143524169922,
        -2168.79541015625,
        652.7044067382812
      ],
      [
        -102.34300994873047,
        -2167.15185546875,
        655.4332885742188
      ],
      [
        -105.28976440429688,
        -2166.400146484375,
        652.7044067382812
      ],
      [
        -99.88549041748047,
        -2167.778076171875,
        657.7044067382812
      ],
      [
        -102.34300994873047,
        -2167.15185546875,
        655.4332885742188
      ],
      [
        -139.03753662109375,
        -2164.591064453125,
        657.4825439453125
      ],
      [
        -138.92935180664062,
        -2164.698486328125,
        657.9076538085938
      ],
      [
        -105.28579711914062,
        -2160.685546875,
        623.748779296875
      ],
      [
        -105.28959655761719,
        -2166.156982421875,
        651.650146484375
      ],
      [
        -98.89990234375,
        -2167.640869140625,
        656.5999755859375
      ],
      [
        -102.34597778320312,
        -2167.134765625,
        655.4305419921875
      ],
      [
        -105.28974151611328,
        -2166.36376953125,
        652.7044067382812
      ],
      [
        -101.08056640625,
        -2167.4736328125,
        656.5999755859375
      ],
      [
        -102.34597778320312,
        -2167.134765625,
        655.4305419921875
      ],
      [
        -101.08056640625,
        -2167.465576171875,
        656.5999755859375
      ],
      [
        -77.42860412597656,
        -2168.98779296875,
        654.6787109375
      ],
      [
        -75.29141998291016,
        -2168.772216796875,
        652.7044067382812
      ],
      [
        -105.28974151611328,
        -2166.36376953125,
        652.7044067382812
      ],
      [
        -443.2167053222656,
        -2206.14794921875,
        690.954345703125
      ],
      [
        -471.8010559082031,
        -2204.33740234375,
        673.632568359375
      ],
      [
        -495.31585693359375,
        -2224.67919921875,
        676.4805297851562
      ],
      [
        -139.03756713867188,
        -2164.591064453125,
        657.4825439453125
      ],
      [
        -70.35136413574219,
        -2150.10498046875,
        631.6541748046875
      ],
      [
        -105.28959655761719,
        -2166.156005859375,
        651.6453247070312
      ],
      [
        -105.2795181274414,
        -2151.646240234375,
        623.9295654296875
      ],
      [
        -105.2835693359375,
        -2157.47216796875,
        644.7898559570312
      ],
      [
        26.063024520874023,
        -2132.764404296875,
        606.1185302734375
      ],
      [
        -70.35136413574219,
        -2150.10498046875,
        631.6541748046875
      ],
      [
        -99.877685546875,
        -2160.506591796875,
        657.7044067382812
      ],
      [
        -99.88368225097656,
        -2166.092529296875,
        677.7044067382812
      ],
      [
        -80.69480895996094,
        -2164.060546875,
        677.7044067382812
      ],
      [
        -99.88368225097656,
        -2166.092529296875,
        677.7044067382812
      ],
      [
        -81.60009765625,
        -2158.262451171875,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2160.094482421875,
        656.5999755859375
      ],
      [
        -79.34645080566406,
        -2157.984375,
        656.4575805664062
      ],
      [
        -75.28289794921875,
        -2156.505859375,
        652.7044067382812
      ],
      [
        -83.60009765625,
        -2159.826171875,
        661.4400024414062
      ],
      [
        -86.60009765625,
        -2159.2724609375,
        658.3200073242188
      ],
      [
        -86.60009765625,
        -2159.2724609375,
        658.3200073242188
      ],
      [
        -86.60009765625,
        -2158.7919921875,
        656.5999755859375
      ],
      [
        -105.28510284423828,
        -2159.6826171875,
        652.7044067382812
      ],
      [
        -103.59712219238281,
        -2159.9404296875,
        654.2674560546875
      ],
      [
        -105.28510284423828,
        -2159.6826171875,
        652.7044067382812
      ],
      [
        -99.877685546875,
        -2160.506591796875,
        657.7044067382812
      ],
      [
        -103.59712219238281,
        -2159.9404296875,
        654.2674560546875
      ],
      [
        -214.34085083007812,
        -2179.7744140625,
        774.1619262695312
      ],
      [
        -256.07354736328125,
        -2167.5234375,
        778.934326171875
      ],
      [
        -343.83367919921875,
        -2211.443115234375,
        796.3135986328125
      ],
      [
        -322.5062255859375,
        -2198.047119140625,
        791.80322265625
      ],
      [
        -279.776123046875,
        -2177.188720703125,
        783.396728515625
      ],
      [
        -291.5123291015625,
        -2183.931884765625,
        785.8125
      ],
      [
        -374.12353515625,
        -2196.99365234375,
        745.1763916015625
      ],
      [
        -358.5287780761719,
        -2215.109375,
        787.3297119140625
      ],
      [
        -278.7546691894531,
        -2146.58154296875,
        732.890380859375
      ],
      [
        -256.07354736328125,
        -2167.5234375,
        778.934326171875
      ],
      [
        -260.9525451660156,
        -2166.373291015625,
        779.5220336914062
      ],
      [
        -338.68157958984375,
        -2134.919677734375,
        667.9999389648438
      ],
      [
        -339.2902526855469,
        -2135.194580078125,
        667.9999389648438
      ],
      [
        -390.7622375488281,
        -2160.501220703125,
        667.9999389648438
      ],
      [
        -352.2388916015625,
        -2141.043701171875,
        667.9999389648438
      ],
      [
        -339.2902526855469,
        -2135.194580078125,
        667.9999389648438
      ],
      [
        -318.5453186035156,
        -2125.823974609375,
        667.9999389648438
      ],
      [
        -323.15570068359375,
        -2119.992431640625,
        654.7406005859375
      ],
      [
        -337.6196594238281,
        -2136.82763671875,
        671.9999389648438
      ],
      [
        -317.1545715332031,
        -2127.583251953125,
        671.9999389648438
      ],
      [
        -318.5453186035156,
        -2125.823974609375,
        667.9999389648438
      ],
      [
        -317.1545715332031,
        -2127.583251953125,
        671.9999389648438
      ],
      [
        -470.0794982910156,
        -2204.446533203125,
        674.6758422851562
      ],
      [
        -291.5123291015625,
        -2183.931884765625,
        785.8125
      ],
      [
        -302.4618225097656,
        -2188.997314453125,
        787.9371948242188
      ],
      [
        -343.83367919921875,
        -2211.443115234375,
        796.3135986328125
      ],
      [
        -346.0715026855469,
        -2213.27392578125,
        796.8316650390625
      ],
      [
        -322.5062255859375,
        -2198.047119140625,
        791.80322265625
      ],
      [
        -302.4618225097656,
        -2188.997314453125,
        787.9371948242188
      ],
      [
        -295.6280212402344,
        -2134.0361328125,
        705.10546875
      ],
      [
        -267.2416076660156,
        -2168.66357421875,
        780.6771850585938
      ],
      [
        -279.776123046875,
        -2177.188720703125,
        783.396728515625
      ],
      [
        -298.57379150390625,
        -2128.281982421875,
        692.6564331054688
      ],
      [
        -263.1219177246094,
        -2165.86181640625,
        779.7833251953125
      ],
      [
        -294.19268798828125,
        -2133.64990234375,
        705.6879272460938
      ],
      [
        -337.98492431640625,
        -2136.17138671875,
        671.9999389648438
      ],
      [
        -318.24664306640625,
        -2126.201904296875,
        671.9999389648438
      ],
      [
        -319.56134033203125,
        -2124.538818359375,
        667.9999389648438
      ],
      [
        -318.24664306640625,
        -2126.201904296875,
        671.9999389648438
      ],
      [
        -319.56134033203125,
        -2124.538818359375,
        667.9999389648438
      ],
      [
        -323.8802795410156,
        -2119.075927734375,
        654.859375
      ],
      [
        -338.995849609375,
        -2134.35498046875,
        667.9999389648438
      ],
      [
        -339.6225280761719,
        -2134.67138671875,
        667.9999389648438
      ],
      [
        -339.6225280761719,
        -2134.67138671875,
        667.9999389648438
      ],
      [
        -294.1375732421875,
        -2133.717529296875,
        705.8518676757812
      ],
      [
        -263.1683654785156,
        -2165.850830078125,
        779.7890014648438
      ],
      [
        -267.2416076660156,
        -2168.66357421875,
        780.6771850585938
      ],
      [
        -295.6280212402344,
        -2134.0361328125,
        705.10546875
      ],
      [
        -263.1683654785156,
        -2165.850830078125,
        779.7889404296875
      ],
      [
        -294.1375732421875,
        -2133.717529296875,
        705.8518676757812
      ],
      [
        -361.60101318359375,
        -2140.760986328125,
        671.0536499023438
      ],
      [
        -342.22509765625,
        -2128.552734375,
        667.9999389648438
      ],
      [
        -343.2314147949219,
        -2128.98828125,
        667.9999389648438
      ],
      [
        -395.28857421875,
        -2153.54345703125,
        667.9999389648438
      ],
      [
        -352.11383056640625,
        -2132.8330078125,
        667.9999389648438
      ],
      [
        -343.2314147949219,
        -2128.98828125,
        667.9999389648438
      ],
      [
        -322.9754333496094,
        -2120.220458984375,
        667.9999389648438
      ],
      [
        -328.5599670410156,
        -2113.15673828125,
        660.4235229492188
      ],
      [
        -331.3144836425781,
        -2109.672607421875,
        656.0779418945312
      ],
      [
        -339.98016357421875,
        -2132.58642578125,
        671.9999389648438
      ],
      [
        -320.0271911621094,
        -2123.94970703125,
        671.9999389648438
      ],
      [
        -322.9754333496094,
        -2120.220458984375,
        667.9999389648438
      ],
      [
        -320.0271911621094,
        -2123.94970703125,
        671.9999389648438
      ],
      [
        -348.87811279296875,
        -2148.298583984375,
        683.3890991210938
      ],
      [
        -349.0511474609375,
        -2140.843505859375,
        676.5722045898438
      ],
      [
        -340.4855041503906,
        -2131.678466796875,
        671.9999389648438
      ],
      [
        -321.2221984863281,
        -2122.438232421875,
        671.9999389648438
      ],
      [
        -323.7575378417969,
        -2119.231201171875,
        667.9999389648438
      ],
      [
        -321.2221984863281,
        -2122.438232421875,
        671.9999389648438
      ],
      [
        -323.7575378417969,
        -2119.231201171875,
        667.9999389648438
      ],
      [
        -342.4284973144531,
        -2128.187255859375,
        667.9999389648438
      ],
      [
        -343.43389892578125,
        -2128.66943359375,
        667.9999389648438
      ],
      [
        -343.43389892578125,
        -2128.66943359375,
        667.9999389648438
      ],
      [
        -361.0242004394531,
        -2141.695556640625,
        671.9999389648438
      ],
      [
        -361.60101318359375,
        -2140.760986328125,
        671.0536499023438
      ],
      [
        -359.44903564453125,
        -2140.775146484375,
        671.9999389648438
      ],
      [
        -349.0511474609375,
        -2140.843505859375,
        676.5722045898438
      ],
      [
        -294.19268798828125,
        -2133.64990234375,
        705.6879272460938
      ],
      [
        -396.31500244140625,
        -2151.965576171875,
        667.9999389648438
      ],
      [
        -352.11383056640625,
        -2132.8330078125,
        667.9999389648438
      ],
      [
        -398.08636474609375,
        -2152.732177734375,
        667.9999389648438
      ],
      [
        -418.117919921875,
        -2164.494384765625,
        667.9999389648438
      ],
      [
        -331.7146911621094,
        -2109.166259765625,
        656.1435546875
      ],
      [
        -328.5599670410156,
        -2113.15673828125,
        660.4235229492188
      ],
      [
        -357.05364990234375,
        -2101.909423828125,
        667.9999389648438
      ],
      [
        -359.3388977050781,
        -2101.161865234375,
        667.9999389648438
      ],
      [
        -330.61334228515625,
        -2110.559326171875,
        667.9999389648438
      ],
      [
        -334.1988525390625,
        -2106.024169921875,
        656.5507202148438
      ],
      [
        -358.6918640136719,
        -2099.048583984375,
        660.0830078125
      ],
      [
        -359.3388977050781,
        -2101.161865234375,
        667.9999389648438
      ],
      [
        -325.8546447753906,
        -2116.57861328125,
        667.9999389648438
      ],
      [
        -333.36688232421875,
        -2107.076416015625,
        659.2074584960938
      ],
      [
        -320.403564453125,
        -2113.8994140625,
        667.9999389648438
      ],
      [
        -341.3185119628906,
        -2130.181640625,
        671.9999389648438
      ],
      [
        -322.4370422363281,
        -2120.901611328125,
        671.9999389648438
      ],
      [
        -325.85455322265625,
        -2116.57861328125,
        667.9999389648438
      ],
      [
        -322.4370422363281,
        -2120.901611328125,
        671.9999389648438
      ],
      [
        -356.2543640136719,
        -2103.345703125,
        671.9999389648438
      ],
      [
        -329.36065673828125,
        -2112.143798828125,
        671.9999389648438
      ],
      [
        -330.61334228515625,
        -2110.559326171875,
        667.9999389648438
      ],
      [
        -329.36065673828125,
        -2112.143798828125,
        671.9999389648438
      ],
      [
        115.1250991821289,
        -2156.200927734375,
        723.808837890625
      ],
      [
        138.8248291015625,
        -2079.12548828125,
        712.2431640625
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        636.99072265625
      ],
      [
        -105.2828140258789,
        -2156.387451171875,
        640.90576171875
      ],
      [
        -66.12939453125,
        -2138.030517578125,
        623.2932739257812
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        626.367431640625
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        625.1433715820312
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        629.5436401367188
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        626.367431640625
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        625.1433715820312
      ],
      [
        -92.5,
        -2138.245849609375,
        627.3795776367188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        622.4317016601562
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        625.9423828125
      ],
      [
        -105.2717514038086,
        -2140.4697265625,
        624.153076171875
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        629.5436401367188
      ],
      [
        -105.2717514038086,
        -2140.4697265625,
        630.7153930664062
      ],
      [
        -91.48381042480469,
        -2130.763916015625,
        622.4384765625
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        634.4107666015625
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        636.99072265625
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        631.224609375
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        634.4107666015625
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        631.224609375
      ],
      [
        -334.962646484375,
        -2105.05810546875,
        656.6759033203125
      ],
      [
        -333.6986389160156,
        -2106.656982421875,
        658.1480102539062
      ],
      [
        -335.4600830078125,
        -2104.428955078125,
        656.7574462890625
      ],
      [
        -333.3668212890625,
        -2107.07666015625,
        659.2075805664062
      ],
      [
        -338.6565246582031,
        -2100.3857421875,
        667.9999389648438
      ],
      [
        -332.48297119140625,
        -2108.1943359375,
        671.9999389648438
      ],
      [
        -338.6565246582031,
        -2100.3857421875,
        667.9999389648438
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        663.4459838867188
      ],
      [
        -332.48297119140625,
        -2108.1943359375,
        671.9999389648438
      ],
      [
        -345.8935852050781,
        -2106.735107421875,
        671.9999389648438
      ],
      [
        -348.068359375,
        -2089.29296875,
        662.3568725585938
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        663.4459838867188
      ],
      [
        -360.30859375,
        -2091.77294921875,
        664.4932250976562
      ],
      [
        -359.2984924316406,
        -2090.097900390625,
        663.4928588867188
      ],
      [
        -114.99471282958984,
        -2097.310302734375,
        626.3668212890625
      ],
      [
        -189.77603149414062,
        -2082.166748046875,
        637.3945922851562
      ],
      [
        -128.59849548339844,
        -2162.389404296875,
        653.5570678710938
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        636.0255737304688
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        639.1056518554688
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        632.0427856445312
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        629.813232421875
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        632.0427856445312
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        636.0255737304688
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        629.813232421875
      ],
      [
        -98.66907501220703,
        -2138.747314453125,
        628.624267578125
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        639.1056518554688
      ],
      [
        -105.28356170654297,
        -2157.47216796875,
        644.789794921875
      ],
      [
        -66.12939453125,
        -2138.030517578125,
        630.6048583984375
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        634.22705078125
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        643.8660888671875
      ],
      [
        -105.28394317626953,
        -2158.017578125,
        646.7430419921875
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        642.92138671875
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        643.8660888671875
      ],
      [
        -108.29047393798828,
        -2143.1201171875,
        641.881591796875
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        642.92138671875
      ],
      [
        -108.29047393798828,
        -2143.1201171875,
        634.0918579101562
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        634.22705078125
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        634.9574584960938
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        634.9574584960938
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        638.9500732421875
      ],
      [
        -92.5,
        -2138.245849609375,
        636.5562133789062
      ],
      [
        -92.49179077148438,
        -2138.185302734375,
        636.5319213867188
      ],
      [
        -92.49179077148438,
        -2138.185302734375,
        636.5319213867188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        625.9423828125
      ],
      [
        -92.2044448852539,
        -2136.069580078125,
        635.6824951171875
      ],
      [
        -108.05609130859375,
        -2142.635498046875,
        641.6494750976562
      ],
      [
        -108.05609130859375,
        -2142.635498046875,
        633.66015625
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        640.7797241210938
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        638.9500732421875
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        640.7797241210938
      ],
      [
        -91.99929809570312,
        -2134.559326171875,
        624.9449462890625
      ],
      [
        -91.99929809570312,
        -2134.559326171875,
        635.0760498046875
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        632.4207763671875
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        632.4207763671875
      ],
      [
        -89.30126953125,
        -2127.946044921875,
        632.0200805664062
      ],
      [
        138.8248291015625,
        -2079.12548828125,
        712.2431640625
      ],
      [
        126.47466278076172,
        -2057.659423828125,
        711.775390625
      ],
      [
        -209.0651397705078,
        -2181.046875,
        773.529541015625
      ],
      [
        -214.34085083007812,
        -2179.7744140625,
        774.1619262695312
      ],
      [
        -160.2327880859375,
        -2184.0478515625,
        766.7507934570312
      ],
      [
        -186.70205688476562,
        -2182.421142578125,
        770.4251708984375
      ],
      [
        -137.9745330810547,
        -2185.415771484375,
        763.6610107421875
      ],
      [
        -160.2327880859375,
        -2184.0478515625,
        766.7507934570312
      ],
      [
        -186.70205688476562,
        -2182.421142578125,
        770.4251708984375
      ],
      [
        -209.0651397705078,
        -2181.046875,
        773.529541015625
      ],
      [
        -137.9745330810547,
        -2185.415771484375,
        763.6610107421875
      ],
      [
        -128.04714965820312,
        -2186.02587890625,
        762.282958984375
      ],
      [
        126.47466278076172,
        -2057.659423828125,
        711.775390625
      ],
      [
        -95.67296600341797,
        -2187.738037109375,
        757.7596435546875
      ],
      [
        -128.04714965820312,
        -2186.02587890625,
        762.282958984375
      ],
      [
        -95.67296600341797,
        -2187.738037109375,
        757.7596435546875
      ],
      [
        -90.22783660888672,
        -2043.1693115234375,
        741.733642578125
      ],
      [
        -75.01756286621094,
        -2043.592041015625,
        739.5682983398438
      ],
      [
        -90.22783660888672,
        -2043.1693115234375,
        741.733642578125
      ],
      [
        -80.62570190429688,
        -2059.58642578125,
        657.6395874023438
      ],
      [
        -80.77599334716797,
        -2059.573974609375,
        657.7044067382812
      ],
      [
        -89.7894515991211,
        -2068.95947265625,
        657.7044067382812
      ],
      [
        -91.1700210571289,
        -2068.792724609375,
        657.7044067382812
      ],
      [
        -89.7894515991211,
        -2068.95947265625,
        657.7044067382812
      ],
      [
        -87.16252899169922,
        -2067.871337890625,
        657.7044067382812
      ],
      [
        -98.60052490234375,
        -2067.89599609375,
        655.689453125
      ],
      [
        -91.1700210571289,
        -2068.792724609375,
        657.7044067382812
      ],
      [
        -99.77224731445312,
        -2062.291259765625,
        656.7517700195312
      ],
      [
        -98.60052490234375,
        -2067.89599609375,
        655.689453125
      ],
      [
        -99.77811431884766,
        -2067.75390625,
        654.6559448242188
      ],
      [
        -99.78120422363281,
        -2070.637939453125,
        652.7044067382812
      ],
      [
        -99.78120422363281,
        -2070.637939453125,
        639.056640625
      ],
      [
        -99.78120422363281,
        -2070.637939453125,
        652.7044067382812
      ],
      [
        -99.77953338623047,
        -2069.074951171875,
        654.1490478515625
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        641.2166748046875
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        645.4983520507812
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        645.4983520507812
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        648.5706787109375
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        636.5319213867188
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        641.2166748046875
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        648.5706787109375
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        651.2399291992188
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        630.484375
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        636.5319213867188
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        651.2399291992188
      ],
      [
        -88.47034454345703,
        -2075.322998046875,
        651.2399291992188
      ],
      [
        -99.77953338623047,
        -2069.074951171875,
        654.1490478515625
      ],
      [
        -79.49996948242188,
        -2157.103515625,
        656.5999755859375
      ],
      [
        -79.49918365478516,
        -2155.970947265625,
        656.5999755859375
      ],
      [
        -85.50799560546875,
        -2141.464599609375,
        656.5999755859375
      ],
      [
        -87.5549087524414,
        -2140.61669921875,
        656.5999755859375
      ],
      [
        -98.60043334960938,
        -2141.9501953125,
        655.6896362304688
      ],
      [
        -97.9036636352539,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -99.86359405517578,
        -2147.37841796875,
        656.5999755859375
      ],
      [
        -99.8579330444336,
        -2142.10205078125,
        654.5860595703125
      ],
      [
        -95.24271392822266,
        -2141.544677734375,
        656.5999755859375
      ],
      [
        -97.9036636352539,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -98.60043334960938,
        -2141.9501953125,
        655.6896362304688
      ],
      [
        -79.4952163696289,
        -2150.27197265625,
        656.5999755859375
      ],
      [
        -82.6537094116211,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -79.4952163696289,
        -2150.27197265625,
        656.5999755859375
      ],
      [
        -82.6537094116211,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -90.278564453125,
        -2139.488525390625,
        656.5999755859375
      ],
      [
        -90.278564453125,
        -2139.488525390625,
        656.5999755859375
      ],
      [
        -99.8564224243164,
        -2140.694091796875,
        654.0486450195312
      ],
      [
        -99.8548583984375,
        -2139.238525390625,
        652.7044067382812
      ],
      [
        -99.8548583984375,
        -2139.238525390625,
        652.7044067382812
      ],
      [
        -99.8548583984375,
        -2139.238525390625,
        638.5621948242188
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        645.4983520507812
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        641.2166748046875
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        648.5706787109375
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        645.4983520507812
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        641.2166748046875
      ],
      [
        -92.2044448852539,
        -2136.069580078125,
        636.5319213867188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        651.2399291992188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        648.5706787109375
      ],
      [
        -92.2044448852539,
        -2136.069580078125,
        636.5319213867188
      ],
      [
        -92.2044448852539,
        -2136.069580078125,
        635.6824951171875
      ],
      [
        -88.2706298828125,
        -2136.103759765625,
        651.2399291992188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        651.2399291992188
      ],
      [
        -90.2786636352539,
        -2135.27197265625,
        651.2399291992188
      ],
      [
        -99.8564224243164,
        -2140.694091796875,
        654.0486450195312
      ],
      [
        -91.99927520751953,
        -2134.559326171875,
        645.4983520507812
      ],
      [
        -91.99927520751953,
        -2134.559326171875,
        641.2166748046875
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        648.5706787109375
      ],
      [
        -91.99927520751953,
        -2134.559326171875,
        645.4983520507812
      ],
      [
        -91.99927520751953,
        -2134.559326171875,
        641.2166748046875
      ],
      [
        -91.99929809570312,
        -2134.559326171875,
        636.5319213867188
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        651.2399291992188
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        648.5706787109375
      ],
      [
        -91.99929809570312,
        -2134.559326171875,
        636.5319213867188
      ],
      [
        -91.99929809570312,
        -2134.559326171875,
        635.0760498046875
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        651.2399291992188
      ],
      [
        -79.49722290039062,
        -2153.1533203125,
        656.5999755859375
      ],
      [
        -84.69074249267578,
        -2142.99853515625,
        659.7044067382812
      ],
      [
        -91.48558807373047,
        -2141.183837890625,
        659.7044067382812
      ],
      [
        -98.33621978759766,
        -2146.5771484375,
        659.7044067382812
      ],
      [
        -97.0795669555664,
        -2146.0439453125,
        659.7044067382812
      ],
      [
        -82.05598449707031,
        -2144.08984375,
        656.5999755859375
      ],
      [
        -88.835693359375,
        -2140.086181640625,
        656.5999755859375
      ],
      [
        -96.46065521240234,
        -2142.04931640625,
        656.5999755859375
      ],
      [
        -108.05611419677734,
        -2142.635498046875,
        644.2874145507812
      ],
      [
        -108.05611419677734,
        -2142.635498046875,
        641.6494750976562
      ],
      [
        -106.26387786865234,
        -2067.95263671875,
        646.3912353515625
      ],
      [
        -415.3110656738281,
        -2348.869140625,
        821.1808471679688
      ],
      [
        -370.31365966796875,
        -2233.106689453125,
        802.4439086914062
      ],
      [
        -370.31365966796875,
        -2233.106689453125,
        802.4439086914062
      ],
      [
        -258.4636535644531,
        -2032.0,
        765.0
      ],
      [
        -290.0,
        -2032.0,
        769.5819702148438
      ],
      [
        -258.4636535644531,
        -2032.0,
        765.0
      ],
      [
        -290.0,
        -2032.0,
        769.5819702148438
      ],
      [
        -597.4422607421875,
        -2061.258056640625,
        817.3342895507812
      ],
      [
        -4203.63427734375,
        -2623.38720703125,
        1400.5242919921875
      ],
      [
        -3970.641357421875,
        -3262.205078125,
        1433.9918212890625
      ],
      [
        -3970.641357421875,
        -3262.205078125,
        1433.9918212890625
      ],
      [
        -3963.7255859375,
        -3278.16796875,
        1434.669189453125
      ],
      [
        -306.4415588378906,
        -2983.1630859375,
        1431.283447265625
      ],
      [
        -234.2976531982422,
        -3017.2685546875,
        865.3178100585938
      ],
      [
        -306.5951843261719,
        -2982.99560546875,
        1431.225341796875
      ],
      [
        -955.45703125,
        -2167.037841796875,
        942.2494506835938
      ],
      [
        -960.8914794921875,
        -2159.280517578125,
        880.4703979492188
      ],
      [
        -698.2745361328125,
        -2408.3671875,
        1479.6412353515625
      ],
      [
        -502.1300354003906,
        -2816.757568359375,
        1479.110595703125
      ],
      [
        -495.6846008300781,
        -2819.032470703125,
        1478.0430908203125
      ],
      [
        -732.7146606445312,
        -2333.082275390625,
        1138.8837890625
      ],
      [
        -783.6495361328125,
        -2253.353515625,
        974.8693237304688
      ],
      [
        -781.6626586914062,
        -2256.458740234375,
        999.04052734375
      ],
      [
        -783.6495361328125,
        -2253.353515625,
        974.869384765625
      ],
      [
        -787.0260009765625,
        -2248.078125,
        929.305419921875
      ],
      [
        -787.0260009765625,
        -2248.078125,
        929.305419921875
      ],
      [
        -792.2826538085938,
        -2239.86328125,
        864.4647827148438
      ],
      [
        -779.03271484375,
        -2261.742919921875,
        1062.635009765625
      ],
      [
        -779.9501342773438,
        -2259.135009765625,
        1019.874267578125
      ],
      [
        -733.7510375976562,
        -2332.29296875,
        1165.0404052734375
      ],
      [
        -733.7015380859375,
        -2332.1337890625,
        1156.9876708984375
      ],
      [
        -733.4498291015625,
        -2333.14013671875,
        1178.760986328125
      ],
      [
        -733.7510375976562,
        -2332.29296875,
        1165.040283203125
      ],
      [
        -732.7146606445312,
        -2333.082275390625,
        1138.8837890625
      ],
      [
        -733.7015380859375,
        -2332.1337890625,
        1156.9876708984375
      ],
      [
        -733.4498291015625,
        -2333.14013671875,
        1178.760986328125
      ],
      [
        -758.3310546875,
        -2310.554931640625,
        866.9813842773438
      ],
      [
        -779.03271484375,
        -2261.742919921875,
        1062.635009765625
      ],
      [
        -777.7199096679688,
        -2262.626220703125,
        1025.4935302734375
      ],
      [
        -774.6851196289062,
        -2267.39453125,
        972.22314453125
      ],
      [
        -774.6851196289062,
        -2267.39453125,
        972.22314453125
      ],
      [
        -771.3636474609375,
        -2272.616455078125,
        902.14453125
      ],
      [
        -770.5025634765625,
        -2273.9755859375,
        864.8950805664062
      ],
      [
        -773.9361572265625,
        -2268.5849609375,
        910.4217529296875
      ],
      [
        -771.3636474609375,
        -2272.616455078125,
        902.14453125
      ],
      [
        -773.9361572265625,
        -2268.5849609375,
        910.4217529296875
      ],
      [
        -781.3290405273438,
        -2254.945068359375,
        946.2813720703125
      ],
      [
        -783.2191162109375,
        -2249.745849609375,
        864.1893310546875
      ],
      [
        -772.17138671875,
        -2266.23876953125,
        864.3222045898438
      ],
      [
        -774.7032470703125,
        -2264.4326171875,
        932.4190063476562
      ],
      [
        -774.7032470703125,
        -2264.4326171875,
        932.4190063476562
      ],
      [
        -775.7066650390625,
        -2263.272216796875,
        944.0588989257812
      ],
      [
        -775.0943603515625,
        -2264.15380859375,
        942.9470825195312
      ],
      [
        -775.7066650390625,
        -2263.272216796875,
        944.0588989257812
      ],
      [
        -771.7664794921875,
        -2271.985107421875,
        903.4407348632812
      ],
      [
        -775.6288452148438,
        -2264.033447265625,
        966.3348388671875
      ],
      [
        -774.9893798828125,
        -2264.304931640625,
        942.7564086914062
      ],
      [
        -775.6288452148438,
        -2264.033447265625,
        966.3348388671875
      ],
      [
        -774.9893798828125,
        -2264.304931640625,
        942.7564086914062
      ],
      [
        -781.0300903320312,
        -2256.06494140625,
        969.5385131835938
      ],
      [
        -781.0300903320312,
        -2256.06494140625,
        969.53857421875
      ],
      [
        -781.3290405273438,
        -2254.945068359375,
        946.2813720703125
      ],
      [
        -718.0658569335938,
        -2356.0107421875,
        1190.5318603515625
      ],
      [
        -732.9428100585938,
        -2332.720458984375,
        1154.5731201171875
      ],
      [
        -733.1166381835938,
        -2332.73046875,
        1164.033935546875
      ],
      [
        -718.0658569335938,
        -2356.0107421875,
        1190.5318603515625
      ],
      [
        -778.4437866210938,
        -2261.489013671875,
        1038.20166015625
      ],
      [
        -779.9501342773438,
        -2259.135009765625,
        1019.874267578125
      ],
      [
        -778.4437866210938,
        -2261.489013671875,
        1038.20166015625
      ],
      [
        -777.7199096679688,
        -2262.626220703125,
        1025.4935302734375
      ],
      [
        -732.9428100585938,
        -2332.720458984375,
        1154.5731201171875
      ],
      [
        -733.1773681640625,
        -2332.494140625,
        1158.9423828125
      ],
      [
        -733.1166381835938,
        -2332.73046875,
        1164.033935546875
      ],
      [
        -733.188232421875,
        -2332.5322265625,
        1160.8394775390625
      ],
      [
        -733.188232421875,
        -2332.5322265625,
        1160.839599609375
      ],
      [
        -733.1773681640625,
        -2332.494140625,
        1158.9423828125
      ],
      [
        -779.7763061523438,
        -2256.816650390625,
        950.9082641601562
      ],
      [
        -781.840576171875,
        -2251.2490234375,
        864.1474609375
      ],
      [
        -772.4083862304688,
        -2265.36767578125,
        864.2648315429688
      ],
      [
        -775.2893676757812,
        -2263.2548828125,
        941.2236938476562
      ],
      [
        -775.2893676757812,
        -2263.2548828125,
        941.2236938476562
      ],
      [
        -775.980712890625,
        -2262.449951171875,
        949.26513671875
      ],
      [
        -775.5611572265625,
        -2263.055419921875,
        948.4863891601562
      ],
      [
        -775.980712890625,
        -2262.449951171875,
        949.26513671875
      ],
      [
        -775.0943603515625,
        -2264.15380859375,
        942.9470825195312
      ],
      [
        -778.0450439453125,
        -2261.486328125,
        1023.680419921875
      ],
      [
        -775.9306640625,
        -2262.95849609375,
        964.4517822265625
      ],
      [
        -778.34228515625,
        -2261.6484375,
        1036.4193115234375
      ],
      [
        -775.9306640625,
        -2262.95849609375,
        964.4517822265625
      ],
      [
        -775.4889526367188,
        -2263.15966796875,
        948.3524169921875
      ],
      [
        -775.4889526367188,
        -2263.15966796875,
        948.3524169921875
      ],
      [
        -778.195068359375,
        -2261.3818359375,
        1027.882080078125
      ],
      [
        -779.5615234375,
        -2257.5849609375,
        966.5499267578125
      ],
      [
        -779.5615234375,
        -2257.5849609375,
        966.5499267578125
      ],
      [
        -779.7763061523438,
        -2256.816650390625,
        950.9082641601562
      ],
      [
        -778.195068359375,
        -2261.3818359375,
        1027.882080078125
      ],
      [
        -775.5611572265625,
        -2263.055419921875,
        948.4863891601562
      ],
      [
        -778.0450439453125,
        -2261.486328125,
        1023.680419921875
      ],
      [
        -477.7598571777344,
        -2825.35888671875,
        1475.0743408203125
      ],
      [
        -467.463623046875,
        -2820.6962890625,
        1405.229248046875
      ],
      [
        -458.1455383300781,
        -2820.93603515625,
        1363.39306640625
      ],
      [
        -467.463623046875,
        -2820.6962890625,
        1405.229248046875
      ],
      [
        -351.9558410644531,
        -2913.74560546875,
        1384.2762451171875
      ],
      [
        -430.2678527832031,
        -2830.660888671875,
        1347.227294921875
      ],
      [
        -424.3450622558594,
        -2839.9580078125,
        1431.2955322265625
      ],
      [
        -420.02252197265625,
        -2845.73681640625,
        1465.511474609375
      ],
      [
        -424.3450622558594,
        -2839.9580078125,
        1431.2955322265625
      ],
      [
        -360.3669128417969,
        -2906.77197265625,
        1432.8883056640625
      ],
      [
        -351.9558410644531,
        -2913.74560546875,
        1384.2762451171875
      ],
      [
        -423.2952880859375,
        -2833.09326171875,
        1343.18408203125
      ],
      [
        -418.51580810546875,
        -2842.56201171875,
        1434.8194580078125
      ],
      [
        -352.0573425292969,
        -2913.139892578125,
        1383.491943359375
      ],
      [
        -415.3899230957031,
        -2847.371826171875,
        1464.744140625
      ],
      [
        -418.51580810546875,
        -2842.56201171875,
        1434.8194580078125
      ],
      [
        -360.6916809082031,
        -2905.960205078125,
        1433.3387451171875
      ],
      [
        -352.0573425292969,
        -2913.139892578125,
        1383.491943359375
      ],
      [
        -48.03181457519531,
        -1978.7965087890625,
        796.4478759765625
      ],
      [
        64.1333999633789,
        -2033.82958984375,
        1080.0
      ],
      [
        -48.64229202270508,
        -1978.221923828125,
        794.5711059570312
      ],
      [
        -48.03181457519531,
        -1978.7965087890625,
        796.4478759765625
      ],
      [
        -48.64228820800781,
        -1978.221923828125,
        794.5711059570312
      ],
      [
        -17.906230926513672,
        -1993.577392578125,
        725.9998168945312
      ],
      [
        -49.43186950683594,
        -1978.1094970703125,
        792.9083862304688
      ],
      [
        131.89161682128906,
        -2067.07470703125,
        711.9805908203125
      ],
      [
        -65.38192749023438,
        -2204.348876953125,
        855.09765625
      ],
      [
        -82.27347564697266,
        -2206.352783203125,
        847.1929321289062
      ],
      [
        -65.38194274902344,
        -2204.348876953125,
        855.09765625
      ],
      [
        -178.07568359375,
        -2239.39990234375,
        861.0
      ],
      [
        -125.63127136230469,
        -2221.324462890625,
        861.0
      ],
      [
        -174.511474609375,
        -2233.716796875,
        861.0
      ],
      [
        -212.53125,
        -2294.34033203125,
        861.0
      ],
      [
        -178.07568359375,
        -2239.39990234375,
        861.0
      ],
      [
        -233.00991821289062,
        -2297.300048828125,
        825.0
      ],
      [
        -232.45169067382812,
        -2297.300048828125,
        826.0791015625
      ],
      [
        -227.06105041503906,
        -2297.300048828125,
        836.5
      ],
      [
        -227.94046020507812,
        -2297.300048828125,
        834.7999877929688
      ],
      [
        -217.74984741210938,
        -2297.300048828125,
        854.5
      ],
      [
        -227.06105041503906,
        -2297.300048828125,
        836.5
      ],
      [
        -217.74984741210938,
        -2297.300048828125,
        854.5
      ],
      [
        -216.45657348632812,
        -2297.300048828125,
        857.0
      ],
      [
        -95.5,
        -2297.300048828125,
        825.0
      ],
      [
        -85.5,
        -2297.300048828125,
        825.0
      ],
      [
        -115.5,
        -2297.300048828125,
        825.0
      ],
      [
        -95.5,
        -2297.300048828125,
        825.0
      ],
      [
        -241.0,
        -2310.040283203125,
        824.9999389648438
      ],
      [
        -242.22906494140625,
        -2312.0,
        824.9999389648438
      ],
      [
        -210.5,
        -2371.5,
        825.0
      ],
      [
        -195.5,
        -2371.5,
        825.0
      ],
      [
        -233.800048828125,
        -2300.1767578125,
        826.9600219726562
      ],
      [
        -232.45169067382812,
        -2297.300048828125,
        826.0791015625
      ],
      [
        -242.2290496826172,
        -2312.0,
        824.9999389648438
      ],
      [
        -241.0,
        -2312.0,
        827.3758544921875
      ],
      [
        -233.800048828125,
        -2305.026611328125,
        832.8400268554688
      ],
      [
        -233.800048828125,
        -2300.1767578125,
        826.9600219726562
      ],
      [
        -228.0,
        -2311.300048828125,
        834.7999877929688
      ],
      [
        -228.0,
        -2311.300048828125,
        825.0
      ],
      [
        -230.800048828125,
        -2301.85986328125,
        834.7999877929688
      ],
      [
        -233.800048828125,
        -2305.026611328125,
        832.8400268554688
      ],
      [
        -198.0,
        -2371.5,
        825.0
      ],
      [
        -198.0,
        -2371.5,
        838.0
      ],
      [
        -85.5,
        -2297.300048828125,
        833.5
      ],
      [
        -95.5,
        -2297.300048828125,
        836.5
      ],
      [
        -85.5,
        -2297.300048828125,
        825.0
      ],
      [
        -85.5,
        -2297.300048828125,
        833.5
      ],
      [
        -216.45657348632812,
        -2297.300048828125,
        857.0
      ],
      [
        -214.60037231445312,
        -2294.34033203125,
        857.0
      ],
      [
        -214.60037231445312,
        -2294.34033203125,
        857.0
      ],
      [
        -212.53126525878906,
        -2294.34033203125,
        861.0
      ],
      [
        -145.5,
        -2240.5,
        857.0
      ],
      [
        -145.5,
        -2291.0,
        857.0
      ],
      [
        -132.5,
        -2291.0,
        857.0
      ],
      [
        -132.5,
        -2240.5,
        857.0
      ],
      [
        -132.5,
        -2240.5,
        857.0
      ],
      [
        -145.5,
        -2240.5,
        857.0
      ],
      [
        -125.63127136230469,
        -2221.324462890625,
        861.0
      ],
      [
        -125.82259368896484,
        -2220.219970703125,
        857.0
      ],
      [
        -171.0,
        -2291.0,
        857.0
      ],
      [
        -171.0,
        -2240.5,
        857.0
      ],
      [
        -184.0,
        -2245.546875,
        857.0
      ],
      [
        -184.0,
        -2246.371826171875,
        858.0
      ],
      [
        -184.0,
        -2291.0,
        857.0
      ],
      [
        -171.0,
        -2240.5,
        857.0
      ],
      [
        -180.3175506591797,
        -2240.5,
        858.0
      ],
      [
        -180.8348388671875,
        -2240.5,
        857.0
      ],
      [
        -209.0,
        -2291.0,
        857.0
      ],
      [
        -209.0,
        -2286.235107421875,
        858.0
      ],
      [
        -209.0,
        -2285.41015625,
        857.0
      ],
      [
        -233.00991821289062,
        -2297.300048828125,
        825.0
      ],
      [
        -231.15370178222656,
        -2294.34033203125,
        825.0
      ],
      [
        -160.0,
        -2219.661376953125,
        825.0
      ],
      [
        -129.6967010498047,
        -2211.97900390625,
        825.0
      ],
      [
        -127.32233428955078,
        -2211.562744140625,
        825.0
      ],
      [
        -160.0,
        -2219.661376953125,
        825.0
      ],
      [
        -196.69815063476562,
        -2239.39990234375,
        825.0
      ],
      [
        -188.91696166992188,
        -2226.99267578125,
        825.0
      ],
      [
        -196.69815063476562,
        -2239.39990234375,
        825.0
      ],
      [
        -197.5,
        -2240.678466796875,
        825.0
      ],
      [
        -197.5,
        -2240.678466796875,
        825.0
      ],
      [
        -231.15370178222656,
        -2294.34033203125,
        825.0
      ],
      [
        -158.0,
        -2217.375732421875,
        818.82861328125
      ],
      [
        -166.52584838867188,
        -2219.5,
        818.7000122070312
      ],
      [
        -158.0,
        -2219.5,
        818.7000122070312
      ],
      [
        -117.70906066894531,
        -2219.5,
        825.0
      ],
      [
        -119.62408447265625,
        -2210.213623046875,
        825.0
      ],
      [
        -121.76889038085938,
        -2209.8974609375,
        819.28125
      ],
      [
        -121.76889038085938,
        -2209.8974609375,
        819.28125
      ],
      [
        -124.5,
        -2210.372802734375,
        819.2525024414062
      ],
      [
        -124.5,
        -2219.5,
        818.7000122070312
      ],
      [
        -142.3841094970703,
        -2213.484619140625,
        819.0640869140625
      ],
      [
        -124.5,
        -2289.84033203125,
        814.4425659179688
      ],
      [
        -128.0,
        -2292.5,
        814.2816162109375
      ],
      [
        -158.0,
        -2289.84033203125,
        814.4425659179688
      ],
      [
        -155.0,
        -2292.5,
        814.2816162109375
      ],
      [
        -120.56061553955078,
        -2264.300048828125,
        855.0
      ],
      [
        -119.3484878540039,
        -2264.300048828125,
        845.0
      ],
      [
        -120.56061553955078,
        -2287.300048828125,
        855.0
      ],
      [
        -119.3484878540039,
        -2287.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2287.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2292.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2264.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2269.300048828125,
        845.0
      ],
      [
        -120.56061553955078,
        -2239.300048828125,
        855.0
      ],
      [
        -119.3484878540039,
        -2239.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2239.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2244.300048828125,
        845.0
      ],
      [
        -113.52716827392578,
        -2219.5,
        836.5
      ],
      [
        -114.96053314208984,
        -2211.69677734375,
        836.9834594726562
      ],
      [
        -115.15491485595703,
        -2211.606689453125,
        836.5
      ],
      [
        -120.9000015258789,
        -2264.300048828125,
        855.0
      ],
      [
        -120.50000762939453,
        -2264.300048828125,
        854.5
      ],
      [
        -120.9000015258789,
        -2287.300048828125,
        855.0
      ],
      [
        -120.50000762939453,
        -2287.300048828125,
        854.5
      ],
      [
        -120.9000015258789,
        -2239.300048828125,
        855.0
      ],
      [
        -120.50000762939453,
        -2239.300048828125,
        854.5
      ],
      [
        -182.38668823242188,
        -2240.5,
        854.0
      ],
      [
        -184.0,
        -2243.072509765625,
        854.0
      ],
      [
        -214.0574188232422,
        -2291.0,
        854.0
      ],
      [
        -209.0,
        -2282.935791015625,
        854.0
      ],
      [
        -184.0,
        -2243.072509765625,
        854.0
      ],
      [
        -182.38668823242188,
        -2240.5,
        854.0
      ],
      [
        -209.0,
        -2282.935791015625,
        854.0
      ],
      [
        -122.89964294433594,
        -2214.002685546875,
        838.0
      ],
      [
        -124.02630615234375,
        -2219.0439453125,
        854.5
      ],
      [
        -119.36579895019531,
        -2239.300048828125,
        845.0
      ],
      [
        -120.5204086303711,
        -2239.300048828125,
        854.5255126953125
      ],
      [
        -119.36579895019531,
        -2239.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2239.39990234375,
        845.0
      ],
      [
        -122.97138977050781,
        -2213.58837890625,
        836.5
      ],
      [
        -122.89964294433594,
        -2214.002685546875,
        838.0
      ],
      [
        -124.02630615234375,
        -2219.0439453125,
        854.5
      ],
      [
        -125.82259368896484,
        -2220.219970703125,
        857.0
      ],
      [
        -120.91727447509766,
        -2239.300048828125,
        855.0
      ],
      [
        -120.517333984375,
        -2239.300048828125,
        854.5001220703125
      ],
      [
        -127.32233428955078,
        -2211.562744140625,
        825.0
      ],
      [
        -126.844482421875,
        -2211.640625,
        826.3350219726562
      ],
      [
        -122.97138977050781,
        -2213.58837890625,
        836.5
      ],
      [
        -117.47883605957031,
        -2210.530029296875,
        830.7199096679688
      ],
      [
        -118.0,
        -2252.099853515625,
        831.6123657226562
      ],
      [
        -118.0,
        -2250.71923828125,
        832.2999877929688
      ],
      [
        -118.0,
        -2250.71923828125,
        832.2999877929688
      ],
      [
        -118.0,
        -2242.2861328125,
        836.5
      ],
      [
        -118.0,
        -2294.34033203125,
        836.5
      ],
      [
        -118.0,
        -2294.34033203125,
        825.0
      ],
      [
        -75.20256805419922,
        -2188.82080078125,
        754.8995361328125
      ],
      [
        -82.27347564697266,
        -2206.352783203125,
        847.1929321289062
      ],
      [
        -85.23542785644531,
        -2204.010009765625,
        836.4595336914062
      ],
      [
        -122.04180908203125,
        -2208.415771484375,
        819.3709106445312
      ],
      [
        -122.04180908203125,
        -2208.415771484375,
        819.3709106445312
      ],
      [
        -127.35315704345703,
        -2211.384765625,
        825.0
      ],
      [
        -127.35315704345703,
        -2211.384765625,
        825.0
      ],
      [
        109.38591766357422,
        -2157.62939453125,
        724.793212890625
      ],
      [
        119.41747283935547,
        -2124.32177734375,
        739.994140625
      ],
      [
        127.53102111816406,
        -2115.854736328125,
        717.754638671875
      ],
      [
        119.41747283935547,
        -2124.32177734375,
        739.994140625
      ],
      [
        114.55083465576172,
        -2156.28759765625,
        723.9014282226562
      ],
      [
        -93.01200103759766,
        -2197.859130859375,
        808.2791137695312
      ],
      [
        -87.60077667236328,
        -2202.13916015625,
        827.8881225585938
      ],
      [
        -106.53463745117188,
        -2187.16357421875,
        759.2772216796875
      ],
      [
        -93.01200103759766,
        -2197.859130859375,
        808.2791137695312
      ],
      [
        -87.60077667236328,
        -2202.13916015625,
        827.8881225585938
      ],
      [
        135.55726623535156,
        -2073.446044921875,
        712.1194458007812
      ],
      [
        -122.41246032714844,
        -2206.403564453125,
        819.49267578125
      ],
      [
        -168.10545349121094,
        -2212.80126953125,
        819.10546875
      ],
      [
        -186.154296875,
        -2217.491455078125,
        818.8215942382812
      ],
      [
        -187.47689819335938,
        -2219.5,
        818.7000122070312
      ],
      [
        -126.46916198730469,
        -2216.487548828125,
        861.0
      ],
      [
        -171.14169311523438,
        -2228.343505859375,
        861.0
      ],
      [
        -86.32891845703125,
        -2208.73486328125,
        861.0
      ],
      [
        -73.71690368652344,
        -2206.524169921875,
        861.0
      ],
      [
        -88.2540283203125,
        -2208.580322265625,
        861.0
      ],
      [
        -86.32891845703125,
        -2208.73486328125,
        861.0
      ],
      [
        -160.0,
        -2212.723388671875,
        825.0
      ],
      [
        -159.4060821533203,
        -2212.565673828125,
        825.0
      ],
      [
        -127.92001342773438,
        -2208.112548828125,
        825.0
      ],
      [
        -160.0,
        -2212.723388671875,
        825.0
      ],
      [
        -183.9552459716797,
        -2219.0810546875,
        825.0
      ],
      [
        -120.28020477294922,
        -2207.03173828125,
        825.0
      ],
      [
        -122.41246032714844,
        -2206.403564453125,
        819.49267578125
      ],
      [
        -119.7785873413086,
        -2209.46435546875,
        825.0
      ],
      [
        -85.23542785644531,
        -2204.010009765625,
        836.4595336914062
      ],
      [
        -123.64456176757812,
        -2209.70263671875,
        838.0
      ],
      [
        -124.59519958496094,
        -2211.625244140625,
        848.5906982421875
      ],
      [
        -124.93572235107422,
        -2213.794189453125,
        854.5
      ],
      [
        -115.61882019042969,
        -2208.4052734375,
        837.0397338867188
      ],
      [
        -127.92001342773438,
        -2208.112548828125,
        825.0
      ],
      [
        -123.68737030029297,
        -2209.455322265625,
        836.5
      ],
      [
        -126.46916198730469,
        -2216.487548828125,
        861.0
      ],
      [
        -126.70217895507812,
        -2215.142578125,
        857.0
      ],
      [
        -124.93572235107422,
        -2213.794189453125,
        854.5
      ],
      [
        -126.70217895507812,
        -2215.142578125,
        857.0
      ],
      [
        -123.68737030029297,
        -2209.455322265625,
        836.5
      ],
      [
        -123.64456176757812,
        -2209.70263671875,
        838.0
      ],
      [
        -137.57774353027344,
        -2185.76123046875,
        765.2666625976562
      ],
      [
        -138.2781219482422,
        -2185.397216796875,
        763.703125
      ],
      [
        -137.57774353027344,
        -2185.76123046875,
        765.2666625976562
      ],
      [
        -123.37515258789062,
        -2201.177490234375,
        819.8090209960938
      ],
      [
        -128.56640625,
        -2204.381103515625,
        825.0
      ],
      [
        -121.22843933105469,
        -2202.43359375,
        825.0
      ],
      [
        -123.37515258789062,
        -2201.177490234375,
        819.8090209960938
      ],
      [
        -120.28020477294922,
        -2207.03173828125,
        825.0
      ],
      [
        -116.22789764404297,
        -2205.35986328125,
        837.0918579101562
      ],
      [
        -128.56640625,
        -2204.381103515625,
        825.0
      ],
      [
        -124.07225799560547,
        -2207.233642578125,
        836.5
      ],
      [
        -123.98490905761719,
        -2207.738037109375,
        838.0
      ],
      [
        -124.07225799560547,
        -2207.233642578125,
        836.5
      ],
      [
        -123.98490905761719,
        -2207.738037109375,
        838.0
      ],
      [
        -170.35752868652344,
        -2193.500732421875,
        820.2736206054688
      ],
      [
        -187.56568908691406,
        -2183.116943359375,
        774.4188842773438
      ],
      [
        -187.56568908691406,
        -2183.116943359375,
        774.4188842773438
      ],
      [
        -188.94747924804688,
        -2182.283203125,
        770.7368774414062
      ],
      [
        -154.5896759033203,
        -2206.3720703125,
        866.360107421875
      ],
      [
        -124.04472351074219,
        -2197.542724609375,
        820.029052734375
      ],
      [
        -170.35745239257812,
        -2193.50048828125,
        820.273681640625
      ],
      [
        -128.4463348388672,
        -2205.07421875,
        861.0
      ],
      [
        -148.3314971923828,
        -2203.318359375,
        861.0
      ],
      [
        -155.38954162597656,
        -2203.226318359375,
        861.0
      ],
      [
        -160.0,
        -2195.32861328125,
        825.0
      ],
      [
        -129.67066955566406,
        -2198.0068359375,
        825.0
      ],
      [
        -160.0,
        -2195.32861328125,
        825.0
      ],
      [
        -168.5838623046875,
        -2194.57080078125,
        825.0
      ],
      [
        -122.00171661376953,
        -2198.68408203125,
        825.0
      ],
      [
        -124.04472351074219,
        -2197.542724609375,
        820.029052734375
      ],
      [
        -121.22843933105469,
        -2202.43359375,
        825.0
      ],
      [
        -125.16641998291016,
        -2200.917724609375,
        838.0
      ],
      [
        -126.63630676269531,
        -2203.9775390625,
        854.5
      ],
      [
        -117.00476837158203,
        -2201.4755859375,
        837.1583251953125
      ],
      [
        -129.67066955566406,
        -2198.0068359375,
        825.0
      ],
      [
        -125.21743774414062,
        -2200.623046875,
        836.5
      ],
      [
        -128.4463348388672,
        -2205.07421875,
        861.0
      ],
      [
        -128.5823974609375,
        -2204.288818359375,
        857.0
      ],
      [
        -126.63630676269531,
        -2203.9775390625,
        854.5
      ],
      [
        -128.5823974609375,
        -2204.288818359375,
        857.0
      ],
      [
        -125.21743774414062,
        -2200.623046875,
        836.5
      ],
      [
        -125.16641998291016,
        -2200.917724609375,
        838.0
      ],
      [
        -155.07388305664062,
        -2202.722900390625,
        861.0
      ],
      [
        -78.03412628173828,
        -1974.035400390625,
        732.6765747070312
      ],
      [
        -84.4427490234375,
        -2033.323486328125,
        792.1666259765625
      ],
      [
        -69.78466796875,
        -2028.850341796875,
        815.0797729492188
      ],
      [
        -84.4427490234375,
        -2033.323486328125,
        792.1666259765625
      ],
      [
        -104.38338470458984,
        -2023.5079345703125,
        741.7183837890625
      ],
      [
        -162.45565795898438,
        -2181.5,
        821.0
      ],
      [
        -166.02816772460938,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -166.02816772460938,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -160.38650512695312,
        -2181.5,
        825.0
      ],
      [
        -162.45565795898438,
        -2181.5,
        821.0
      ],
      [
        -139.69480895996094,
        -2181.5,
        865.0
      ],
      [
        -143.83319091796875,
        -2181.5,
        857.0
      ],
      [
        -160.38653564453125,
        -2181.5,
        825.0
      ],
      [
        -164.1160888671875,
        -2187.44677734375,
        825.0
      ],
      [
        -164.11610412597656,
        -2187.44677734375,
        825.0
      ],
      [
        -124.42652130126953,
        -2186.925537109375,
        825.0
      ],
      [
        -125.54545593261719,
        -2181.5,
        825.0
      ],
      [
        -124.42652130126953,
        -2186.925537109375,
        825.0
      ],
      [
        -122.00171661376953,
        -2198.68408203125,
        825.0
      ],
      [
        -145.49356079101562,
        -2187.44677734375,
        861.0
      ],
      [
        -130.71417236328125,
        -2181.5,
        856.0177001953125
      ],
      [
        -127.5,
        -2186.3974609375,
        836.5
      ],
      [
        -128.129150390625,
        -2181.5,
        834.6912231445312
      ],
      [
        -127.5,
        -2186.3974609375,
        836.5
      ],
      [
        -132.53016662597656,
        -2181.5,
        857.0
      ],
      [
        -127.5,
        -2186.668701171875,
        836.8875732421875
      ],
      [
        -147.56275939941406,
        -2187.44677734375,
        857.0
      ],
      [
        -143.83319091796875,
        -2181.5,
        857.0
      ],
      [
        -140.26210021972656,
        -2179.60009765625,
        861.5999755859375
      ],
      [
        -142.79855346679688,
        -2181.5,
        859.0
      ],
      [
        -139.53794860839844,
        -2179.60009765625,
        863.0
      ],
      [
        -140.26210021972656,
        -2179.60009765625,
        861.5999755859375
      ],
      [
        -129.078369140625,
        -1946.19970703125,
        862.9799194335938
      ],
      [
        -116.65182495117188,
        -1951.1494140625,
        804.3529052734375
      ],
      [
        -129.07835388183594,
        -1946.19970703125,
        862.9799194335938
      ],
      [
        -48.71263885498047,
        -1978.2119140625,
        794.4229736328125
      ],
      [
        -48.609130859375,
        -1978.253173828125,
        794.6730346679688
      ],
      [
        -170.0,
        -1922.31591796875,
        770.0
      ],
      [
        -170.0,
        -1924.0889892578125,
        765.0
      ],
      [
        -172.9431915283203,
        -1920.0,
        765.0
      ],
      [
        -170.0,
        -1924.0889892578125,
        765.0
      ],
      [
        -170.0,
        -1922.31591796875,
        770.0
      ],
      [
        -171.66697692871094,
        -1920.0,
        770.0
      ],
      [
        -194.8513946533203,
        -1920.0,
        765.0
      ],
      [
        -170.0,
        -1929.899169921875,
        765.0
      ],
      [
        -170.0,
        -1929.899169921875,
        770.0
      ],
      [
        -180.0,
        -1925.915771484375,
        770.0
      ],
      [
        -170.0,
        -1929.899169921875,
        770.0
      ],
      [
        -170.0,
        -1929.899169921875,
        765.0
      ],
      [
        -184.0,
        -1924.322509765625,
        765.0
      ],
      [
        -184.0,
        -1924.322509765625,
        754.0
      ],
      [
        -194.8513946533203,
        -1920.0,
        754.0
      ],
      [
        -184.0,
        -1924.322509765625,
        754.0
      ],
      [
        -49.43193054199219,
        -1978.1094970703125,
        792.9082641601562
      ],
      [
        -118.56556701660156,
        -1950.38720703125,
        813.3817138671875
      ],
      [
        -103.21552276611328,
        -1964.927001953125,
        735.3753662109375
      ],
      [
        -156.7864990234375,
        -1941.345947265625,
        768.1051025390625
      ],
      [
        -144.57403564453125,
        -1940.0272216796875,
        819.6739501953125
      ],
      [
        -156.7864990234375,
        -1941.345947265625,
        768.1051025390625
      ],
      [
        -152.91403198242188,
        -1956.10107421875,
        741.6661376953125
      ],
      [
        -154.65696716308594,
        -2187.44677734375,
        861.0
      ],
      [
        -268.35565185546875,
        -2215.476318359375,
        861.0
      ],
      [
        -210.4822540283203,
        -2205.627197265625,
        866.3333129882812
      ],
      [
        -277.4501953125,
        -2218.526123046875,
        861.0
      ],
      [
        -291.0722351074219,
        -2224.105224609375,
        861.0
      ],
      [
        -310.88970947265625,
        -2233.276611328125,
        861.0
      ],
      [
        -306.70843505859375,
        -2230.509033203125,
        861.0
      ],
      [
        -277.4001159667969,
        -2219.5,
        862.9827880859375
      ],
      [
        -277.6429138183594,
        -2219.5,
        861.0
      ],
      [
        -277.4501647949219,
        -2218.526123046875,
        861.0
      ],
      [
        -301.7933654785156,
        -2227.839599609375,
        861.0
      ],
      [
        -291.0722351074219,
        -2224.105224609375,
        861.0
      ],
      [
        -305.518310546875,
        -2229.72119140625,
        861.0
      ],
      [
        -305.518310546875,
        -2229.72119140625,
        861.0
      ],
      [
        -301.7933654785156,
        -2227.839599609375,
        861.0
      ],
      [
        -277.3228454589844,
        -2217.8828125,
        861.0
      ],
      [
        -277.37689208984375,
        -2219.5,
        863.17236328125
      ],
      [
        -277.2821350097656,
        -2217.677001953125,
        861.0
      ],
      [
        -264.94683837890625,
        -2181.5,
        821.0
      ],
      [
        -268.1400451660156,
        -2182.24951171875,
        820.9546508789062
      ],
      [
        -251.5053253173828,
        -2181.5,
        825.0
      ],
      [
        -264.94683837890625,
        -2181.5,
        821.0
      ],
      [
        -143.9765167236328,
        -2181.5,
        857.0
      ],
      [
        -143.80711364746094,
        -2181.5,
        857.0504150390625
      ],
      [
        -354.6549377441406,
        -2233.1513671875,
        817.8739624023438
      ],
      [
        -330.51251220703125,
        -2217.7978515625,
        818.80322265625
      ],
      [
        -251.50534057617188,
        -2181.5,
        825.0
      ],
      [
        -263.5,
        -2184.45703125,
        825.0
      ],
      [
        -326.5,
        -2294.34033203125,
        825.0
      ],
      [
        -326.5,
        -2239.39990234375,
        825.0
      ],
      [
        -326.8420104980469,
        -2219.548828125,
        825.0
      ],
      [
        -330.51251220703125,
        -2217.7978515625,
        818.80322265625
      ],
      [
        -326.5,
        -2215.840087890625,
        818.9216918945312
      ],
      [
        -326.5,
        -2219.3759765625,
        825.0
      ],
      [
        -270.3253479003906,
        -2186.925537109375,
        825.0
      ],
      [
        -268.1400451660156,
        -2182.24951171875,
        820.9546508789062
      ],
      [
        -270.1554870605469,
        -2186.09765625,
        825.0
      ],
      [
        -270.3253479003906,
        -2186.925537109375,
        825.0
      ],
      [
        -272.5,
        -2197.52392578125,
        825.0
      ],
      [
        -276.49090576171875,
        -2219.5,
        823.2896118164062
      ],
      [
        -272.6390075683594,
        -2198.289306640625,
        824.9404296875
      ],
      [
        -284.41485595703125,
        -2199.781005859375,
        819.8936767578125
      ],
      [
        -286.2059631347656,
        -2200.8349609375,
        820.6588745117188
      ],
      [
        -286.6089782714844,
        -2200.54150390625,
        819.84765625
      ],
      [
        -279.50006103515625,
        -2199.158447265625,
        822.0
      ],
      [
        -290.6774597167969,
        -2201.914306640625,
        819.7645874023438
      ],
      [
        -286.6089782714844,
        -2200.54150390625,
        819.84765625
      ],
      [
        -286.2059631347656,
        -2200.8349609375,
        820.6588745117188
      ],
      [
        -314.0660095214844,
        -2210.18701171875,
        820.0
      ],
      [
        -314.28076171875,
        -2209.878173828125,
        819.2825317382812
      ],
      [
        -289.5003662109375,
        -2201.630126953125,
        820.0
      ],
      [
        -314.28076171875,
        -2209.878173828125,
        819.2825317382812
      ],
      [
        -314.0660095214844,
        -2210.18701171875,
        820.0
      ],
      [
        -326.5,
        -2216.46728515625,
        820.0
      ],
      [
        -279.5,
        -2294.34033203125,
        825.0
      ],
      [
        -289.5,
        -2294.34033203125,
        825.0
      ],
      [
        -279.5,
        -2294.34033203125,
        825.0
      ],
      [
        -326.5,
        -2294.34033203125,
        825.0
      ],
      [
        -289.5,
        -2294.34033203125,
        825.0
      ],
      [
        -312.5693359375,
        -2212.33984375,
        825.0
      ],
      [
        -284.0493469238281,
        -2202.405517578125,
        825.0
      ],
      [
        -272.6896667480469,
        -2198.4482421875,
        825.0
      ],
      [
        -277.0091857910156,
        -2219.5,
        825.0
      ],
      [
        -272.6593322753906,
        -2198.401123046875,
        824.9317016601562
      ],
      [
        -292.0,
        -2294.340087890625,
        823.7935791015625
      ],
      [
        -292.0,
        -2294.340087890625,
        825.0
      ],
      [
        -292.0,
        -2292.558349609375,
        825.0
      ],
      [
        -312.5693359375,
        -2212.33984375,
        825.0
      ],
      [
        -314.5,
        -2294.340087890625,
        825.0
      ],
      [
        -314.5,
        -2284.537109375,
        825.0
      ],
      [
        -325.5,
        -2294.340087890625,
        825.0
      ],
      [
        -325.5,
        -2284.537109375,
        825.0
      ],
      [
        -325.5,
        -2284.537109375,
        825.0
      ],
      [
        -326.5,
        -2284.537109375,
        825.0
      ],
      [
        -314.5,
        -2284.537109375,
        825.0
      ],
      [
        -315.5,
        -2284.537109375,
        825.0
      ],
      [
        -303.0,
        -2294.340087890625,
        825.0
      ],
      [
        -303.0,
        -2284.537109375,
        825.0
      ],
      [
        -303.0,
        -2284.537109375,
        825.0
      ],
      [
        -304.0,
        -2284.537109375,
        825.0
      ],
      [
        -292.0,
        -2249.202880859375,
        825.0
      ],
      [
        -292.0,
        -2239.39990234375,
        825.0
      ],
      [
        -292.0,
        -2284.537109375,
        825.0
      ],
      [
        -292.0,
        -2284.537109375,
        825.0
      ],
      [
        -293.0,
        -2284.537109375,
        825.0
      ],
      [
        -272.6656188964844,
        -2198.3310546875,
        825.0
      ],
      [
        -284.0493469238281,
        -2202.405517578125,
        825.0
      ],
      [
        -272.6656494140625,
        -2198.3310546875,
        825.0
      ],
      [
        -272.6390380859375,
        -2198.289306640625,
        824.9404296875
      ],
      [
        -326.5,
        -2219.7119140625,
        825.577392578125
      ],
      [
        -326.5,
        -2219.3759765625,
        825.0
      ],
      [
        -304.0383605957031,
        -2224.610595703125,
        853.5
      ],
      [
        -286.9925842285156,
        -2218.6728515625,
        853.5
      ],
      [
        -309.96075439453125,
        -2227.60205078125,
        853.5
      ],
      [
        -304.0383605957031,
        -2224.610595703125,
        853.5
      ],
      [
        -278.561279296875,
        -2219.5,
        853.5
      ],
      [
        -277.7611999511719,
        -2215.457275390625,
        853.5
      ],
      [
        -277.62744140625,
        -2219.421875,
        861.0
      ],
      [
        -277.6394958496094,
        -2214.84228515625,
        853.5
      ],
      [
        -286.9925842285156,
        -2218.6728515625,
        853.5
      ],
      [
        -277.6394958496094,
        -2214.84228515625,
        853.5
      ],
      [
        -277.4501647949219,
        -2218.526123046875,
        861.0
      ],
      [
        -276.9549560546875,
        -2211.38330078125,
        853.5
      ],
      [
        -309.12701416015625,
        -2217.291259765625,
        836.5
      ],
      [
        -295.0,
        -2212.370361328125,
        836.5
      ],
      [
        -295.0,
        -2221.462158203125,
        853.5
      ],
      [
        -320.0302734375,
        -2222.79833984375,
        836.5
      ],
      [
        -309.12701416015625,
        -2217.291259765625,
        836.5
      ],
      [
        -294.0,
        -2212.02197265625,
        836.5
      ],
      [
        -294.0,
        -2221.11376953125,
        853.5
      ],
      [
        -294.0,
        -2293.0,
        853.5
      ],
      [
        -294.0,
        -2293.0,
        841.5
      ],
      [
        -276.72222900390625,
        -2293.0,
        851.72216796875
      ],
      [
        -284.8999328613281,
        -2293.0,
        841.5
      ],
      [
        -288.89996337890625,
        -2210.245361328125,
        836.5
      ],
      [
        -282.2601013183594,
        -2212.371337890625,
        844.7998046875
      ],
      [
        -282.1000061035156,
        -2291.5,
        845.0
      ],
      [
        -279.5,
        -2291.5,
        848.25
      ],
      [
        -279.5,
        -2293.0,
        848.25
      ],
      [
        -279.5,
        -2291.5,
        848.25
      ],
      [
        -279.15069580078125,
        -2219.5,
        848.6865234375
      ],
      [
        -277.8173522949219,
        -2213.7939453125,
        850.353271484375
      ],
      [
        -277.7611999511719,
        -2215.457275390625,
        853.5
      ],
      [
        -277.7156982421875,
        -2213.359130859375,
        850.4803466796875
      ],
      [
        -282.2601013183594,
        -2212.371337890625,
        844.7998046875
      ],
      [
        -277.7157287597656,
        -2213.359130859375,
        850.4802856445312
      ],
      [
        -277.6394958496094,
        -2214.84228515625,
        853.5
      ],
      [
        -276.869384765625,
        -2209.737060546875,
        851.5382690429688
      ],
      [
        -276.5,
        -2244.0,
        850.0
      ],
      [
        -276.5,
        -2290.0,
        850.0
      ],
      [
        -276.8022766113281,
        -2208.4462890625,
        850.0
      ],
      [
        -278.0999450683594,
        -2215.00341796875,
        850.0
      ],
      [
        -276.9375,
        -2293.0,
        850.0
      ],
      [
        -278.0999450683594,
        -2293.0,
        850.0
      ],
      [
        -277.7278137207031,
        -2213.123291015625,
        850.0
      ],
      [
        -278.0999755859375,
        -2213.275634765625,
        850.0
      ],
      [
        -276.5,
        -2290.0,
        845.0
      ],
      [
        -276.5,
        -2244.0,
        845.0
      ],
      [
        -276.5,
        -2198.99951171875,
        837.2006225585938
      ],
      [
        -280.4940490722656,
        -2219.5,
        836.5
      ],
      [
        -276.5,
        -2200.034423828125,
        836.5
      ],
      [
        -279.60211181640625,
        -2219.5,
        845.0
      ],
      [
        -276.5,
        -2198.99951171875,
        837.2006225585938
      ],
      [
        -276.5,
        -2202.631591796875,
        843.07080078125
      ],
      [
        -276.58416748046875,
        -2204.25048828125,
        845.0
      ],
      [
        -277.5625,
        -2293.0,
        845.0
      ],
      [
        -282.0999450683594,
        -2293.0,
        845.0
      ],
      [
        -279.0,
        -2284.10009765625,
        845.0
      ],
      [
        -279.0,
        -2281.60009765625,
        845.0
      ],
      [
        -279.8333435058594,
        -2281.60009765625,
        845.0
      ],
      [
        -280.8052062988281,
        -2281.60009765625,
        845.0
      ],
      [
        -279.8333435058594,
        -2281.60009765625,
        845.0
      ],
      [
        -279.0,
        -2281.60009765625,
        845.0
      ],
      [
        -277.85400390625,
        -2210.667236328125,
        845.0
      ],
      [
        -281.5699768066406,
        -2212.189208984375,
        845.0
      ],
      [
        -277.80072021484375,
        -2206.3740234375,
        836.5
      ],
      [
        -278.3362121582031,
        -2206.565673828125,
        836.5
      ],
      [
        -278.3362121582031,
        -2206.565673828125,
        836.5
      ],
      [
        -282.0999450683594,
        -2212.40625,
        845.0
      ],
      [
        -276.5,
        -2290.5,
        845.5
      ],
      [
        -276.5,
        -2290.5,
        849.5
      ],
      [
        -276.5,
        -2290.0,
        845.0
      ],
      [
        -276.5,
        -2290.5,
        845.5
      ],
      [
        -276.5,
        -2290.0,
        850.0
      ],
      [
        -276.5,
        -2290.5,
        849.5
      ],
      [
        -276.33734130859375,
        -2199.50244140625,
        839.342041015625
      ],
      [
        -276.5,
        -2199.494140625,
        838.0000610351562
      ],
      [
        -272.5,
        -2227.854736328125,
        854.5
      ],
      [
        -272.5,
        -2216.3095703125,
        838.0
      ],
      [
        -275.8849182128906,
        -2197.03662109375,
        836.5
      ],
      [
        -276.244873046875,
        -2197.723876953125,
        837.2224731445312
      ],
      [
        -276.244873046875,
        -2197.723876953125,
        837.2224731445312
      ],
      [
        -272.5,
        -2216.3095703125,
        838.0
      ],
      [
        -272.5,
        -2216.3095703125,
        836.5
      ],
      [
        -272.5,
        -2227.854736328125,
        854.5
      ],
      [
        -168.098388671875,
        -2187.44677734375,
        857.0
      ],
      [
        -143.97653198242188,
        -2181.5,
        857.0
      ],
      [
        -184.0,
        -2240.5,
        857.0
      ],
      [
        -184.0,
        -2245.546875,
        857.0
      ],
      [
        -184.0,
        -2240.5,
        857.0
      ],
      [
        -180.8348388671875,
        -2240.5,
        857.0
      ],
      [
        -268.35565185546875,
        -2215.476318359375,
        861.0
      ],
      [
        -267.7560119628906,
        -2212.014892578125,
        857.0
      ],
      [
        -267.7560119628906,
        -2212.014892578125,
        857.0
      ],
      [
        -269.4704895019531,
        -2210.36669921875,
        854.5
      ],
      [
        -269.4704895019531,
        -2210.36669921875,
        854.5
      ],
      [
        -269.4588317871094,
        -2209.94970703125,
        854.0
      ],
      [
        -272.5,
        -2227.5048828125,
        854.0
      ],
      [
        -269.0862121582031,
        -2196.603271484375,
        838.0
      ],
      [
        -269.0862121582031,
        -2196.603271484375,
        838.0
      ],
      [
        -268.8613586425781,
        -2195.305419921875,
        836.5
      ],
      [
        -268.8613586425781,
        -2195.305419921875,
        836.5
      ],
      [
        -264.6375732421875,
        -2187.44677734375,
        828.2705078125
      ],
      [
        -282.4072570800781,
        -2273.5,
        836.5
      ],
      [
        -282.337158203125,
        -2274.300048828125,
        835.9000244140625
      ],
      [
        -314.5,
        -2286.70166015625,
        826.5999755859375
      ],
      [
        -314.5,
        -2288.8349609375,
        825.0
      ],
      [
        -314.5,
        -2286.70166015625,
        826.5999755859375
      ],
      [
        -314.5,
        -2282.840087890625,
        829.4957885742188
      ],
      [
        -325.5,
        -2286.70166015625,
        826.5999755859375
      ],
      [
        -325.5,
        -2288.8349609375,
        825.0
      ],
      [
        -325.5,
        -2286.70166015625,
        826.5999755859375
      ],
      [
        -325.5,
        -2282.840087890625,
        829.4957885742188
      ],
      [
        -325.5,
        -2282.840087890625,
        829.4957885742188
      ],
      [
        -326.5,
        -2282.840087890625,
        829.4957885742188
      ],
      [
        -314.5,
        -2282.840087890625,
        829.4957885742188
      ],
      [
        -315.5,
        -2282.840087890625,
        829.4957885742188
      ],
      [
        -303.0,
        -2286.70166015625,
        826.5999755859375
      ],
      [
        -303.0,
        -2288.8349609375,
        825.0
      ],
      [
        -303.0,
        -2286.70166015625,
        826.5999755859375
      ],
      [
        -303.0,
        -2282.840087890625,
        829.4957885742188
      ],
      [
        -303.0,
        -2282.840087890625,
        829.4957885742188
      ],
      [
        -304.0,
        -2282.840087890625,
        829.4957885742188
      ],
      [
        -292.0,
        -2286.70166015625,
        826.5999755859375
      ],
      [
        -292.0,
        -2288.8349609375,
        825.0
      ],
      [
        -292.0,
        -2286.70166015625,
        826.5999755859375
      ],
      [
        -292.0,
        -2282.840087890625,
        829.4957885742188
      ],
      [
        -292.0,
        -2282.840087890625,
        829.4957885742188
      ],
      [
        -293.0,
        -2282.840087890625,
        829.4957885742188
      ],
      [
        -277.80194091796875,
        -2206.379638671875,
        836.5
      ],
      [
        -272.6896667480469,
        -2198.4482421875,
        825.0
      ],
      [
        -270.589111328125,
        -2186.925537109375,
        825.870361328125
      ],
      [
        -270.589111328125,
        -2186.925537109375,
        825.870361328125
      ],
      [
        -263.5,
        -2184.45703125,
        825.0
      ],
      [
        -264.6375732421875,
        -2187.44677734375,
        828.2705078125
      ],
      [
        -255.55990600585938,
        -2179.60009765625,
        821.5
      ],
      [
        -261.0,
        -2180.941162109375,
        821.5
      ],
      [
        -253.87985229492188,
        -2179.60009765625,
        822.0
      ],
      [
        -255.55990600585938,
        -2179.60009765625,
        821.5
      ],
      [
        -252.8496856689453,
        -2181.5,
        824.5999755859375
      ],
      [
        -253.87985229492188,
        -2179.60009765625,
        822.0
      ],
      [
        -261.0,
        -2181.5,
        822.1744995117188
      ],
      [
        -261.0,
        -2180.941162109375,
        821.5
      ],
      [
        -354.308349609375,
        -2220.012451171875,
        798.7385864257812
      ],
      [
        -347.122802734375,
        -2228.361328125,
        818.1638793945312
      ],
      [
        -165.52450561523438,
        -2187.44677734375,
        861.0
      ],
      [
        -268.3276672363281,
        -2215.314697265625,
        861.0
      ],
      [
        -141.7639923095703,
        -2181.5,
        861.0
      ],
      [
        -141.41397094726562,
        -2181.5,
        861.6766357421875
      ],
      [
        -143.58685302734375,
        -2181.5,
        861.0
      ],
      [
        -277.2162780761719,
        -2216.41015625,
        859.4903564453125
      ],
      [
        -276.0447998046875,
        -2196.723388671875,
        837.2395629882812
      ],
      [
        -178.36936950683594,
        -2187.44677734375,
        857.0
      ],
      [
        -156.43209838867188,
        -2181.5,
        857.0
      ],
      [
        -156.4320831298828,
        -2181.5,
        857.0
      ],
      [
        -268.3276672363281,
        -2215.314697265625,
        861.0
      ],
      [
        -267.6947326660156,
        -2211.6611328125,
        857.0
      ],
      [
        -146.0,
        -2181.00390625,
        859.6788330078125
      ],
      [
        -141.37191772460938,
        -2180.431396484375,
        860.4623413085938
      ],
      [
        -146.0,
        -2181.00390625,
        859.6788330078125
      ],
      [
        -146.0,
        -2181.5,
        860.2486572265625
      ],
      [
        -269.397705078125,
        -2209.946533203125,
        854.5
      ],
      [
        -268.8855285644531,
        -2195.44482421875,
        838.0
      ],
      [
        -271.09100341796875,
        -2186.925537109375,
        827.5264892578125
      ],
      [
        -268.71612548828125,
        -2183.349365234375,
        822.1109619140625
      ],
      [
        -268.3963317871094,
        -2181.595947265625,
        822.2429809570312
      ],
      [
        -271.09100341796875,
        -2186.925537109375,
        827.5264892578125
      ],
      [
        -276.0447998046875,
        -2196.723388671875,
        837.2395629882812
      ],
      [
        -268.3478698730469,
        -2181.5,
        822.14794921875
      ],
      [
        -265.8244323730469,
        -2181.5,
        822.933837890625
      ],
      [
        -259.18975830078125,
        -2181.5,
        825.0
      ],
      [
        -265.8244323730469,
        -2181.5,
        822.933837890625
      ],
      [
        -259.18975830078125,
        -2181.5,
        825.0
      ],
      [
        -263.5,
        -2182.66845703125,
        825.0
      ],
      [
        -268.3478698730469,
        -2181.5,
        822.14794921875
      ],
      [
        -268.6481628417969,
        -2194.07470703125,
        836.5
      ],
      [
        -265.2227478027344,
        -2187.44677734375,
        829.952880859375
      ],
      [
        -263.5,
        -2182.66845703125,
        825.0
      ],
      [
        -265.2227478027344,
        -2187.44677734375,
        829.952880859375
      ],
      [
        -267.6947326660156,
        -2211.6611328125,
        857.0
      ],
      [
        -269.397705078125,
        -2209.946533203125,
        854.5
      ],
      [
        -268.8855285644531,
        -2195.44482421875,
        838.0
      ],
      [
        -268.6481628417969,
        -2194.07470703125,
        836.5
      ],
      [
        -260.47467041015625,
        -2181.5,
        824.5999755859375
      ],
      [
        -261.0,
        -2180.755615234375,
        823.5812377929688
      ],
      [
        -261.0,
        -2181.5,
        824.4364013671875
      ],
      [
        -261.0,
        -2180.755615234375,
        823.5812377929688
      ],
      [
        -280.39111328125,
        -2001.767822265625,
        765.0
      ],
      [
        -179.7589569091797,
        -1926.0118408203125,
        765.0
      ],
      [
        -279.09942626953125,
        -1999.4329833984375,
        765.0
      ],
      [
        -265.2267761230469,
        -2181.5,
        860.06982421875
      ],
      [
        -268.19189453125,
        -2181.5,
        858.9865112304688
      ],
      [
        -268.19189453125,
        -2181.5,
        858.9865112304688
      ],
      [
        -270.470947265625,
        -2181.5,
        858.15380859375
      ],
      [
        -251.7324981689453,
        -2181.5,
        865.0
      ],
      [
        -265.2267761230469,
        -2181.5,
        860.06982421875
      ],
      [
        -277.2821350097656,
        -2217.677001953125,
        861.0
      ],
      [
        -271.3973693847656,
        -2187.942138671875,
        861.0
      ],
      [
        -271.8732604980469,
        -2191.251220703125,
        862.4619140625
      ],
      [
        -271.8732604980469,
        -2191.251220703125,
        862.4619140625
      ],
      [
        -270.9947814941406,
        -2197.5283203125,
        865.8857421875
      ],
      [
        -271.25115966796875,
        -2186.925537109375,
        860.5508422851562
      ],
      [
        -271.68597412109375,
        -2186.925537109375,
        857.0
      ],
      [
        -270.61224365234375,
        -2181.5,
        857.0
      ],
      [
        -270.470947265625,
        -2181.5,
        858.15380859375
      ],
      [
        -277.0851745605469,
        -2214.206787109375,
        857.0
      ],
      [
        -271.68597412109375,
        -2186.925537109375,
        857.0
      ],
      [
        -271.25115966796875,
        -2186.925537109375,
        860.5508422851562
      ],
      [
        -265.6839599609375,
        -2181.5,
        852.9822998046875
      ],
      [
        -269.2153015136719,
        -2183.2158203125,
        823.8487548828125
      ],
      [
        -269.1147155761719,
        -2181.5,
        824.678466796875
      ],
      [
        -267.5,
        -2186.3974609375,
        836.5
      ],
      [
        -268.3963317871094,
        -2181.595947265625,
        822.2429809570312
      ],
      [
        -268.3788757324219,
        -2181.5,
        822.250244140625
      ],
      [
        -267.5,
        -2186.3974609375,
        836.5
      ],
      [
        -266.870849609375,
        -2181.5,
        834.6912231445312
      ],
      [
        -268.0217590332031,
        -2190.458740234375,
        838.0
      ],
      [
        -291.3096008300781,
        -2030.6904296875,
        770.0
      ],
      [
        -286.2725524902344,
        -2021.5853271484375,
        770.0
      ],
      [
        -270.0,
        -2002.8223876953125,
        770.0
      ],
      [
        -286.2725524902344,
        -2021.5853271484375,
        770.0
      ],
      [
        -279.9681701660156,
        -2010.189697265625,
        770.0
      ],
      [
        -200.0,
        -1951.08642578125,
        770.0
      ],
      [
        -184.99984741210938,
        -1940.0,
        770.0
      ],
      [
        -270.0,
        -2002.8223876953125,
        770.0
      ],
      [
        -268.8873596191406,
        -2002.0,
        770.0
      ],
      [
        -200.0,
        -1951.08642578125,
        770.0
      ],
      [
        -268.8873596191406,
        -2002.0,
        770.0
      ],
      [
        -180.0,
        -1936.3046875,
        770.0
      ],
      [
        -170.86631774902344,
        -1929.5540771484375,
        770.0
      ],
      [
        -208.41311645507812,
        -1947.1898193359375,
        765.0
      ],
      [
        -188.77700805664062,
        -1942.7916259765625,
        770.0
      ],
      [
        -170.0,
        -1941.3094482421875,
        770.0
      ],
      [
        -170.0,
        -1944.15771484375,
        765.0
      ],
      [
        -291.3096008300781,
        -2030.6904296875,
        770.0
      ],
      [
        -291.5428161621094,
        -2030.4571533203125,
        769.6435546875
      ],
      [
        -158.70838928222656,
        -1940.418212890625,
        770.0
      ],
      [
        -156.33169555664062,
        -1943.078857421875,
        765.0
      ],
      [
        -158.70838928222656,
        -1940.418212890625,
        770.0
      ],
      [
        -156.33775329589844,
        -1941.2974853515625,
        770.0
      ],
      [
        -164.88003540039062,
        -1937.4390869140625,
        776.0849609375
      ],
      [
        -164.88003540039062,
        -1937.4390869140625,
        776.0849609375
      ],
      [
        -153.4959716796875,
        -1940.9906005859375,
        781.9998168945312
      ],
      [
        -258.4679870605469,
        -2179.60009765625,
        861.5999755859375
      ],
      [
        -261.0,
        -2180.0966796875,
        860.92041015625
      ],
      [
        -254.63604736328125,
        -2179.60009765625,
        863.0
      ],
      [
        -258.4679870605469,
        -2179.60009765625,
        861.5999755859375
      ],
      [
        -261.0,
        -2180.0966796875,
        860.92041015625
      ],
      [
        -261.0,
        -2181.5,
        861.6140747070312
      ],
      [
        -184.0,
        -1929.1463623046875,
        765.0
      ],
      [
        -184.0,
        -1924.322509765625,
        762.6154174804688
      ],
      [
        -198.0,
        -1920.0,
        755.36376953125
      ],
      [
        -198.0,
        -1939.4935302734375,
        765.0
      ],
      [
        -198.0,
        -1946.367919921875,
        765.0
      ],
      [
        -184.0,
        -1945.2628173828125,
        765.0
      ],
      [
        -184.0,
        -1951.5289306640625,
        754.0
      ],
      [
        -198.0,
        -1952.6339111328125,
        754.0
      ],
      [
        -184.0,
        -1955.98876953125,
        746.1708374023438
      ],
      [
        -198.0,
        -1955.9381103515625,
        748.1995849609375
      ],
      [
        -224.05992126464844,
        -1950.6944580078125,
        761.0158081054688
      ],
      [
        -241.719970703125,
        -1953.8861083984375,
        756.1414184570312
      ],
      [
        -224.05992126464844,
        -1950.6944580078125,
        761.0158081054688
      ],
      [
        -241.719970703125,
        -1953.8861083984375,
        756.1414184570312
      ],
      [
        -245.54180908203125,
        -1954.2607421875,
        754.9302978515625
      ],
      [
        -272.0,
        -1994.18603515625,
        765.0
      ],
      [
        -272.0,
        -1988.9971923828125,
        762.43505859375
      ],
      [
        -298.2779235839844,
        -2023.7220458984375,
        770.0
      ],
      [
        -290.7815856933594,
        -2018.181640625,
        770.0
      ],
      [
        -290.0,
        -2017.60400390625,
        770.0
      ],
      [
        -290.0,
        -2017.60400390625,
        770.0
      ],
      [
        -290.7815856933594,
        -2018.181640625,
        770.0
      ],
      [
        -298.2779235839844,
        -2023.7220458984375,
        770.0
      ],
      [
        -298.3752746582031,
        -2023.624755859375,
        769.916259765625
      ],
      [
        -281.04278564453125,
        -2000.8692626953125,
        765.0
      ],
      [
        -433.4872741699219,
        -1935.8033447265625,
        892.0023193359375
      ],
      [
        -433.48736572265625,
        -1935.8033447265625,
        912.0
      ],
      [
        -433.4872741699219,
        -1935.8033447265625,
        892.0023193359375
      ],
      [
        -433.4872741699219,
        -1935.8033447265625,
        872.4360961914062
      ],
      [
        -433.6276550292969,
        -1935.6746826171875,
        780.299072265625
      ],
      [
        -433.48736572265625,
        -1935.8033447265625,
        912.0
      ],
      [
        -430.0,
        -1933.3961181640625,
        921.1698608398438
      ],
      [
        -430.0,
        -1933.3961181640625,
        921.1698608398438
      ],
      [
        -422.18267822265625,
        -1928.0,
        930.0
      ],
      [
        -431.22930908203125,
        -1934.768798828125,
        1080.0
      ],
      [
        -434.07379150390625,
        -1936.41796875,
        960.5042114257812
      ],
      [
        -434.07379150390625,
        -1936.41796875,
        960.5042114257812
      ],
      [
        -433.45745849609375,
        -1935.8306884765625,
        892.0023193359375
      ],
      [
        -433.427001953125,
        -1935.858642578125,
        912.0
      ],
      [
        -433.45745849609375,
        -1935.8306884765625,
        892.0023193359375
      ],
      [
        -430.0,
        -1933.5428466796875,
        920.9298095703125
      ],
      [
        -421.8410339355469,
        -1928.0,
        930.0
      ],
      [
        -433.427001953125,
        -1935.858642578125,
        912.0
      ],
      [
        -430.0,
        -1933.5428466796875,
        920.9298095703125
      ],
      [
        -348.0,
        -1905.1326904296875,
        892.0023193359375
      ],
      [
        -348.0,
        -1905.1326904296875,
        912.0
      ],
      [
        -348.0,
        -1905.1326904296875,
        892.0023193359375
      ],
      [
        -348.0,
        -1905.1326904296875,
        766.0
      ],
      [
        -348.0,
        -1905.1326904296875,
        912.0
      ],
      [
        -360.0,
        -1907.0894775390625,
        930.0
      ],
      [
        -433.3038635253906,
        -1935.971435546875,
        892.0023193359375
      ],
      [
        -433.3038635253906,
        -1935.9715576171875,
        912.0
      ],
      [
        -433.3038635253906,
        -1935.971435546875,
        892.0023193359375
      ],
      [
        -433.30377197265625,
        -1935.9715576171875,
        780.2833251953125
      ],
      [
        -430.0,
        -1934.0562744140625,
        920.089599609375
      ],
      [
        -419.5531921386719,
        -1928.0,
        930.0
      ],
      [
        -433.3038635253906,
        -1935.9715576171875,
        912.0
      ],
      [
        -430.0,
        -1934.0562744140625,
        920.089599609375
      ],
      [
        -348.0,
        -1928.0,
        818.517333984375
      ],
      [
        -348.0,
        -1905.1326904296875,
        871.5677490234375
      ],
      [
        -430.0,
        -1939.0,
        836.4241943359375
      ],
      [
        -433.3038330078125,
        -1935.971435546875,
        845.1998291015625
      ],
      [
        -430.0,
        -1939.0,
        836.4241943359375
      ],
      [
        -422.5,
        -1939.0,
        832.4523315429688
      ],
      [
        -360.0,
        -1939.0,
        799.3532104492188
      ],
      [
        -369.0,
        -1939.0,
        804.1192626953125
      ],
      [
        -360.0,
        -1939.0,
        799.3532104492188
      ],
      [
        -348.0,
        -1928.0,
        818.517333984375
      ],
      [
        -422.5,
        -1939.0,
        832.4524536132812
      ],
      [
        -422.5,
        -1945.875,
        816.5027465820312
      ],
      [
        -422.5,
        -1945.875,
        779.7572631835938
      ],
      [
        -371.6431579589844,
        -1950.0,
        780.0
      ],
      [
        -412.0,
        -1950.0,
        801.3724365234375
      ],
      [
        -417.9999694824219,
        -1950.0,
        804.5498657226562
      ],
      [
        -414.0,
        -1950.0,
        802.4315185546875
      ],
      [
        -417.9999694824219,
        -1950.0,
        779.5380859375
      ],
      [
        -369.0,
        -1950.0,
        778.6002197265625
      ],
      [
        -369.0,
        -1939.0,
        804.1193237304688
      ],
      [
        -369.377197265625,
        -1950.0,
        778.7999267578125
      ],
      [
        -406.73394775390625,
        -1958.5277099609375,
        778.7999267578125
      ],
      [
        -412.0,
        -1955.5,
        780.0
      ],
      [
        -404.0,
        -1957.38623046875,
        780.0
      ],
      [
        -408.7575378417969,
        -1958.4722900390625,
        780.0
      ],
      [
        -404.0,
        -1957.38623046875,
        780.0
      ],
      [
        -371.6431579589844,
        -1950.0,
        780.0
      ],
      [
        -414.0,
        -1953.6666259765625,
        779.3433837890625
      ],
      [
        -414.0,
        -1950.0,
        780.0
      ],
      [
        -414.0,
        -1953.6666259765625,
        780.0
      ],
      [
        -414.0,
        -1950.0,
        802.4315795898438
      ],
      [
        -414.0,
        -1953.6666259765625,
        793.9251708984375
      ],
      [
        -404.0,
        -1957.38623046875,
        780.0
      ],
      [
        -387.601806640625,
        -1950.0,
        788.451416015625
      ],
      [
        -412.0,
        -1950.0,
        801.3723754882812
      ],
      [
        -412.0,
        -1955.5,
        780.0
      ],
      [
        -412.0,
        -1955.5,
        788.612548828125
      ],
      [
        -388.1759033203125,
        -1950.0,
        788.7554931640625
      ],
      [
        -404.0,
        -1957.127685546875,
        780.5999755859375
      ],
      [
        -422.5,
        -1950.0,
        806.9329833984375
      ],
      [
        -422.5,
        -1950.0,
        806.9329833984375
      ],
      [
        -414.0,
        -1959.678955078125,
        779.9769287109375
      ],
      [
        -412.0,
        -1959.21240234375,
        780.0
      ],
      [
        -412.0,
        -1959.21240234375,
        780.0
      ],
      [
        -211.90008544921875,
        -1920.0,
        765.0
      ],
      [
        -300.0,
        -1940.111328125,
        765.0
      ],
      [
        -300.0,
        -1940.111328125,
        765.0
      ],
      [
        -300.0,
        -1937.9560546875,
        770.0
      ],
      [
        -300.0,
        -1937.9560546875,
        770.0
      ],
      [
        -290.0,
        -1935.673095703125,
        770.0
      ],
      [
        -286.0,
        -1936.9154052734375,
        765.0
      ],
      [
        -286.0,
        -1939.397216796875,
        759.2422485351562
      ],
      [
        -272.0,
        -1933.719482421875,
        765.0
      ],
      [
        -272.0,
        -1937.178955078125,
        756.974365234375
      ],
      [
        -198.0,
        -1920.0,
        757.638671875
      ],
      [
        -198.0,
        -1920.808349609375,
        755.7633666992188
      ],
      [
        -414.0,
        -1972.0,
        788.121337890625
      ],
      [
        -414.0,
        -1950.0,
        833.34326171875
      ],
      [
        -371.0,
        -1950.0,
        780.0711059570312
      ],
      [
        -393.5435791015625,
        -1950.0,
        808.0
      ],
      [
        -393.5435791015625,
        -1950.0,
        808.0
      ],
      [
        -412.0,
        -1950.0,
        830.8653564453125
      ],
      [
        -412.0,
        -1950.0,
        830.8652954101562
      ],
      [
        -412.0,
        -1970.0,
        789.75439453125
      ],
      [
        -412.0,
        -1972.0,
        780.9847412109375
      ],
      [
        -414.0,
        -1972.0,
        788.121337890625
      ],
      [
        -412.0,
        -1972.0,
        785.503662109375
      ],
      [
        -370.3376159667969,
        -1950.21923828125,
        778.7999267578125
      ],
      [
        -399.8562316894531,
        -1968.0101318359375,
        778.7999267578125
      ],
      [
        -404.2236633300781,
        -1970.0,
        780.0
      ],
      [
        -404.0,
        -1969.874755859375,
        780.0
      ],
      [
        -404.0,
        -1969.874755859375,
        780.0
      ],
      [
        -371.0,
        -1950.0345458984375,
        780.0
      ],
      [
        -402.8489074707031,
        -1969.2301025390625,
        780.0
      ],
      [
        -392.371826171875,
        -1960.0,
        785.9929809570312
      ],
      [
        -380.6545104980469,
        -1950.0,
        792.0319213867188
      ],
      [
        -380.99658203125,
        -1950.0,
        792.4556274414062
      ],
      [
        -392.7138671875,
        -1960.0,
        786.4166870117188
      ],
      [
        -392.7138671875,
        -1960.0,
        786.4166870117188
      ],
      [
        -392.371826171875,
        -1960.0,
        785.9929809570312
      ],
      [
        -405.16424560546875,
        -1970.0,
        780.0
      ],
      [
        -404.2237854003906,
        -1970.0,
        780.0
      ],
      [
        -404.489501953125,
        -1970.0,
        780.3477783203125
      ],
      [
        -412.0,
        -1961.41552734375,
        807.4000244140625
      ],
      [
        -404.0,
        -1956.593994140625,
        807.4000244140625
      ],
      [
        -404.0,
        -1956.593994140625,
        807.4000244140625
      ],
      [
        -396.3738708496094,
        -1950.0,
        811.5064086914062
      ],
      [
        -412.0,
        -1970.0,
        789.7544555664062
      ],
      [
        -405.9512634277344,
        -1970.0,
        782.260986328125
      ],
      [
        -408.11614990234375,
        -1972.0,
        780.42041015625
      ],
      [
        -371.0,
        -1950.0,
        780.0711059570312
      ],
      [
        -371.0,
        -1950.0345458984375,
        780.0
      ],
      [
        -422.5,
        -1939.0,
        862.8701782226562
      ],
      [
        -422.5,
        -1950.0,
        842.9549560546875
      ],
      [
        -422.5,
        -1950.0,
        842.9549560546875
      ],
      [
        -414.0,
        -1950.0,
        833.3432006835938
      ],
      [
        -430.0,
        -1939.0,
        871.35107421875
      ],
      [
        -433.3038635253906,
        -1935.971435546875,
        880.5703125
      ],
      [
        -430.0,
        -1939.0,
        871.35107421875
      ],
      [
        -422.5,
        -1939.0,
        862.870361328125
      ],
      [
        -396.4644775390625,
        -1935.34716796875,
        841.7379760742188
      ],
      [
        -414.0011291503906,
        -1944.9122314453125,
        843.802490234375
      ],
      [
        -379.35919189453125,
        -1926.017333984375,
        839.7244873046875
      ],
      [
        -382.8941955566406,
        -1927.9451904296875,
        840.1409912109375
      ],
      [
        -414.0011291503906,
        -1944.9122314453125,
        843.802490234375
      ],
      [
        -430.0,
        -1939.0,
        871.6712036132812
      ],
      [
        -422.5,
        -1939.0,
        863.5264282226562
      ],
      [
        -430.0,
        -1939.0,
        871.6712036132812
      ],
      [
        -433.3038635253906,
        -1935.971435546875,
        880.6351318359375
      ],
      [
        -422.5,
        -1939.0,
        863.5265502929688
      ],
      [
        -422.5,
        -1942.0526123046875,
        858.107666015625
      ],
      [
        -422.5,
        -1945.1715087890625,
        851.69677734375
      ],
      [
        -422.5,
        -1949.5487060546875,
        844.80126953125
      ],
      [
        -422.5,
        -1950.0,
        843.8737182617188
      ],
      [
        -422.5,
        -1950.0,
        843.8737182617188
      ],
      [
        -422.5,
        -1939.0,
        866.4845581054688
      ],
      [
        -430.0,
        -1939.0,
        875.7760620117188
      ],
      [
        -422.5,
        -1939.0,
        866.4844970703125
      ],
      [
        -430.0,
        -1939.0,
        875.7760620117188
      ],
      [
        -433.3038635253906,
        -1935.971435546875,
        886.0947875976562
      ],
      [
        -407.739990234375,
        -1972.0,
        780.3657836914062
      ],
      [
        -404.1261901855469,
        -1970.0,
        780.0
      ],
      [
        -404.1263122558594,
        -1970.0,
        780.0
      ],
      [
        -404.0,
        -1969.923828125,
        780.0
      ],
      [
        -404.0,
        -1969.923828125,
        780.0
      ],
      [
        -414.0006103515625,
        -1975.16845703125,
        781.6093139648438
      ],
      [
        -300.0,
        -1945.209228515625,
        765.0
      ],
      [
        -245.41371154785156,
        -1948.967041015625,
        765.0
      ],
      [
        -224.35549926757812,
        -1948.4483642578125,
        765.0
      ],
      [
        -208.4135284423828,
        -1947.18994140625,
        765.0
      ],
      [
        -200.0,
        -1943.677490234375,
        770.0
      ],
      [
        -188.77719116210938,
        -1942.791748046875,
        770.0
      ],
      [
        -290.0,
        -1943.264892578125,
        770.0
      ],
      [
        -270.0,
        -1944.6416015625,
        770.0
      ],
      [
        -270.0,
        -1944.6416015625,
        770.0
      ],
      [
        -200.0,
        -1943.677490234375,
        770.0
      ],
      [
        -224.7386016845703,
        -1945.6302490234375,
        770.0
      ],
      [
        -247.49603271484375,
        -1946.1907958984375,
        770.0
      ],
      [
        -300.0,
        -1942.57666015625,
        770.0
      ],
      [
        -290.0,
        -1943.2650146484375,
        770.0
      ],
      [
        -300.0,
        -1945.209228515625,
        765.0
      ],
      [
        -300.0,
        -1942.57666015625,
        770.0
      ],
      [
        -272.0,
        -1947.1368408203125,
        765.0
      ],
      [
        -272.0,
        -1950.6171875,
        758.3905029296875
      ],
      [
        -286.0,
        -1946.173095703125,
        765.0
      ],
      [
        -286.0,
        -1948.6893310546875,
        760.221435546875
      ],
      [
        -159.68482971191406,
        -1939.059814453125,
        778.7842407226562
      ],
      [
        -200.0,
        -1945.0208740234375,
        770.0
      ],
      [
        -191.51014709472656,
        -1944.8116455078125,
        770.0
      ],
      [
        -200.0,
        -1945.0208740234375,
        770.0
      ],
      [
        -209.6251220703125,
        -1948.08544921875,
        765.0
      ],
      [
        -208.44378662109375,
        -1914.585693359375,
        835.1259765625
      ],
      [
        -150.88079833984375,
        -1940.708251953125,
        793.042724609375
      ],
      [
        -200.0,
        -1949.46044921875,
        770.0
      ],
      [
        -197.9874725341797,
        -1949.5989990234375,
        770.0
      ],
      [
        -200.0,
        -1949.46044921875,
        770.0
      ],
      [
        -213.76577758789062,
        -1951.145751953125,
        765.0
      ],
      [
        -412.0,
        -1939.0,
        912.0
      ],
      [
        -414.0,
        -1939.0,
        912.0
      ],
      [
        -414.0,
        -1928.0,
        930.0
      ],
      [
        -412.0,
        -1928.0,
        930.0
      ],
      [
        -412.0,
        -1945.5858154296875,
        840.4337158203125
      ],
      [
        -412.0,
        -1950.0,
        831.3602905273438
      ],
      [
        -412.0,
        -1945.5858154296875,
        840.4337158203125
      ],
      [
        -412.0,
        -1943.82080078125,
        843.56689453125
      ],
      [
        -414.0,
        -1939.0,
        904.0
      ],
      [
        -412.0,
        -1939.0,
        903.0
      ],
      [
        -412.0,
        -1939.0,
        898.0
      ],
      [
        -414.0,
        -1939.0,
        894.0
      ],
      [
        -412.0,
        -1939.0,
        903.0
      ],
      [
        -414.0,
        -1939.0,
        904.0
      ],
      [
        -414.0,
        -1939.0,
        912.0
      ],
      [
        -412.0,
        -1939.0,
        912.0
      ],
      [
        -369.0,
        -1939.0,
        912.0
      ],
      [
        -369.0,
        -1928.0,
        930.0
      ],
      [
        -369.0,
        -1970.0,
        778.7999267578125
      ],
      [
        -398.4129943847656,
        -1970.0,
        778.7999267578125
      ],
      [
        -369.0,
        -1957.1702880859375,
        773.1744384765625
      ],
      [
        -369.0,
        -1936.5960693359375,
        809.6964111328125
      ],
      [
        -371.0,
        -1954.5487060546875,
        780.0
      ],
      [
        -396.25750732421875,
        -1970.0,
        780.0
      ],
      [
        -369.0,
        -1954.0013427734375,
        778.7999267578125
      ],
      [
        -395.15228271484375,
        -1970.0,
        778.7999267578125
      ],
      [
        -371.0,
        -1950.0,
        788.0746459960938
      ],
      [
        -389.3483581542969,
        -1950.0,
        808.0
      ],
      [
        -389.3483581542969,
        -1950.0,
        808.0
      ],
      [
        -412.0,
        -1950.0,
        832.5980224609375
      ],
      [
        -378.0,
        -1950.9443359375,
        794.0
      ],
      [
        -388.03863525390625,
        -1960.0,
        788.8262329101562
      ],
      [
        -387.6640625,
        -1960.0,
        788.4193115234375
      ],
      [
        -378.0,
        -1951.2822265625,
        793.4000244140625
      ],
      [
        -388.03863525390625,
        -1960.0,
        788.8262329101562
      ],
      [
        -387.6640625,
        -1960.0,
        788.4193115234375
      ],
      [
        -378.0,
        -1950.9443359375,
        794.0
      ],
      [
        -376.8359680175781,
        -1950.0,
        794.0
      ],
      [
        -376.8359680175781,
        -1950.232177734375,
        794.0
      ],
      [
        -371.0,
        -1950.0,
        788.0747680664062
      ],
      [
        -371.0,
        -1954.5487060546875,
        780.0
      ],
      [
        -375.904052734375,
        -1950.0,
        793.4000244140625
      ],
      [
        -378.0,
        -1951.2822265625,
        793.4000244140625
      ],
      [
        -376.4563903808594,
        -1950.0,
        794.0
      ],
      [
        -404.0,
        -1959.301025390625,
        807.4000244140625
      ],
      [
        -393.8359375,
        -1950.0,
        812.8729858398438
      ],
      [
        -412.0,
        -1964.195068359375,
        807.4000244140625
      ],
      [
        -404.0,
        -1959.301025390625,
        807.4000244140625
      ],
      [
        -369.0,
        -1939.0,
        909.7214965820312
      ],
      [
        -369.0,
        -1939.0,
        912.0
      ],
      [
        -369.0,
        -1939.0,
        909.7214965820312
      ],
      [
        -371.0,
        -1955.224853515625,
        778.7999267578125
      ],
      [
        -371.0,
        -1970.0,
        778.7999267578125
      ],
      [
        -378.0,
        -1960.0,
        793.4000244140625
      ],
      [
        -376.8858947753906,
        -1970.0,
        793.4000244140625
      ],
      [
        -376.8858947753906,
        -1960.0,
        793.4000244140625
      ],
      [
        -371.46435546875,
        -1968.0,
        789.880859375
      ],
      [
        -371.14385986328125,
        -1968.0,
        790.3082275390625
      ],
      [
        -371.14385986328125,
        -1969.5,
        790.3082275390625
      ],
      [
        -371.46435546875,
        -1969.5,
        789.880859375
      ],
      [
        -371.46435546875,
        -1960.5,
        789.880859375
      ],
      [
        -371.14385986328125,
        -1960.5,
        790.3082275390625
      ],
      [
        -371.14385986328125,
        -1962.0,
        790.3082275390625
      ],
      [
        -371.46435546875,
        -1962.0,
        789.880859375
      ],
      [
        -371.46435546875,
        -1962.0,
        789.880859375
      ],
      [
        -371.14385986328125,
        -1962.0,
        790.3082275390625
      ],
      [
        -371.0,
        -1962.0,
        790.2307739257812
      ],
      [
        -371.0,
        -1962.0,
        789.630859375
      ],
      [
        -371.0,
        -1960.5,
        789.630859375
      ],
      [
        -371.0,
        -1960.5,
        790.2307739257812
      ],
      [
        -371.14385986328125,
        -1960.5,
        790.3082275390625
      ],
      [
        -371.46435546875,
        -1960.5,
        789.880859375
      ],
      [
        -371.0,
        -1968.0,
        789.630859375
      ],
      [
        -371.0,
        -1968.0,
        790.2307739257812
      ],
      [
        -371.14385986328125,
        -1968.0,
        790.3082275390625
      ],
      [
        -371.46435546875,
        -1968.0,
        789.880859375
      ],
      [
        -412.0,
        -1960.0,
        835.4000244140625
      ],
      [
        -404.0,
        -1960.0,
        835.4000244140625
      ],
      [
        -378.0,
        -1960.0,
        794.0
      ],
      [
        -371.0,
        -1960.0,
        794.0
      ],
      [
        -371.0,
        -1960.0,
        793.4000244140625
      ],
      [
        -404.0,
        -1960.0,
        807.4000244140625
      ],
      [
        -405.142578125,
        -1960.0,
        807.4000244140625
      ],
      [
        -376.8359680175781,
        -1950.232177734375,
        794.0
      ],
      [
        -376.8359680175781,
        -1960.0,
        794.0
      ],
      [
        -422.5,
        -1939.0,
        912.0
      ],
      [
        -422.5,
        -1929.7083740234375,
        927.2045288085938
      ],
      [
        -422.5,
        -1939.0,
        908.25
      ],
      [
        -422.5,
        -1939.0,
        908.25
      ],
      [
        -422.5,
        -1939.0,
        912.0
      ],
      [
        -366.6459655761719,
        -1939.0,
        802.872802734375
      ],
      [
        -369.0,
        -1939.0,
        805.4291381835938
      ],
      [
        -147.15283203125,
        -1939.0,
        820.2978515625
      ],
      [
        -154.64505004882812,
        -1939.0,
        795.794677734375
      ],
      [
        -300.0,
        -1972.0,
        765.0
      ],
      [
        -241.98204040527344,
        -1972.0,
        765.0
      ],
      [
        -290.0,
        -1972.0,
        770.0
      ],
      [
        -270.0,
        -1972.0,
        770.0
      ],
      [
        -270.0,
        -1972.0,
        770.0
      ],
      [
        -228.29660034179688,
        -1972.0,
        770.0
      ],
      [
        -300.0,
        -1972.0,
        770.0
      ],
      [
        -290.0,
        -1972.0,
        770.0
      ],
      [
        -300.0,
        -1972.0,
        765.0
      ],
      [
        -300.0,
        -1972.0,
        770.0
      ],
      [
        -349.0,
        -1972.0,
        780.0
      ],
      [
        -349.0,
        -1972.0,
        778.7999267578125
      ],
      [
        -349.0,
        -1972.0,
        780.0
      ],
      [
        -349.0,
        -1972.0,
        778.7999267578125
      ],
      [
        -286.0,
        -1972.0,
        765.0
      ],
      [
        -286.0,
        -1972.0,
        762.6779174804688
      ],
      [
        -272.0,
        -1972.0,
        765.0
      ],
      [
        -272.0,
        -1972.0,
        760.6438598632812
      ],
      [
        -317.39141845703125,
        -1977.0,
        778.800048828125
      ],
      [
        -362.6666564941406,
        -1977.0,
        778.7999877929688
      ],
      [
        -362.6666564941406,
        -1977.0,
        780.0
      ],
      [
        -317.39141845703125,
        -1977.0,
        778.800048828125
      ],
      [
        -317.3915710449219,
        -1987.0,
        778.8001098632812
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -3536.330078125,
        -300.0
      ],
      "bbox_max": [
        199.43505859375,
        2921.382080078125,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14295123517513275,
        0.10370974987745285,
        0.984281063079834
      ],
      "plane_d": -505.4921875,
      "bbox_min": [
        -4912.15185546875,
        -3271.534912109375,
        -300.0
      ],
      "bbox_max": [
        -645.88818359375,
        2200.0,
        1401.26220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9293507933616638,
        0.34574177861213684,
        0.1294977068901062
      ],
      "plane_d": 4632.30078125,
      "bbox_min": [
        -4205.1796875,
        -3169.967041015625,
        1220.0
      ],
      "bbox_max": [
        -3790.39453125,
        -2416.412353515625,
        1401.26220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4914821684360504,
        -0.7588846683502197,
        0.4272461533546448
      ],
      "plane_d": -492.10723876953125,
      "bbox_min": [
        -4205.1796875,
        -2659.13720703125,
        1220.0
      ],
      "bbox_max": [
        -3790.39453125,
        -2416.412353515625,
        1400.2685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5384979844093323,
        -0.7894291877746582,
        0.29465532302856445
      ],
      "plane_d": -215.73916625976562,
      "bbox_min": [
        -4205.1796875,
        -2659.13720703125,
        1220.0
      ],
      "bbox_max": [
        -3902.9365234375,
        -2462.454833984375,
        1400.2685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -4912.15185546875,
        -3126.308349609375,
        -300.0
      ],
      "bbox_max": [
        -645.88818359375,
        2200.0,
        1181.5367431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -4100.0,
        -2269.10009765625,
        -300.0
      ],
      "bbox_max": [
        -3509.2900390625,
        2200.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8203666806221008,
        0.5627213716506958,
        0.1017010360956192
      ],
      "plane_d": 4234.45703125,
      "bbox_min": [
        -3714.02392578125,
        -3126.308349609375,
        0.0
      ],
      "bbox_max": [
        -645.88818359375,
        -2269.10009765625,
        1181.5367431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6826116442680359,
        -0.6173016428947449,
        0.39112648367881775
      ],
      "plane_d": 596.6063232421875,
      "bbox_min": [
        -3699.87890625,
        -2864.23095703125,
        450.0
      ],
      "bbox_max": [
        -3288.09619140625,
        -2364.646728515625,
        1181.5367431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321149587631226,
        0.2707196772098541,
        0.2405669242143631
      ],
      "plane_d": 3807.88525390625,
      "bbox_min": [
        -3699.87890625,
        -2864.23095703125,
        450.0
      ],
      "bbox_max": [
        -3288.09619140625,
        -2376.406982421875,
        1181.5367431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499688863754272,
        0.6611048579216003,
        -0.022072864696383476
      ],
      "plane_d": 4375.75048828125,
      "bbox_min": [
        -3697.488525390625,
        -2864.23095703125,
        700.0
      ],
      "bbox_max": [
        -3288.09619140625,
        -2384.901123046875,
        1181.5367431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3662.39306640625,
        -2668.90283203125,
        984.034423828125
      ],
      "bbox_max": [
        -3452.950927734375,
        -2424.958984375,
        1174.1900634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3547.5966796875,
        -3126.308349609375,
        0.0
      ],
      "bbox_max": [
        -645.88818359375,
        -2289.004638671875,
        1150.8623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499688863754272,
        0.6611048579216003,
        -0.022072864696383476
      ],
      "plane_d": 4375.75048828125,
      "bbox_min": [
        -3452.950927734375,
        -2969.13720703125,
        735.013427734375
      ],
      "bbox_max": [
        -3195.179443359375,
        -2668.90283203125,
        984.034423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8710070252418518,
        0.4906066656112671,
        0.025533335283398628
      ],
      "plane_d": 1752.1368408203125,
      "bbox_min": [
        -739.388427734375,
        -2424.544921875,
        0.0
      ],
      "bbox_max": [
        -645.88818359375,
        -2289.004638671875,
        82.3607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7153007388114929,
        0.6982023119926453,
        0.029299555346369743
      ],
      "plane_d": 2127.64697265625,
      "bbox_min": [
        -739.388427734375,
        -2333.46923828125,
        0.0
      ],
      "bbox_max": [
        -697.9111328125,
        -2289.004638671875,
        82.3607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9409332871437073,
        0.3373378813266754,
        0.0291153434664011
      ],
      "plane_d": 1465.486572265625,
      "bbox_min": [
        -739.388427734375,
        -2333.46923828125,
        0.0
      ],
      "bbox_max": [
        -697.9111328125,
        -2289.004638671875,
        82.3607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -704.1276245117188,
        -2333.46923828125,
        0.0
      ],
      "bbox_max": [
        -697.9111328125,
        -2329.093994140625,
        74.91236877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8764687180519104,
        0.48085832595825195,
        0.02404039539396763
      ],
      "plane_d": 1733.21240234375,
      "bbox_min": [
        -699.4265747070312,
        -2424.544921875,
        0.0
      ],
      "bbox_max": [
        -645.88818359375,
        -2332.319091796875,
        73.79135131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -699.4265747070312,
        -2333.705078125,
        0.0
      ],
      "bbox_max": [
        -697.9111328125,
        -2332.319091796875,
        73.79135131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.834480881690979,
        0.550487756729126,
        0.024593127891421318
      ],
      "plane_d": 1872.022705078125,
      "bbox_min": [
        -659.8515014648438,
        -2424.544921875,
        0.0
      ],
      "bbox_max": [
        -645.88818359375,
        -2403.364990234375,
        68.94023895263672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14300712943077087,
        0.10372389853000641,
        0.9842714667320251
      ],
      "plane_d": -505.2385559082031,
      "bbox_min": [
        -4912.15185546875,
        -3536.330078125,
        66.72640991210938
      ],
      "bbox_max": [
        199.43505859375,
        2154.178466796875,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14295123517513275,
        0.10370974987745285,
        0.984281063079834
      ],
      "plane_d": -505.4921875,
      "bbox_min": [
        -4912.15185546875,
        -3518.638427734375,
        66.72640991210938
      ],
      "bbox_max": [
        199.43505859375,
        2154.178466796875,
        1434.669189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4914821684360504,
        -0.7588846683502197,
        0.4272461533546448
      ],
      "plane_d": -492.10723876953125,
      "bbox_min": [
        -4000.395751953125,
        -3278.162353515625,
        1181.2401123046875
      ],
      "bbox_max": [
        -3697.77392578125,
        -2329.13720703125,
        1434.638916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6826116442680359,
        -0.6173016428947449,
        0.39112648367881775
      ],
      "plane_d": 596.6063232421875,
      "bbox_min": [
        -3725.179443359375,
        -2378.998046875,
        1181.2401123046875
      ],
      "bbox_max": [
        -3699.20947265625,
        -2329.13720703125,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321149587631226,
        0.2707196772098541,
        0.2405669242143631
      ],
      "plane_d": 3807.88525390625,
      "bbox_min": [
        -3712.849365234375,
        -2378.998046875,
        1181.2401123046875
      ],
      "bbox_max": [
        -3699.20947265625,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8682754039764404,
        0.3892272710800171,
        0.3075709939002991
      ],
      "plane_d": 4276.294921875,
      "bbox_min": [
        -4000.395751953125,
        -3278.162353515625,
        1181.5616455078125
      ],
      "bbox_max": [
        -3697.77392578125,
        -2366.191162109375,
        1434.638916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321149587631226,
        0.2707196772098541,
        0.2405669242143631
      ],
      "plane_d": 3807.88525390625,
      "bbox_min": [
        -3712.849365234375,
        -2384.5537109375,
        1181.5616455078125
      ],
      "bbox_max": [
        -3697.77392578125,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499688863754272,
        0.6611048579216003,
        -0.022072864696383476
      ],
      "plane_d": 4375.75048828125,
      "bbox_min": [
        -3712.849365234375,
        -2384.5537109375,
        1182.2510986328125
      ],
      "bbox_max": [
        -3697.77392578125,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3712.849365234375,
        -2378.32275390625,
        1210.5433349609375
      ],
      "bbox_max": [
        -3702.43359375,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3725.179443359375,
        -3518.638427734375,
        66.72640991210938
      ],
      "bbox_max": [
        199.43505859375,
        -1918.043212890625,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499688863754272,
        0.6611048579216003,
        -0.022072864696383476
      ],
      "plane_d": 4375.75048828125,
      "bbox_min": [
        -3702.43359375,
        -2424.958984375,
        1174.1900634765625
      ],
      "bbox_max": [
        -3662.39306640625,
        -2378.32275390625,
        1210.5433349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321149587631226,
        0.2707196772098541,
        0.2405669242143631
      ],
      "plane_d": 3807.88525390625,
      "bbox_min": [
        -3698.34423828125,
        -2384.901123046875,
        1181.455322265625
      ],
      "bbox_max": [
        -3697.488525390625,
        -2382.34619140625,
        1182.2510986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -3725.179443359375,
        -3518.638427734375,
        66.72640991210938
      ],
      "bbox_max": [
        199.43505859375,
        -1918.043212890625,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8764687180519104,
        0.48085832595825195,
        0.02404039539396763
      ],
      "plane_d": 1733.21240234375,
      "bbox_min": [
        -3725.179443359375,
        -3518.638427734375,
        66.72640991210938
      ],
      "bbox_max": [
        199.43505859375,
        -2022.358642578125,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.034249160438776016,
        0.9861814379692078,
        0.16208960115909576
      ],
      "plane_d": 2026.164306640625,
      "bbox_min": [
        -3725.179443359375,
        -2812.84814453125,
        219.68569946289062
      ],
      "bbox_max": [
        -450.5662841796875,
        -2022.358642578125,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -3725.179443359375,
        -2812.84814453125,
        406.1564636230469
      ],
      "bbox_max": [
        -450.5662841796875,
        -2086.769287109375,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -3725.179443359375,
        -2576.875,
        406.1564636230469
      ],
      "bbox_max": [
        -673.747314453125,
        -2086.769287109375,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6762436032295227,
        0.7347268462181091,
        0.053582221269607544
      ],
      "plane_d": 2184.045166015625,
      "bbox_min": [
        -3725.179443359375,
        -2576.875,
        406.1564636230469
      ],
      "bbox_max": [
        -703.939208984375,
        -2086.769287109375,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8203666806221008,
        0.5627213716506958,
        0.1017010360956192
      ],
      "plane_d": 4234.45703125,
      "bbox_min": [
        -3725.179443359375,
        -2364.646728515625,
        1174.237060546875
      ],
      "bbox_max": [
        -3685.231201171875,
        -2323.554931640625,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004718358162790537,
        0.006487742997705936,
        0.9999678134918213
      ],
      "plane_d": -620.764404296875,
      "bbox_min": [
        -3699.87890625,
        -2576.875,
        639.4187622070312
      ],
      "bbox_max": [
        -716.3812866210938,
        -2314.45263671875,
        1181.9771728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -789.134033203125,
        -2435.9833984375,
        639.421142578125
      ],
      "bbox_max": [
        -719.7263793945312,
        -2323.13134765625,
        640.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6539711952209473,
        0.5783635973930359,
        0.4876650273799896
      ],
      "plane_d": 580.55517578125,
      "bbox_min": [
        -789.134033203125,
        -2435.9833984375,
        639.421142578125
      ],
      "bbox_max": [
        -719.7263793945312,
        -2356.77197265625,
        640.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00834949966520071,
        0.011480561457574368,
        0.9998992085456848
      ],
      "plane_d": -605.692626953125,
      "bbox_min": [
        -3699.87890625,
        -2576.875,
        639.4187622070312
      ],
      "bbox_max": [
        -716.3812866210938,
        -2314.45263671875,
        1181.9771728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -3699.87890625,
        -2576.875,
        639.4187622070312
      ],
      "bbox_max": [
        -716.3812866210938,
        -2314.45263671875,
        1181.9771728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -3699.87890625,
        -2576.875,
        639.4187622070312
      ],
      "bbox_max": [
        -716.3812866210938,
        -2314.45263671875,
        1181.9771728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321149587631226,
        0.2707196772098541,
        0.2405669242143631
      ],
      "plane_d": 3807.88525390625,
      "bbox_min": [
        -3699.87890625,
        -2382.568603515625,
        1181.2401123046875
      ],
      "bbox_max": [
        -3698.14501953125,
        -2376.406982421875,
        1181.9771728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -837.259033203125,
        -2400.9833984375,
        663.75
      ],
      "bbox_max": [
        -759.2192993164062,
        -2314.45263671875,
        684.730224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -924.609375,
        -2576.875,
        639.4187622070312
      ],
      "bbox_max": [
        -716.3812866210938,
        -2315.43408203125,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7721387147903442,
        -0.5362740755081177,
        0.34089893102645874
      ],
      "plane_d": -867.376708984375,
      "bbox_min": [
        -924.609375,
        -2576.875,
        639.4711303710938
      ],
      "bbox_max": [
        -716.3812866210938,
        -2356.79296875,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.675027072429657,
        -0.49037832021713257,
        -0.5512418150901794
      ],
      "plane_d": -246.33090209960938,
      "bbox_min": [
        -924.609375,
        -2576.875,
        639.4711303710938
      ],
      "bbox_max": [
        -716.3812866210938,
        -2356.79296875,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7694186568260193,
        -0.5282776355743408,
        0.35905107855796814
      ],
      "plane_d": -862.0191650390625,
      "bbox_min": [
        -924.609375,
        -2576.875,
        639.4711303710938
      ],
      "bbox_max": [
        -716.3812866210938,
        -2356.79296875,
        673.9669189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7135183811187744,
        0.6962600350379944,
        -0.0781886950135231
      ],
      "plane_d": 1183.0814208984375,
      "bbox_min": [
        -924.609375,
        -2576.875,
        639.4711303710938
      ],
      "bbox_max": [
        -716.3812866210938,
        -2356.79296875,
        673.9669189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08756548166275024,
        0.15032073855400085,
        0.9847517609596252
      ],
      "plane_d": -179.49295043945312,
      "bbox_min": [
        -915.7357788085938,
        -2576.875,
        641.796875
      ],
      "bbox_max": [
        -841.7667236328125,
        -2509.036865234375,
        652.96875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03805441036820412,
        0.1391364485025406,
        0.98954176902771
      ],
      "plane_d": -254.50424194335938,
      "bbox_min": [
        -915.7357788085938,
        -2576.875,
        646.73974609375
      ],
      "bbox_max": [
        -869.765625,
        -2529.48095703125,
        652.96875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6539711952209473,
        0.5783635973930359,
        0.4876650273799896
      ],
      "plane_d": 580.55517578125,
      "bbox_min": [
        -924.609375,
        -2564.302001953125,
        639.4711303710938
      ],
      "bbox_max": [
        -716.3812866210938,
        -2356.79296875,
        665.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8587960600852966,
        -0.3669477105140686,
        0.3575173616409302
      ],
      "plane_d": -379.470947265625,
      "bbox_min": [
        -924.609375,
        -2564.302001953125,
        641.796875
      ],
      "bbox_max": [
        -860.583251953125,
        -2487.185546875,
        665.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03805441036820412,
        0.1391364485025406,
        0.98954176902771
      ],
      "plane_d": -254.50424194335938,
      "bbox_min": [
        -924.609375,
        -2564.302001953125,
        641.796875
      ],
      "bbox_max": [
        -860.583251953125,
        -2491.873046875,
        652.96875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08756548166275024,
        0.15032073855400085,
        0.9847517609596252
      ],
      "plane_d": -179.49295043945312,
      "bbox_min": [
        -890.0479736328125,
        -2529.48095703125,
        641.796875
      ],
      "bbox_max": [
        -860.583251953125,
        -2491.873046875,
        646.73974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -969.41943359375,
        -2371.302734375,
        467.370361328125
      ],
      "bbox_max": [
        -703.939208984375,
        -2121.847900390625,
        867.2271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -768.4713134765625,
        -2360.521240234375,
        639.3530883789062
      ],
      "bbox_max": [
        -711.3695678710938,
        -2310.43701171875,
        686.684326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -761.555908203125,
        -2318.2919921875,
        639.3778686523438
      ],
      "bbox_max": [
        -758.4019775390625,
        -2314.276123046875,
        639.4259643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7135183811187744,
        0.6962600350379944,
        -0.0781886950135231
      ],
      "plane_d": 1183.0814208984375,
      "bbox_min": [
        -768.4713134765625,
        -2360.521240234375,
        639.3538208007812
      ],
      "bbox_max": [
        -711.3695678710938,
        -2310.43701171875,
        686.684326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -768.4713134765625,
        -2360.521240234375,
        639.3538208007812
      ],
      "bbox_max": [
        -711.3695678710938,
        -2310.43701171875,
        686.684326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -759.2192993164062,
        -2324.705810546875,
        684.730224609375
      ],
      "bbox_max": [
        -754.6053466796875,
        -2319.55615234375,
        686.684326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6539711952209473,
        0.5783635973930359,
        0.4876650273799896
      ],
      "plane_d": 580.55517578125,
      "bbox_min": [
        -766.3020629882812,
        -2360.521240234375,
        639.3538208007812
      ],
      "bbox_max": [
        -711.3695678710938,
        -2310.982421875,
        651.81005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -766.3020629882812,
        -2318.289794921875,
        639.3829345703125
      ],
      "bbox_max": [
        -758.4041137695312,
        -2310.982421875,
        651.81005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -766.3020629882812,
        -2315.43408203125,
        648.81787109375
      ],
      "bbox_max": [
        -762.5053100585938,
        -2310.982421875,
        651.81005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -969.41943359375,
        -2363.59228515625,
        467.370361328125
      ],
      "bbox_max": [
        -713.2835083007812,
        -2121.847900390625,
        867.2271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -969.41943359375,
        -2363.59228515625,
        467.370361328125
      ],
      "bbox_max": [
        -713.2835083007812,
        -2121.847900390625,
        866.0255126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005043566226959,
        0.9524807333946228,
        0.04977479577064514
      ],
      "plane_d": 2285.599609375,
      "bbox_min": [
        -969.41943359375,
        -2333.9970703125,
        467.370361328125
      ],
      "bbox_max": [
        -734.5917358398438,
        -2121.847900390625,
        741.552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34745892882347107,
        0.9374035000801086,
        0.023386523127555847
      ],
      "plane_d": 2312.29541015625,
      "bbox_min": [
        -964.5498046875,
        -2333.9970703125,
        467.370361328125
      ],
      "bbox_max": [
        -734.5917358398438,
        -2121.847900390625,
        686.6563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -765.279052734375,
        -2333.9970703125,
        639.3507080078125
      ],
      "bbox_max": [
        -734.5917358398438,
        -2306.33251953125,
        686.6563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -758.4041137695312,
        -2314.277587890625,
        639.3507080078125
      ],
      "bbox_max": [
        -756.310791015625,
        -2311.613525390625,
        639.3829345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -765.279052734375,
        -2319.914306640625,
        639.3507080078125
      ],
      "bbox_max": [
        -752.123779296875,
        -2306.33251953125,
        686.6563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -765.279052734375,
        -2319.914306640625,
        639.3507080078125
      ],
      "bbox_max": [
        -752.123779296875,
        -2306.33251953125,
        686.6563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -754.98779296875,
        -2319.914306640625,
        685.8677978515625
      ],
      "bbox_max": [
        -752.123779296875,
        -2316.721435546875,
        686.6563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -763.1380004882812,
        -2314.276123046875,
        639.3507080078125
      ],
      "bbox_max": [
        -756.310791015625,
        -2307.621826171875,
        651.2776489257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -763.1380004882812,
        -2311.396728515625,
        649.1970825195312
      ],
      "bbox_max": [
        -760.0313110351562,
        -2307.621826171875,
        651.2776489257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -969.41943359375,
        -2144.2890625,
        650.2186279296875
      ],
      "bbox_max": [
        -924.068359375,
        -2127.7587890625,
        741.552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -765.0918579101562,
        -2352.376220703125,
        639.28125
      ],
      "bbox_max": [
        -714.7833862304688,
        -2295.123779296875,
        867.2271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -728.7424926757812,
        -2352.376220703125,
        686.9425659179688
      ],
      "bbox_max": [
        -720.4447631835938,
        -2339.38037109375,
        865.884033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -765.0918579101562,
        -2350.402099609375,
        639.28125
      ],
      "bbox_max": [
        -714.7833862304688,
        -2295.123779296875,
        867.2271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -762.0160522460938,
        -2308.695556640625,
        647.44970703125
      ],
      "bbox_max": [
        -755.9295654296875,
        -2302.23095703125,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -762.0160522460938,
        -2306.4140625,
        675.0604858398438
      ],
      "bbox_max": [
        -761.55126953125,
        -2305.747802734375,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -765.0918579101562,
        -2317.2421875,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2295.123779296875,
        759.6312255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -761.9382934570312,
        -2316.721435546875,
        675.13037109375
      ],
      "bbox_max": [
        -752.123779296875,
        -2305.747802734375,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -759.273681640625,
        -2317.2421875,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2302.23388671875,
        650.0578002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -756.310791015625,
        -2317.2421875,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2308.314453125,
        639.357421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -757.0103149414062,
        -2350.402099609375,
        639.28125
      ],
      "bbox_max": [
        -714.7833862304688,
        -2299.9072265625,
        666.3358764648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -757.0103149414062,
        -2303.119873046875,
        648.4926147460938
      ],
      "bbox_max": [
        -755.6077270507812,
        -2300.06005859375,
        666.3358764648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -755.9369506835938,
        -2302.23388671875,
        650.0578002929688
      ],
      "bbox_max": [
        -755.906494140625,
        -2302.20166015625,
        650.1961669921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -755.9295654296875,
        -2303.119873046875,
        648.4926147460938
      ],
      "bbox_max": [
        -755.6077270507812,
        -2302.20166015625,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -756.3975830078125,
        -2308.314453125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2299.9072265625,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -756.3975830078125,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2299.9072265625,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9562264084815979,
        0.139556884765625,
        0.257205992937088
      ],
      "plane_d": 836.2110595703125,
      "bbox_min": [
        -742.0281372070312,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2313.18505859375,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8815664052963257,
        0.47085967659950256,
        0.03364010900259018
      ],
      "plane_d": 1707.248779296875,
      "bbox_min": [
        -742.0281372070312,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2313.18505859375,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -742.0281372070312,
        -2355.322998046875,
        639.28125
      ],
      "bbox_max": [
        -706.224853515625,
        -2313.18505859375,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7135183811187744,
        0.6962600350379944,
        -0.0781886950135231
      ],
      "plane_d": 1183.0814208984375,
      "bbox_min": [
        -714.5018920898438,
        -2355.322998046875,
        639.28125
      ],
      "bbox_max": [
        -706.224853515625,
        -2344.337158203125,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6539711952209473,
        0.5783635973930359,
        0.4876650273799896
      ],
      "plane_d": 580.55517578125,
      "bbox_min": [
        -714.5018920898438,
        -2355.322998046875,
        639.28125
      ],
      "bbox_max": [
        -706.224853515625,
        -2344.337158203125,
        649.505126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -488.8430480957031,
        -2803.54736328125,
        529.9791259765625
      ],
      "bbox_max": [
        -482.3701171875,
        -2800.61376953125,
        879.7427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -487.7523498535156,
        -2812.84814453125,
        529.9791259765625
      ],
      "bbox_max": [
        -450.5662841796875,
        -2800.61376953125,
        879.6206665039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6762436032295227,
        0.7347268462181091,
        0.053582221269607544
      ],
      "plane_d": 2184.045166015625,
      "bbox_min": [
        -1049.821533203125,
        -2165.07177734375,
        219.68569946289062
      ],
      "bbox_max": [
        -924.2988891601562,
        -2022.358642578125,
        884.4805297851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21514897048473358,
        0.9664539694786072,
        0.14027751982212067
      ],
      "plane_d": 1756.6002197265625,
      "bbox_min": [
        -986.5693359375,
        -2165.07177734375,
        650.2186279296875
      ],
      "bbox_max": [
        -954.936279296875,
        -2127.7587890625,
        884.4805297851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21514897048473358,
        0.9664539694786072,
        0.14027751982212067
      ],
      "plane_d": 1756.6002197265625,
      "bbox_min": [
        -969.41943359375,
        -2157.806640625,
        650.2186279296875
      ],
      "bbox_max": [
        -924.2988891601562,
        -2127.7587890625,
        879.4498291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -969.41943359375,
        -2145.107666015625,
        650.2186279296875
      ],
      "bbox_max": [
        -925.69384765625,
        -2127.7587890625,
        832.941162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8710070252418518,
        0.4906066656112671,
        0.025533335283398628
      ],
      "plane_d": 1752.1368408203125,
      "bbox_min": [
        -708.7366943359375,
        -3518.638427734375,
        66.72640991210938
      ],
      "bbox_max": [
        199.43505859375,
        -2341.75634765625,
        876.3236083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -550.1892700195312,
        -2814.923583984375,
        468.4744567871094
      ],
      "bbox_max": [
        -443.48846435546875,
        -2618.961181640625,
        876.3236083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -458.31414794921875,
        -2814.923583984375,
        558.68603515625
      ],
      "bbox_max": [
        -443.48846435546875,
        -2811.09033203125,
        876.3236083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.834480881690979,
        0.550487756729126,
        0.024593127891421318
      ],
      "plane_d": 1872.022705078125,
      "bbox_min": [
        -708.7366943359375,
        -3518.638427734375,
        66.72640991210938
      ],
      "bbox_max": [
        199.43505859375,
        -2344.52734375,
        875.587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -579.789306640625,
        -2830.772216796875,
        443.0972900390625
      ],
      "bbox_max": [
        -394.7469177246094,
        -2544.010009765625,
        875.587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -451.7450866699219,
        -2830.772216796875,
        565.0746459960938
      ],
      "bbox_max": [
        -394.7469177246094,
        -2813.421875,
        875.587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -708.7366943359375,
        -3518.638427734375,
        443.0972900390625
      ],
      "bbox_max": [
        199.43505859375,
        -2344.52734375,
        869.9696655273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313450217247009,
        0.5555300712585449,
        0.01586890034377575
      ],
      "plane_d": 1886.90283203125,
      "bbox_min": [
        -708.7366943359375,
        -2544.7578125,
        443.0972900390625
      ],
      "bbox_max": [
        -578.171875,
        -2344.52734375,
        866.5881958007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -689.266845703125,
        -2459.815673828125,
        558.2156982421875
      ],
      "bbox_max": [
        -642.5032958984375,
        -2391.343994140625,
        865.8818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -689.266845703125,
        -2405.76025390625,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2391.343994140625,
        865.4605712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -708.7366943359375,
        -2349.337158203125,
        630.2252807617188
      ],
      "bbox_max": [
        -704.3489990234375,
        -2344.52734375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -708.7366943359375,
        -2349.337158203125,
        641.6248779296875
      ],
      "bbox_max": [
        -704.5856323242188,
        -2344.52734375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8467844724655151,
        0.531133234500885,
        0.029217718169093132
      ],
      "plane_d": 1677.308349609375,
      "bbox_min": [
        -401.5820617675781,
        -3518.638427734375,
        609.0699462890625
      ],
      "bbox_max": [
        199.43505859375,
        -2829.477783203125,
        869.9696655273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5775443315505981,
        0.816006064414978,
        0.024013593792915344
      ],
      "plane_d": 2576.892578125,
      "bbox_min": [
        -401.5820617675781,
        -3518.638427734375,
        609.0699462890625
      ],
      "bbox_max": [
        199.43505859375,
        -2829.477783203125,
        869.9696655273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        -55.04105758666992,
        -3518.638427734375,
        748.3753662109375
      ],
      "bbox_max": [
        199.43505859375,
        -3144.068603515625,
        855.624267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5784721970558167,
        0.8153333067893982,
        0.024523697793483734
      ],
      "plane_d": 2574.3935546875,
      "bbox_min": [
        -55.04105758666992,
        -3165.64599609375,
        765.4616088867188
      ],
      "bbox_max": [
        -22.141357421875,
        -3144.068603515625,
        852.6356201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -401.5820617675781,
        -3018.20361328125,
        609.0699462890625
      ],
      "bbox_max": [
        -229.613525390625,
        -2829.477783203125,
        869.9696655273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -352.2469787597656,
        -3018.20361328125,
        651.6136474609375
      ],
      "bbox_max": [
        -229.613525390625,
        -2845.004150390625,
        867.947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -326.8922119140625,
        -2929.62353515625,
        688.5384521484375
      ],
      "bbox_max": [
        -312.7353515625,
        -2904.17919921875,
        867.947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388458251953125,
        0.6731601357460022,
        0.031021643429994583
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -318.19537353515625,
        -2929.62353515625,
        688.5384521484375
      ],
      "bbox_max": [
        -312.7353515625,
        -2924.27294921875,
        867.947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388458251953125,
        0.6731601357460022,
        0.031021643429994583
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -315.3895263671875,
        -3018.20361328125,
        688.5384521484375
      ],
      "bbox_max": [
        -229.613525390625,
        -2924.27294921875,
        867.8637084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -257.3710632324219,
        -3018.20361328125,
        699.149169921875
      ],
      "bbox_max": [
        -229.613525390625,
        -2993.223876953125,
        866.1363525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7153007388114929,
        0.6982023119926453,
        0.029299555346369743
      ],
      "plane_d": 2127.64697265625,
      "bbox_min": [
        -928.2157592773438,
        -2372.12451171875,
        74.912353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1918.043212890625,
        874.1994018554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -928.2157592773438,
        -2304.79736328125,
        441.74444580078125
      ],
      "bbox_max": [
        -750.960693359375,
        -2135.580078125,
        874.1994018554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21514897048473358,
        0.9664539694786072,
        0.14027751982212067
      ],
      "plane_d": 1756.6002197265625,
      "bbox_min": [
        -928.2157592773438,
        -2301.549560546875,
        642.3101806640625
      ],
      "bbox_max": [
        -754.3570556640625,
        -2145.107666015625,
        874.1994018554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -756.52685546875,
        -2301.549560546875,
        642.3101806640625
      ],
      "bbox_max": [
        -754.3570556640625,
        -2299.30322265625,
        645.4570922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -765.2636108398438,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2294.6083984375,
        754.5840454101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -754.571533203125,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2301.44482421875,
        643.3828735351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34745892882347107,
        0.9374035000801086,
        0.023386523127555847
      ],
      "plane_d": 2312.29541015625,
      "bbox_min": [
        -926.8214111328125,
        -2151.04931640625,
        441.74444580078125
      ],
      "bbox_max": [
        -899.52685546875,
        -2135.580078125,
        697.4168701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005043566226959,
        0.9524807333946228,
        0.04977479577064514
      ],
      "plane_d": 2285.599609375,
      "bbox_min": [
        -926.8214111328125,
        -2151.04931640625,
        583.9189453125
      ],
      "bbox_max": [
        -903.4149169921875,
        -2137.733642578125,
        697.4168701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9409332871437073,
        0.3373378813266754,
        0.0291153434664011
      ],
      "plane_d": 1465.486572265625,
      "bbox_min": [
        -909.4484252929688,
        -2372.12451171875,
        82.31546020507812
      ],
      "bbox_max": [
        162.44873046875,
        -1918.043212890625,
        872.2504272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7385133504867554,
        0.6736845970153809,
        0.027333253994584084
      ],
      "plane_d": 2070.8447265625,
      "bbox_min": [
        -909.4484252929688,
        -2304.79736328125,
        386.6241149902344
      ],
      "bbox_max": [
        -750.960693359375,
        -2144.3037109375,
        872.2504272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34745892882347107,
        0.9374035000801086,
        0.023386523127555847
      ],
      "plane_d": 2312.29541015625,
      "bbox_min": [
        -909.4484252929688,
        -2304.79736328125,
        386.6241149902344
      ],
      "bbox_max": [
        -750.960693359375,
        -2144.3037109375,
        872.2504272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -909.4484252929688,
        -2304.79736328125,
        560.3877563476562
      ],
      "bbox_max": [
        -750.960693359375,
        -2147.172119140625,
        872.2504272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -909.4484252929688,
        -2300.9306640625,
        629.1983032226562
      ],
      "bbox_max": [
        -757.1561889648438,
        -2147.172119140625,
        872.2504272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -909.4484252929688,
        -2168.956298828125,
        629.1983032226562
      ],
      "bbox_max": [
        -852.66796875,
        -2147.172119140625,
        872.2504272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005043566226959,
        0.9524807333946228,
        0.04977479577064514
      ],
      "plane_d": 2285.599609375,
      "bbox_min": [
        -904.4052734375,
        -2168.956298828125,
        629.1983032226562
      ],
      "bbox_max": [
        -852.66796875,
        -2147.172119140625,
        733.704833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -771.5575561523438,
        -2300.9306640625,
        745.6580810546875
      ],
      "bbox_max": [
        -759.466064453125,
        -2275.722412109375,
        865.232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -768.5449829101562,
        -2304.79736328125,
        560.3877563476562
      ],
      "bbox_max": [
        -750.960693359375,
        -2257.5107421875,
        866.58154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -768.0648193359375,
        -2303.75732421875,
        759.6312255859375
      ],
      "bbox_max": [
        -758.6404418945312,
        -2280.178466796875,
        866.58154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -753.873046875,
        -2300.73291015625,
        630.2252807617188
      ],
      "bbox_max": [
        -752.4913940429688,
        -2299.746337890625,
        638.5557861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.871337890625,
        -2304.58740234375,
        641.6248779296875
      ],
      "bbox_max": [
        -751.1085205078125,
        -2299.947021484375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -881.6675415039062,
        -2170.06396484375,
        733.704833984375
      ],
      "bbox_max": [
        -852.66796875,
        -2161.587646484375,
        869.2028198242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -856.5706787109375,
        -2259.71875,
        560.3877563476562
      ],
      "bbox_max": [
        -765.472412109375,
        -2168.956298828125,
        866.44970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -856.5706787109375,
        -2170.197509765625,
        733.704833984375
      ],
      "bbox_max": [
        -852.66796875,
        -2168.956298828125,
        866.44970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -856.1751708984375,
        -2222.050537109375,
        733.704833984375
      ],
      "bbox_max": [
        -808.619384765625,
        -2168.956298828125,
        866.4063110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -856.1751708984375,
        -2170.466796875,
        733.704833984375
      ],
      "bbox_max": [
        -852.66796875,
        -2168.956298828125,
        866.4063110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -774.0728149414062,
        -2372.12451171875,
        560.3877563476562
      ],
      "bbox_max": [
        162.44873046875,
        -1918.043212890625,
        863.9918212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -774.0728149414062,
        -2259.916259765625,
        560.3877563476562
      ],
      "bbox_max": [
        -765.472412109375,
        -2257.5107421875,
        863.911376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137159526348114,
        -0.01990017108619213,
        0.9903489947319031
      ],
      "plane_d": -646.2860107421875,
      "bbox_min": [
        -752.7722778320312,
        -2372.12451171875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1918.043212890625,
        825.35693359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        -752.7722778320312,
        -2348.42529296875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1979.0,
        697.1158447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13787776231765747,
        -0.03273407742381096,
        0.9899080991744995
      ],
      "plane_d": -673.2636108398438,
      "bbox_min": [
        -752.7722778320312,
        -2348.42529296875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1979.0,
        697.1158447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -752.7722778320312,
        -2348.42529296875,
        618.4127807617188
      ],
      "bbox_max": [
        -64.5244140625,
        -1979.0,
        697.0984497070312
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -752.7145385742188,
        -2348.38916015625,
        618.4127807617188
      ],
      "bbox_max": [
        -64.5244140625,
        -1979.0,
        639.2814331054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        639.2814331054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        639.2814331054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -1979.0,
        635.0
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        639.2814331054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -195.0,
        -2181.199951171875,
        618.4127807617188
      ],
      "bbox_max": [
        -64.5244140625,
        -1979.0,
        635.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      "bbox_max": [
        -64.5244140625,
        -2044.573974609375,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -105.2154541015625,
        -2068.18017578125,
        618.412841796875
      ],
      "bbox_max": [
        -64.5244140625,
        -2044.573974609375,
        624.7360229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6248225569725037,
        0.7807667851448059,
        -0.0
      ],
      "plane_d": 1655.082763671875,
      "bbox_min": [
        -90.278564453125,
        -2068.18017578125,
        618.412841796875
      ],
      "bbox_max": [
        -64.5244140625,
        -2044.573974609375,
        622.0775756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 1923.475830078125,
      "bbox_min": [
        -90.278564453125,
        -2048.967529296875,
        618.412841796875
      ],
      "bbox_max": [
        -79.672119140625,
        -2044.573974609375,
        622.0775756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      "bbox_max": [
        -66.12939453125,
        -2069.38525390625,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      "bbox_max": [
        -79.672119140625,
        -2069.38525390625,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        618.5244140625
      ],
      "bbox_max": [
        -92.20442962646484,
        -2071.60009765625,
        623.3185424804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        618.5244140625
      ],
      "bbox_max": [
        -92.20442199707031,
        -2136.069580078125,
        622.3348388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      "bbox_max": [
        -89.30126953125,
        -2069.38525390625,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2081.89990234375,
      "bbox_min": [
        -91.10107421875,
        -2081.89990234375,
        618.5244140625
      ],
      "bbox_max": [
        -89.30126953125,
        -2081.89990234375,
        623.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      "bbox_max": [
        -89.30126953125,
        -2069.38525390625,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2127.946044921875,
      "bbox_min": [
        -91.10107421875,
        -2127.946044921875,
        618.5244140625
      ],
      "bbox_max": [
        -89.30126953125,
        -2127.946044921875,
        622.4420776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      "bbox_max": [
        -100.88525390625,
        -2069.38525390625,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      "bbox_max": [
        -100.88525390625,
        -2139.665283203125,
        624.0093994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -195.0,
        -2150.27197265625,
        618.412841796875
      ],
      "bbox_max": [
        -105.2154541015625,
        -1979.0,
        635.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        618.412841796875
      ],
      "bbox_max": [
        -105.22237396240234,
        -2064.5546875,
        625.504150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.177978515625,
        -2069.38525390625,
        618.412841796875
      ],
      "bbox_max": [
        -105.22237396240234,
        -2069.026611328125,
        625.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -107.177978515625,
        -2140.8193359375,
        618.412841796875
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        624.2633666992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -2059.573974609375,
        618.412841796875
      ],
      "bbox_max": [
        -105.2154541015625,
        -1979.0,
        635.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -195.0,
        -2059.573974609375,
        618.412841796875
      ],
      "bbox_max": [
        -105.2154541015625,
        -1979.0,
        635.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -195.0,
        -1979.0,
        635.0
      ],
      "bbox_max": [
        -194.09686279296875,
        -1979.0,
        635.1311645507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -752.7722778320312,
        -2348.42529296875,
        639.2811889648438
      ],
      "bbox_max": [
        -249.7219696044922,
        -1979.0,
        697.0984497070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -752.7722778320312,
        -2304.796142578125,
        639.28125
      ],
      "bbox_max": [
        -356.5550231933594,
        -2022.1925048828125,
        697.0984497070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -752.7722778320312,
        -2299.947021484375,
        639.28125
      ],
      "bbox_max": [
        -407.5297546386719,
        -2058.7177734375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -600.715087890625,
        -2195.333251953125,
        639.28125
      ],
      "bbox_max": [
        -510.4124755859375,
        -2130.041748046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -600.715087890625,
        -2195.306396484375,
        639.2813110351562
      ],
      "bbox_max": [
        -598.208740234375,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -599.2575073242188,
        -2195.333251953125,
        639.28125
      ],
      "bbox_max": [
        -510.4124755859375,
        -2130.041748046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -599.2575073242188,
        -2195.333251953125,
        639.2813110351562
      ],
      "bbox_max": [
        -598.191650390625,
        -2193.659912109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -599.1027221679688,
        -2195.333251953125,
        639.28125
      ],
      "bbox_max": [
        -407.5297546386719,
        -2058.7177734375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -599.1027221679688,
        -2195.333251953125,
        639.28125
      ],
      "bbox_max": [
        -413.5885009765625,
        -2063.05908203125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -416.1728515625,
        -2064.681640625,
        639.28125
      ],
      "bbox_max": [
        -413.5885009765625,
        -2063.05908203125,
        639.4384155273438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -635.3164672851562,
        -2193.9814453125,
        641.6248779296875
      ],
      "bbox_max": [
        -356.5550231933594,
        -2022.1925048828125,
        697.0984497070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -581.8072509765625,
        -2132.99560546875,
        641.6248779296875
      ],
      "bbox_max": [
        -489.5420837402344,
        -2082.13818359375,
        690.3377685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -438.2563171386719,
        -2063.322021484375,
        641.6248779296875
      ],
      "bbox_max": [
        -356.5550231933594,
        -2022.1925048828125,
        672.068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -438.2563171386719,
        -2063.322021484375,
        641.6248779296875
      ],
      "bbox_max": [
        -387.0029296875,
        -2031.0792236328125,
        672.068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5919927358627319,
        0.8059433102607727,
        0.0
      ],
      "plane_d": 1469.767333984375,
      "bbox_min": [
        -708.852294921875,
        -2348.42529296875,
        639.2811889648438
      ],
      "bbox_max": [
        -249.7219696044922,
        -1979.0,
        679.6005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -708.852294921875,
        -2348.42529296875,
        639.2811889648438
      ],
      "bbox_max": [
        -249.7219696044922,
        -2018.424560546875,
        679.6005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -704.5856323242188,
        -2348.42529296875,
        639.2811889648438
      ],
      "bbox_max": [
        -314.135009765625,
        -2083.615234375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -351.3531799316406,
        -2083.615234375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -360.30859375,
        -2091.77294921875,
        639.9999389648438
      ],
      "bbox_max": [
        -351.3531799316406,
        -2086.47412109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -357.18017578125,
        -2086.585205078125,
        639.9999389648438
      ],
      "bbox_max": [
        -351.3531799316406,
        -2086.47412109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39295151829719543,
        0.5888877511024475,
        0.7062578797340393
      ],
      "plane_d": 638.5640869140625,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -392.548828125,
        -2117.024169921875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -392.548828125,
        -2117.024169921875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -402.07666015625,
        -2123.822265625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8059484362602234,
        0.5919858813285828,
        -0.0
      ],
      "plane_d": 1778.2655029296875,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -563.099609375,
        -2240.273681640625,
        639.28125
      ],
      "bbox_max": [
        -561.334716796875,
        -2237.27685546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -563.099609375,
        -2239.679443359375,
        639.28125
      ],
      "bbox_max": [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3294079899787903,
        0.5428956151008606,
        0.7724989652633667
      ],
      "plane_d": 525.8377685546875,
      "bbox_min": [
        -402.07666015625,
        -2123.822265625,
        640.0
      ],
      "bbox_max": [
        -392.548828125,
        -2117.024169921875,
        640.4600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.639268015831476e-06,
        2.1011842363805044e-06,
        1.0
      ],
      "plane_d": -639.994140625,
      "bbox_min": [
        -393.1123962402344,
        -2117.414306640625,
        640.0
      ],
      "bbox_max": [
        -392.548828125,
        -2117.024169921875,
        640.0736083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8492053747177124,
        0.4903010427951813,
        -0.19610005617141724
      ],
      "plane_d": 1497.4755859375,
      "bbox_min": [
        -393.1123962402344,
        -2117.414306640625,
        640.0
      ],
      "bbox_max": [
        -393.0628967285156,
        -2117.34912109375,
        640.0736083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -402.55328369140625,
        -2124.443359375,
        640.9903564453125
      ],
      "bbox_max": [
        -351.6673278808594,
        -2086.480224609375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -357.18017578125,
        -2086.585205078125,
        641.346923828125
      ],
      "bbox_max": [
        -351.6673278808594,
        -2086.480224609375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -402.55328369140625,
        -2124.443359375,
        641.0430297851562
      ],
      "bbox_max": [
        -400.4469909667969,
        -2122.88134765625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -402.55328369140625,
        -2124.443359375,
        641.0430297851562
      ],
      "bbox_max": [
        -402.07666015625,
        -2123.822265625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8059484362602234,
        0.5919858813285828,
        -0.0
      ],
      "plane_d": 1778.2655029296875,
      "bbox_min": [
        -563.099609375,
        -2238.921875,
        639.28125
      ],
      "bbox_max": [
        -561.891357421875,
        -2237.27685546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.28125
      ],
      "bbox_max": [
        -314.135009765625,
        -2086.4697265625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -639.9998779296875,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.28125
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        641.6248779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.3294079899787903,
        0.5428956151008606,
        0.7724989652633667
      ],
      "plane_d": 525.8377685546875,
      "bbox_min": [
        -394.21533203125,
        -2118.445556640625,
        639.28125
      ],
      "bbox_max": [
        -371.0722961425781,
        -2101.98828125,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3261350691318512,
        0.5656665563583374,
        0.757401704788208
      ],
      "plane_d": 584.7686767578125,
      "bbox_min": [
        -392.548828125,
        -2117.024169921875,
        639.28125
      ],
      "bbox_max": [
        -371.0722961425781,
        -2101.98828125,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3580712676048279,
        0.6098201870918274,
        0.7070391774177551
      ],
      "plane_d": 697.9349975585938,
      "bbox_min": [
        -392.0283203125,
        -2116.63818359375,
        639.28125
      ],
      "bbox_max": [
        -380.9677734375,
        -2109.384765625,
        639.9358520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -381.4368591308594,
        -2110.094482421875,
        639.28125
      ],
      "bbox_max": [
        -371.0722961425781,
        -2101.98828125,
        639.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3726341724395752,
        0.5366532206535339,
        0.7570648193359375
      ],
      "plane_d": 506.0691223144531,
      "bbox_min": [
        -380.9677734375,
        -2110.094482421875,
        639.28125
      ],
      "bbox_max": [
        -371.07244873046875,
        -2103.527587890625,
        639.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3294079899787903,
        0.5428956151008606,
        0.7724989652633667
      ],
      "plane_d": 525.8377685546875,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        639.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        0.8660230040550232,
        5.416695330495713e-06
      ],
      "plane_d": 1638.2353515625,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        639.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2089.988525390625,
        641.6248779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.550537109375,
        -2120.05419921875,
        640.0
      ],
      "bbox_max": [
        -391.2690734863281,
        -2118.259765625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        639.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2091.35302734375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -345.839111328125,
        -2091.495361328125,
        639.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2091.35302734375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -392.9297180175781,
        -2118.322265625,
        639.9999389648438
      ],
      "bbox_max": [
        -345.83905029296875,
        -2089.988525390625,
        641.5885009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8492053747177124,
        0.4903010427951813,
        -0.19610005617141724
      ],
      "plane_d": 1497.4755859375,
      "bbox_min": [
        -392.9297180175781,
        -2118.322265625,
        640.0
      ],
      "bbox_max": [
        -392.44219970703125,
        -2117.66552734375,
        640.6255493164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -404.71063232421875,
        -2127.013427734375,
        639.9999389648438
      ],
      "bbox_max": [
        -345.8052673339844,
        -2086.4697265625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.3531799316406,
        -2091.38427734375,
        639.9999389648438
      ],
      "bbox_max": [
        -345.8052673339844,
        -2086.4697265625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -351.3531799316406,
        -2086.47412109375,
        639.9999389648438
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3726341724395752,
        0.5366532206535339,
        0.7570648193359375
      ],
      "plane_d": 506.0691223144531,
      "bbox_min": [
        -404.71063232421875,
        -2127.013427734375,
        639.9999389648438
      ],
      "bbox_max": [
        -358.675537109375,
        -2096.52099609375,
        641.6248779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -404.71063232421875,
        -2127.013427734375,
        640.0
      ],
      "bbox_max": [
        -371.94342041015625,
        -2106.4248046875,
        641.6248779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -404.71063232421875,
        -2127.013427734375,
        640.62548828125
      ],
      "bbox_max": [
        -391.6632080078125,
        -2118.15966796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.44219970703125,
        -2119.208984375,
        640.62548828125
      ],
      "bbox_max": [
        -391.6632080078125,
        -2118.15966796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3580781817436218,
        0.6098334789276123,
        0.7070240378379822
      ],
      "plane_d": 697.9700927734375,
      "bbox_min": [
        -404.71063232421875,
        -2126.043212890625,
        641.3375854492188
      ],
      "bbox_max": [
        -402.5533142089844,
        -2124.443359375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35808607935905457,
        0.6098407506942749,
        0.7070139646530151
      ],
      "plane_d": 697.9887084960938,
      "bbox_min": [
        -400.4471740722656,
        -2122.88134765625,
        640.0
      ],
      "bbox_max": [
        -392.3555908203125,
        -2117.405517578125,
        641.1256103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8492053747177124,
        0.4903010427951813,
        -0.19610005617141724
      ],
      "plane_d": 1497.4755859375,
      "bbox_min": [
        -393.0747985839844,
        -2118.259765625,
        640.0
      ],
      "bbox_max": [
        -392.3555908203125,
        -2117.405517578125,
        641.1256103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -561.7347412109375,
        -2288.8349609375,
        641.6248779296875
      ],
      "bbox_max": [
        -249.7219696044922,
        -2018.424560546875,
        679.6005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      "bbox_max": [
        -249.7219696044922,
        -2018.424560546875,
        676.8448486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -406.736328125,
        -2131.402587890625,
        641.6248779296875
      ],
      "bbox_max": [
        -249.7219696044922,
        -2042.298095703125,
        656.8388061523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -406.736328125,
        -2131.402587890625,
        641.6248779296875
      ],
      "bbox_max": [
        -299.1034240722656,
        -2076.33544921875,
        656.8388061523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        641.6248779296875
      ],
      "bbox_max": [
        -359.34197998046875,
        -2101.172119140625,
        642.8467407226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        641.6248779296875
      ],
      "bbox_max": [
        -406.5956115722656,
        -2129.710693359375,
        641.7142333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        641.6248779296875
      ],
      "bbox_max": [
        -359.34197998046875,
        -2101.172119140625,
        642.8467407226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -337.21307373046875,
        -2104.4287109375,
        652.1087646484375
      ],
      "bbox_max": [
        -299.1034240722656,
        -2076.33544921875,
        656.7574462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26295778155326843,
        0.5350207686424255,
        0.8028736114501953
      ],
      "plane_d": 510.40802001953125,
      "bbox_min": [
        -337.21307373046875,
        -2104.4287109375,
        652.5119018554688
      ],
      "bbox_max": [
        -326.5126953125,
        -2095.089111328125,
        656.7574462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -292.9984130859375,
        -2070.21044921875,
        645.7384643554688
      ],
      "bbox_max": [
        -249.7219696044922,
        -2042.298095703125,
        645.8165893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -268.6907958984375,
        -2067.064453125,
        645.7384643554688
      ],
      "bbox_max": [
        -249.7219696044922,
        -2042.298095703125,
        645.8165893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39295151829719543,
        0.5888877511024475,
        0.7062578797340393
      ],
      "plane_d": 638.5640869140625,
      "bbox_min": [
        -475.8996887207031,
        -2177.475341796875,
        641.6248779296875
      ],
      "bbox_max": [
        -254.21792602539062,
        -2018.424560546875,
        668.8554077148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -347.17852783203125,
        -2092.55712890625,
        641.6248779296875
      ],
      "bbox_max": [
        -254.21792602539062,
        -2030.5015869140625,
        646.0267333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -347.17852783203125,
        -2092.55712890625,
        641.6248779296875
      ],
      "bbox_max": [
        -344.845703125,
        -2090.115234375,
        641.7520141601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -345.68505859375,
        -2092.55712890625,
        641.6248779296875
      ],
      "bbox_max": [
        -344.845703125,
        -2091.495361328125,
        641.7520141601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -297.43212890625,
        -2066.11767578125,
        645.7384643554688
      ],
      "bbox_max": [
        -254.21792602539062,
        -2030.5015869140625,
        646.0267333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -297.43212890625,
        -2066.11767578125,
        645.7384643554688
      ],
      "bbox_max": [
        -292.9984130859375,
        -2065.151123046875,
        646.0267333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -431.2630920410156,
        -2163.538818359375,
        641.6248779296875
      ],
      "bbox_max": [
        -293.274658203125,
        -2065.151123046875,
        666.8973388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -431.2630920410156,
        -2147.856201171875,
        641.6248779296875
      ],
      "bbox_max": [
        -293.274658203125,
        -2065.151123046875,
        652.6318969726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35807520151138306,
        0.6098346710205078,
        0.7070246934890747
      ],
      "plane_d": 697.973388671875,
      "bbox_min": [
        -431.2630920410156,
        -2147.856201171875,
        641.6248779296875
      ],
      "bbox_max": [
        -338.43505859375,
        -2084.468994140625,
        652.6318969726562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        641.6248779296875
      ],
      "bbox_max": [
        -338.43505859375,
        -2091.48779296875,
        652.6318969726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.01971435546875,
        -2119.8916015625,
        641.6248779296875
      ],
      "bbox_max": [
        -391.0085754394531,
        -2118.591552734375,
        643.128662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        641.6248779296875
      ],
      "bbox_max": [
        -358.68206787109375,
        -2099.0166015625,
        644.3175659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        641.6248779296875
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        650.8302612304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263402342796326,
        0.536638617515564,
        0.7570752501487732
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -349.2779235839844,
        -2092.92724609375,
        641.6248779296875
      ],
      "bbox_max": [
        -344.6956787109375,
        -2088.8212890625,
        645.4060668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -347.7262268066406,
        -2091.495361328125,
        641.6248779296875
      ],
      "bbox_max": [
        -345.68505859375,
        -2089.609130859375,
        643.9666137695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -349.2779235839844,
        -2091.495361328125,
        641.6248779296875
      ],
      "bbox_max": [
        -345.68505859375,
        -2088.8212890625,
        644.1882934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -349.2779235839844,
        -2090.284423828125,
        641.6248779296875
      ],
      "bbox_max": [
        -347.660400390625,
        -2089.070068359375,
        641.7003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -348.3093566894531,
        -2089.669677734375,
        641.6913452148438
      ],
      "bbox_max": [
        -347.29803466796875,
        -2088.8212890625,
        641.7266235351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -392.2690734863281,
        -2119.7412109375,
        641.6248779296875
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.791015625,
        645.9818725585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.2690734863281,
        -2119.7412109375,
        641.6248779296875
      ],
      "bbox_max": [
        -390.6972961425781,
        -2117.9755859375,
        644.9256591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263527512550354,
        0.5366376042366028,
        0.7570752501487732
      ],
      "plane_d": 506.02935791015625,
      "bbox_min": [
        -367.435791015625,
        -2103.822265625,
        641.9987182617188
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.791015625,
        645.025146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263527512550354,
        0.5366376042366028,
        0.7570752501487732
      ],
      "plane_d": 506.02935791015625,
      "bbox_min": [
        -371.9428405761719,
        -2106.424560546875,
        641.6248779296875
      ],
      "bbox_max": [
        -358.7217712402344,
        -2097.4541015625,
        642.7213134765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.37263402342796326,
        0.536638617515564,
        0.7570752501487732
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -347.79913330078125,
        -2092.7470703125,
        641.726318359375
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        645.3406982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -347.79913330078125,
        -2089.455322265625,
        641.726318359375
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        642.3384399414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35807520151138306,
        0.6098346710205078,
        0.7070246934890747
      ],
      "plane_d": 697.973388671875,
      "bbox_min": [
        -427.6852722167969,
        -2163.538818359375,
        641.6248779296875
      ],
      "bbox_max": [
        -329.4198913574219,
        -2079.83544921875,
        666.8973388671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.26295778155326843,
        0.5350207686424255,
        0.8028736114501953
      ],
      "plane_d": 510.40802001953125,
      "bbox_min": [
        -339.98199462890625,
        -2103.80126953125,
        650.8302612304688
      ],
      "bbox_max": [
        -329.4198913574219,
        -2093.555419921875,
        656.8781127929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -339.98199462890625,
        -2102.21142578125,
        650.8302612304688
      ],
      "bbox_max": [
        -337.2131042480469,
        -2098.708984375,
        654.7056884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -338.4957275390625,
        -2103.80126953125,
        653.2045288085938
      ],
      "bbox_max": [
        -335.95623779296875,
        -2100.5888671875,
        656.8781127929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263402342796326,
        0.536638617515564,
        0.7570752501487732
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        641.6248779296875
      ],
      "bbox_max": [
        -330.7852783203125,
        -2079.83544921875,
        657.4176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -344.6959533691406,
        -2100.5888671875,
        645.3402709960938
      ],
      "bbox_max": [
        -338.4957275390625,
        -2092.74658203125,
        653.2045288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -341.9147033691406,
        -2103.497802734375,
        649.2028198242188
      ],
      "bbox_max": [
        -336.19610595703125,
        -2096.264404296875,
        656.90625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        641.6248779296875
      ],
      "bbox_max": [
        -336.3678283691406,
        -2079.83544921875,
        657.4176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        0.8660230040550232,
        5.416695330495713e-06
      ],
      "plane_d": 1638.2353515625,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        643.40478515625
      ],
      "bbox_max": [
        -367.435791015625,
        -2103.822265625,
        645.8018188476562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        644.9672241210938
      ],
      "bbox_max": [
        -405.7651062011719,
        -2128.62841796875,
        645.4821166992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        641.6248779296875
      ],
      "bbox_max": [
        -345.68505859375,
        -2087.014404296875,
        648.9979248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -350.61993408203125,
        -2091.495361328125,
        641.6248779296875
      ],
      "bbox_max": [
        -345.68505859375,
        -2087.014404296875,
        647.4326782226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -350.61993408203125,
        -2089.54248046875,
        641.6248779296875
      ],
      "bbox_max": [
        -348.3093566894531,
        -2087.480224609375,
        641.6913452148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -350.02972412109375,
        -2089.070068359375,
        641.66748046875
      ],
      "bbox_max": [
        -347.79913330078125,
        -2087.014404296875,
        641.726318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -349.2276611328125,
        -2088.8212890625,
        641.7254028320312
      ],
      "bbox_max": [
        -336.9632263183594,
        -2079.83544921875,
        642.5633544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -342.99163818359375,
        -2084.468994140625,
        642.1755981445312
      ],
      "bbox_max": [
        -336.9632263183594,
        -2079.83544921875,
        642.5633544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        641.6248779296875
      ],
      "bbox_max": [
        -257.122314453125,
        -2018.424560546875,
        660.8609619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -302.2524108886719,
        -2058.38330078125,
        645.7384643554688
      ],
      "bbox_max": [
        -257.122314453125,
        -2018.424560546875,
        646.6192016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -265.7866516113281,
        -2019.491943359375,
        645.8646240234375
      ],
      "bbox_max": [
        -259.83294677734375,
        -2018.424560546875,
        646.6192016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        641.6248779296875
      ],
      "bbox_max": [
        -331.83782958984375,
        -2067.406982421875,
        660.8609619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -353.9037780761719,
        -2087.822998046875,
        641.6248779296875
      ],
      "bbox_max": [
        -342.9916076660156,
        -2081.348388671875,
        642.1755981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.6669921875,
        -2087.48046875,
        641.6248779296875
      ],
      "bbox_max": [
        -350.02978515625,
        -2086.4697265625,
        641.6674194335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -351.6669921875,
        -2086.47998046875,
        641.6248779296875
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        641.6522827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -352.7531433105469,
        -2087.52099609375,
        641.6248779296875
      ],
      "bbox_max": [
        -349.98590087890625,
        -2086.4697265625,
        641.7257080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -352.7531433105469,
        -2086.500732421875,
        641.6248779296875
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        641.70263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        641.6248779296875
      ],
      "bbox_max": [
        -339.48736572265625,
        -2086.4697265625,
        660.8609619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        0.8660230040550232,
        5.416695330495713e-06
      ],
      "plane_d": 1638.2353515625,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        643.0118408203125
      ],
      "bbox_max": [
        -367.435791015625,
        -2103.822265625,
        659.3778076171875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        643.0118408203125
      ],
      "bbox_max": [
        -388.779052734375,
        -2116.827880859375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -391.8966369628906,
        -2119.473876953125,
        643.7750244140625
      ],
      "bbox_max": [
        -388.779052734375,
        -2116.827880859375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -360.30859375,
        -2102.82275390625,
        641.6248779296875
      ],
      "bbox_max": [
        -339.48736572265625,
        -2086.4697265625,
        660.167236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -360.30859375,
        -2102.82275390625,
        641.6248779296875
      ],
      "bbox_max": [
        -346.551025390625,
        -2086.4697265625,
        660.167236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -650.9999389648438,
      "bbox_min": [
        -360.0203857421875,
        -2102.82275390625,
        646.4585571289062
      ],
      "bbox_max": [
        -346.551025390625,
        -2087.43603515625,
        660.167236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        646.4585571289062
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        650.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.97299724817276,
        0.23081716895103455,
        0.0
      ],
      "plane_d": 832.5162353515625,
      "bbox_min": [
        -360.0203857421875,
        -2102.82275390625,
        650.9999389648438
      ],
      "bbox_max": [
        -357.809326171875,
        -2092.0322265625,
        660.167236328125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -360.0203857421875,
        -2102.82275390625,
        650.9999389648438
      ],
      "bbox_max": [
        -357.809326171875,
        -2092.43212890625,
        660.167236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -654.9999389648438,
      "bbox_min": [
        -358.675537109375,
        -2098.995361328125,
        654.9999389648438
      ],
      "bbox_max": [
        -357.809326171875,
        -2097.18310546875,
        654.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -654.9999389648438,
      "bbox_min": [
        -360.0203857421875,
        -2098.995361328125,
        654.9999389648438
      ],
      "bbox_max": [
        -358.1206359863281,
        -2092.43212890625,
        654.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        651.2236328125
      ],
      "bbox_max": [
        -348.8742370605469,
        -2086.4697265625,
        666.1172485351562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        652.55908203125
      ],
      "bbox_max": [
        -364.9534606933594,
        -2103.495361328125,
        666.1172485351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -389.9620056152344,
        -2117.49951171875,
        654.9437255859375
      ],
      "bbox_max": [
        -364.9534606933594,
        -2103.495361328125,
        661.1981811523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -389.9620056152344,
        -2117.49951171875,
        654.9437255859375
      ],
      "bbox_max": [
        -389.3301696777344,
        -2116.72216796875,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -360.30859375,
        -2097.1103515625,
        651.2236328125
      ],
      "bbox_max": [
        -348.8742370605469,
        -2086.4697265625,
        660.4531860351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -360.30859375,
        -2097.1103515625,
        651.2236938476562
      ],
      "bbox_max": [
        -348.8742370605469,
        -2086.4697265625,
        660.4531860351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -654.9999389648438,
      "bbox_min": [
        -360.30859375,
        -2097.1103515625,
        654.572509765625
      ],
      "bbox_max": [
        -348.8742370605469,
        -2086.4697265625,
        659.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.97299724817276,
        0.23081716895103455,
        -0.0
      ],
      "plane_d": 832.5162353515625,
      "bbox_min": [
        -359.342529296875,
        -2092.43212890625,
        654.572509765625
      ],
      "bbox_max": [
        -359.2476501464844,
        -2092.0322265625,
        654.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8645933270454407,
        0.5024722814559937,
        0.0
      ],
      "plane_d": 740.5030517578125,
      "bbox_min": [
        -359.342529296875,
        -2097.1103515625,
        654.9999389648438
      ],
      "bbox_max": [
        -348.8742370605469,
        -2086.4697265625,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.97299724817276,
        0.23081716895103455,
        0.0
      ],
      "plane_d": 832.5162353515625,
      "bbox_min": [
        -359.342529296875,
        -2097.1103515625,
        654.9999389648438
      ],
      "bbox_max": [
        -348.8742370605469,
        -2086.4697265625,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.123291015625,
        -2088.548095703125,
        655.4558715820312
      ],
      "bbox_max": [
        -348.8742370605469,
        -2086.4697265625,
        659.28759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -563.099609375,
        -2237.27685546875,
        639.28125
      ],
      "bbox_max": [
        -265.1526794433594,
        -1979.0,
        660.0204467773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -415.853271484375,
        -2105.640869140625,
        639.28125
      ],
      "bbox_max": [
        -265.1526794433594,
        -1979.0,
        647.9818115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -309.987548828125,
        -2039.8380126953125,
        639.2814331054688
      ],
      "bbox_max": [
        -265.1526794433594,
        -1979.0,
        647.9818115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        639.2814331054688
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        647.9818115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        639.2814331054688
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        647.8992309570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -309.987548828125,
        -2039.8380126953125,
        645.7384643554688
      ],
      "bbox_max": [
        -265.7866516113281,
        -2014.4228515625,
        645.8646240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -309.987548828125,
        -2039.8380126953125,
        645.7384643554688
      ],
      "bbox_max": [
        -287.17596435546875,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -563.099609375,
        -2237.27685546875,
        639.28125
      ],
      "bbox_max": [
        -271.35888671875,
        -1981.056396484375,
        660.0204467773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39295151829719543,
        0.5888877511024475,
        0.7062578797340393
      ],
      "plane_d": 638.5640869140625,
      "bbox_min": [
        -481.86572265625,
        -2177.4140625,
        639.28125
      ],
      "bbox_max": [
        -271.35888671875,
        -2016.63916015625,
        647.85302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3580712676048279,
        0.6098201870918274,
        0.7070391774177551
      ],
      "plane_d": 697.9349975585938,
      "bbox_min": [
        -432.43115234375,
        -2140.79345703125,
        639.28125
      ],
      "bbox_max": [
        -420.93878173828125,
        -2132.854736328125,
        640.6549072265625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -481.86572265625,
        -2177.4140625,
        639.28125
      ],
      "bbox_max": [
        -271.35888671875,
        -2016.63916015625,
        647.85302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -304.0990295410156,
        -2045.675537109375,
        645.7384643554688
      ],
      "bbox_max": [
        -271.35888671875,
        -2016.63916015625,
        647.85302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -275.1498107910156,
        -2017.1793212890625,
        647.308837890625
      ],
      "bbox_max": [
        -271.35888671875,
        -2016.63916015625,
        647.85302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -481.86572265625,
        -2177.4140625,
        639.28125
      ],
      "bbox_max": [
        -475.89971923828125,
        -2172.58935546875,
        643.8072509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -413.5885009765625,
        -2063.05908203125,
        639.4384155273438
      ],
      "bbox_max": [
        -274.051025390625,
        -1981.056396484375,
        660.0204467773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        647.8088989257812
      ],
      "bbox_max": [
        -281.0845947265625,
        -1981.056396484375,
        648.1774291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        647.8088989257812
      ],
      "bbox_max": [
        -281.0845947265625,
        -1987.0,
        648.1774291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -326.17449951171875,
        -2053.674072265625,
        643.8331909179688
      ],
      "bbox_max": [
        -274.051025390625,
        -2009.4410400390625,
        653.2543334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -309.987548828125,
        -2038.2144775390625,
        645.7384643554688
      ],
      "bbox_max": [
        -274.051025390625,
        -2014.4228515625,
        648.1777954101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -309.987548828125,
        -2038.2144775390625,
        645.7384643554688
      ],
      "bbox_max": [
        -298.20367431640625,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -312.8653259277344,
        -2016.169189453125,
        645.7384643554688
      ],
      "bbox_max": [
        -276.39306640625,
        -2009.4410400390625,
        653.2543334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -312.8653259277344,
        -2014.4228515625,
        645.7384643554688
      ],
      "bbox_max": [
        -300.8400573730469,
        -2009.4410400390625,
        653.2543334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -635.32763671875,
        -2290.83056640625,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2113.157470703125,
        697.1158447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -506.88580322265625,
        -2234.2978515625,
        618.63818359375
      ],
      "bbox_max": [
        -66.12939453125,
        -2130.7216796875,
        677.71142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -506.88580322265625,
        -2234.2978515625,
        618.63818359375
      ],
      "bbox_max": [
        -66.12939453125,
        -2130.7216796875,
        677.71142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -109.34033203125,
        -2181.199951171875,
        618.63818359375
      ],
      "bbox_max": [
        -66.12939453125,
        -2130.7216796875,
        624.61962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.63818359375
      ],
      "bbox_max": [
        -66.12939453125,
        -2130.7216796875,
        624.153076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        620.4703369140625
      ],
      "bbox_max": [
        -79.672119140625,
        -2130.7216796875,
        624.153076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        0.9238802790641785,
        -0.0
      ],
      "plane_d": 2007.28369140625,
      "bbox_min": [
        -92.5,
        -2139.665283203125,
        620.4703369140625
      ],
      "bbox_max": [
        -79.672119140625,
        -2135.27197265625,
        622.4317016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        622.3040161132812
      ],
      "bbox_max": [
        -92.20442962646484,
        -2136.069580078125,
        622.4317016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        622.3347778320312
      ],
      "bbox_max": [
        -91.47808074951172,
        -2130.7216796875,
        624.153076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        623.4249877929688
      ],
      "bbox_max": [
        -100.88525390625,
        -2139.665283203125,
        624.153076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        623.6862182617188
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        624.61962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        624.0093994140625
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        624.61962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -107.177978515625,
        -2140.8193359375,
        624.0093994140625
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        624.4100341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35807520151138306,
        0.6098346710205078,
        0.7070246934890747
      ],
      "plane_d": 697.973388671875,
      "bbox_min": [
        -436.0340270996094,
        -2177.524658203125,
        664.5492553710938
      ],
      "bbox_max": [
        -398.3159484863281,
        -2148.872802734375,
        669.1537475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39295151829719543,
        0.5888877511024475,
        0.7062578797340393
      ],
      "plane_d": 638.5640869140625,
      "bbox_min": [
        -436.0340270996094,
        -2177.524658203125,
        666.8973388671875
      ],
      "bbox_max": [
        -418.5774230957031,
        -2163.538818359375,
        669.1537475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -635.32763671875,
        -2162.76806640625,
        696.8292236328125
      ],
      "bbox_max": [
        -633.0643310546875,
        -2161.42333984375,
        697.1158447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        -91.48384094238281,
        -2132.77880859375,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2113.157470703125,
        622.4413452148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        26.906936645507812,
        -2132.77880859375,
        605.8223876953125
      ],
      "bbox_max": [
        27.273826599121094,
        -2132.563232421875,
        606.0013427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -91.48384094238281,
        -2130.76416015625,
        622.4104614257812
      ],
      "bbox_max": [
        -91.18179321289062,
        -2128.540283203125,
        622.4413452148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        -410.68280029296875,
        -2113.157470703125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1979.0,
        668.4697875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        646.7520751953125
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        652.0123291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        646.7520751953125
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        652.0123291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        647.015380859375
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        652.0123291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        647.015380859375
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        651.8515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -410.68280029296875,
        -2077.08203125,
        619.113525390625
      ],
      "bbox_max": [
        -64.5244140625,
        -1979.0,
        668.4697875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 1923.475830078125,
      "bbox_min": [
        -195.0,
        -2051.198974609375,
        620.6815185546875
      ],
      "bbox_max": [
        -79.672119140625,
        -1979.0,
        639.8246459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826923370361328,
        0.9238758087158203,
        0.0
      ],
      "plane_d": 1854.383544921875,
      "bbox_min": [
        -101.80957794189453,
        -2051.198974609375,
        622.0775756835938
      ],
      "bbox_max": [
        -90.278564453125,
        -2044.573974609375,
        625.4306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -101.80957794189453,
        -2051.198974609375,
        623.762939453125
      ],
      "bbox_max": [
        -100.88525390625,
        -2048.967529296875,
        625.4306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        639.8246459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        639.8246459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        639.8246459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -187.0,
        -1987.0,
        639.6639404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -410.68280029296875,
        -2077.08203125,
        619.113525390625
      ],
      "bbox_max": [
        -64.5244140625,
        -2007.820556640625,
        668.4697875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -109.34033203125,
        -2077.08203125,
        619.46630859375
      ],
      "bbox_max": [
        -66.12939453125,
        -2050.2138671875,
        626.241943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -109.34033203125,
        -2066.72607421875,
        623.9706420898438
      ],
      "bbox_max": [
        -101.40145874023438,
        -2050.2138671875,
        626.241943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2066.72607421875,
        624.7501831054688
      ],
      "bbox_max": [
        -105.278564453125,
        -2059.573974609375,
        626.241943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2066.72607421875,
        625.423095703125
      ],
      "bbox_max": [
        -108.29034423828125,
        -2064.5546875,
        626.241943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -108.29034423828125,
        -2077.08203125,
        623.0650024414062
      ],
      "bbox_max": [
        -90.278564453125,
        -2066.72607421875,
        626.0529174804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -108.29034423828125,
        -2073.7763671875,
        623.2898559570312
      ],
      "bbox_max": [
        -92.20442962646484,
        -2066.72607421875,
        626.0529174804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.29034423828125,
        -2067.21044921875,
        625.405029296875
      ],
      "bbox_max": [
        -108.0561294555664,
        -2066.72607421875,
        626.0529174804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -108.0561294555664,
        -2077.08203125,
        623.3185424804688
      ],
      "bbox_max": [
        -91.75545501708984,
        -2067.21044921875,
        626.0107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.0561294555664,
        -2069.026611328125,
        625.3372802734375
      ],
      "bbox_max": [
        -107.177978515625,
        -2067.21044921875,
        626.0107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20443725585938,
        -2077.08203125,
        623.3185424804688
      ],
      "bbox_max": [
        -91.75545501708984,
        -2073.7763671875,
        623.683349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -410.68280029296875,
        -2040.0169677734375,
        651.5675659179688
      ],
      "bbox_max": [
        -297.8909912109375,
        -2007.820556640625,
        668.4697875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -313.8014221191406,
        -2011.263671875,
        651.5675659179688
      ],
      "bbox_max": [
        -297.8909912109375,
        -2007.820556640625,
        655.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8734391927719116,
        -0.19791147112846375,
        -0.44489893317222595
      ],
      "plane_d": -14.895965576171875,
      "bbox_min": [
        -91.76782989501953,
        -2113.157470703125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2063.799072265625,
        623.5582885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.76782989501953,
        -2080.781494140625,
        623.362060546875
      ],
      "bbox_max": [
        -91.25299072265625,
        -2076.990966796875,
        623.5582885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        -674.18994140625,
        -2372.12451171875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1918.043212890625,
        825.35693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05980534851551056,
        -0.671236515045166,
        0.7388266921043396
      ],
      "plane_d": -1850.9669189453125,
      "bbox_min": [
        -465.2196960449219,
        -2083.561767578125,
        619.9622802734375
      ],
      "bbox_max": [
        121.512451171875,
        -1918.043212890625,
        772.1456298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -447.1927490234375,
        -2078.106689453125,
        619.9622802734375
      ],
      "bbox_max": [
        -64.5244140625,
        -1918.043212890625,
        772.1456298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -404.3952941894531,
        -2078.106689453125,
        619.9622802734375
      ],
      "bbox_max": [
        -64.5244140625,
        -1969.5943603515625,
        714.317626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -2071.8154296875,
        619.9622802734375
      ],
      "bbox_max": [
        -64.5244140625,
        -1979.0,
        705.9292602539062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -283.0,
        -2071.8154296875,
        619.9622802734375
      ],
      "bbox_max": [
        -64.5244140625,
        -1979.0,
        705.9292602539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        638.555908203125
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        705.9292602539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        638.555908203125
      ],
      "bbox_max": [
        -187.0,
        -1987.0,
        700.3240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        650.7435913085938
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        692.49462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        650.7435913085938
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        690.0587768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        650.7435913085938
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        681.0655517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -106.79007720947266,
        -2071.8154296875,
        619.9622802734375
      ],
      "bbox_max": [
        -64.5244140625,
        -1998.9012451171875,
        690.36474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 1923.475830078125,
      "bbox_min": [
        -96.21092987060547,
        -2071.8154296875,
        619.9622802734375
      ],
      "bbox_max": [
        -64.5244140625,
        -2044.573974609375,
        653.6278076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -92.90218353271484,
        -2071.8154296875,
        620.1115112304688
      ],
      "bbox_max": [
        -66.12939453125,
        -2045.5958251953125,
        652.7847290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -92.90218353271484,
        -2045.6607666015625,
        652.7044067382812
      ],
      "bbox_max": [
        -92.67390441894531,
        -2045.5958251953125,
        652.7847290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -92.74551391601562,
        -2046.704833984375,
        652.7044067382812
      ],
      "bbox_max": [
        -85.1344985961914,
        -2044.573974609375,
        653.6278076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -92.74551391601562,
        -2045.6531982421875,
        652.7044067382812
      ],
      "bbox_max": [
        -90.278564453125,
        -2044.573974609375,
        653.6278076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826923370361328,
        0.9238758087158203,
        0.0
      ],
      "plane_d": 1854.383544921875,
      "bbox_min": [
        -106.79007720947266,
        -2061.427490234375,
        623.9732666015625
      ],
      "bbox_max": [
        -90.0726547241211,
        -2044.573974609375,
        649.739013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 1923.475830078125,
      "bbox_min": [
        -90.278564453125,
        -2044.6593017578125,
        623.9732666015625
      ],
      "bbox_max": [
        -90.0726547241211,
        -2044.573974609375,
        624.9468994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -106.79007720947266,
        -2061.427490234375,
        625.7794799804688
      ],
      "bbox_max": [
        -105.278564453125,
        -2059.573974609375,
        629.0596923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -404.3952941894531,
        -2078.106689453125,
        621.8562622070312
      ],
      "bbox_max": [
        -64.5244140625,
        -1969.5943603515625,
        714.317626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -109.34033203125,
        -2076.99072265625,
        621.8562622070312
      ],
      "bbox_max": [
        -64.5244140625,
        -2039.248046875,
        660.4769287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -108.26380157470703,
        -2076.99072265625,
        621.8562622070312
      ],
      "bbox_max": [
        -64.5244140625,
        -2040.298095703125,
        659.3046264648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6248225569725037,
        0.7807667851448059,
        -0.0
      ],
      "plane_d": 1655.082763671875,
      "bbox_min": [
        -100.88525390625,
        -2068.18017578125,
        629.1729736328125
      ],
      "bbox_max": [
        -64.5244140625,
        -2040.298095703125,
        659.3046264648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826923370361328,
        0.9238758087158203,
        0.0
      ],
      "plane_d": 1854.383544921875,
      "bbox_min": [
        -100.88525390625,
        -2048.967529296875,
        645.5496826171875
      ],
      "bbox_max": [
        -91.90425109863281,
        -2041.94140625,
        658.0177001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -98.24224853515625,
        -2047.9700927734375,
        652.2024536132812
      ],
      "bbox_max": [
        -91.90425109863281,
        -2045.6531982421875,
        653.6482543945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -96.99676513671875,
        -2047.9700927734375,
        652.2024536132812
      ],
      "bbox_max": [
        -96.80043029785156,
        -2047.2755126953125,
        652.889892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -97.00777435302734,
        -2047.5574951171875,
        652.7045288085938
      ],
      "bbox_max": [
        -96.92056274414062,
        -2047.3253173828125,
        653.0689697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -97.31201934814453,
        -2047.3614501953125,
        651.5167236328125
      ],
      "bbox_max": [
        -96.41828918457031,
        -2041.94140625,
        658.0177001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -97.3911361694336,
        -2046.26904296875,
        652.7847290039062
      ],
      "bbox_max": [
        -88.0482177734375,
        -2040.298095703125,
        659.3046264648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -92.67390441894531,
        -2046.26904296875,
        652.7847290039062
      ],
      "bbox_max": [
        -88.0482177734375,
        -2045.573486328125,
        653.890380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -90.278564453125,
        -2046.2249755859375,
        653.3761596679688
      ],
      "bbox_max": [
        -88.0482177734375,
        -2045.573486328125,
        653.890380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.26380157470703,
        -2076.99072265625,
        623.4006958007812
      ],
      "bbox_max": [
        -90.278564453125,
        -2066.781005859375,
        636.3370361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -107.177978515625,
        -2076.99072265625,
        623.4006958007812
      ],
      "bbox_max": [
        -90.278564453125,
        -2069.026611328125,
        634.2090454101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        623.683349609375
      ],
      "bbox_max": [
        -92.20441436767578,
        -2071.60009765625,
        630.682861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.177978515625,
        -2076.99072265625,
        623.5582885742188
      ],
      "bbox_max": [
        -91.76782989501953,
        -2069.026611328125,
        634.2090454101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20442199707031,
        -2076.99072265625,
        623.5582885742188
      ],
      "bbox_max": [
        -91.76782989501953,
        -2073.7763671875,
        628.6817626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        625.9515991210938
      ],
      "bbox_max": [
        -97.29426574707031,
        -2039.248046875,
        660.4769287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        626.048095703125
      ],
      "bbox_max": [
        -108.26380157470703,
        -2064.5546875,
        638.4468383789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -97.46321105957031,
        -2040.531982421875,
        659.0282592773438
      ],
      "bbox_max": [
        -97.29426574707031,
        -2039.248046875,
        660.4769287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -404.3952941894531,
        -2078.106689453125,
        626.3668212890625
      ],
      "bbox_max": [
        -112.20849609375,
        -1969.5943603515625,
        714.317626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -404.3952941894531,
        -2065.927734375,
        645.7430419921875
      ],
      "bbox_max": [
        -217.74951171875,
        -2003.981689453125,
        670.569580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -404.3952941894531,
        -2065.927734375,
        645.7430419921875
      ],
      "bbox_max": [
        -217.74951171875,
        -2003.981689453125,
        670.569580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -404.3952941894531,
        -2037.5177001953125,
        665.295654296875
      ],
      "bbox_max": [
        -382.3850402832031,
        -2025.824462890625,
        670.569580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -400.1608581542969,
        -2033.2711181640625,
        646.001708984375
      ],
      "bbox_max": [
        -217.74951171875,
        -1969.5943603515625,
        714.317626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        678.6298828125
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        704.0978393554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        678.6298828125
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        704.0978393554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        678.6298828125
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        688.9048461914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -400.1608581542969,
        -2033.2711181640625,
        646.001708984375
      ],
      "bbox_max": [
        -217.74951171875,
        -1969.5943603515625,
        714.317626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        687.8591918945312
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        704.5525512695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        687.8591918945312
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        704.5525512695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        687.8591918945312
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        704.55224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -1979.0,
        703.0516357421875
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        704.55224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -400.1608581542969,
        -2033.2711181640625,
        646.001708984375
      ],
      "bbox_max": [
        -217.74951171875,
        -1969.5943603515625,
        714.317626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -341.9967041015625,
        -1987.0,
        691.26025390625
      ],
      "bbox_max": [
        -275.0,
        -1969.5943603515625,
        714.317626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        691.26025390625
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        707.0723266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        691.26025390625
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        707.0723266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -1979.0,
        703.7771606445312
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        707.0723266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -341.9967041015625,
        -1974.9398193359375,
        710.3526000976562
      ],
      "bbox_max": [
        -333.4532470703125,
        -1969.5943603515625,
        714.317626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794841408729553,
        -0.8249640464782715,
        0.4013371765613556
      ],
      "plane_d": -1778.3809814453125,
      "bbox_min": [
        -341.9967041015625,
        -1974.9398193359375,
        710.3526000976562
      ],
      "bbox_max": [
        -334.72802734375,
        -1970.38037109375,
        713.7988891601562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -336.5265808105469,
        -1971.594482421875,
        710.3526000976562
      ],
      "bbox_max": [
        -334.72802734375,
        -1970.38037109375,
        713.7988891601562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -447.1927490234375,
        -2070.297119140625,
        642.3065795898438
      ],
      "bbox_max": [
        -99.61474609375,
        -1918.043212890625,
        772.1456298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -442.0,
        -1980.298828125,
        705.019287109375
      ],
      "bbox_max": [
        -187.0,
        -1918.043212890625,
        772.1456298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -442.0,
        -1935.4681396484375,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1918.043212890625,
        772.1456298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -348.0,
        -1933.4263916015625,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1918.043212890625,
        766.5938110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -272.0,
        -1931.6163330078125,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1920.0,
        756.0791625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -348.0,
        -1924.5157470703125,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1918.043212890625,
        766.5938110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -195.0,
        -1980.298828125,
        705.019287109375
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        707.2992553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -1980.298828125,
        705.019287109375
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        707.2992553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -187.0,
        -1979.346435546875,
        705.5827026367188
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        706.1907348632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.9729309082031,
        -1935.596923828125,
        766.0
      ],
      "bbox_max": [
        -433.71240234375,
        -1935.358154296875,
        766.1931762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -350.2874755859375,
        -1970.9891357421875,
        713.3803100585938
      ],
      "bbox_max": [
        -335.9169616699219,
        -1961.27294921875,
        739.6506958007812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -341.20086669921875,
        -1987.0,
        701.3633422851562
      ],
      "bbox_max": [
        -275.0,
        -1955.786376953125,
        741.6904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        701.3633422851562
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        719.4930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        701.3633422851562
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        719.4930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        701.3633422851562
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        719.4930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        701.3633422851562
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        705.4495849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -447.1927490234375,
        -2070.297119140625,
        642.3065795898438
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        728.0740966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -250.77687072753906,
        -2069.13037109375,
        645.7384643554688
      ],
      "bbox_max": [
        -243.34588623046875,
        -2065.764892578125,
        645.7661743164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -446.5451354980469,
        -2054.210205078125,
        674.6094970703125
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        721.415283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -446.5451354980469,
        -2054.210205078125,
        674.6094970703125
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        721.415283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        704.3411254882812
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        721.415283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -1979.0,
        718.3843994140625
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        721.415283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -446.5451354980469,
        -2054.210205078125,
        674.6094970703125
      ],
      "bbox_max": [
        -439.9678649902344,
        -2047.226806640625,
        681.3184814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        700.22021484375
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        713.3493041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -195.0,
        -1979.0,
        706.1907348632812
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        713.3493041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -465.2196960449219,
        -2083.561767578125,
        626.3668212890625
      ],
      "bbox_max": [
        -64.5244140625,
        -2015.7926025390625,
        707.94580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -465.2196960449219,
        -2078.49365234375,
        645.7384643554688
      ],
      "bbox_max": [
        -245.07896423339844,
        -2054.210205078125,
        676.5702514648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -301.4764709472656,
        -2078.49365234375,
        652.2869262695312
      ],
      "bbox_max": [
        -299.1501770019531,
        -2076.648193359375,
        652.658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -465.2196960449219,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -245.07896423339844,
        -2054.210205078125,
        676.5702514648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -250.93359375,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -245.07896423339844,
        -2068.60986328125,
        645.750244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -248.38270568847656,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -245.07896423339844,
        -2068.60986328125,
        645.750244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -464.254150390625,
        -2083.561767578125,
        626.3668212890625
      ],
      "bbox_max": [
        -64.5244140625,
        -2015.7926025390625,
        707.94580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -464.254150390625,
        -2078.300537109375,
        645.7384643554688
      ],
      "bbox_max": [
        -246.357421875,
        -2059.23974609375,
        677.0161743164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -300.9225158691406,
        -2078.300537109375,
        652.5308227539062
      ],
      "bbox_max": [
        -299.21417236328125,
        -2077.076416015625,
        652.908447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -464.254150390625,
        -2065.688232421875,
        675.7670288085938
      ],
      "bbox_max": [
        -454.30517578125,
        -2059.23974609375,
        677.0161743164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -463.8616027832031,
        -2083.32763671875,
        627.3399658203125
      ],
      "bbox_max": [
        -64.5244140625,
        -2015.7926025390625,
        707.94580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -253.28384399414062,
        -2083.32763671875,
        627.3399658203125
      ],
      "bbox_max": [
        -64.5244140625,
        -2067.037109375,
        649.47802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -253.28384399414062,
        -2078.29150390625,
        645.7384643554688
      ],
      "bbox_max": [
        -239.5581512451172,
        -2070.70849609375,
        649.47802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -107.86450958251953,
        -2075.235595703125,
        627.3399658203125
      ],
      "bbox_max": [
        -64.5244140625,
        -2067.037109375,
        637.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        628.6817626953125
      ],
      "bbox_max": [
        -92.20441436767578,
        -2071.60009765625,
        635.1734008789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.86450958251953,
        -2075.235595703125,
        627.3399658203125
      ],
      "bbox_max": [
        -92.00621032714844,
        -2067.60693359375,
        636.5714111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -107.86450958251953,
        -2069.026611328125,
        634.2090454101562
      ],
      "bbox_max": [
        -107.177978515625,
        -2067.60693359375,
        636.3084106445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20441436767578,
        -2075.235595703125,
        627.3399658203125
      ],
      "bbox_max": [
        -92.00621032714844,
        -2073.7763671875,
        630.4842529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -463.8616027832031,
        -2071.3681640625,
        632.6793823242188
      ],
      "bbox_max": [
        -64.5244140625,
        -2033.12158203125,
        691.3499145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -97.63478088378906,
        -2049.502197265625,
        652.889892578125
      ],
      "bbox_max": [
        -90.46661376953125,
        -2046.26904296875,
        655.2613525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -91.90426635742188,
        -2049.59716796875,
        650.2066040039062
      ],
      "bbox_max": [
        -79.41132354736328,
        -2045.857666015625,
        655.2828369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 1923.475830078125,
      "bbox_min": [
        -91.90426635742188,
        -2049.59716796875,
        650.2066040039062
      ],
      "bbox_max": [
        -79.41132354736328,
        -2045.857666015625,
        655.2828369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -91.90426635742188,
        -2049.59716796875,
        652.7044067382812
      ],
      "bbox_max": [
        -79.41132354736328,
        -2045.857666015625,
        655.2828369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532700657844543,
        0.2706069350242615,
        0.7071138620376587
      ],
      "plane_d": 144.97592163085938,
      "bbox_min": [
        -79.91655731201172,
        -2049.59716796875,
        652.7044067382812
      ],
      "bbox_max": [
        -79.41132354736328,
        -2048.967529296875,
        653.0237426757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -109.34033203125,
        -2071.3681640625,
        635.5545043945312
      ],
      "bbox_max": [
        -96.99674224853516,
        -2047.5574951171875,
        654.442138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -108.26383972167969,
        -2071.3681640625,
        635.5545043945312
      ],
      "bbox_max": [
        -96.99674224853516,
        -2047.5574951171875,
        654.442138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.26383972167969,
        -2069.026611328125,
        635.5545043945312
      ],
      "bbox_max": [
        -96.99674224853516,
        -2047.5574951171875,
        654.442138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -100.88525390625,
        -2050.113525390625,
        651.9237060546875
      ],
      "bbox_max": [
        -96.99674224853516,
        -2047.5574951171875,
        654.442138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826923370361328,
        0.9238758087158203,
        0.0
      ],
      "plane_d": 1854.383544921875,
      "bbox_min": [
        -100.88525390625,
        -2048.967529296875,
        651.9237060546875
      ],
      "bbox_max": [
        -98.24224853515625,
        -2047.8726806640625,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -100.88525390625,
        -2071.3681640625,
        636.5714111328125
      ],
      "bbox_max": [
        -98.01828002929688,
        -2070.1806640625,
        640.0797729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        636.3370971679688
      ],
      "bbox_max": [
        -105.278564453125,
        -2059.573974609375,
        648.0020141601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        636.3370971679688
      ],
      "bbox_max": [
        -108.2637939453125,
        -2064.0283203125,
        645.1771240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7667246460914612,
        -0.3175787925720215,
        0.5579220652580261
      ],
      "plane_d": -1098.954833984375,
      "bbox_min": [
        -109.34033203125,
        -2065.29248046875,
        644.2874145507812
      ],
      "bbox_max": [
        -108.91099548339844,
        -2064.0283203125,
        645.1771240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        -0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": -1186.8843994140625,
      "bbox_min": [
        -109.34033203125,
        -2065.29248046875,
        644.2874145507812
      ],
      "bbox_max": [
        -108.98356628417969,
        -2064.5546875,
        644.642333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -570.8470458984375,
        -2100.602294921875,
        637.62353515625
      ],
      "bbox_max": [
        121.512451171875,
        -1923.67822265625,
        810.5653076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -132.99354553222656,
        -1971.048828125,
        711.7363891601562
      ],
      "bbox_max": [
        -87.22331237792969,
        -1956.173095703125,
        738.7794189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -132.99354553222656,
        -1968.943359375,
        711.7363891601562
      ],
      "bbox_max": [
        -99.61474609375,
        -1956.173095703125,
        738.7794189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -570.8470458984375,
        -2100.602294921875,
        637.62353515625
      ],
      "bbox_max": [
        121.512451171875,
        -1923.67822265625,
        810.5653076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -442.0,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1923.67822265625,
        781.2753295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1923.67822265625,
        781.2753295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 412.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -406.67291259765625,
        -1962.6553955078125,
        780.7739868164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1970.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -406.67291259765625,
        -1970.0,
        780.7739868164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -369.0,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1923.67822265625,
        772.4188232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1947.25,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1923.67822265625,
        772.1290283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -348.0,
        -1928.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1923.67822265625,
        767.0492553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1947.25,
        766.0
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        772.1290283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -369.0,
        -1947.25,
        772.4188232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -442.0,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -414.0,
        -1928.0,
        780.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -414.0,
        -1950.0,
        780.1919555664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -442.0,
        -1939.0,
        766.0
      ],
      "bbox_max": [
        -422.5,
        -1928.0,
        780.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -430.0,
        -1939.0,
        766.0
      ],
      "bbox_max": [
        -422.5,
        -1939.0,
        780.1223754882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -468.130615234375,
        -2032.99267578125,
        716.4224243164062
      ],
      "bbox_max": [
        -399.3085632324219,
        -1968.051025390625,
        782.4132080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -408.1163024902344,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -399.3085632324219,
        -1968.051025390625,
        780.4204711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -408.1163024902344,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -405.1982727050781,
        -1972.0,
        780.4204711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45699819922447205,
        -0.8811807036399841,
        -0.1211327537894249
      ],
      "plane_d": -1669.15185546875,
      "bbox_min": [
        -570.8470458984375,
        -2100.602294921875,
        637.62353515625
      ],
      "bbox_max": [
        121.512451171875,
        -1927.76171875,
        780.4797973632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -570.8470458984375,
        -2100.602294921875,
        639.6060791015625
      ],
      "bbox_max": [
        -66.71080017089844,
        -1927.76171875,
        780.4797973632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02143726870417595,
        -0.8702447414398193,
        0.49215301871299744
      ],
      "plane_d": -2067.314453125,
      "bbox_min": [
        -286.0,
        -1974.3787841796875,
        718.9976196289062
      ],
      "bbox_max": [
        -220.87794494628906,
        -1927.76171875,
        760.221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1952.9293212890625,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1927.76171875,
        760.221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -286.0,
        -1952.9293212890625,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1927.76171875,
        760.221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -1951.9654541015625,
        754.0
      ],
      "bbox_max": [
        -286.0,
        -1927.76171875,
        760.221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -372.4571533203125,
        -1981.1729736328125,
        728.0740966796875
      ],
      "bbox_max": [
        -272.0,
        -1944.3687744140625,
        772.447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47034135460853577,
        -0.768880307674408,
        0.43313068151474
      ],
      "plane_d": -1666.1593017578125,
      "bbox_min": [
        -372.4571533203125,
        -1981.1729736328125,
        728.0740966796875
      ],
      "bbox_max": [
        -272.0,
        -1948.689453125,
        772.447265625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3979502022266388,
        -0.8249621391296387,
        0.40133896470069885
      ],
      "plane_d": -1778.3778076171875,
      "bbox_min": [
        -372.4571533203125,
        -1981.1729736328125,
        728.0740966796875
      ],
      "bbox_max": [
        -350.2874755859375,
        -1961.25390625,
        762.07080078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -272.0,
        -1958.47509765625,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1950.6173095703125,
        758.923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -570.8470458984375,
        -2100.602294921875,
        639.6060791015625
      ],
      "bbox_max": [
        -66.71080017089844,
        -1955.333251953125,
        780.4797973632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -489.5420837402344,
        -2082.13818359375,
        675.4734497070312
      ],
      "bbox_max": [
        -442.95172119140625,
        -2032.99267578125,
        716.4224243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -468.130615234375,
        -2043.1591796875,
        691.3499145507812
      ],
      "bbox_max": [
        -442.95172119140625,
        -2032.99267578125,
        716.4224243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -468.130615234375,
        -2091.646728515625,
        639.6060791015625
      ],
      "bbox_max": [
        -66.71080017089844,
        -1955.333251953125,
        780.4797973632812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.47035908699035645,
        -0.7688663601875305,
        0.4331360161304474
      ],
      "plane_d": -1666.129638671875,
      "bbox_min": [
        -406.2379455566406,
        -1972.0,
        762.07080078125
      ],
      "bbox_max": [
        -365.32745361328125,
        -1955.333251953125,
        780.1475830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -406.2379455566406,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -404.598876953125,
        -1972.0,
        780.1475830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -468.130615234375,
        -2091.646728515625,
        639.6060791015625
      ],
      "bbox_max": [
        -66.71080017089844,
        -1955.6201171875,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -111.8211441040039,
        -2066.430419921875,
        639.6060791015625
      ],
      "bbox_max": [
        -66.71080017089844,
        -2013.17724609375,
        741.7178955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532700657844543,
        0.2706069350242615,
        0.7071138620376587
      ],
      "plane_d": 144.97592163085938,
      "bbox_min": [
        -99.86669921875,
        -2066.430419921875,
        639.6060791015625
      ],
      "bbox_max": [
        -66.71080017089844,
        -2047.364990234375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -99.86669921875,
        -2066.430419921875,
        639.6060791015625
      ],
      "bbox_max": [
        -66.71080017089844,
        -2047.364990234375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6248225569725037,
        0.7807667851448059,
        -0.0
      ],
      "plane_d": 1655.082763671875,
      "bbox_min": [
        -99.86669921875,
        -2066.430419921875,
        639.6060791015625
      ],
      "bbox_max": [
        -66.71080017089844,
        -2047.364990234375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.653276264667511,
        0.27059444785118103,
        0.7071129083633423
      ],
      "plane_d": 26.99755859375,
      "bbox_min": [
        -99.86669921875,
        -2062.0478515625,
        650.2849731445312
      ],
      "bbox_max": [
        -72.18734741210938,
        -2051.547119140625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        -0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -959.4097900390625,
      "bbox_min": [
        -76.02014923095703,
        -2062.0478515625,
        650.2849731445312
      ],
      "bbox_max": [
        -72.18734741210938,
        -2059.573974609375,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        -0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -937.260986328125,
      "bbox_min": [
        -76.02014923095703,
        -2061.798583984375,
        651.1747436523438
      ],
      "bbox_max": [
        -73.61585235595703,
        -2059.573974609375,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -90.46661376953125,
        -2047.570068359375,
        655.2613525390625
      ],
      "bbox_max": [
        -90.278564453125,
        -2047.364990234375,
        655.4723510742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9814715385437012,
        0.1916080117225647
      ],
      "plane_d": -2147.4345703125,
      "bbox_min": [
        -99.86669921875,
        -2059.573974609375,
        657.7044067382812
      ],
      "bbox_max": [
        -80.77708435058594,
        -2058.040283203125,
        665.5609741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532886624336243,
        -0.2705933749675751,
        0.7071020007133484
      ],
      "plane_d": -1087.6129150390625,
      "bbox_min": [
        -100.01698303222656,
        -2062.45703125,
        656.4622192382812
      ],
      "bbox_max": [
        -98.35603332519531,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -99.86669921875,
        -2061.745849609375,
        657.7044067382812
      ],
      "bbox_max": [
        -98.35603332519531,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -468.130615234375,
        -2091.646728515625,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63478088378906,
        -1955.6201171875,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2032.0,
      "bbox_min": [
        -300.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -273.67132568359375,
        -2022.0,
        769.9811401367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -300.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -290.0,
        -2022.0,
        769.9811401367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 768.4999389648438,
      "bbox_min": [
        -405.9098205566406,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -311.5650939941406,
        -1969.2711181640625,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -325.0,
      "bbox_min": [
        -405.9098205566406,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -311.5650939941406,
        -1969.2711181640625,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1992.0,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -311.5650939941406,
        -1975.51904296875,
        769.9249877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1634.8309326171875,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1975.51904296875,
        769.9249877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1168.1405029296875,
      "bbox_min": [
        -325.0,
        -1977.0,
        768.5
      ],
      "bbox_max": [
        -323.5190734863281,
        -1975.51904296875,
        768.8712158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -405.9098205566406,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -396.96240234375,
        -1969.2711181640625,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -404.598876953125,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -396.96240234375,
        -1969.2711181640625,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -468.130615234375,
        -2091.646728515625,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63478088378906,
        -1955.6201171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -360.2325439453125,
        -2091.646728515625,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63478088378906,
        -1955.6201171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -286.0,
        -1987.0,
        715.0101928710938
      ],
      "bbox_max": [
        -272.0,
        -1958.47509765625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -286.0,
        -1987.0,
        715.7435913085938
      ],
      "bbox_max": [
        -275.0,
        -1958.7119140625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        720.681884765625
      ],
      "bbox_max": [
        -275.0,
        -1958.7119140625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -283.0,
        -1979.0,
        754.0
      ],
      "bbox_max": [
        -275.0,
        -1958.7119140625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -283.0,
        -1959.3433837890625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -275.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1958.47509765625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.41665470600128174,
        -0.9090648293495178
      ],
      "plane_d": -143.7080078125,
      "bbox_min": [
        -286.0,
        -2084.843505859375,
        650.8728637695312
      ],
      "bbox_max": [
        -272.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1990.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1987.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -286.0,
        -2084.843505859375,
        650.8728637695312
      ],
      "bbox_max": [
        -272.0,
        -2077.079345703125,
        656.0780639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -360.2325439453125,
        -2091.646728515625,
        651.916259765625
      ],
      "bbox_max": [
        -286.0,
        -2077.417724609375,
        670.4046630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -300.5304870605469,
        -2085.88525390625,
        651.916259765625
      ],
      "bbox_max": [
        -286.0,
        -2077.417724609375,
        657.5479736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -360.2325439453125,
        -2091.646728515625,
        658.53662109375
      ],
      "bbox_max": [
        -346.3417663574219,
        -2086.4697265625,
        670.4046630859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -360.2325439453125,
        -2091.646728515625,
        659.28759765625
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        670.4046630859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -360.2325439453125,
        -2091.646728515625,
        660.1242065429688
      ],
      "bbox_max": [
        -357.18017578125,
        -2086.585205078125,
        670.4046630859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -272.0,
        -2083.83984375,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63478088378906,
        -1979.0,
        751.0370483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        706.9443969726562
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        751.0370483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        706.9443969726562
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        750.1940307617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -195.0,
        -1979.0,
        712.6160888671875
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        750.1940307617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -272.0,
        -2083.83984375,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63478088378906,
        -2049.502197265625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -272.0,
        -2083.83984375,
        641.18310546875
      ],
      "bbox_max": [
        -216.42385864257812,
        -2076.626953125,
        654.661865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -272.0,
        -2083.83984375,
        649.47802734375
      ],
      "bbox_max": [
        -253.28384399414062,
        -2076.626953125,
        654.661865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -219.54531860351562,
        -2083.685302734375,
        641.18310546875
      ],
      "bbox_max": [
        -216.42385864257812,
        -2083.32763671875,
        641.6351318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.653276264667511,
        0.27059444785118103,
        0.7071129083633423
      ],
      "plane_d": 26.99755859375,
      "bbox_min": [
        -108.98380279541016,
        -2070.30615234375,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63478088378906,
        -2049.502197265625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532886624336243,
        -0.2705933749675751,
        0.7071020007133484
      ],
      "plane_d": -1087.6129150390625,
      "bbox_min": [
        -108.98380279541016,
        -2070.30615234375,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63478088378906,
        -2049.502197265625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -108.98380279541016,
        -2070.30615234375,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63478088378906,
        -2049.502197265625,
        656.0746459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        -0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": -1186.8843994140625,
      "bbox_min": [
        -108.98380279541016,
        -2069.031982421875,
        641.4745483398438
      ],
      "bbox_max": [
        -97.63478088378906,
        -2049.502197265625,
        656.0746459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -108.98356628417969,
        -2069.026611328125,
        641.4745483398438
      ],
      "bbox_max": [
        -97.63478088378906,
        -2049.502197265625,
        656.0746459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.2637939453125,
        -2069.026611328125,
        641.4745483398438
      ],
      "bbox_max": [
        -97.63478088378906,
        -2049.502197265625,
        656.0746459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -99.73934173583984,
        -2051.547119140625,
        654.2015991210938
      ],
      "bbox_max": [
        -97.63478088378906,
        -2049.502197265625,
        656.0746459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -108.98356628417969,
        -2066.781005859375,
        643.1660766601562
      ],
      "bbox_max": [
        -105.278564453125,
        -2059.573974609375,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.98356628417969,
        -2066.781005859375,
        643.1660766601562
      ],
      "bbox_max": [
        -108.2637939453125,
        -2065.29248046875,
        644.2874145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -100.88525390625,
        -2070.30615234375,
        639.9630126953125
      ],
      "bbox_max": [
        -100.58235168457031,
        -2070.1806640625,
        640.3057250976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879413485527039,
        0.423933207988739,
        0.6889162063598633
      ],
      "plane_d": 185.86029052734375,
      "bbox_min": [
        -674.18994140625,
        -2372.12451171875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        825.35693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -495.31585693359375,
        -2232.79736328125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        796.8316650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        -495.31585693359375,
        -2232.79736328125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        796.8316650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -495.31585693359375,
        -2232.79736328125,
        606.0013427734375
      ],
      "bbox_max": [
        26.906936645507812,
        -2132.764404296875,
        760.3947143554688
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.07822323590517044,
        0.9795448184013367,
        0.1854003369808197
      ],
      "plane_d": 2009.3104248046875,
      "bbox_min": [
        -139.03753662109375,
        -2181.199951171875,
        623.3385620117188
      ],
      "bbox_max": [
        -75.29141998291016,
        -2160.685546875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.300048828125,
        -2181.199951171875,
        623.3385620117188
      ],
      "bbox_max": [
        -75.29143524169922,
        -2160.9189453125,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -677.7044067382812,
      "bbox_min": [
        -99.89990234375,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -75.29143524169922,
        -2167.647705078125,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.89990234375,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -75.29143524169922,
        -2167.647705078125,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785882115364075,
        -0.00047138650552369654,
        0.7345187664031982
      ],
      "plane_d": -429.3540954589844,
      "bbox_min": [
        -77.42676544189453,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -75.29143524169922,
        -2168.79541015625,
        654.677001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6793980598449707,
        0.0004719383723568171,
        0.7337697148323059
      ],
      "plane_d": -549.4459838867188,
      "bbox_min": [
        -105.300048828125,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -99.88549041748047,
        -2166.400146484375,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.08373019099235535,
        0.9710349440574646,
        0.22378645837306976
      ],
      "plane_d": 1966.399658203125,
      "bbox_min": [
        -139.03753662109375,
        -2169.029541015625,
        623.7440795898438
      ],
      "bbox_max": [
        -75.29141998291016,
        -2160.685546875,
        657.9076538085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28976440429688,
        -2166.400146484375,
        623.7440795898438
      ],
      "bbox_max": [
        -105.28579711914062,
        -2160.685546875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -105.28976440429688,
        -2169.029541015625,
        651.650146484375
      ],
      "bbox_max": [
        -75.29141998291016,
        -2166.156982421875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6793980598449707,
        0.0004719383723568171,
        0.7337697148323059
      ],
      "plane_d": -549.4459838867188,
      "bbox_min": [
        -105.28976440429688,
        -2168.998291015625,
        651.650146484375
      ],
      "bbox_max": [
        -75.29141998291016,
        -2166.156982421875,
        656.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6785882115364075,
        -0.00047138650552369654,
        0.7345187664031982
      ],
      "plane_d": -429.3540954589844,
      "bbox_min": [
        -105.28976440429688,
        -2168.998291015625,
        651.650146484375
      ],
      "bbox_max": [
        -75.29141998291016,
        -2166.156982421875,
        654.6787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28976440429688,
        -2166.400146484375,
        651.650146484375
      ],
      "bbox_max": [
        -105.28959655761719,
        -2166.156982421875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786047220230103,
        0.0007285246392711997,
        0.7345033884048462
      ],
      "plane_d": -549.2896118164062,
      "bbox_min": [
        -101.08056640625,
        -2167.778076171875,
        656.5999755859375
      ],
      "bbox_max": [
        -99.88549041748047,
        -2167.465576171875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -495.31585693359375,
        -2232.79736328125,
        673.632568359375
      ],
      "bbox_max": [
        -443.2167053222656,
        -2204.33740234375,
        695.7612915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -495.31585693359375,
        -2232.79736328125,
        674.6224365234375
      ],
      "bbox_max": [
        -478.577392578125,
        -2210.26318359375,
        695.7612915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16232021152973175,
        0.6113415360450745,
        0.7745409607887268
      ],
      "plane_d": 836.6258544921875,
      "bbox_min": [
        -139.03756713867188,
        -2173.240966796875,
        606.0013427734375
      ],
      "bbox_max": [
        26.906936645507812,
        -2132.764404296875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28959655761719,
        -2166.156005859375,
        623.748779296875
      ],
      "bbox_max": [
        -105.2795181274414,
        -2151.646240234375,
        651.6453247070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -105.28974151611328,
        -2173.240966796875,
        606.0013427734375
      ],
      "bbox_max": [
        26.906936645507812,
        -2132.764404296875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -677.7044067382812,
      "bbox_min": [
        -99.88970184326172,
        -2173.240966796875,
        652.7044067382812
      ],
      "bbox_max": [
        -75.28289794921875,
        -2156.505859375,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.89990234375,
        -2169.029541015625,
        652.7044067382812
      ],
      "bbox_max": [
        -75.28289794921875,
        -2156.505859375,
        661.4400024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785882115364075,
        -0.00047138650552369654,
        0.7345187664031982
      ],
      "plane_d": -429.3540954589844,
      "bbox_min": [
        -79.34645080566406,
        -2168.98779296875,
        652.7044067382812
      ],
      "bbox_max": [
        -75.28289794921875,
        -2156.505859375,
        656.4575805664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7208325266838074,
        0.0,
        0.6931092739105225
      ],
      "plane_d": -518.7118530273438,
      "bbox_min": [
        -86.60009765625,
        -2160.0,
        656.5999755859375
      ],
      "bbox_max": [
        -83.60009765625,
        -2158.7919921875,
        661.4400024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -86.60009765625,
      "bbox_min": [
        -86.60009765625,
        -2160.0,
        656.5999755859375
      ],
      "bbox_max": [
        -86.60009765625,
        -2158.7919921875,
        658.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28974151611328,
        -2167.778076171875,
        644.7898559570312
      ],
      "bbox_max": [
        -99.877685546875,
        -2157.47216796875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786047220230103,
        0.0007285246392711997,
        0.7345033884048462
      ],
      "plane_d": -549.2896118164062,
      "bbox_min": [
        -105.28974151611328,
        -2167.778076171875,
        652.7044067382812
      ],
      "bbox_max": [
        -99.877685546875,
        -2159.6826171875,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -471.8010559082031,
        -2220.312255859375,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        796.8316650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -471.8010559082031,
        -2220.312255859375,
        653.261962890625
      ],
      "bbox_max": [
        -256.07354736328125,
        -2099.048583984375,
        796.8316650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36162224411964417,
        0.8005647659301758,
        0.4778340458869934
      ],
      "plane_d": 1267.4736328125,
      "bbox_min": [
        -470.0794982910156,
        -2220.312255859375,
        653.261962890625
      ],
      "bbox_max": [
        -256.07354736328125,
        -2119.075927734375,
        796.8316650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -470.0794982910156,
        -2220.312255859375,
        653.261962890625
      ],
      "bbox_max": [
        -256.07354736328125,
        -2119.992431640625,
        787.3297119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -390.7622375488281,
        -2170.64208984375,
        653.261962890625
      ],
      "bbox_max": [
        -256.07354736328125,
        -2119.992431640625,
        779.5220336914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -323.15570068359375,
        -2131.402587890625,
        653.261962890625
      ],
      "bbox_max": [
        -314.135009765625,
        -2119.992431640625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -337.6196594238281,
        -2144.902587890625,
        667.9999389648438
      ],
      "bbox_max": [
        -314.135009765625,
        -2125.823974609375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -318.5453186035156,
        -2131.402587890625,
        667.9999389648438
      ],
      "bbox_max": [
        -314.135009765625,
        -2125.823974609375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -470.0794982910156,
        -2206.14794921875,
        674.6758422851562
      ],
      "bbox_max": [
        -408.99609375,
        -2180.35791015625,
        690.954345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -374.12353515625,
        -2215.109375,
        654.7406005859375
      ],
      "bbox_max": [
        -260.9525451660156,
        -2119.075927734375,
        796.8316650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -374.12353515625,
        -2215.109375,
        745.1763916015625
      ],
      "bbox_max": [
        -343.83367919921875,
        -2196.99365234375,
        796.8316650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -355.803466796875,
        -2198.047119140625,
        654.7406005859375
      ],
      "bbox_max": [
        -260.9525451660156,
        -2119.075927734375,
        791.80322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -355.803466796875,
        -2177.188720703125,
        654.7406005859375
      ],
      "bbox_max": [
        -260.9525451660156,
        -2119.075927734375,
        783.396728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -352.2388916015625,
        -2141.043701171875,
        654.7406005859375
      ],
      "bbox_max": [
        -317.1545715332031,
        -2119.075927734375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -352.2388916015625,
        -2141.043701171875,
        667.9999389648438
      ],
      "bbox_max": [
        -338.68157958984375,
        -2134.35498046875,
        667.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -295.6280212402344,
        -2168.66357421875,
        705.10546875
      ],
      "bbox_max": [
        -263.1219177246094,
        -2133.64990234375,
        780.6771850585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -294.19268798828125,
        -2165.86181640625,
        705.6879272460938
      ],
      "bbox_max": [
        -263.1219177246094,
        -2133.64990234375,
        779.7889404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3062765598297119,
        0.638495922088623,
        0.7060579061508179
      ],
      "plane_d": 782.314453125,
      "bbox_min": [
        -471.8010559082031,
        -2204.446533203125,
        654.859375
      ],
      "bbox_max": [
        -294.1375732421875,
        -2099.048583984375,
        705.8518676757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2608638405799866,
        0.6026611328125,
        0.7541548013687134
      ],
      "plane_d": 689.7464599609375,
      "bbox_min": [
        -471.8010559082031,
        -2204.446533203125,
        654.859375
      ],
      "bbox_max": [
        -305.860595703125,
        -2109.672607421875,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -471.8010559082031,
        -2204.446533203125,
        654.859375
      ],
      "bbox_max": [
        -318.24664306640625,
        -2109.672607421875,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -395.28857421875,
        -2160.501220703125,
        654.859375
      ],
      "bbox_max": [
        -318.24664306640625,
        -2109.672607421875,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -331.3144836425781,
        -2124.538818359375,
        654.859375
      ],
      "bbox_max": [
        -319.56134033203125,
        -2109.672607421875,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -339.98016357421875,
        -2136.17138671875,
        667.9999389648438
      ],
      "bbox_max": [
        -318.24664306640625,
        -2120.220458984375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -322.9754333496094,
        -2126.201904296875,
        667.9999389648438
      ],
      "bbox_max": [
        -318.24664306640625,
        -2120.220458984375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39295151829719543,
        0.5888877511024475,
        0.7062578797340393
      ],
      "plane_d": 638.5640869140625,
      "bbox_min": [
        -435.57171630859375,
        -2180.35791015625,
        667.0780029296875
      ],
      "bbox_max": [
        -408.99609375,
        -2163.6953125,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -361.60101318359375,
        -2150.153564453125,
        660.4235229492188
      ],
      "bbox_max": [
        -305.860595703125,
        -2113.15673828125,
        683.3890991210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -361.60101318359375,
        -2141.695556640625,
        660.4235229492188
      ],
      "bbox_max": [
        -320.0271911621094,
        -2113.15673828125,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -361.60101318359375,
        -2141.695556640625,
        667.9999389648438
      ],
      "bbox_max": [
        -342.22509765625,
        -2128.187255859375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -361.0242004394531,
        -2150.153564453125,
        671.9999389648438
      ],
      "bbox_max": [
        -349.0511474609375,
        -2140.775146484375,
        680.5648193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -418.5774230957031,
        -2180.35791015625,
        656.0779418945312
      ],
      "bbox_max": [
        -294.1375732421875,
        -2099.048583984375,
        705.8518676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -305.860595703125,
        -2133.64990234375,
        677.8638305664062
      ],
      "bbox_max": [
        -294.19268798828125,
        -2121.553955078125,
        705.6879272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2608638405799866,
        0.6026611328125,
        0.7541548013687134
      ],
      "plane_d": 689.7464599609375,
      "bbox_min": [
        -418.5774230957031,
        -2180.35791015625,
        656.0779418945312
      ],
      "bbox_max": [
        -294.1375732421875,
        -2099.048583984375,
        705.8518676757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -331.7146911621094,
        -2113.15673828125,
        656.0779418945312
      ],
      "bbox_max": [
        -328.5599670410156,
        -2109.166259765625,
        660.4235229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35807520151138306,
        0.6098346710205078,
        0.7070246934890747
      ],
      "plane_d": 697.973388671875,
      "bbox_min": [
        -418.117919921875,
        -2180.35791015625,
        667.9999389648438
      ],
      "bbox_max": [
        -398.08636474609375,
        -2152.732177734375,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -406.736328125,
        -2151.965576171875,
        656.1435546875
      ],
      "bbox_max": [
        -294.1375732421875,
        -2099.048583984375,
        705.8518676757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        0.8660248517990112,
        4.552165592031088e-06
      ],
      "plane_d": 1638.2412109375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        656.1435546875
      ],
      "bbox_max": [
        -320.403564453125,
        -2099.048583984375,
        667.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        656.1435546875
      ],
      "bbox_max": [
        -320.403564453125,
        -2099.048583984375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        665.5939331054688
      ],
      "bbox_max": [
        -402.07666015625,
        -2123.822265625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        660.0830078125
      ],
      "bbox_max": [
        -358.6918640136719,
        -2099.048583984375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26295778155326843,
        0.5350207686424255,
        0.8028736114501953
      ],
      "plane_d": 510.40802001953125,
      "bbox_min": [
        -333.36688232421875,
        -2116.57861328125,
        659.2074584960938
      ],
      "bbox_max": [
        -320.403564453125,
        -2107.076416015625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2629581093788147,
        0.5350224375724792,
        0.8028724193572998
      ],
      "plane_d": 510.412353515625,
      "bbox_min": [
        -363.46234130859375,
        -2140.843505859375,
        667.9998779296875
      ],
      "bbox_max": [
        -294.1375732421875,
        -2103.345703125,
        705.8518676757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -341.3185119628906,
        -2131.678466796875,
        667.9999389648438
      ],
      "bbox_max": [
        -321.2221984863281,
        -2116.57861328125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -325.85455322265625,
        -2122.438232421875,
        667.9999389648438
      ],
      "bbox_max": [
        -321.2221984863281,
        -2116.57861328125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -363.46234130859375,
        -2140.843505859375,
        668.0
      ],
      "bbox_max": [
        -341.3185729980469,
        -2130.181640625,
        676.5722045898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -356.2543640136719,
        -2134.0361328125,
        667.9999389648438
      ],
      "bbox_max": [
        -294.1375732421875,
        -2103.345703125,
        705.8518676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -330.61334228515625,
        -2120.901611328125,
        667.9999389648438
      ],
      "bbox_max": [
        -322.4370422363281,
        -2110.559326171875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -305.860595703125,
        -2134.0361328125,
        677.8638305664062
      ],
      "bbox_max": [
        -294.1375732421875,
        -2121.553955078125,
        705.8518676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -305.860595703125,
        -2134.0361328125,
        677.8638305664062
      ],
      "bbox_max": [
        -294.1375732421875,
        -2121.553955078125,
        705.8518676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9362152218818665,
        0.2509586215019226,
        -0.2460101991891861
      ],
      "plane_d": 826.9634399414062,
      "bbox_min": [
        -360.30859375,
        -2187.80908203125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        774.1619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -360.30859375,
        -2187.80908203125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        774.1619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -360.30859375,
        -2163.4716796875,
        606.1185302734375
      ],
      "bbox_max": [
        26.063024520874023,
        -2082.166748046875,
        677.8638305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -109.34033203125,
        -2156.387451171875,
        618.7809448242188
      ],
      "bbox_max": [
        -66.12939453125,
        -2130.763916015625,
        640.90576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.7809448242188
      ],
      "bbox_max": [
        -66.12939453125,
        -2130.763916015625,
        630.7153930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        620.623779296875
      ],
      "bbox_max": [
        -79.672119140625,
        -2130.763916015625,
        630.7153930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        0.9238802790641785,
        -0.0
      ],
      "plane_d": 2007.28369140625,
      "bbox_min": [
        -92.5,
        -2139.665283203125,
        620.623779296875
      ],
      "bbox_max": [
        -79.672119140625,
        -2135.27197265625,
        627.3795776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        622.4288940429688
      ],
      "bbox_max": [
        -92.20442962646484,
        -2136.069580078125,
        627.3795776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        622.4317016601562
      ],
      "bbox_max": [
        -91.48381042480469,
        -2130.763916015625,
        630.7153930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.20442962646484,
        -2136.069580078125,
        622.4317016601562
      ],
      "bbox_max": [
        -91.48381042480469,
        -2130.763916015625,
        625.9423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        623.95703125
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        636.99072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        624.153076171875
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        634.4107666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -107.177978515625,
        -2140.8193359375,
        624.153076171875
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        631.224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -360.30859375,
        -2163.4716796875,
        622.1928100585938
      ],
      "bbox_max": [
        -66.12939453125,
        -2082.166748046875,
        677.8638305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -360.30859375,
        -2121.553955078125,
        653.5272827148438
      ],
      "bbox_max": [
        -260.7839660644531,
        -2083.035888671875,
        677.8638305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -360.30859375,
        -2121.553955078125,
        654.2220458984375
      ],
      "bbox_max": [
        -300.5304870605469,
        -2085.88525390625,
        677.8638305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -335.4600830078125,
        -2107.07666015625,
        656.6759033203125
      ],
      "bbox_max": [
        -333.3668212890625,
        -2104.428955078125,
        659.2075805664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -360.30859375,
        -2112.143798828125,
        656.7574462890625
      ],
      "bbox_max": [
        -329.36065673828125,
        -2089.29296875,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -360.30859375,
        -2112.143798828125,
        658.4334716796875
      ],
      "bbox_max": [
        -329.36065673828125,
        -2089.29296875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -359.3388977050781,
        -2101.909423828125,
        659.9719848632812
      ],
      "bbox_max": [
        -357.05364990234375,
        -2097.967041015625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.97299724817276,
        0.23081716895103455,
        0.0
      ],
      "plane_d": 832.5162353515625,
      "bbox_min": [
        -357.9346923828125,
        -2098.495361328125,
        659.9719848632812
      ],
      "bbox_max": [
        -357.809326171875,
        -2097.967041015625,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -360.30859375,
        -2091.77294921875,
        660.4451904296875
      ],
      "bbox_max": [
        -359.2984924316406,
        -2090.097900390625,
        664.4932250976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -360.30859375,
        -2108.1943359375,
        662.3568725585938
      ],
      "bbox_max": [
        -332.48297119140625,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -360.30859375,
        -2108.1943359375,
        662.3568725585938
      ],
      "bbox_max": [
        -332.48297119140625,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        -0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -360.30859375,
        -2091.77294921875,
        662.3568725585938
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -360.30859375,
        -2091.77294921875,
        663.4928588867188
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -357.18017578125,
        -2086.585205078125,
        669.1162109375
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -218.78538513183594,
        -2163.4716796875,
        622.1928100585938
      ],
      "bbox_max": [
        -66.12939453125,
        -2082.166748046875,
        661.6588745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2157.47216796875,
        628.624267578125
      ],
      "bbox_max": [
        -98.66907501220703,
        -2138.747314453125,
        644.789794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        628.624267578125
      ],
      "bbox_max": [
        -98.66907501220703,
        -2138.747314453125,
        636.0255737304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        631.224609375
      ],
      "bbox_max": [
        -107.177978515625,
        -2140.8193359375,
        636.0255737304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -100.88525390625,
        -2139.665283203125,
        628.624267578125
      ],
      "bbox_max": [
        -98.66907501220703,
        -2138.747314453125,
        629.813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28356170654297,
        -2157.47216796875,
        636.99072265625
      ],
      "bbox_max": [
        -105.278564453125,
        -2150.27197265625,
        644.789794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -109.34033203125,
        -2158.017578125,
        622.1928100585938
      ],
      "bbox_max": [
        -66.12939453125,
        -2127.946044921875,
        646.7430419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -109.34033203125,
        -2158.017578125,
        634.0918579101562
      ],
      "bbox_max": [
        -105.278564453125,
        -2143.1201171875,
        646.7430419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        634.0918579101562
      ],
      "bbox_max": [
        -105.278564453125,
        -2143.1201171875,
        643.8660888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        634.0918579101562
      ],
      "bbox_max": [
        -108.29047393798828,
        -2143.1201171875,
        642.92138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        0.9238802790641785,
        -0.0
      ],
      "plane_d": 2007.28369140625,
      "bbox_min": [
        -108.29047393798828,
        -2143.1201171875,
        622.1928100585938
      ],
      "bbox_max": [
        -79.672119140625,
        -2127.946044921875,
        641.881591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -108.29047393798828,
        -2143.1201171875,
        624.9449462890625
      ],
      "bbox_max": [
        -90.278564453125,
        -2134.559326171875,
        641.881591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -108.29047393798828,
        -2143.1201171875,
        625.9423828125
      ],
      "bbox_max": [
        -92.20442962646484,
        -2136.069580078125,
        641.881591796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -108.29047393798828,
        -2143.1201171875,
        633.66015625
      ],
      "bbox_max": [
        -108.05609130859375,
        -2142.635498046875,
        641.881591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -108.05609130859375,
        -2142.635498046875,
        624.9449462890625
      ],
      "bbox_max": [
        -91.99929809570312,
        -2134.559326171875,
        641.6494750976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -108.05609130859375,
        -2142.635498046875,
        632.0427856445312
      ],
      "bbox_max": [
        -107.177978515625,
        -2140.8193359375,
        641.6494750976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.2044448852539,
        -2136.069580078125,
        624.9449462890625
      ],
      "bbox_max": [
        -91.99929809570312,
        -2134.559326171875,
        635.6824951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -91.99929809570312,
        -2134.559326171875,
        622.1928100585938
      ],
      "bbox_max": [
        -89.30126953125,
        -2127.946044921875,
        635.0760498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2127.946044921875,
      "bbox_min": [
        -91.10107421875,
        -2127.946044921875,
        622.1928100585938
      ],
      "bbox_max": [
        -89.30126953125,
        -2127.946044921875,
        632.4207763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        -214.34085083007812,
        -2187.80908203125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        774.1619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8734391927719116,
        -0.19791147112846375,
        -0.44489893317222595
      ],
      "plane_d": -14.895965576171875,
      "bbox_min": [
        121.512451171875,
        -2113.157470703125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2044.892578125,
        637.62353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25527524948120117,
        0.9336197376251221,
        0.25137388706207275
      ],
      "plane_d": 1895.1923828125,
      "bbox_min": [
        -214.34085083007812,
        -2187.80908203125,
        623.1181030273438
      ],
      "bbox_max": [
        126.47466278076172,
        -2015.640380859375,
        774.1619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0863649919629097,
        0.9781539440155029,
        0.18909214437007904
      ],
      "plane_d": 2005.18701171875,
      "bbox_min": [
        -209.0651397705078,
        -2187.80908203125,
        623.1181030273438
      ],
      "bbox_max": [
        126.47466278076172,
        -2015.640380859375,
        773.529541015625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.45699819922447205,
        -0.8811807036399841,
        -0.1211327537894249
      ],
      "plane_d": -1669.15185546875,
      "bbox_min": [
        -189.77603149414062,
        -2187.80908203125,
        623.1181030273438
      ],
      "bbox_max": [
        126.47466278076172,
        -2015.640380859375,
        762.282958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07853952795267105,
        0.978276252746582,
        0.19185161590576172
      ],
      "plane_d": 2002.348876953125,
      "bbox_min": [
        -189.77603149414062,
        -2187.80908203125,
        623.1181030273438
      ],
      "bbox_max": [
        -64.5244140625,
        -2022.8271484375,
        762.282958984375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.08373019099235535,
        0.9710349440574646,
        0.22378645837306976
      ],
      "plane_d": 1966.399658203125,
      "bbox_min": [
        -163.181640625,
        -2164.698486328125,
        657.4825439453125
      ],
      "bbox_max": [
        -138.92935180664062,
        -2163.4716796875,
        661.6588745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9814715385437012,
        0.1916080117225647
      ],
      "plane_d": -2147.4345703125,
      "bbox_min": [
        -189.77603149414062,
        -2166.092529296875,
        623.1181030273438
      ],
      "bbox_max": [
        -64.5244140625,
        -2022.8271484375,
        741.733642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -104.87355041503906,
        -2059.58642578125,
        657.6395874023438
      ],
      "bbox_max": [
        -80.62570190429688,
        -2022.8271484375,
        741.733642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -80.77599334716797,
        -2059.573974609375,
        657.6742553710938
      ],
      "bbox_max": [
        -80.6580581665039,
        -2059.564208984375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532700657844543,
        0.2706069350242615,
        0.7071138620376587
      ],
      "plane_d": 144.97592163085938,
      "bbox_min": [
        -80.69474792480469,
        -2059.573974609375,
        657.6742553710938
      ],
      "bbox_max": [
        -80.6580581665039,
        -2059.564208984375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -189.77603149414062,
        -2166.092529296875,
        623.1181030273438
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16232021152973175,
        0.6113415360450745,
        0.7745409607887268
      ],
      "plane_d": 836.6258544921875,
      "bbox_min": [
        -163.181640625,
        -2166.092529296875,
        623.1181030273438
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -677.7044067382812,
      "bbox_min": [
        -109.34033203125,
        -2166.092529296875,
        623.1181030273438
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.999999463558197,
        0.0010735620744526386,
        0.0
      ],
      "plane_d": -97.55819702148438,
      "bbox_min": [
        -109.34033203125,
        -2166.092529296875,
        623.1181030273438
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -99.86669921875,
        -2160.094482421875,
        623.1181030273438
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6248225569725037,
        0.7807667851448059,
        -0.0
      ],
      "plane_d": 1655.082763671875,
      "bbox_min": [
        -99.77811431884766,
        -2071.8154296875,
        635.3427734375
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -99.77811431884766,
        -2071.8154296875,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        -0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -937.260986328125,
      "bbox_min": [
        -99.77811431884766,
        -2071.8154296875,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2705991268157959,
        -0.6532875299453735,
        0.7071007490158081
      ],
      "plane_d": -1792.391845703125,
      "bbox_min": [
        -99.77811431884766,
        -2070.1806640625,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2061.745849609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2705896496772766,
        -0.6532796025276184,
        0.7071117758750916
      ],
      "plane_d": -1841.240234375,
      "bbox_min": [
        -99.77811431884766,
        -2068.792724609375,
        654.6559448242188
      ],
      "bbox_max": [
        -91.1700210571289,
        -2061.745849609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532886624336243,
        -0.2705933749675751,
        0.7071020007133484
      ],
      "plane_d": -1087.6129150390625,
      "bbox_min": [
        -99.77811431884766,
        -2067.89599609375,
        654.6559448242188
      ],
      "bbox_max": [
        -97.058349609375,
        -2061.745849609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        -0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -959.4097900390625,
      "bbox_min": [
        -87.16252899169922,
        -2071.8154296875,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532716155052185,
        -0.270601361989975,
        0.7071146368980408
      ],
      "plane_d": -969.6830444335938,
      "bbox_min": [
        -87.16252899169922,
        -2070.1806640625,
        652.7044067382812
      ],
      "bbox_max": [
        -76.02014923095703,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2705991268157959,
        -0.6532875299453735,
        0.7071007490158081
      ],
      "plane_d": -1792.391845703125,
      "bbox_min": [
        -87.16252899169922,
        -2070.1806640625,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2066.353759765625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -99.86669921875,
        -2160.094482421875,
        623.1181030273438
      ],
      "bbox_max": [
        -64.5244140625,
        -2067.75390625,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -99.77953338623047,
        -2075.322998046875,
        630.484375
      ],
      "bbox_max": [
        -88.0,
        -2067.75390625,
        657.7044067382812
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -91.1700210571289,
        -2069.162109375,
        657.7044067382812
      ],
      "bbox_max": [
        -89.7894515991211,
        -2068.792724609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532886624336243,
        -0.2705933749675751,
        0.7071020007133484
      ],
      "plane_d": -1087.6129150390625,
      "bbox_min": [
        -99.77953338623047,
        -2069.074951171875,
        654.1490478515625
      ],
      "bbox_max": [
        -98.60052490234375,
        -2067.75390625,
        655.689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2081.89990234375,
      "bbox_min": [
        -99.86669921875,
        -2160.094482421875,
        623.1181030273438
      ],
      "bbox_max": [
        -64.5244140625,
        -2073.7763671875,
        677.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20442962646484,
        -2081.89990234375,
        623.3673095703125
      ],
      "bbox_max": [
        -88.47034454345703,
        -2073.7763671875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.20442962646484,
        -2081.89990234375,
        636.5319213867188
      ],
      "bbox_max": [
        -88.47034454345703,
        -2073.7763671875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9126664400100708,
        0.4087052345275879
      ],
      "plane_d": -2160.234130859375,
      "bbox_min": [
        -91.385986328125,
        -2081.89990234375,
        636.5319213867188
      ],
      "bbox_max": [
        -89.0361328125,
        -2079.802001953125,
        645.4983520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2079.802001953125,
      "bbox_min": [
        -91.385986328125,
        -2079.802001953125,
        641.2166748046875
      ],
      "bbox_max": [
        -89.0361328125,
        -2079.802001953125,
        645.4983520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -99.86669921875,
        -2160.094482421875,
        630.6048583984375
      ],
      "bbox_max": [
        -64.5244140625,
        -2127.946044921875,
        677.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -99.86359405517578,
        -2157.984375,
        630.6048583984375
      ],
      "bbox_max": [
        -64.5244140625,
        -2127.946044921875,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -68.14163208007812,
      "bbox_min": [
        -99.86359405517578,
        -2157.984375,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785882115364075,
        -0.00047138650552369654,
        0.7345187664031982
      ],
      "plane_d": -429.3540954589844,
      "bbox_min": [
        -99.86359405517578,
        -2157.984375,
        652.7044067382812
      ],
      "bbox_max": [
        -75.278564453125,
        -2139.665283203125,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -99.86359405517578,
        -2147.37841796875,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2139.665283203125,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -99.86359405517578,
        -2147.37841796875,
        654.5860595703125
      ],
      "bbox_max": [
        -95.24271392822266,
        -2141.544677734375,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -98.60043334960938,
        -2142.64697265625,
        655.6896362304688
      ],
      "bbox_max": [
        -95.24271392822266,
        -2141.544677734375,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -50.819091796875,
      "bbox_min": [
        -85.50799560546875,
        -2155.970947265625,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532713174819946,
        0.27060064673423767,
        0.7071151733398438
      ],
      "plane_d": 169.50509643554688,
      "bbox_min": [
        -85.50799560546875,
        -2155.970947265625,
        652.7044067382812
      ],
      "bbox_max": [
        -75.278564453125,
        -2139.665283203125,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785882115364075,
        -0.00047138650552369654,
        0.7345187664031982
      ],
      "plane_d": -429.3540954589844,
      "bbox_min": [
        -85.50799560546875,
        -2155.970947265625,
        652.7044067382812
      ],
      "bbox_max": [
        -75.278564453125,
        -2139.665283203125,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -85.50799560546875,
        -2142.64697265625,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2139.665283203125,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        0.9238802790641785,
        -0.0
      ],
      "plane_d": 2007.28369140625,
      "bbox_min": [
        -99.8579330444336,
        -2142.10205078125,
        632.0200805664062
      ],
      "bbox_max": [
        -79.672119140625,
        -2127.946044921875,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -99.8579330444336,
        -2142.10205078125,
        634.9574584960938
      ],
      "bbox_max": [
        -79.672119140625,
        -2134.559326171875,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -99.8579330444336,
        -2142.10205078125,
        634.9574584960938
      ],
      "bbox_max": [
        -88.0,
        -2134.559326171875,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -99.8579330444336,
        -2142.10205078125,
        634.9574584960938
      ],
      "bbox_max": [
        -88.0,
        -2134.559326171875,
        655.6896362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909016489982605,
        0.13458801805973053,
        0.0
      ],
      "plane_d": 196.12387084960938,
      "bbox_min": [
        -99.8579330444336,
        -2142.10205078125,
        635.6824951171875
      ],
      "bbox_max": [
        -88.0,
        -2135.27197265625,
        655.6896362304688
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        651.2399291992188
      ],
      "bbox_max": [
        -88.0,
        -2135.27197265625,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -99.8579330444336,
        -2142.10205078125,
        654.0486450195312
      ],
      "bbox_max": [
        -98.60043334960938,
        -2140.694091796875,
        655.6896362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909016489982605,
        0.13458801805973053,
        0.0
      ],
      "plane_d": 196.12387084960938,
      "bbox_min": [
        -92.2044448852539,
        -2136.069580078125,
        635.0760498046875
      ],
      "bbox_max": [
        -90.2786636352539,
        -2134.559326171875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.20442962646484,
        -2136.069580078125,
        651.2399291992188
      ],
      "bbox_max": [
        -90.2786636352539,
        -2134.559326171875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -91.99929809570312,
        -2136.103759765625,
        632.0200805664062
      ],
      "bbox_max": [
        -88.2706298828125,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -91.99929809570312,
        -2134.559326171875,
        632.0200805664062
      ],
      "bbox_max": [
        -89.0361328125,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2127.946044921875,
      "bbox_min": [
        -91.10107421875,
        -2127.946044921875,
        632.0200805664062
      ],
      "bbox_max": [
        -89.30126953125,
        -2127.946044921875,
        636.5319213867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2130.0439453125,
      "bbox_min": [
        -91.385986328125,
        -2130.0439453125,
        641.2166748046875
      ],
      "bbox_max": [
        -89.0361328125,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8258352875709534,
        -0.563911497592926
      ],
      "plane_d": 2123.0693359375,
      "bbox_min": [
        -91.385986328125,
        -2130.0439453125,
        645.4983520507812
      ],
      "bbox_max": [
        -89.0361328125,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2127.946044921875,
      "bbox_min": [
        -91.10107421875,
        -2127.946044921875,
        648.5706787109375
      ],
      "bbox_max": [
        -89.30126953125,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238762259483337,
        0.3826916813850403,
        0.0
      ],
      "plane_d": 730.626708984375,
      "bbox_min": [
        -99.86669921875,
        -2159.826171875,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2139.488525390625,
        677.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826916813850403,
        0.9238762259483337,
        0.0
      ],
      "plane_d": 1943.1781005859375,
      "bbox_min": [
        -99.86669921875,
        -2159.826171875,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2139.488525390625,
        677.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3827034533023834,
        0.9238713383674622,
        -0.0
      ],
      "plane_d": 2012.266357421875,
      "bbox_min": [
        -99.86669921875,
        -2159.826171875,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2140.086181640625,
        677.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238762259483337,
        0.3826916813850403,
        -0.0
      ],
      "plane_d": 897.4393920898438,
      "bbox_min": [
        -99.86669921875,
        -2159.826171875,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2140.683837890625,
        677.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.387968510389328,
        0.9216726422309875,
        0.0
      ],
      "plane_d": 1950.5413818359375,
      "bbox_min": [
        -99.86669921875,
        -2159.826171875,
        656.5999755859375
      ],
      "bbox_max": [
        -79.49722290039062,
        -2140.683837890625,
        664.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -98.89990234375,
        -2159.826171875,
        656.5999755859375
      ],
      "bbox_max": [
        -79.49722290039062,
        -2150.27197265625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6785882115364075,
        -0.00047138650552369654,
        0.7345187664031982
      ],
      "plane_d": -429.3540954589844,
      "bbox_min": [
        -80.690673828125,
        -2157.103515625,
        656.5999755859375
      ],
      "bbox_max": [
        -79.49722290039062,
        -2150.27197265625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2158.0,
      "bbox_min": [
        -98.89990234375,
        -2159.826171875,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2158.0,
        661.4400024414062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7208325266838074,
        0.0,
        0.6931092739105225
      ],
      "plane_d": -518.7118530273438,
      "bbox_min": [
        -86.60009765625,
        -2159.826171875,
        656.5999755859375
      ],
      "bbox_max": [
        -83.60009765625,
        -2158.0,
        661.4400024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -86.60009765625,
      "bbox_min": [
        -86.60009765625,
        -2159.2724609375,
        656.5999755859375
      ],
      "bbox_max": [
        -86.60009765625,
        -2158.0,
        658.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3681499660015106,
        0.9297664761543274,
        0.0
      ],
      "plane_d": 2036.0167236328125,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -80.690673828125,
        -2140.683837890625,
        664.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9272966980934143,
        -0.3743273913860321,
        0.0
      ],
      "plane_d": -880.7164916992188,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -80.690673828125,
        -2140.683837890625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -84.69074249267578,
        -2150.65478515625,
        659.7044067382812
      ],
      "bbox_max": [
        -80.690673828125,
        -2142.99853515625,
        659.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -91.48558807373047,
        -2144.19921875,
        659.7044067382812
      ],
      "bbox_max": [
        -84.2060546875,
        -2140.683837890625,
        659.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2010255753993988,
        -0.4735967814922333,
        0.8574933409690857
      ],
      "plane_d": -1600.109375,
      "bbox_min": [
        -88.23503875732422,
        -2148.014892578125,
        659.5287475585938
      ],
      "bbox_max": [
        -84.85640716552734,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33503803610801697,
        0.7893171906471252,
        0.5145173072814941
      ],
      "plane_d": 1382.001708984375,
      "bbox_min": [
        -87.25821685791016,
        -2145.713623046875,
        660.5999755859375
      ],
      "bbox_max": [
        -84.85640716552734,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3907240033149719,
        0.9205079078674316,
        0.0
      ],
      "plane_d": 1937.51904296875,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -90.278564453125,
        -2141.183837890625,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9205050468444824,
        -0.3907306492328644,
        -0.0
      ],
      "plane_d": -926.4359741210938,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -92.36495971679688,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9205051064491272,
        0.3907306492328644,
        -0.0
      ],
      "plane_d": 923.93603515625,
      "bbox_min": [
        -95.74359130859375,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -92.36495971679688,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2010255753993988,
        -0.4735967814922333,
        0.8574933409690857
      ],
      "plane_d": -1563.80419921875,
      "bbox_min": [
        -95.74359130859375,
        -2148.014892578125,
        659.5287475585938
      ],
      "bbox_max": [
        -92.36495971679688,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33503803610801697,
        0.7893171906471252,
        0.5145173072814941
      ],
      "plane_d": 1321.4937744140625,
      "bbox_min": [
        -95.74359130859375,
        -2145.713623046875,
        660.5999755859375
      ],
      "bbox_max": [
        -93.34178161621094,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        659.7044067382812
      ],
      "bbox_max": [
        -97.0795669555664,
        -2146.0439453125,
        659.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -98.33621978759766,
        -2146.5771484375,
        659.7044067382812
      ],
      "bbox_max": [
        -90.278564453125,
        -2141.183837890625,
        659.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6532713174819946,
        0.27060064673423767,
        0.7071151733398438
      ],
      "plane_d": 169.50509643554688,
      "bbox_min": [
        -83.4990234375,
        -2153.1533203125,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2143.4921875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785882115364075,
        -0.00047138650552369654,
        0.7345187664031982
      ],
      "plane_d": -429.3540954589844,
      "bbox_min": [
        -80.690673828125,
        -2153.1533203125,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2150.27197265625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -90.278564453125,
        -2144.08984375,
        656.5999755859375
      ],
      "bbox_max": [
        -82.05598449707031,
        -2140.086181640625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532713174819946,
        0.27060064673423767,
        0.7071151733398438
      ],
      "plane_d": 169.50509643554688,
      "bbox_min": [
        -83.4990234375,
        -2144.08984375,
        656.5999755859375
      ],
      "bbox_max": [
        -82.05598449707031,
        -2142.64697265625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -97.058349609375,
        -2143.4921875,
        656.5999755859375
      ],
      "bbox_max": [
        -88.835693359375,
        -2139.488525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -90.278564453125,
        -2140.683837890625,
        656.5999755859375
      ],
      "bbox_max": [
        -88.835693359375,
        -2139.488525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -99.86669921875,
        -2150.27197265625,
        656.5999755859375
      ],
      "bbox_max": [
        -96.46065521240234,
        -2142.04931640625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -97.9036636352539,
        -2143.4921875,
        656.5999755859375
      ],
      "bbox_max": [
        -96.46065521240234,
        -2142.04931640625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7667246460914612,
        0.3175787925720215,
        0.5579220652580261
      ],
      "plane_d": 238.0029296875,
      "bbox_min": [
        -109.34033203125,
        -2160.506591796875,
        638.5621948242188
      ],
      "bbox_max": [
        -99.77224731445312,
        -2062.291259765625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": 375.2848815917969,
      "bbox_min": [
        -109.34033203125,
        -2160.506591796875,
        638.5621948242188
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -109.34033203125,
        -2160.506591796875,
        638.5621948242188
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -109.34033203125,
        -2160.506591796875,
        638.5621948242188
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786047220230103,
        0.0007285246392711997,
        0.7345033884048462
      ],
      "plane_d": -549.2896118164062,
      "bbox_min": [
        -109.34033203125,
        -2160.506591796875,
        641.6494750976562
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -109.34033203125,
        -2159.6826171875,
        641.6494750976562
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        654.0486450195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -100.88525390625,
        -2140.694091796875,
        652.7044067382812
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        654.0486450195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        641.6494750976562
      ],
      "bbox_max": [
        -105.278564453125,
        -2142.635498046875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        641.6494750976562
      ],
      "bbox_max": [
        -108.05611419677734,
        -2142.635498046875,
        644.2874145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -108.05611419677734,
        -2142.635498046875,
        638.9500732421875
      ],
      "bbox_max": [
        -100.88525390625,
        -2139.665283203125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -108.05611419677734,
        -2142.635498046875,
        640.7797241210938
      ],
      "bbox_max": [
        -107.177978515625,
        -2140.8193359375,
        644.2874145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -107.14860534667969,
        -2070.637939453125,
        639.056640625
      ],
      "bbox_max": [
        -99.77224731445312,
        -2062.291259765625,
        656.7517700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532886624336243,
        -0.2705933749675751,
        0.7071020007133484
      ],
      "plane_d": -1087.6129150390625,
      "bbox_min": [
        -105.54733276367188,
        -2070.637939453125,
        648.0633544921875
      ],
      "bbox_max": [
        -99.77224731445312,
        -2062.291259765625,
        656.7517700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2705896496772766,
        -0.6532796025276184,
        0.7071117758750916
      ],
      "plane_d": -1841.240234375,
      "bbox_min": [
        -100.88525390625,
        -2070.637939453125,
        652.7044067382812
      ],
      "bbox_max": [
        -99.77953338623047,
        -2069.074951171875,
        654.1490478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.14860534667969,
        -2070.1806640625,
        640.3057250976562
      ],
      "bbox_max": [
        -100.88525390625,
        -2067.95263671875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        -0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": -1186.8843994140625,
      "bbox_min": [
        -107.14860534667969,
        -2070.1806640625,
        644.3267211914062
      ],
      "bbox_max": [
        -100.88525390625,
        -2067.95263671875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6538359522819519,
        0.3617154061794281,
        0.6645753979682922
      ],
      "plane_d": 32.34027099609375,
      "bbox_min": [
        -674.18994140625,
        -2348.869140625,
        676.4805297851562
      ],
      "bbox_max": [
        -258.4636535644531,
        -2030.328857421875,
        821.1808471679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -478.577392578125,
        -2233.106689453125,
        695.7612915039062
      ],
      "bbox_max": [
        -258.4636535644531,
        -2030.328857421875,
        802.4439086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2032.0,
      "bbox_min": [
        -290.1921691894531,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -258.4636535644531,
        -2030.328857421875,
        769.5896606445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -290.1921691894531,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -258.4636535644531,
        -2030.328857421875,
        769.5896606445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -290.1921691894531,
        -2032.0,
        769.133544921875
      ],
      "bbox_max": [
        -290.0,
        -2031.807861328125,
        769.5896606445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -674.18994140625,
        -2295.365234375,
        676.4805297851562
      ],
      "bbox_max": [
        -478.577392578125,
        -2045.0107421875,
        817.3342895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -538.70947265625,
        -2295.365234375,
        676.4805297851562
      ],
      "bbox_max": [
        -478.577392578125,
        -2224.67919921875,
        695.7612915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -505.5889892578125,
        -2234.22900390625,
        676.4805297851562
      ],
      "bbox_max": [
        -478.577392578125,
        -2224.67919921875,
        695.7612915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9293507933616638,
        0.34574177861213684,
        0.1294977068901062
      ],
      "plane_d": 4632.30078125,
      "bbox_min": [
        -4204.98828125,
        -3278.16796875,
        1400.3001708984375
      ],
      "bbox_max": [
        -3963.71728515625,
        -2619.663330078125,
        1434.669189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8682754039764404,
        0.3892272710800171,
        0.3075709939002991
      ],
      "plane_d": 4276.294921875,
      "bbox_min": [
        -3970.672607421875,
        -3278.16796875,
        1433.9573974609375
      ],
      "bbox_max": [
        -3963.71728515625,
        -3262.108154296875,
        1434.669189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        -4203.63427734375,
        -3536.330078125,
        711.775390625
      ],
      "bbox_max": [
        196.0666046142578,
        -1865.0,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9293507933616638,
        0.34574177861213684,
        0.1294977068901062
      ],
      "plane_d": 4632.30078125,
      "bbox_min": [
        -4203.63427734375,
        -3536.330078125,
        850.4774169921875
      ],
      "bbox_max": [
        176.252197265625,
        -2148.940673828125,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8467844724655151,
        0.531133234500885,
        0.029217718169093132
      ],
      "plane_d": 1677.308349609375,
      "bbox_min": [
        -3970.641357421875,
        -3536.330078125,
        850.4774169921875
      ],
      "bbox_max": [
        176.252197265625,
        -2148.940673828125,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5784721970558167,
        0.8153333067893982,
        0.024523697793483734
      ],
      "plane_d": 2574.3935546875,
      "bbox_min": [
        -3970.641357421875,
        -3536.330078125,
        850.4774780273438
      ],
      "bbox_max": [
        176.252197265625,
        -2148.940673828125,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5775443315505981,
        0.816006064414978,
        0.024013593792915344
      ],
      "plane_d": 2576.892578125,
      "bbox_min": [
        -3970.641357421875,
        -3536.330078125,
        852.6356201171875
      ],
      "bbox_max": [
        176.252197265625,
        -2982.99560546875,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8440337181091309,
        0.5237486362457275,
        0.11530200392007828
      ],
      "plane_d": 1527.4400634765625,
      "bbox_min": [
        -3970.641357421875,
        -3536.330078125,
        1354.7957763671875
      ],
      "bbox_max": [
        176.252197265625,
        -2983.1630859375,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8434123396873474,
        0.5291796922683716,
        0.09286854416131973
      ],
      "plane_d": 1580.055908203125,
      "bbox_min": [
        -3970.641357421875,
        -3527.64501953125,
        1354.7957763671875
      ],
      "bbox_max": [
        176.252197265625,
        -2983.1630859375,
        1577.280517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5382782816886902,
        0.8385637402534485,
        0.08406741917133331
      ],
      "plane_d": 2561.375,
      "bbox_min": [
        -3970.641357421875,
        -3279.13720703125,
        1354.7957763671875
      ],
      "bbox_max": [
        -40.82177734375,
        -2983.1630859375,
        1577.280517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8682754039764404,
        0.3892272710800171,
        0.3075709939002991
      ],
      "plane_d": 4276.294921875,
      "bbox_min": [
        -3970.641357421875,
        -3279.13720703125,
        1433.9918212890625
      ],
      "bbox_max": [
        -3963.7255859375,
        -3262.205078125,
        1440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5380130410194397,
        0.8274743556976318,
        0.16071178019046783
      ],
      "plane_d": 2416.71533203125,
      "bbox_min": [
        -306.4415588378906,
        -3171.47509765625,
        1354.7957763671875
      ],
      "bbox_max": [
        -40.82177734375,
        -2983.1630859375,
        1447.936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -306.4415588378906,
        -3031.18994140625,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2983.1630859375,
        1447.936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -306.5951843261719,
        -3024.712158203125,
        865.2859497070312
      ],
      "bbox_max": [
        -233.4002685546875,
        -2982.99560546875,
        1431.283447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -306.5951843261719,
        -3024.712158203125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2982.99560546875,
        1431.283447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -984.291259765625,
        -3024.712158203125,
        863.9058837890625
      ],
      "bbox_max": [
        -234.2976531982422,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -984.291259765625,
        -2819.032470703125,
        863.9058837890625
      ],
      "bbox_max": [
        -495.6846008300781,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313450217247009,
        0.5555300712585449,
        0.01586890034377575
      ],
      "plane_d": 1886.90283203125,
      "bbox_min": [
        -984.291259765625,
        -2819.032470703125,
        863.9058837890625
      ],
      "bbox_max": [
        -495.6846008300781,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -984.291259765625,
        -2819.032470703125,
        864.1474609375
      ],
      "bbox_max": [
        -495.6846008300781,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -984.291259765625,
        -2819.032470703125,
        864.1893310546875
      ],
      "bbox_max": [
        -495.6846008300781,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -984.291259765625,
        -2819.032470703125,
        865.4462890625
      ],
      "bbox_max": [
        -495.6846008300781,
        -2159.280517578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9314306974411011,
        0.3556700348854065,
        0.0770426094532013
      ],
      "plane_d": 1355.5810546875,
      "bbox_min": [
        -984.291259765625,
        -2819.032470703125,
        880.4703979492188
      ],
      "bbox_max": [
        -495.6846008300781,
        -2159.280517578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321791529655457,
        0.32900404930114746,
        0.1509908139705658
      ],
      "plane_d": 1178.5645751953125,
      "bbox_min": [
        -984.291259765625,
        -2816.757568359375,
        880.4703979492188
      ],
      "bbox_max": [
        -498.223876953125,
        -2159.280517578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8198854923248291,
        0.5702467560768127,
        0.05105101317167282
      ],
      "plane_d": 1870.3758544921875,
      "bbox_min": [
        -984.291259765625,
        -2549.36376953125,
        880.4703979492188
      ],
      "bbox_max": [
        -594.252197265625,
        -2159.280517578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8297061324119568,
        0.5531379580497742,
        0.07500854879617691
      ],
      "plane_d": 1800.5321044921875,
      "bbox_min": [
        -984.291259765625,
        -2549.36376953125,
        880.4703979492188
      ],
      "bbox_max": [
        -594.252197265625,
        -2159.280517578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21514897048473358,
        0.9664539694786072,
        0.14027751982212067
      ],
      "plane_d": 1756.6002197265625,
      "bbox_min": [
        -984.291259765625,
        -2167.037841796875,
        880.4703979492188
      ],
      "bbox_max": [
        -955.45703125,
        -2159.280517578125,
        942.2494506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -698.2745361328125,
        -2409.47900390625,
        1258.9176025390625
      ],
      "bbox_max": [
        -685.0712890625,
        -2407.66796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -511.1015625,
        -2816.757568359375,
        1386.6339111328125
      ],
      "bbox_max": [
        -498.223876953125,
        -2806.955322265625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -502.1300354003906,
        -2819.032470703125,
        1386.6339111328125
      ],
      "bbox_max": [
        -495.6846008300781,
        -2806.955322265625,
        1479.110595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -960.8914794921875,
        -2408.3671875,
        864.1893310546875
      ],
      "bbox_max": [
        -685.0712890625,
        -2148.940673828125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -960.8914794921875,
        -2264.956787109375,
        864.4647827148438
      ],
      "bbox_max": [
        -781.6626586914062,
        -2148.940673828125,
        1371.9813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -960.8914794921875,
        -2253.353515625,
        864.4647827148438
      ],
      "bbox_max": [
        -783.6495361328125,
        -2148.940673828125,
        1131.8846435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21514897048473358,
        0.9664539694786072,
        0.14027751982212067
      ],
      "plane_d": 1756.6002197265625,
      "bbox_min": [
        -960.8914794921875,
        -2253.353515625,
        864.4647827148438
      ],
      "bbox_max": [
        -783.6495361328125,
        -2148.940673828125,
        1131.8846435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -808.619384765625,
        -2248.078125,
        864.4647827148438
      ],
      "bbox_max": [
        -787.0260009765625,
        -2222.050537109375,
        929.305419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -786.48876953125,
        -2408.3671875,
        864.8950805664062
      ],
      "bbox_max": [
        -685.0712890625,
        -2256.458740234375,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -767.986572265625,
        -2408.3671875,
        865.7201538085938
      ],
      "bbox_max": [
        -685.0712890625,
        -2310.554931640625,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -761.962646484375,
        -2408.3671875,
        865.7201538085938
      ],
      "bbox_max": [
        -685.0712890625,
        -2310.554931640625,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -738.92578125,
        -2408.3671875,
        1178.760986328125
      ],
      "bbox_max": [
        -685.0712890625,
        -2333.14013671875,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -738.92578125,
        -2408.3671875,
        1258.9176025390625
      ],
      "bbox_max": [
        -685.0712890625,
        -2339.8720703125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -761.962646484375,
        -2328.31640625,
        866.7424926757812
      ],
      "bbox_max": [
        -743.80419921875,
        -2310.554931640625,
        1051.602294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -761.962646484375,
        -2314.733154296875,
        866.9813842773438
      ],
      "bbox_max": [
        -756.9921875,
        -2310.554931640625,
        1051.602294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -786.48876953125,
        -2312.703125,
        864.8950805664062
      ],
      "bbox_max": [
        -758.3310546875,
        -2261.742919921875,
        1371.9813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -773.9361572265625,
        -2280.178466796875,
        864.8950805664062
      ],
      "bbox_max": [
        -768.0648193359375,
        -2268.5849609375,
        910.4217529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -773.9361572265625,
        -2280.178466796875,
        865.194580078125
      ],
      "bbox_max": [
        -768.0648193359375,
        -2268.5849609375,
        910.4217529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -792.2826538085938,
        -2273.9755859375,
        864.1893310546875
      ],
      "bbox_max": [
        -770.2017211914062,
        -2239.86328125,
        1025.4935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -777.7199096679688,
        -2273.9755859375,
        864.3222045898438
      ],
      "bbox_max": [
        -770.2017211914062,
        -2262.626220703125,
        1025.4935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -775.7066650390625,
        -2273.9755859375,
        864.7988891601562
      ],
      "bbox_max": [
        -770.2017211914062,
        -2263.272216796875,
        944.0588989257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.7066650390625,
        -2271.985107421875,
        903.4407348632812
      ],
      "bbox_max": [
        -771.7664794921875,
        -2263.272216796875,
        944.0588989257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -777.7199096679688,
        -2272.616455078125,
        902.14453125
      ],
      "bbox_max": [
        -771.3636474609375,
        -2262.626220703125,
        1025.4935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -777.7199096679688,
        -2272.616455078125,
        902.14453125
      ],
      "bbox_max": [
        -771.3636474609375,
        -2262.626220703125,
        1025.4935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.0943603515625,
        -2272.616455078125,
        902.14453125
      ],
      "bbox_max": [
        -771.3636474609375,
        -2264.15380859375,
        942.9470825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -787.0260009765625,
        -2259.135009765625,
        929.305419921875
      ],
      "bbox_max": [
        -779.9501342773438,
        -2248.078125,
        1019.874267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -787.0260009765625,
        -2256.06494140625,
        929.305419921875
      ],
      "bbox_max": [
        -781.0300903320312,
        -2248.078125,
        974.869384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -779.9501342773438,
        -2407.66796875,
        1019.874267578125
      ],
      "bbox_max": [
        -685.0712890625,
        -2259.135009765625,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.7510375976562,
        -2333.14013671875,
        1156.9876708984375
      ],
      "bbox_max": [
        -733.1166381835938,
        -2332.1337890625,
        1178.760986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.7510375976562,
        -2332.5322265625,
        1156.9876708984375
      ],
      "bbox_max": [
        -733.1773681640625,
        -2332.1337890625,
        1165.0404052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -783.2191162109375,
        -2266.23876953125,
        864.1474609375
      ],
      "bbox_max": [
        -772.17138671875,
        -2249.745849609375,
        1038.20166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -778.34228515625,
        -2266.23876953125,
        864.2648315429688
      ],
      "bbox_max": [
        -772.17138671875,
        -2261.486328125,
        1036.4193115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -775.980712890625,
        -2264.4326171875,
        932.4190063476562
      ],
      "bbox_max": [
        -774.7032470703125,
        -2262.449951171875,
        949.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.980712890625,
        -2264.15380859375,
        942.9470825195312
      ],
      "bbox_max": [
        -775.0943603515625,
        -2262.449951171875,
        949.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.34228515625,
        -2264.304931640625,
        942.7564086914062
      ],
      "bbox_max": [
        -774.9893798828125,
        -2261.486328125,
        1036.4193115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.5611572265625,
        -2264.304931640625,
        942.7564086914062
      ],
      "bbox_max": [
        -774.9893798828125,
        -2263.055419921875,
        948.4863891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -781.3290405273438,
        -2261.6484375,
        946.2813720703125
      ],
      "bbox_max": [
        -778.0450439453125,
        -2254.945068359375,
        1038.20166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.4437866210938,
        -2261.6484375,
        1023.680419921875
      ],
      "bbox_max": [
        -778.0450439453125,
        -2261.3818359375,
        1038.20166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -781.840576171875,
        -2356.0107421875,
        863.9058837890625
      ],
      "bbox_max": [
        -718.0658569335938,
        -2251.2490234375,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.570068359375,
        -2263.055419921875,
        948.4863891601562
      ],
      "bbox_max": [
        -775.5611572265625,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.0450439453125,
        -2356.0107421875,
        948.3524169921875
      ],
      "bbox_max": [
        -718.0658569335938,
        -2260.681396484375,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -776.570068359375,
        -2263.15966796875,
        948.3524169921875
      ],
      "bbox_max": [
        -775.4889526367188,
        -2260.681396484375,
        964.4517822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.570068359375,
        -2263.15966796875,
        948.3524169921875
      ],
      "bbox_max": [
        -775.4889526367188,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -733.188232421875,
        -2356.0107421875,
        1154.5731201171875
      ],
      "bbox_max": [
        -718.0658569335938,
        -2332.494140625,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -733.188232421875,
        -2356.0107421875,
        1154.5731201171875
      ],
      "bbox_max": [
        -718.0658569335938,
        -2332.494140625,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -733.188232421875,
        -2332.73046875,
        1154.5731201171875
      ],
      "bbox_max": [
        -732.9428100585938,
        -2332.494140625,
        1164.033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.188232421875,
        -2332.73046875,
        1158.9423828125
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.494140625,
        1164.033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.188232421875,
        -2332.605712890625,
        1158.9423828125
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.494140625,
        1160.839599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -779.7763061523438,
        -2261.486328125,
        950.9082641601562
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        1027.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -779.7763061523438,
        -2261.3818359375,
        950.9082641601562
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        1027.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -779.7763061523438,
        -2260.681396484375,
        950.9082641601562
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        966.5499267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        864.626953125
      ],
      "bbox_max": [
        -234.2976531982422,
        -2803.202880859375,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        864.626953125
      ],
      "bbox_max": [
        -234.2976531982422,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        864.626953125
      ],
      "bbox_max": [
        -234.2976531982422,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6857489347457886,
        0.7124961614608765,
        0.1486533135175705
      ],
      "plane_d": 2121.406005859375,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        1313.6531982421875
      ],
      "bbox_max": [
        -244.5576171875,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -498.223876953125,
        -2825.35888671875,
        1363.39306640625
      ],
      "bbox_max": [
        -458.1455383300781,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -498.223876953125,
        -2820.93603515625,
        1363.39306640625
      ],
      "bbox_max": [
        -458.1455383300781,
        -2806.955322265625,
        1405.229248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -477.7598571777344,
        -2937.93310546875,
        1313.6531982421875
      ],
      "bbox_max": [
        -331.759765625,
        -2820.6962890625,
        1475.0743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -477.7598571777344,
        -2845.73681640625,
        1405.229248046875
      ],
      "bbox_max": [
        -420.02252197265625,
        -2820.6962890625,
        1475.0743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -360.3669128417969,
        -2937.93310546875,
        1384.2762451171875
      ],
      "bbox_max": [
        -347.90234375,
        -2906.77197265625,
        1432.8883056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388458251953125,
        0.6731601357460022,
        0.031021643429994583
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -430.2678527832031,
        -2993.223876953125,
        864.626953125
      ],
      "bbox_max": [
        -257.3710632324219,
        -2830.660888671875,
        1465.511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -430.2678527832031,
        -2932.19970703125,
        1313.6531982421875
      ],
      "bbox_max": [
        -331.759765625,
        -2830.660888671875,
        1465.511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -424.3450622558594,
        -2932.19970703125,
        1313.6531982421875
      ],
      "bbox_max": [
        -331.759765625,
        -2839.9580078125,
        1465.511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -424.3450622558594,
        -2847.371826171875,
        1431.2955322265625
      ],
      "bbox_max": [
        -415.3899230957031,
        -2839.9580078125,
        1465.511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -360.6916809082031,
        -2913.74560546875,
        1383.491943359375
      ],
      "bbox_max": [
        -351.9558410644531,
        -2905.960205078125,
        1433.3387451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -423.2952880859375,
        -2932.19970703125,
        864.626953125
      ],
      "bbox_max": [
        -318.19537353515625,
        -2833.09326171875,
        1464.744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -423.2952880859375,
        -2932.19970703125,
        864.626953125
      ],
      "bbox_max": [
        -326.8922119140625,
        -2833.09326171875,
        1464.744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -423.2952880859375,
        -2932.19970703125,
        1307.5714111328125
      ],
      "bbox_max": [
        -331.759765625,
        -2833.09326171875,
        1464.744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -418.51580810546875,
        -2932.19970703125,
        1307.5714111328125
      ],
      "bbox_max": [
        -331.759765625,
        -2842.56201171875,
        1464.744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -418.51580810546875,
        -2860.219482421875,
        1434.8194580078125
      ],
      "bbox_max": [
        -378.988037109375,
        -2842.56201171875,
        1464.744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -361.8818359375,
        -2932.19970703125,
        1307.5714111328125
      ],
      "bbox_max": [
        -331.759765625,
        -2854.516357421875,
        1383.491943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7759400010108948,
        0.4866269528865814,
        0.4013866186141968
      ],
      "plane_d": 605.982421875,
      "bbox_min": [
        -597.4422607421875,
        -2457.307861328125,
        711.775390625
      ],
      "bbox_max": [
        138.8248291015625,
        -1865.0,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.440481036901474,
        -0.8977619409561157,
        0.0
      ],
      "plane_d": -1797.645263671875,
      "bbox_min": [
        -242.22906494140625,
        -2457.307861328125,
        711.775390625
      ],
      "bbox_max": [
        138.8248291015625,
        -1974.035400390625,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45699819922447205,
        -0.8811807036399841,
        -0.1211327537894249
      ],
      "plane_d": -1669.15185546875,
      "bbox_min": [
        -49.43186950683594,
        -2067.07470703125,
        711.775390625
      ],
      "bbox_max": [
        131.89161682128906,
        -1978.1094970703125,
        796.4478759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -49.43186950683594,
        -2067.07470703125,
        711.775390625
      ],
      "bbox_max": [
        131.89161682128906,
        -1978.1094970703125,
        794.5711059570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        126.47466278076172,
        -2067.07470703125,
        711.775390625
      ],
      "bbox_max": [
        131.89161682128906,
        -2057.659423828125,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7798405289649963,
        0.46382713317871094,
        0.42037254571914673
      ],
      "plane_d": 529.9271850585938,
      "bbox_min": [
        -242.22906494140625,
        -2457.307861328125,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -1974.035400390625,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2366829514503479,
        0.9335814118385315,
        0.2690852880477905
      ],
      "plane_d": 1812.3699951171875,
      "bbox_min": [
        -242.22906494140625,
        -2371.5,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -1974.035400390625,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        -242.22906494140625,
        -2371.5,
        717.754638671875
      ],
      "bbox_max": [
        127.53102111816406,
        -2115.854736328125,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -242.22906494140625,
        -2371.5,
        800.5
      ],
      "bbox_max": [
        -85.5,
        -2209.8974609375,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2297.300048828125,
      "bbox_min": [
        -242.22906494140625,
        -2371.5,
        800.5
      ],
      "bbox_max": [
        -85.5,
        -2209.8974609375,
        861.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -242.22906494140625,
        -2371.5,
        820.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        838.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        820.0
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 228.0,
      "bbox_min": [
        -242.2290496826172,
        -2371.5,
        824.9999389648438
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5469529032707214,
        0.0,
        0.8371633887290955
      ],
      "plane_d": -564.4230346679688,
      "bbox_min": [
        -242.2290496826172,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -228.0,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2312.0,
      "bbox_min": [
        -242.2290496826172,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -241.0,
        -2312.0,
        827.3758544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 233.800048828125,
      "bbox_min": [
        -233.800048828125,
        -2311.300048828125,
        825.0
      ],
      "bbox_max": [
        -228.0,
        -2300.1767578125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2311.300048828125,
      "bbox_min": [
        -233.800048828125,
        -2311.300048828125,
        825.0
      ],
      "bbox_max": [
        -228.0,
        -2301.85986328125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5469409227371216,
        0.0,
        -0.837171196937561
      ],
      "plane_d": 825.1044921875,
      "bbox_min": [
        -233.800048828125,
        -2311.300048828125,
        832.8400268554688
      ],
      "bbox_max": [
        -230.800048828125,
        -2301.85986328125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0,
      "bbox_min": [
        -228.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2299.34033203125,
      "bbox_min": [
        -198.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        838.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -198.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        0.0,
        -0.9578263163566589
      ],
      "plane_d": 773.780029296875,
      "bbox_min": [
        -95.5,
        -2299.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -85.5,
      "bbox_min": [
        -85.5,
        -2299.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        833.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2359.0,
      "bbox_min": [
        -228.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2297.300048828125,
        838.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2359.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.0,
      "bbox_min": [
        -199.0,
        -2360.5,
        825.0
      ],
      "bbox_max": [
        -199.0,
        -2359.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.39990234375,
      "bbox_min": [
        -228.0,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -199.39990234375,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5469529032707214,
        0.0,
        0.8371633887290955
      ],
      "plane_d": -801.363037109375,
      "bbox_min": [
        -228.0,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -199.39990234375,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5469409227371216,
        -0.0,
        -0.837171196937561
      ],
      "plane_d": 588.169677734375,
      "bbox_min": [
        -228.0,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -199.39990234375,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2311.300048828125,
      "bbox_min": [
        -228.0,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -199.39990234375,
        -2311.300048828125,
        834.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 223.199951171875,
      "bbox_min": [
        -223.199951171875,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -208.60009765625,
        -2311.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -208.60009765625,
      "bbox_min": [
        -208.60009765625,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -208.60009765625,
        -2311.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -233.00991821289062,
        -2297.300048828125,
        800.5
      ],
      "bbox_max": [
        -85.5,
        -2209.8974609375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.34033203125,
      "bbox_min": [
        -214.60037231445312,
        -2294.34033203125,
        857.0
      ],
      "bbox_max": [
        -122.5,
        -2220.219970703125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -122.5,
      "bbox_min": [
        -209.0,
        -2294.34033203125,
        857.0
      ],
      "bbox_max": [
        -122.5,
        -2220.219970703125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -145.5,
      "bbox_min": [
        -209.0,
        -2291.0,
        857.0
      ],
      "bbox_max": [
        -122.5,
        -2220.219970703125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 132.5,
      "bbox_min": [
        -145.5,
        -2291.0,
        857.0
      ],
      "bbox_max": [
        -122.5,
        -2220.219970703125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -145.5,
        -2240.5,
        857.0
      ],
      "bbox_max": [
        -132.5,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -125.82259368896484,
        -2239.39990234375,
        857.0
      ],
      "bbox_max": [
        -122.5,
        -2220.219970703125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 171.0,
      "bbox_min": [
        -209.0,
        -2291.0,
        857.0
      ],
      "bbox_max": [
        -171.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -184.0,
      "bbox_min": [
        -209.0,
        -2291.0,
        857.0
      ],
      "bbox_max": [
        -171.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -180.8348388671875,
        -2240.5,
        857.0
      ],
      "bbox_max": [
        -171.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 209.0,
      "bbox_min": [
        -209.0,
        -2291.0,
        857.0
      ],
      "bbox_max": [
        -209.0,
        -2285.41015625,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 158.0,
      "bbox_min": [
        -166.52584838867188,
        -2292.5,
        800.5
      ],
      "bbox_max": [
        -87.0,
        -2209.8974609375,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -166.52584838867188,
        -2219.5,
        818.7000122070312
      ],
      "bbox_max": [
        -158.0,
        -2217.375732421875,
        818.82861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -124.5,
      "bbox_min": [
        -158.0,
        -2292.5,
        800.5
      ],
      "bbox_max": [
        -87.0,
        -2209.8974609375,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2283.0,
      "bbox_min": [
        -124.5,
        -2283.0,
        800.5
      ],
      "bbox_max": [
        -87.0,
        -2209.8974609375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -87.0,
      "bbox_min": [
        -124.5,
        -2281.0,
        818.7000122070312
      ],
      "bbox_max": [
        -87.0,
        -2209.8974609375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -124.5,
        -2281.0,
        818.7000122070312
      ],
      "bbox_max": [
        -87.0,
        -2209.8974609375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -124.5,
        -2219.5,
        818.7000122070312
      ],
      "bbox_max": [
        -120.0,
        -2209.8974609375,
        819.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2281.0,
      "bbox_min": [
        -94.0,
        -2281.0,
        822.0
      ],
      "bbox_max": [
        -87.0,
        -2281.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2292.5,
      "bbox_min": [
        -158.0,
        -2292.5,
        805.0
      ],
      "bbox_max": [
        -124.5,
        -2210.372802734375,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -158.0,
        -2292.5,
        805.0
      ],
      "bbox_max": [
        -124.5,
        -2210.372802734375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6050354242324829,
        0.7961986660957336,
        0.0
      ],
      "plane_d": 1747.8408203125,
      "bbox_min": [
        -158.0,
        -2292.5,
        814.2816162109375
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6633881330490112,
        0.7482755184173584,
        0.0
      ],
      "plane_d": 1818.246826171875,
      "bbox_min": [
        -158.0,
        -2292.5,
        814.2816162109375
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.637175977230072,
        -0.7707184553146362,
        -0.0
      ],
      "plane_d": -1808.738525390625,
      "bbox_min": [
        -128.0,
        -2243.8935546875,
        820.0
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6050354242324829,
        0.7961986660957336,
        0.0
      ],
      "plane_d": 1747.8408203125,
      "bbox_min": [
        -158.0,
        -2292.5,
        805.0
      ],
      "bbox_max": [
        -124.5,
        -2289.84033203125,
        814.4425659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6633881330490112,
        0.7482755184173584,
        0.0
      ],
      "plane_d": 1818.246826171875,
      "bbox_min": [
        -158.0,
        -2292.5,
        805.0
      ],
      "bbox_max": [
        -155.0,
        -2289.84033203125,
        814.4425659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -95.5,
      "bbox_min": [
        -214.0574188232422,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2210.213623046875,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28734785318374634,
        -0.0,
        -0.9578262567520142
      ],
      "plane_d": 773.7799682617188,
      "bbox_min": [
        -95.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -85.5,
      "bbox_min": [
        -89.0,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2244.3935546875,
        833.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -827.5,
      "bbox_min": [
        -89.0,
        -2294.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2283.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -89.0,
      "bbox_min": [
        -89.0,
        -2294.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2283.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2283.0,
      "bbox_min": [
        -89.0,
        -2283.0,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2283.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 836.5,
      "bbox_min": [
        -214.0574188232422,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -95.5,
        -2210.213623046875,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9927337765693665,
        -0.0,
        -0.12033136934041977
      ],
      "plane_d": -16.80126953125,
      "bbox_min": [
        -214.0574188232422,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -95.5,
        -2211.606689453125,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.34033203125,
      "bbox_min": [
        -120.56061553955078,
        -2294.34033203125,
        836.5
      ],
      "bbox_max": [
        -95.5,
        -2211.606689453125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2264.300048828125,
      "bbox_min": [
        -120.56061553955078,
        -2292.300048828125,
        836.5
      ],
      "bbox_max": [
        -113.39990234375,
        -2211.606689453125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2287.300048828125,
      "bbox_min": [
        -120.56061553955078,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2264.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -119.3484878540039,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2287.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -119.3484878540039,
        -2269.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2264.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -120.56061553955078,
        -2244.300048828125,
        836.5
      ],
      "bbox_max": [
        -113.39990234375,
        -2211.606689453125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -119.3484878540039,
        -2244.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2239.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -115.15491485595703,
        -2219.5,
        836.5
      ],
      "bbox_max": [
        -113.39990234375,
        -2211.606689453125,
        836.9834594726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -118.5,
      "bbox_min": [
        -214.0574188232422,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 439.70721435546875,
      "bbox_min": [
        -214.0574188232422,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2264.300048828125,
      "bbox_min": [
        -120.9000015258789,
        -2287.300048828125,
        854.5
      ],
      "bbox_max": [
        -120.50000762939453,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2287.300048828125,
      "bbox_min": [
        -120.9000015258789,
        -2287.300048828125,
        854.5
      ],
      "bbox_max": [
        -120.50000762939453,
        -2287.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -120.9000015258789,
        -2239.300048828125,
        854.5
      ],
      "bbox_max": [
        -120.50000762939453,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 132.5,
      "bbox_min": [
        -214.0574188232422,
        -2292.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 854.0,
      "bbox_min": [
        -214.0574188232422,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -132.5,
        -2240.5,
        857.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 171.0,
      "bbox_min": [
        -209.0,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -132.5,
        -2240.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -184.0,
      "bbox_min": [
        -209.0,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -171.0,
        -2240.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -182.38668823242188,
        -2240.5,
        854.0
      ],
      "bbox_max": [
        -171.0,
        -2240.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 209.0,
      "bbox_min": [
        -209.0,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -209.0,
        -2282.935791015625,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -145.5,
      "bbox_min": [
        -145.5,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -132.5,
        -2240.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -145.5,
        -2240.5,
        854.0
      ],
      "bbox_max": [
        -132.5,
        -2240.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -125.82259368896484,
        -2292.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -120.5204086303711,
        -2239.39990234375,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        854.5255126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -119.36579895019531,
        -2239.39990234375,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -125.82259368896484,
        -2292.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -125.82259368896484,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2219.0439453125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -120.91727447509766,
        -2239.300048828125,
        854.5001220703125
      ],
      "bbox_max": [
        -120.517333984375,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        855.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2264.300048828125,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2287.300048828125,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2264.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2287.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -123.0,
        -2269.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2264.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -123.0,
        -2244.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -123.0,
        -2244.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -127.32233428955078,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -113.52716827392578,
        -2210.213623046875,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -119.62408447265625,
        -2253.8935546875,
        825.0
      ],
      "bbox_max": [
        -113.52716827392578,
        -2210.213623046875,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -118.0,
        -2253.8935546875,
        825.0
      ],
      "bbox_max": [
        -118.0,
        -2239.39990234375,
        836.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -122.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -115.5,
        -2242.2861328125,
        836.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.34033203125,
      "bbox_min": [
        -118.0,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -115.5,
        -2279.84033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3579343557357788,
        0.9337468147277832
      ],
      "plane_d": 44.75830078125,
      "bbox_min": [
        -118.0,
        -2285.84033203125,
        825.0
      ],
      "bbox_max": [
        -116.5,
        -2279.84033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2279.84033203125,
      "bbox_min": [
        -118.0,
        -2279.84033203125,
        825.0
      ],
      "bbox_max": [
        -116.5,
        -2279.84033203125,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3579343557357788,
        -0.9337468147277832
      ],
      "plane_d": 1593.190673828125,
      "bbox_min": [
        -118.0,
        -2285.84033203125,
        828.2999877929688
      ],
      "bbox_max": [
        -116.5,
        -2279.84033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2279.84033203125,
      "bbox_min": [
        -118.0,
        -2279.84033203125,
        832.2999877929688
      ],
      "bbox_max": [
        -116.5,
        -2279.84033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2285.84033203125,
      "bbox_min": [
        -118.0,
        -2285.84033203125,
        828.2999877929688
      ],
      "bbox_max": [
        -116.5,
        -2285.84033203125,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9444968700408936,
        0.0,
        0.32852062582969666
      ],
      "plane_d": -386.7303771972656,
      "bbox_min": [
        -122.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -118.0,
        -2294.34033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.34033203125,
      "bbox_min": [
        -122.5,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -118.0,
        -2294.34033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -142.3841094970703,
        -2213.484619140625,
        724.793212890625
      ],
      "bbox_max": [
        113.528564453125,
        -2157.62939453125,
        847.1929321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -142.3841094970703,
        -2213.484619140625,
        819.0640869140625
      ],
      "bbox_max": [
        -117.47883605957031,
        -2208.415771484375,
        830.7199096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -129.6967010498047,
        -2211.97900390625,
        819.28125
      ],
      "bbox_max": [
        -117.47883605957031,
        -2208.415771484375,
        830.7199096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -129.6967010498047,
        -2211.97900390625,
        825.0
      ],
      "bbox_max": [
        -126.844482421875,
        -2211.384765625,
        826.3350219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -127.35315704345703,
        -2211.640625,
        825.0
      ],
      "bbox_max": [
        -126.844482421875,
        -2211.384765625,
        826.3350219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        108.4993896484375,
        -2158.119384765625,
        724.793212890625
      ],
      "bbox_max": [
        113.528564453125,
        -2157.62939453125,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9630944132804871,
        0.2227189689874649,
        -0.15114662051200867
      ],
      "plane_d": 699.9846801757812,
      "bbox_min": [
        -106.53463745117188,
        -2206.544921875,
        717.754638671875
      ],
      "bbox_max": [
        127.53102111816406,
        -2115.854736328125,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9362152218818665,
        0.2509586215019226,
        -0.2460101991891861
      ],
      "plane_d": 826.9634399414062,
      "bbox_min": [
        113.528564453125,
        -2157.653076171875,
        717.754638671875
      ],
      "bbox_max": [
        127.53102111816406,
        -2115.854736328125,
        739.994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        113.528564453125,
        -2157.653076171875,
        723.808837890625
      ],
      "bbox_max": [
        115.1250991821289,
        -2156.200927734375,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -106.53463745117188,
        -2204.010009765625,
        723.9014282226562
      ],
      "bbox_max": [
        114.55083465576172,
        -2156.28759765625,
        836.4595336914062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        109.38591766357422,
        -2157.653076171875,
        724.5084228515625
      ],
      "bbox_max": [
        113.528564453125,
        -2156.85595703125,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642076253890991,
        0.49060776829719543,
        -0.11157596111297607
      ],
      "plane_d": 1246.207275390625,
      "bbox_min": [
        -188.94747924804688,
        -2303.484619140625,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -1974.035400390625,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9042837023735046,
        0.4269319474697113,
        0.0
      ],
      "plane_d": 999.3490600585938,
      "bbox_min": [
        -188.94747924804688,
        -2247.94970703125,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -1974.035400390625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9630944132804871,
        0.2227189689874649,
        -0.15114662051200867
      ],
      "plane_d": 699.9846801757812,
      "bbox_min": [
        63.3701171875,
        -2206.544921875,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -2066.00927734375,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9362152218818665,
        0.2509586215019226,
        -0.2460101991891861
      ],
      "plane_d": 826.9634399414062,
      "bbox_min": [
        119.41747283935547,
        -2124.32177734375,
        712.1194458007812
      ],
      "bbox_max": [
        138.8248291015625,
        -2066.00927734375,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        129.7200469970703,
        -2079.12548828125,
        712.1194458007812
      ],
      "bbox_max": [
        138.8248291015625,
        -2066.00927734375,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        129.7200469970703,
        -2073.446044921875,
        711.9805908203125
      ],
      "bbox_max": [
        135.55726623535156,
        -2066.00927734375,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24286268651485443,
        0.915098249912262,
        0.3218894898891449
      ],
      "plane_d": 1720.4425048828125,
      "bbox_min": [
        -188.94747924804688,
        -2247.94970703125,
        725.9998168945312
      ],
      "bbox_max": [
        63.3701171875,
        -1974.035400390625,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        -188.91696166992188,
        -2233.716796875,
        759.2772216796875
      ],
      "bbox_max": [
        63.3701171875,
        -2185.397216796875,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -188.91696166992188,
        -2233.716796875,
        819.3709106445312
      ],
      "bbox_max": [
        -65.38194274902344,
        -2204.010009765625,
        872.276611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -89.64111328125,
        -2210.680419921875,
        861.0
      ],
      "bbox_max": [
        -73.71690368652344,
        -2206.524169921875,
        872.276611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -89.64111328125,
        -2210.680419921875,
        861.0
      ],
      "bbox_max": [
        -86.32891845703125,
        -2208.580322265625,
        872.276611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -188.91696166992188,
        -2226.99267578125,
        819.3709106445312
      ],
      "bbox_max": [
        -65.38194274902344,
        -2204.010009765625,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -122.41246032714844,
        -2209.46435546875,
        819.3709106445312
      ],
      "bbox_max": [
        -119.7785873413086,
        -2206.403564453125,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -127.92001342773438,
        -2221.324462890625,
        825.0
      ],
      "bbox_max": [
        -65.38194274902344,
        -2204.010009765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -127.92001342773438,
        -2221.324462890625,
        825.0
      ],
      "bbox_max": [
        -114.96053314208984,
        -2207.03173828125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -120.28020477294922,
        -2211.69677734375,
        825.0
      ],
      "bbox_max": [
        -114.96053314208984,
        -2207.03173828125,
        837.0397338867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -127.92001342773438,
        -2221.324462890625,
        825.0
      ],
      "bbox_max": [
        -122.89964294433594,
        -2208.112548828125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -126.70217895507812,
        -2221.324462890625,
        836.5
      ],
      "bbox_max": [
        -122.89964294433594,
        -2209.455322265625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -126.70217895507812,
        -2220.219970703125,
        836.5
      ],
      "bbox_max": [
        -122.89964294433594,
        -2209.455322265625,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -123.68737030029297,
        -2214.002685546875,
        836.5
      ],
      "bbox_max": [
        -122.89964294433594,
        -2209.455322265625,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -86.32891845703125,
        -2208.73486328125,
        847.1929321289062
      ],
      "bbox_max": [
        -65.38194274902344,
        -2204.348876953125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -168.10545349121094,
        -2212.80126953125,
        819.10546875
      ],
      "bbox_max": [
        -115.61882019042969,
        -2201.177490234375,
        848.5906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -159.4060821533203,
        -2212.565673828125,
        819.49267578125
      ],
      "bbox_max": [
        -115.61882019042969,
        -2201.177490234375,
        848.5906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -123.37515258789062,
        -2207.03173828125,
        819.49267578125
      ],
      "bbox_max": [
        -120.28020477294922,
        -2201.177490234375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -128.56640625,
        -2211.625244140625,
        825.0
      ],
      "bbox_max": [
        -115.61882019042969,
        -2202.43359375,
        848.5906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -128.56640625,
        -2211.625244140625,
        825.0
      ],
      "bbox_max": [
        -123.64456176757812,
        -2204.381103515625,
        848.5906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -124.59519958496094,
        -2211.625244140625,
        836.5
      ],
      "bbox_max": [
        -123.64456176757812,
        -2207.233642578125,
        848.5906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -124.07225799560547,
        -2209.70263671875,
        836.5
      ],
      "bbox_max": [
        -123.64456176757812,
        -2207.233642578125,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07853952795267105,
        0.978276252746582,
        0.19185161590576172
      ],
      "plane_d": 2002.348876953125,
      "bbox_min": [
        -128.04714965820312,
        -2210.680419921875,
        759.2772216796875
      ],
      "bbox_max": [
        -85.23542785644531,
        -2186.02587890625,
        872.276611328125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.086369089782238,
        0.9781539440155029,
        0.18909035623073578
      ],
      "plane_d": 2005.18896484375,
      "bbox_min": [
        -188.94747924804688,
        -2247.94970703125,
        725.9998168945312
      ],
      "bbox_max": [
        -17.906230926513672,
        -1974.035400390625,
        937.2014770507812
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.011260570026934147,
        0.8631108403205872,
        0.5048890709877014
      ],
      "plane_d": 1468.668701171875,
      "bbox_min": [
        -186.154296875,
        -2247.94970703125,
        818.8215942382812
      ],
      "bbox_max": [
        -89.64111328125,
        -2193.50048828125,
        937.2014770507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -183.9552459716797,
        -2228.343505859375,
        819.8090209960938
      ],
      "bbox_max": [
        -116.22789764404297,
        -2194.57080078125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -183.9552459716797,
        -2219.0810546875,
        819.8090209960938
      ],
      "bbox_max": [
        -116.22789764404297,
        -2194.57080078125,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -124.04472351074219,
        -2202.43359375,
        819.8090209960938
      ],
      "bbox_max": [
        -121.22843933105469,
        -2197.542724609375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -129.67066955566406,
        -2216.487548828125,
        825.0
      ],
      "bbox_max": [
        -116.22789764404297,
        -2198.0068359375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -122.00171661376953,
        -2205.35986328125,
        825.0
      ],
      "bbox_max": [
        -116.22789764404297,
        -2198.68408203125,
        837.1583251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -129.67066955566406,
        -2216.487548828125,
        825.0
      ],
      "bbox_max": [
        -123.98490905761719,
        -2198.0068359375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -128.5823974609375,
        -2216.487548828125,
        836.5
      ],
      "bbox_max": [
        -123.98490905761719,
        -2200.623046875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -128.5823974609375,
        -2215.142578125,
        836.5
      ],
      "bbox_max": [
        -123.98490905761719,
        -2200.623046875,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -125.21743774414062,
        -2207.738037109375,
        836.5
      ],
      "bbox_max": [
        -123.98490905761719,
        -2200.623046875,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -155.38954162597656,
        -2203.318359375,
        861.0
      ],
      "bbox_max": [
        -148.3314971923828,
        -2202.722900390625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -170.35745239257812,
        -2206.7255859375,
        725.9998168945312
      ],
      "bbox_max": [
        -17.906230926513672,
        -1974.035400390625,
        866.218994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -104.38338470458984,
        -2043.1693115234375,
        741.7183837890625
      ],
      "bbox_max": [
        -84.4427490234375,
        -2023.5079345703125,
        792.1666259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -170.35745239257812,
        -2206.7255859375,
        820.029052734375
      ],
      "bbox_max": [
        -117.00476837158203,
        -2179.60009765625,
        866.218994140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -168.5838623046875,
        -2206.7255859375,
        820.029052734375
      ],
      "bbox_max": [
        -117.00476837158203,
        -2179.60009765625,
        866.218994140625
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.9739704728126526,
        0.1927611380815506,
        0.11926676332950592
      ],
      "plane_d": 438.472900390625,
      "bbox_min": [
        -168.5838623046875,
        -2206.7255859375,
        820.029052734375
      ],
      "bbox_max": [
        -117.00476837158203,
        -2181.5,
        866.218994140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -168.5838623046875,
        -2206.7255859375,
        820.029052734375
      ],
      "bbox_max": [
        -117.00476837158203,
        -2181.5,
        866.218994140625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -127.0,
        -2198.68408203125,
        820.029052734375
      ],
      "bbox_max": [
        -122.00171661376953,
        -2181.5,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8180037140846252,
        0.18297229707241058,
        0.5453358292579651
      ],
      "plane_d": 30.507049560546875,
      "bbox_min": [
        -126.0,
        -2206.7255859375,
        862.0
      ],
      "bbox_max": [
        -119.234130859375,
        -2181.5,
        866.218994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -147.56275939941406,
        -2205.07421875,
        825.0
      ],
      "bbox_max": [
        -117.00476837158203,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -130.71417236328125,
        -2201.4755859375,
        825.0
      ],
      "bbox_max": [
        -117.00476837158203,
        -2181.5,
        856.0177001953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 432.67938232421875,
      "bbox_min": [
        -130.71417236328125,
        -2187.44677734375,
        834.6912231445312
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        856.0177001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -127.5,
      "bbox_min": [
        -128.129150390625,
        -2187.44677734375,
        834.6912231445312
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9444968104362488,
        0.0,
        0.32852062582969666
      ],
      "plane_d": -395.2308349609375,
      "bbox_min": [
        -128.129150390625,
        -2186.3974609375,
        834.6912231445312
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -147.56275939941406,
        -2205.07421875,
        825.0
      ],
      "bbox_max": [
        -125.16641998291016,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -132.53016662597656,
        -2204.288818359375,
        825.0
      ],
      "bbox_max": [
        -125.16641998291016,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 432.67938232421875,
      "bbox_min": [
        -132.53016662597656,
        -2187.44677734375,
        854.5
      ],
      "bbox_max": [
        -129.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -132.53016662597656,
        -2187.44677734375,
        857.0
      ],
      "bbox_max": [
        -131.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -131.5,
        -2200.917724609375,
        825.0
      ],
      "bbox_max": [
        -125.16641998291016,
        -2181.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9444968104362488,
        0.0,
        0.32852062582969666
      ],
      "plane_d": -395.2308349609375,
      "bbox_min": [
        -131.5,
        -2187.44677734375,
        825.0
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        836.8875732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -127.5,
      "bbox_min": [
        -127.5,
        -2187.44677734375,
        836.5
      ],
      "bbox_max": [
        -127.5,
        -2186.3974609375,
        836.8875732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -127.5,
        -2200.917724609375,
        836.5
      ],
      "bbox_max": [
        -125.16641998291016,
        -2186.668701171875,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -127.5,
      "bbox_min": [
        -127.5,
        -2187.44677734375,
        836.5
      ],
      "bbox_max": [
        -127.5,
        -2186.668701171875,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -147.56275939941406,
        -2187.44677734375,
        857.0
      ],
      "bbox_max": [
        -131.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        0.5900004506111145
      ],
      "plane_d": 1274.8353271484375,
      "bbox_min": [
        -146.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -146.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -146.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -146.0,
      "bbox_min": [
        -146.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 134.0,
      "bbox_min": [
        -134.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        -0.5900004506111145
      ],
      "plane_d": 2268.16015625,
      "bbox_min": [
        -142.79855346679688,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -140.26210021972656,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 134.0,
      "bbox_min": [
        -134.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3700557053089142,
        -0.9290096163749695,
        0.0
      ],
      "plane_d": -1855.8043212890625,
      "bbox_min": [
        -597.4422607421875,
        -2457.307861328125,
        732.6765747070312
      ],
      "bbox_max": [
        64.1333999633789,
        -1865.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -194.8513946533203,
        -1978.253173828125,
        754.0
      ],
      "bbox_max": [
        -48.609130859375,
        -1865.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -51.42585754394531,
        -1978.253173828125,
        794.4229736328125
      ],
      "bbox_max": [
        -48.609130859375,
        -1977.1312255859375,
        797.1386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45699819922447205,
        -0.8811807036399841,
        -0.1211327537894249
      ],
      "plane_d": -1669.15185546875,
      "bbox_min": [
        -51.42585754394531,
        -1978.253173828125,
        794.5711059570312
      ],
      "bbox_max": [
        -48.609130859375,
        -1977.1312255859375,
        797.1386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -172.9431915283203,
        -1924.0889892578125,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -172.9431915283203,
        -1924.0889892578125,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -171.66697692871094,
        -1922.31591796875,
        770.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -194.8513946533203,
        -1929.899169921875,
        754.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -180.0,
        -1929.899169921875,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -170.0,
        -1929.899169921875,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1922.31591796875,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 184.0,
      "bbox_min": [
        -194.8513946533203,
        -1924.322509765625,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -194.8513946533203,
        -1924.322509765625,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.440481036901474,
        -0.8977619409561157,
        0.0
      ],
      "plane_d": -1797.645263671875,
      "bbox_min": [
        -597.4422607421875,
        -2457.307861328125,
        732.6765747070312
      ],
      "bbox_max": [
        64.1333999633789,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -51.42585754394531,
        -1978.7965087890625,
        792.9082641601562
      ],
      "bbox_max": [
        -48.03181457519531,
        -1977.1312255859375,
        797.1386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45699819922447205,
        -0.8811807036399841,
        -0.1211327537894249
      ],
      "plane_d": -1669.15185546875,
      "bbox_min": [
        -51.42585754394531,
        -1978.7965087890625,
        794.6730346679688
      ],
      "bbox_max": [
        -48.03181457519531,
        -1977.1312255859375,
        797.1386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -597.4422607421875,
        -2457.307861328125,
        732.6765747070312
      ],
      "bbox_max": [
        -49.43193054199219,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9814715385437012,
        0.1916080117225647
      ],
      "plane_d": -2147.4345703125,
      "bbox_min": [
        -156.7864990234375,
        -2033.323486328125,
        732.6765747070312
      ],
      "bbox_max": [
        -49.43193054199219,
        -1940.0272216796875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -156.7864990234375,
        -2013.17724609375,
        732.6765747070312
      ],
      "bbox_max": [
        -49.43193054199219,
        -1940.0272216796875,
        862.9799194335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -118.56556701660156,
        -1978.1094970703125,
        732.6765747070312
      ],
      "bbox_max": [
        -49.43193054199219,
        -1950.38720703125,
        813.3817138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -87.22331237792969,
        -1978.1094970703125,
        732.6765747070312
      ],
      "bbox_max": [
        -49.43193054199219,
        -1971.048828125,
        797.1386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -156.7864990234375,
        -1964.927001953125,
        735.3753662109375
      ],
      "bbox_max": [
        -103.21552276611328,
        -1940.0272216796875,
        819.6739501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -156.7864990234375,
        -1956.1983642578125,
        737.7685546875
      ],
      "bbox_max": [
        -126.01776123046875,
        -1941.345947265625,
        768.1051025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31125202775001526,
        0.42113131284713745,
        0.8519217371940613
      ],
      "plane_d": 103.43341064453125,
      "bbox_min": [
        -597.4422607421875,
        -2457.307861328125,
        741.6661376953125
      ],
      "bbox_max": [
        -139.53794860839844,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5552207231521606,
        0.3105274438858032,
        0.7715587019920349
      ],
      "plane_d": -146.06512451171875,
      "bbox_min": [
        -427.18609619140625,
        -2457.307861328125,
        741.6661376953125
      ],
      "bbox_max": [
        -139.53794860839844,
        -1920.0,
        1005.6622924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6538359522819519,
        0.3617154061794281,
        0.6645753979682922
      ],
      "plane_d": 32.34027099609375,
      "bbox_min": [
        -427.18609619140625,
        -2399.99365234375,
        741.6661376953125
      ],
      "bbox_max": [
        -139.53794860839844,
        -1920.0,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1865149885416031,
        0.7565726637840271,
        0.6267455220222473
      ],
      "plane_d": 1086.4886474609375,
      "bbox_min": [
        -370.31365966796875,
        -2312.0,
        741.6661376953125
      ],
      "bbox_max": [
        -139.53794860839844,
        -1920.0,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -370.31365966796875,
        -2312.0,
        770.7368774414062
      ],
      "bbox_max": [
        -143.80711364746094,
        -2165.850830078125,
        937.2014770507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.011262818239629269,
        0.8631109595298767,
        0.5048885345458984
      ],
      "plane_d": 1468.6697998046875,
      "bbox_min": [
        -310.88970947265625,
        -2247.94970703125,
        861.0
      ],
      "bbox_max": [
        -144.019287109375,
        -2205.627197265625,
        937.2014770507812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -310.88970947265625,
        -2233.3134765625,
        861.0
      ],
      "bbox_max": [
        -277.4001159667969,
        -2218.526123046875,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.6429138183594,
        -2219.5,
        861.0
      ],
      "bbox_max": [
        -277.4001159667969,
        -2218.526123046875,
        862.9827880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -306.70843505859375,
        -2233.3134765625,
        861.0
      ],
      "bbox_max": [
        -277.3228454589844,
        -2217.8828125,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -306.70843505859375,
        -2233.3134765625,
        861.0
      ],
      "bbox_max": [
        -297.98779296875,
        -2227.839599609375,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -305.518310546875,
        -2233.3134765625,
        861.0
      ],
      "bbox_max": [
        -297.98779296875,
        -2227.839599609375,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.4501647949219,
        -2219.5,
        861.0
      ],
      "bbox_max": [
        -277.3228454589844,
        -2217.8828125,
        862.9827880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.4001159667969,
        -2219.5,
        861.0
      ],
      "bbox_max": [
        -277.2821350097656,
        -2217.677001953125,
        863.17236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -370.31365966796875,
        -2312.0,
        770.7368774414062
      ],
      "bbox_max": [
        -143.80711364746094,
        -2165.850830078125,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -354.6549377441406,
        -2312.0,
        817.8739624023438
      ],
      "bbox_max": [
        -143.80711364746094,
        -2179.60009765625,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -330.51251220703125,
        -2312.0,
        818.7000122070312
      ],
      "bbox_max": [
        -143.83319091796875,
        -2181.5,
        861.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.5,
      "bbox_min": [
        -330.51251220703125,
        -2294.34033203125,
        818.7000122070312
      ],
      "bbox_max": [
        -268.1400451660156,
        -2182.24951171875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -330.51251220703125,
        -2219.548828125,
        818.80322265625
      ],
      "bbox_max": [
        -326.5,
        -2215.840087890625,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39391934871673584,
        0.0,
        0.9191451072692871
      ],
      "plane_d": -865.6377563476562,
      "bbox_min": [
        -326.5,
        -2294.34033203125,
        818.7000122070312
      ],
      "bbox_max": [
        -268.1400451660156,
        -2182.24951171875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -284.41485595703125,
        -2219.5,
        818.7000122070312
      ],
      "bbox_max": [
        -268.1400451660156,
        -2182.24951171875,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -284.41485595703125,
        -2199.781005859375,
        819.8936767578125
      ],
      "bbox_max": [
        -270.515625,
        -2194.963623046875,
        824.9404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1961161345243454,
        0.0,
        0.9805806875228882
      ],
      "plane_d": -860.851806640625,
      "bbox_min": [
        -326.5,
        -2294.34033203125,
        818.9216918945312
      ],
      "bbox_max": [
        -272.5,
        -2197.52392578125,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -290.6774597167969,
        -2201.914306640625,
        819.7645874023438
      ],
      "bbox_max": [
        -279.50006103515625,
        -2199.158447265625,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -290.6774597167969,
        -2201.914306640625,
        819.7645874023438
      ],
      "bbox_max": [
        -286.2059631347656,
        -2200.54150390625,
        820.6588745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        -326.5,
        -2294.34033203125,
        818.9216918945312
      ],
      "bbox_max": [
        -272.5,
        -2197.52392578125,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -326.5,
        -2216.46728515625,
        818.9216918945312
      ],
      "bbox_max": [
        -289.5003662109375,
        -2201.630126953125,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -326.5,
        -2216.46728515625,
        818.9216918945312
      ],
      "bbox_max": [
        -314.0660095214844,
        -2209.878173828125,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.34033203125,
      "bbox_min": [
        -326.5,
        -2294.34033203125,
        820.0
      ],
      "bbox_max": [
        -272.5,
        -2197.52392578125,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 292.0,
      "bbox_min": [
        -292.0,
        -2294.340087890625,
        823.7935791015625
      ],
      "bbox_max": [
        -292.0,
        -2292.558349609375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -326.5,
        -2294.340087890625,
        820.0
      ],
      "bbox_max": [
        -292.0,
        -2210.18701171875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 314.5,
      "bbox_min": [
        -326.5,
        -2294.340087890625,
        820.0
      ],
      "bbox_max": [
        -292.0,
        -2239.39990234375,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.5,
      "bbox_min": [
        -326.5,
        -2294.340087890625,
        820.0
      ],
      "bbox_max": [
        -314.5,
        -2284.537109375,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2286.340087890625,
      "bbox_min": [
        -326.5,
        -2286.340087890625,
        820.0
      ],
      "bbox_max": [
        -325.5,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -326.5,
        -2286.340087890625,
        823.2999877929688
      ],
      "bbox_max": [
        -325.5,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2286.340087890625,
      "bbox_min": [
        -315.5,
        -2286.340087890625,
        820.0
      ],
      "bbox_max": [
        -314.5,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -315.5,
        -2286.340087890625,
        823.2999877929688
      ],
      "bbox_max": [
        -314.5,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 303.0,
      "bbox_min": [
        -304.0,
        -2294.340087890625,
        820.0
      ],
      "bbox_max": [
        -292.0,
        -2239.39990234375,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2286.340087890625,
      "bbox_min": [
        -304.0,
        -2286.340087890625,
        820.0
      ],
      "bbox_max": [
        -303.0,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -304.0,
        -2286.340087890625,
        823.2999877929688
      ],
      "bbox_max": [
        -303.0,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 292.0,
      "bbox_min": [
        -293.0,
        -2294.340087890625,
        820.0
      ],
      "bbox_max": [
        -292.0,
        -2239.39990234375,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -293.0,
        -2286.340087890625,
        823.2999877929688
      ],
      "bbox_max": [
        -292.0,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -286.2059631347656,
        -2202.405517578125,
        820.6588745117188
      ],
      "bbox_max": [
        -272.5,
        -2197.52392578125,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -272.6896667480469,
        -2198.4482421875,
        824.9317016601562
      ],
      "bbox_max": [
        -272.6390380859375,
        -2198.289306640625,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -272.6656494140625,
        -2198.3310546875,
        824.9404296875
      ],
      "bbox_max": [
        -272.5,
        -2197.52392578125,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.34033203125,
      "bbox_min": [
        -326.8420104980469,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -143.83319091796875,
        -2181.5,
        861.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2297.300048828125,
      "bbox_min": [
        -276.5,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -216.45657348632812,
        -2294.34033203125,
        857.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2312.0,
      "bbox_min": [
        -273.0,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -230.800048828125,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -251.5,
      "bbox_min": [
        -258.5,
        -2305.026611328125,
        825.0
      ],
      "bbox_max": [
        -230.800048828125,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 233.800048828125,
      "bbox_min": [
        -233.800048828125,
        -2305.026611328125,
        826.0791015625
      ],
      "bbox_max": [
        -230.800048828125,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5469409227371216,
        0.0,
        -0.837171196937561
      ],
      "plane_d": 825.1044921875,
      "bbox_min": [
        -233.800048828125,
        -2305.026611328125,
        826.0791015625
      ],
      "bbox_max": [
        -230.800048828125,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5469529032707214,
        0.0,
        0.8371633887290955
      ],
      "plane_d": -564.4230346679688,
      "bbox_min": [
        -233.800048828125,
        -2300.1767578125,
        826.0791015625
      ],
      "bbox_max": [
        -232.45169067382812,
        -2297.300048828125,
        826.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 258.5,
      "bbox_min": [
        -258.5,
        -2299.5,
        825.0
      ],
      "bbox_max": [
        -258.5,
        -2297.300048828125,
        834.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927338361740112,
        0.0,
        -0.12033137679100037
      ],
      "plane_d": 375.32861328125,
      "bbox_min": [
        -276.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -272.5,
        -2294.34033203125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9444968700408936,
        -0.0,
        0.32852062582969666
      ],
      "plane_d": -13.65411376953125,
      "bbox_min": [
        -276.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -272.5,
        -2294.34033203125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688879013062,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 748.150390625,
      "bbox_min": [
        -276.5,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -272.5,
        -2294.34033203125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 276.5,
      "bbox_min": [
        -276.5,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -276.5,
        -2294.34033203125,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.5,
      "bbox_min": [
        -326.8420104980469,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -143.83319091796875,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -326.8420104980469,
        -2219.7119140625,
        825.0
      ],
      "bbox_max": [
        -326.5,
        -2219.3759765625,
        825.577392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 272.5,
      "bbox_min": [
        -320.0302734375,
        -2294.34033203125,
        836.5
      ],
      "bbox_max": [
        -143.83319091796875,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 748.150390625,
      "bbox_min": [
        -320.0302734375,
        -2294.34033203125,
        836.5
      ],
      "bbox_max": [
        -272.5,
        -2197.03662109375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 853.5,
      "bbox_min": [
        -320.0302734375,
        -2293.0,
        836.5
      ],
      "bbox_max": [
        -276.5,
        -2209.737060546875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -309.96075439453125,
        -2229.72119140625,
        853.5
      ],
      "bbox_max": [
        -276.9549560546875,
        -2211.38330078125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -309.96075439453125,
        -2229.72119140625,
        853.5
      ],
      "bbox_max": [
        -277.62744140625,
        -2215.457275390625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -278.561279296875,
        -2219.5,
        853.5
      ],
      "bbox_max": [
        -277.62744140625,
        -2215.457275390625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3437800109386444,
        0.839401125907898,
        0.4209762513637543
      ],
      "plane_d": 1404.3909912109375,
      "bbox_min": [
        -291.0722351074219,
        -2224.105224609375,
        853.5
      ],
      "bbox_max": [
        -276.9549560546875,
        -2211.38330078125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.7611999511719,
        -2219.421875,
        853.5
      ],
      "bbox_max": [
        -277.4501647949219,
        -2214.84228515625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.6394958496094,
        -2218.526123046875,
        853.5
      ],
      "bbox_max": [
        -276.9549560546875,
        -2211.38330078125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -320.0302734375,
        -2293.0,
        836.5
      ],
      "bbox_max": [
        -276.5,
        -2209.737060546875,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -320.0302734375,
        -2257.0,
        836.5
      ],
      "bbox_max": [
        -295.0,
        -2212.370361328125,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -320.0302734375,
        -2257.0,
        836.5
      ],
      "bbox_max": [
        -295.0,
        -2217.291259765625,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 1804.5362548828125,
      "bbox_min": [
        -298.0,
        -2257.0,
        841.5
      ],
      "bbox_max": [
        -295.0,
        -2254.0,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 294.0,
      "bbox_min": [
        -295.0,
        -2293.0,
        836.5
      ],
      "bbox_max": [
        -276.5,
        -2209.737060546875,
        853.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -295.0,
        -2293.0,
        836.5
      ],
      "bbox_max": [
        -294.0,
        -2212.02197265625,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2293.0,
      "bbox_min": [
        -295.0,
        -2293.0,
        841.5
      ],
      "bbox_max": [
        -294.0,
        -2261.39990234375,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2261.39990234375,
      "bbox_min": [
        -295.0,
        -2283.60009765625,
        844.2000122070312
      ],
      "bbox_max": [
        -294.0,
        -2261.39990234375,
        852.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2283.60009765625,
      "bbox_min": [
        -295.0,
        -2283.60009765625,
        846.0
      ],
      "bbox_max": [
        -294.0,
        -2283.60009765625,
        850.9047241210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2293.0,
      "bbox_min": [
        -294.0,
        -2293.0,
        836.5
      ],
      "bbox_max": [
        -276.5,
        -2209.737060546875,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -294.0,
        -2293.0,
        836.5
      ],
      "bbox_max": [
        -276.869384765625,
        -2209.737060546875,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 279.5,
      "bbox_min": [
        -279.5,
        -2293.0,
        848.25
      ],
      "bbox_max": [
        -279.5,
        -2291.5,
        852.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -279.15069580078125,
        -2219.5,
        848.6865234375
      ],
      "bbox_max": [
        -277.7611999511719,
        -2213.7939453125,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3437800109386444,
        0.839401125907898,
        0.4209762513637543
      ],
      "plane_d": 1404.3909912109375,
      "bbox_min": [
        -286.9925842285156,
        -2218.6728515625,
        844.7998046875
      ],
      "bbox_max": [
        -276.869384765625,
        -2209.737060546875,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.8173522949219,
        -2215.457275390625,
        850.353271484375
      ],
      "bbox_max": [
        -277.6394958496094,
        -2213.359130859375,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.7157287597656,
        -2214.84228515625,
        850.4802856445312
      ],
      "bbox_max": [
        -276.869384765625,
        -2209.737060546875,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 276.5,
      "bbox_min": [
        -288.89996337890625,
        -2294.34033203125,
        836.5
      ],
      "bbox_max": [
        -272.5,
        -2197.03662109375,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 850.0,
      "bbox_min": [
        -288.89996337890625,
        -2293.0,
        836.5
      ],
      "bbox_max": [
        -276.5,
        -2198.99951171875,
        851.72216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -278.0999755859375,
        -2293.0,
        850.0
      ],
      "bbox_max": [
        -276.72222900390625,
        -2208.4462890625,
        851.72216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2293.0,
      "bbox_min": [
        -278.0999450683594,
        -2293.0,
        850.0
      ],
      "bbox_max": [
        -276.72222900390625,
        -2293.0,
        851.72216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3437800109386444,
        0.839401125907898,
        0.4209762513637543
      ],
      "plane_d": 1404.3909912109375,
      "bbox_min": [
        -278.0999755859375,
        -2213.359130859375,
        850.0
      ],
      "bbox_max": [
        -277.7156982421875,
        -2213.123291015625,
        850.4803466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        -288.89996337890625,
        -2293.0,
        836.5
      ],
      "bbox_max": [
        -276.5,
        -2198.99951171875,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -288.89996337890625,
        -2293.0,
        836.5
      ],
      "bbox_max": [
        -276.5,
        -2198.99951171875,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2293.0,
      "bbox_min": [
        -284.8999328613281,
        -2293.0,
        841.5
      ],
      "bbox_max": [
        -277.5625,
        -2281.60009765625,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2281.60009765625,
      "bbox_min": [
        -281.75726318359375,
        -2281.60009765625,
        841.5
      ],
      "bbox_max": [
        -279.0,
        -2281.60009765625,
        845.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3437800109386444,
        0.839401125907898,
        0.4209762513637543
      ],
      "plane_d": 1404.3909912109375,
      "bbox_min": [
        -281.5699768066406,
        -2212.189208984375,
        837.0676879882812
      ],
      "bbox_max": [
        -277.85400390625,
        -2206.77099609375,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -288.89996337890625,
        -2212.40625,
        836.5
      ],
      "bbox_max": [
        -277.80072021484375,
        -2206.3740234375,
        845.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -282.1000061035156,
        -2293.0,
        845.0
      ],
      "bbox_max": [
        -276.5,
        -2204.25048828125,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2290.5,
      "bbox_min": [
        -282.1000061035156,
        -2293.0,
        845.0
      ],
      "bbox_max": [
        -276.5,
        -2281.60009765625,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2291.5,
      "bbox_min": [
        -282.1000061035156,
        -2293.0,
        845.0
      ],
      "bbox_max": [
        -279.5,
        -2291.5,
        848.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 279.5,
      "bbox_min": [
        -279.5,
        -2293.0,
        845.0
      ],
      "bbox_max": [
        -279.5,
        -2291.5,
        848.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.0,
        0.5144957900047302
      ],
      "plane_d": -195.7656707763672,
      "bbox_min": [
        -280.8052062988281,
        -2290.5,
        845.0
      ],
      "bbox_max": [
        -276.5,
        -2281.60009765625,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 279.0,
      "bbox_min": [
        -280.8052062988281,
        -2284.10009765625,
        845.0
      ],
      "bbox_max": [
        -279.0,
        -2281.60009765625,
        845.9287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2281.60009765625,
      "bbox_min": [
        -280.8052062988281,
        -2281.60009765625,
        845.0
      ],
      "bbox_max": [
        -279.0,
        -2281.60009765625,
        845.9287719726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1021.7693481445312,
      "bbox_min": [
        -277.5625,
        -2290.5,
        845.0
      ],
      "bbox_max": [
        -276.5,
        -2290.0,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2220.3154296875,
      "bbox_min": [
        -277.0,
        -2290.5,
        849.5
      ],
      "bbox_max": [
        -276.5,
        -2290.0,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3437800109386444,
        0.839401125907898,
        0.4209762513637543
      ],
      "plane_d": 1404.3909912109375,
      "bbox_min": [
        -282.0999450683594,
        -2213.275634765625,
        845.0
      ],
      "bbox_max": [
        -277.7278137207031,
        -2210.667236328125,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927353858947754,
        0.0,
        -0.12031792104244232
      ],
      "plane_d": 375.3177490234375,
      "bbox_min": [
        -276.5,
        -2294.34033203125,
        836.5
      ],
      "bbox_max": [
        -272.5,
        -2197.03662109375,
        857.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 850.0,
      "bbox_min": [
        -276.5,
        -2290.5,
        838.0000610351562
      ],
      "bbox_max": [
        -275.04541015625,
        -2199.494140625,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        -276.5,
        -2290.5,
        838.0000610351562
      ],
      "bbox_max": [
        -275.04541015625,
        -2199.494140625,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -276.5,
        -2202.631591796875,
        838.0000610351562
      ],
      "bbox_max": [
        -276.33734130859375,
        -2199.494140625,
        843.07080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1021.7693481445312,
      "bbox_min": [
        -276.5,
        -2290.5,
        845.0
      ],
      "bbox_max": [
        -275.5908203125,
        -2290.0,
        845.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -9.649078369140625,
      "bbox_min": [
        -276.5,
        -2239.39990234375,
        836.5
      ],
      "bbox_max": [
        -272.5,
        -2197.03662109375,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -276.5,
        -2200.034423828125,
        836.5
      ],
      "bbox_max": [
        -275.8849182128906,
        -2197.03662109375,
        839.342041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -276.5,
        -2199.50244140625,
        837.2006225585938
      ],
      "bbox_max": [
        -276.244873046875,
        -2197.723876953125,
        839.342041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -276.5,
        -2239.39990234375,
        836.5
      ],
      "bbox_max": [
        -272.5,
        -2216.3095703125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 441.2032470703125,
      "bbox_min": [
        -274.5,
        -2239.39990234375,
        854.5
      ],
      "bbox_max": [
        -272.5,
        -2227.854736328125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 854.0,
      "bbox_min": [
        -272.5,
        -2291.0,
        836.5
      ],
      "bbox_max": [
        -143.83319091796875,
        -2181.5,
        861.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -222.0,
      "bbox_min": [
        -272.5,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -143.83319091796875,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 209.0,
      "bbox_min": [
        -222.0,
        -2286.235107421875,
        854.0
      ],
      "bbox_max": [
        -143.83319091796875,
        -2181.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -222.0,
        -2240.5,
        854.0
      ],
      "bbox_max": [
        -209.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -184.0,
        -2246.371826171875,
        854.0
      ],
      "bbox_max": [
        -143.83319091796875,
        -2181.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -184.0,
      "bbox_min": [
        -184.0,
        -2246.371826171875,
        857.0
      ],
      "bbox_max": [
        -180.3175506591797,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -184.0,
        -2240.5,
        857.0
      ],
      "bbox_max": [
        -180.3175506591797,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -184.0,
      "bbox_min": [
        -184.0,
        -2245.546875,
        854.0
      ],
      "bbox_max": [
        -180.8348388671875,
        -2240.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -184.0,
        -2240.5,
        854.0
      ],
      "bbox_max": [
        -180.8348388671875,
        -2240.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -259.0,
      "bbox_min": [
        -272.5,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -246.0,
        -2209.94970703125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 246.0,
      "bbox_min": [
        -259.0,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -246.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -259.0,
        -2240.5,
        854.0
      ],
      "bbox_max": [
        -246.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -113.74404907226562,
      "bbox_min": [
        -272.5,
        -2239.39990234375,
        854.0
      ],
      "bbox_max": [
        -267.7560119628906,
        -2209.94970703125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 441.2032470703125,
      "bbox_min": [
        -272.5,
        -2239.39990234375,
        854.0
      ],
      "bbox_max": [
        -267.7560119628906,
        -2209.94970703125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -9.649078369140625,
      "bbox_min": [
        -272.5,
        -2227.854736328125,
        854.0
      ],
      "bbox_max": [
        -269.4588317871094,
        -2209.94970703125,
        854.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -9.649078369140625,
      "bbox_min": [
        -272.5,
        -2227.5048828125,
        836.5
      ],
      "bbox_max": [
        -268.8613586425781,
        -2195.305419921875,
        854.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -272.5,
        -2216.3095703125,
        836.5
      ],
      "bbox_max": [
        -268.8613586425781,
        -2195.305419921875,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -375.0731201171875,
      "bbox_min": [
        -326.5,
        -2294.340087890625,
        825.0
      ],
      "bbox_max": [
        -263.5,
        -2184.45703125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.59996098279953,
        -0.8000293970108032
      ],
      "plane_d": 2023.636474609375,
      "bbox_min": [
        -326.5,
        -2294.340087890625,
        825.0
      ],
      "bbox_max": [
        -263.5,
        -2184.45703125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.59996098279953,
        -0.8000293970108032
      ],
      "plane_d": 2033.2359619140625,
      "bbox_min": [
        -326.5,
        -2294.340087890625,
        825.0
      ],
      "bbox_max": [
        -281.0,
        -2257.5,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 314.5,
      "bbox_min": [
        -326.5,
        -2294.340087890625,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2282.840087890625,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2282.840087890625,
      "bbox_min": [
        -326.5,
        -2282.840087890625,
        829.4957885742188
      ],
      "bbox_max": [
        -325.5,
        -2282.840087890625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2282.840087890625,
      "bbox_min": [
        -315.5,
        -2282.840087890625,
        829.4957885742188
      ],
      "bbox_max": [
        -314.5,
        -2282.840087890625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 303.0,
      "bbox_min": [
        -304.0,
        -2294.340087890625,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2282.840087890625,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2282.840087890625,
      "bbox_min": [
        -304.0,
        -2282.840087890625,
        829.4957885742188
      ],
      "bbox_max": [
        -303.0,
        -2282.840087890625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 292.0,
      "bbox_min": [
        -293.0,
        -2294.340087890625,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2282.840087890625,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2282.840087890625,
      "bbox_min": [
        -293.0,
        -2282.840087890625,
        829.4957885742188
      ],
      "bbox_max": [
        -292.0,
        -2282.840087890625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 314.5,
      "bbox_min": [
        -326.5,
        -2288.8349609375,
        825.0
      ],
      "bbox_max": [
        -281.0,
        -2257.5,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2282.840087890625,
      "bbox_min": [
        -326.5,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -325.5,
        -2282.840087890625,
        829.4957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -326.5,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -325.5,
        -2282.840087890625,
        826.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2282.840087890625,
      "bbox_min": [
        -315.5,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -314.5,
        -2282.840087890625,
        829.4957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -315.5,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -314.5,
        -2282.840087890625,
        826.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 303.0,
      "bbox_min": [
        -304.0,
        -2288.8349609375,
        825.0
      ],
      "bbox_max": [
        -281.0,
        -2257.5,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -304.0,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -303.0,
        -2282.840087890625,
        826.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 292.0,
      "bbox_min": [
        -293.0,
        -2288.8349609375,
        825.0
      ],
      "bbox_max": [
        -281.0,
        -2257.5,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -293.0,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2282.840087890625,
        826.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 281.0,
      "bbox_min": [
        -281.0,
        -2260.0,
        835.9000244140625
      ],
      "bbox_max": [
        -281.0,
        -2257.5,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -326.5,
        -2250.89990234375,
        825.0
      ],
      "bbox_max": [
        -263.5,
        -2184.45703125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -326.5,
        -2250.89990234375,
        825.0
      ],
      "bbox_max": [
        -272.6896667480469,
        -2198.4482421875,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -326.5,
        -2250.89990234375,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2212.33984375,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 292.0,
      "bbox_min": [
        -292.0,
        -2250.89990234375,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2239.39990234375,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -284.0493469238281,
        -2206.565673828125,
        825.0
      ],
      "bbox_max": [
        -263.5,
        -2184.45703125,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9444968104362488,
        -0.0,
        0.32852062582969666
      ],
      "plane_d": -22.15460205078125,
      "bbox_min": [
        -264.6375732421875,
        -2187.44677734375,
        825.0
      ],
      "bbox_max": [
        -263.5,
        -2184.45703125,
        828.2705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -284.0493469238281,
        -2206.565673828125,
        825.0
      ],
      "bbox_max": [
        -272.6656188964844,
        -2198.3310546875,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 281.0,
      "bbox_min": [
        -282.4072570800781,
        -2276.0,
        835.9000244140625
      ],
      "bbox_max": [
        -281.0,
        -2273.5,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.59996098279953,
        -0.8000293970108032
      ],
      "plane_d": 2033.2359619140625,
      "bbox_min": [
        -282.4072570800781,
        -2274.300048828125,
        835.9000244140625
      ],
      "bbox_max": [
        -281.0,
        -2273.5,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        0.5900004506111145
      ],
      "plane_d": 1274.8353271484375,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 249.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -261.0,
        -2180.941162109375,
        822.1744995117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -370.31365966796875,
        -2233.1513671875,
        770.7368774414062
      ],
      "bbox_max": [
        -170.35752868652344,
        -2165.850830078125,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -370.31365966796875,
        -2233.1513671875,
        778.934326171875
      ],
      "bbox_max": [
        -235.501708984375,
        -2165.850830078125,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -370.31365966796875,
        -2233.1513671875,
        779.7890014648438
      ],
      "bbox_max": [
        -245.962646484375,
        -2165.850830078125,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -370.31365966796875,
        -2233.1513671875,
        779.7890014648438
      ],
      "bbox_max": [
        -245.962646484375,
        -2165.850830078125,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36162224411964417,
        0.8005647659301758,
        0.4778340458869934
      ],
      "plane_d": 1267.4736328125,
      "bbox_min": [
        -370.31365966796875,
        -2233.1513671875,
        783.396728515625
      ],
      "bbox_max": [
        -252.22021484375,
        -2177.188720703125,
        820.6678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -370.31365966796875,
        -2233.1513671875,
        798.7385864257812
      ],
      "bbox_max": [
        -347.122802734375,
        -2220.012451171875,
        818.1638793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -354.308349609375,
        -2228.361328125,
        785.8125
      ],
      "bbox_max": [
        -270.515625,
        -2183.931884765625,
        820.1851196289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -354.308349609375,
        -2228.361328125,
        791.80322265625
      ],
      "bbox_max": [
        -314.28076171875,
        -2198.047119140625,
        819.2825317382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -354.308349609375,
        -2228.361328125,
        796.3135986328125
      ],
      "bbox_max": [
        -330.51251220703125,
        -2211.443115234375,
        818.80322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -302.4618225097656,
        -2200.54150390625,
        785.8125
      ],
      "bbox_max": [
        -270.515625,
        -2183.931884765625,
        820.1851196289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0863649919629097,
        0.9781539440155029,
        0.18909214437007904
      ],
      "plane_d": 2005.18701171875,
      "bbox_min": [
        -235.501708984375,
        -2193.500732421875,
        770.7368774414062
      ],
      "bbox_max": [
        -170.35752868652344,
        -2179.7744140625,
        820.6962890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25527524948120117,
        0.9336197376251221,
        0.25137388706207275
      ],
      "plane_d": 1895.1923828125,
      "bbox_min": [
        -235.501708984375,
        -2188.4384765625,
        773.529541015625
      ],
      "bbox_max": [
        -209.0651397705078,
        -2179.7744140625,
        820.6962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20032097399234772,
        0.7389717102050781,
        0.6432669162750244
      ],
      "plane_d": 1029.450439453125,
      "bbox_min": [
        -291.5428161621094,
        -2247.94970703125,
        741.6661376953125
      ],
      "bbox_max": [
        -139.53794860839844,
        -1920.0,
        937.2014770507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -277.2162780761719,
        -2247.94970703125,
        820.9546508789062
      ],
      "bbox_max": [
        -141.37191772460938,
        -2179.60009765625,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011262818239629269,
        0.8631109595298767,
        0.5048885345458984
      ],
      "plane_d": 1468.6697998046875,
      "bbox_min": [
        -215.23876953125,
        -2247.94970703125,
        861.0
      ],
      "bbox_max": [
        -141.41397094726562,
        -2181.5,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -143.58685302734375,
        -2181.5,
        861.0
      ],
      "bbox_max": [
        -141.41397094726562,
        -2181.5,
        861.6766357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.2162780761719,
        -2216.41015625,
        820.9546508789062
      ],
      "bbox_max": [
        -141.37191772460938,
        -2179.60009765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -268.35565185546875,
        -2215.476318359375,
        857.0
      ],
      "bbox_max": [
        -141.37191772460938,
        -2180.431396484375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -113.74404907226562,
      "bbox_min": [
        -268.35565185546875,
        -2215.476318359375,
        857.0
      ],
      "bbox_max": [
        -267.6947326660156,
        -2211.6611328125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        -0.5900004506111145
      ],
      "plane_d": 2268.16015625,
      "bbox_min": [
        -146.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -141.37191772460938,
        -2180.431396484375,
        860.4623413085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -146.0,
      "bbox_min": [
        -146.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -146.0,
        -2181.00390625,
        860.2486572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -9.649078369140625,
      "bbox_min": [
        -276.244873046875,
        -2212.014892578125,
        820.9546508789062
      ],
      "bbox_max": [
        -251.5053253173828,
        -2179.60009765625,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -276.244873046875,
        -2197.723876953125,
        822.1109619140625
      ],
      "bbox_max": [
        -268.3963317871094,
        -2181.595947265625,
        837.2395629882812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -269.4704895019531,
        -2212.014892578125,
        820.9546508789062
      ],
      "bbox_max": [
        -251.5053253173828,
        -2179.60009765625,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -269.4704895019531,
        -2212.014892578125,
        820.9546508789062
      ],
      "bbox_max": [
        -251.50534057617188,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -268.71612548828125,
        -2183.349365234375,
        820.9546508789062
      ],
      "bbox_max": [
        -264.94683837890625,
        -2181.5,
        822.2429809570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390894770622253,
        0.19267703592777252,
        -0.2845814824104309
      ],
      "plane_d": 402.2903747558594,
      "bbox_min": [
        -268.71612548828125,
        -2183.349365234375,
        820.9546508789062
      ],
      "bbox_max": [
        -268.0,
        -2181.5,
        822.2429809570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -375.0731201171875,
      "bbox_min": [
        -269.4704895019531,
        -2212.014892578125,
        825.0
      ],
      "bbox_max": [
        -263.5,
        -2182.66845703125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9444968104362488,
        -0.0,
        0.32852062582969666
      ],
      "plane_d": -22.15460205078125,
      "bbox_min": [
        -265.2227478027344,
        -2187.44677734375,
        825.0
      ],
      "bbox_max": [
        -263.5,
        -2182.66845703125,
        829.952880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 441.2032470703125,
      "bbox_min": [
        -269.4704895019531,
        -2212.014892578125,
        836.5
      ],
      "bbox_max": [
        -267.6947326660156,
        -2194.07470703125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -269.0862121582031,
        -2196.603271484375,
        836.5
      ],
      "bbox_max": [
        -268.6481628417969,
        -2194.07470703125,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        0.5900004506111145
      ],
      "plane_d": 1274.8353271484375,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -252.8496856689453,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -253.87985229492188,
        -2179.60009765625,
        824.4364013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -255.55990600585938,
        -2179.60009765625,
        824.4364013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -261.0,
        -2179.60009765625,
        824.4364013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -291.5428161621094,
        -2219.5,
        741.6661376953125
      ],
      "bbox_max": [
        -139.53794860839844,
        -1920.0,
        867.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -291.5428161621094,
        -2219.5,
        765.0
      ],
      "bbox_max": [
        -139.53794860839844,
        -1929.5540771484375,
        867.0999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.37689208984375,
        -2219.5,
        861.0
      ],
      "bbox_max": [
        -270.9947814941406,
        -2187.942138671875,
        867.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8180076479911804,
        0.18297654390335083,
        0.5453283786773682
      ],
      "plane_d": -291.77178955078125,
      "bbox_min": [
        -277.300048828125,
        -2219.5,
        862.4619140625
      ],
      "bbox_max": [
        -270.9947814941406,
        -2191.251220703125,
        867.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -277.2821350097656,
        -2217.677001953125,
        822.14794921875
      ],
      "bbox_max": [
        -156.43209838867188,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.2821350097656,
        -2217.677001953125,
        857.0
      ],
      "bbox_max": [
        -263.5,
        -2181.5,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -113.74404907226562,
      "bbox_min": [
        -268.3276672363281,
        -2215.314697265625,
        857.0
      ],
      "bbox_max": [
        -263.5,
        -2187.44677734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.0851745605469,
        -2214.206787109375,
        822.14794921875
      ],
      "bbox_max": [
        -259.18975830078125,
        -2181.5,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 741.12255859375,
      "bbox_min": [
        -265.6839599609375,
        -2187.44677734375,
        852.9822998046875
      ],
      "bbox_max": [
        -263.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927337765693665,
        0.0,
        -0.12033136934041977
      ],
      "plane_d": 366.3939514160156,
      "bbox_min": [
        -265.6839599609375,
        -2187.44677734375,
        852.9822998046875
      ],
      "bbox_max": [
        -265.5,
        -2181.5,
        854.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -9.649078369140625,
      "bbox_min": [
        -276.0447998046875,
        -2209.946533203125,
        822.14794921875
      ],
      "bbox_max": [
        -259.18975830078125,
        -2181.5,
        854.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927337765693665,
        0.0,
        -0.12033136934041977
      ],
      "plane_d": 366.3939514160156,
      "bbox_min": [
        -276.0447998046875,
        -2196.723388671875,
        822.2429809570312
      ],
      "bbox_max": [
        -265.5,
        -2181.5,
        854.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -276.0447998046875,
        -2196.723388671875,
        823.8487548828125
      ],
      "bbox_max": [
        -269.1147155761719,
        -2181.5,
        837.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9390894770622253,
        0.19267703592777252,
        -0.2845814824104309
      ],
      "plane_d": 402.2903747558594,
      "bbox_min": [
        -269.2153015136719,
        -2183.2158203125,
        822.2429809570312
      ],
      "bbox_max": [
        -268.3788757324219,
        -2181.5,
        824.678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9444968104362488,
        -0.0,
        0.32852062582969666
      ],
      "plane_d": -22.15460205078125,
      "bbox_min": [
        -267.5,
        -2186.3974609375,
        834.6912231445312
      ],
      "bbox_max": [
        -266.870849609375,
        -2181.5,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9444968104362488,
        -0.0,
        0.32852062582969666
      ],
      "plane_d": -22.15460205078125,
      "bbox_min": [
        -268.8855285644531,
        -2195.44482421875,
        822.14794921875
      ],
      "bbox_max": [
        -259.18975830078125,
        -2181.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -375.0731201171875,
      "bbox_min": [
        -268.8855285644531,
        -2195.44482421875,
        822.14794921875
      ],
      "bbox_max": [
        -265.2227478027344,
        -2181.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390894770622253,
        0.19267703592777252,
        -0.2845814824104309
      ],
      "plane_d": 402.2903747558594,
      "bbox_min": [
        -268.3963317871094,
        -2181.595947265625,
        822.14794921875
      ],
      "bbox_max": [
        -268.3478698730469,
        -2181.5,
        822.250244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -268.8855285644531,
        -2195.44482421875,
        836.5
      ],
      "bbox_max": [
        -267.5,
        -2187.44677734375,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -268.0217590332031,
        -2190.458740234375,
        825.0
      ],
      "bbox_max": [
        -259.18975830078125,
        -2181.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -268.0217590332031,
        -2190.458740234375,
        836.5
      ],
      "bbox_max": [
        -267.5,
        -2186.3974609375,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 267.5,
      "bbox_min": [
        -267.5,
        -2187.44677734375,
        836.5
      ],
      "bbox_max": [
        -267.5,
        -2186.3974609375,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -291.5428161621094,
        -2181.5,
        765.0
      ],
      "bbox_max": [
        -139.53794860839844,
        -1929.5540771484375,
        863.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -291.5428161621094,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1941.3094482421875,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1309.5618896484375,
      "bbox_min": [
        -291.5428161621094,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -2022.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -291.5428161621094,
        -2032.0,
        769.5819702148438
      ],
      "bbox_max": [
        -290.0,
        -2030.4571533203125,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -170.0,
        -1944.15771484375,
        765.0
      ],
      "bbox_max": [
        -156.33169555664062,
        -1940.418212890625,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -158.70838928222656,
        -1941.345947265625,
        768.1051025390625
      ],
      "bbox_max": [
        -156.33775329589844,
        -1940.418212890625,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -261.0,
        -2181.5,
        770.0
      ],
      "bbox_max": [
        -139.53794860839844,
        -1937.4390869140625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        -0.5900004506111145
      ],
      "plane_d": 2268.16015625,
      "bbox_min": [
        -261.0,
        -2181.5,
        823.5812377929688
      ],
      "bbox_max": [
        -139.53794860839844,
        -2179.60009765625,
        863.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -139.53794860839844,
        -2179.60009765625,
        863.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 249.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -146.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -261.0,
        -2180.0966796875,
        861.6140747070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -146.0,
      "bbox_min": [
        -146.0,
        -2181.5,
        859.6788330078125
      ],
      "bbox_max": [
        -146.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        0.5900004506111145
      ],
      "plane_d": 1274.8353271484375,
      "bbox_min": [
        -261.0,
        -2181.5,
        823.5812377929688
      ],
      "bbox_max": [
        -260.47467041015625,
        -2180.755615234375,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        823.5812377929688
      ],
      "bbox_max": [
        -261.0,
        -2180.755615234375,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 184.0,
      "bbox_min": [
        -272.0,
        -2014.0,
        741.6661376953125
      ],
      "bbox_max": [
        -152.91403198242188,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -2014.0,
        746.1708374023438
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.41665470600128174,
        -0.9090648293495178
      ],
      "plane_d": -143.7080078125,
      "bbox_min": [
        -198.0,
        -2014.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1945.2628173828125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -198.0,
        -1952.6339111328125,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1945.2628173828125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -198.0,
        -1987.0,
        746.1708374023438
      ],
      "bbox_max": [
        -184.0,
        -1951.5289306640625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        749.0316162109375
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        749.0316162109375
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        749.8746337890625
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        750.1940307617188
      ],
      "bbox_max": [
        -195.0,
        -1979.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -272.0,
        -2013.3367919921875,
        748.1995849609375
      ],
      "bbox_max": [
        -198.0,
        -1946.367919921875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -245.54180908203125,
        -1954.890869140625,
        754.3318481445312
      ],
      "bbox_max": [
        -240.9657440185547,
        -1953.8861083984375,
        756.1414184570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -272.0,
        -2013.3367919921875,
        762.43505859375
      ],
      "bbox_max": [
        -272.0,
        -1988.9971923828125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -184.0,
        -1956.10107421875,
        741.6661376953125
      ],
      "bbox_max": [
        -152.91403198242188,
        -1943.078857421875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879413485527039,
        0.423933207988739,
        0.6889162063598633
      ],
      "plane_d": 185.86029052734375,
      "bbox_min": [
        -427.18609619140625,
        -2399.99365234375,
        765.0
      ],
      "bbox_max": [
        -279.09942626953125,
        -1999.4329833984375,
        876.422607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -298.3752746582031,
        -2030.6904296875,
        765.0
      ],
      "bbox_max": [
        -279.09942626953125,
        -1999.4329833984375,
        770.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -281.04278564453125,
        -2001.767822265625,
        765.0
      ],
      "bbox_max": [
        -279.09942626953125,
        -1999.4329833984375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1926385760307312,
        -0.9812697768211365,
        0.0
      ],
      "plane_d": -1914.5927734375,
      "bbox_min": [
        -597.4422607421875,
        -2197.5283203125,
        754.9302978515625
      ],
      "bbox_max": [
        -144.57403564453125,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5634797811508179,
        -0.8261274099349976,
        -0.002011953853070736
      ],
      "plane_d": -1353.20361328125,
      "bbox_min": [
        -597.4422607421875,
        -2197.5283203125,
        754.9302978515625
      ],
      "bbox_max": [
        -144.57403564453125,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5680782794952393,
        -0.8229745030403137,
        0.0
      ],
      "plane_d": -1346.862060546875,
      "bbox_min": [
        -495.131103515625,
        -1978.3544921875,
        780.299072265625
      ],
      "bbox_max": [
        -421.8410339355469,
        -1928.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -442.0,
        -1935.8033447265625,
        780.299072265625
      ],
      "bbox_max": [
        -422.18267822265625,
        -1928.0,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -442.0,
        -1935.8033447265625,
        912.0
      ],
      "bbox_max": [
        -422.18267822265625,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -430.0,
        -1933.3961181640625,
        921.1698608398438
      ],
      "bbox_max": [
        -422.18267822265625,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        872.4360961914062
      ],
      "bbox_max": [
        -421.8410339355469,
        -1928.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -433.48736572265625,
        -1935.858642578125,
        872.4360961914062
      ],
      "bbox_max": [
        -421.8410339355469,
        -1928.0,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.48736572265625,
        -1935.858642578125,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1933.3961181640625,
        921.1698608398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.160947784781456,
        -0.9869629144668579,
        0.0
      ],
      "plane_d": -1824.285400390625,
      "bbox_min": [
        -597.4422607421875,
        -2197.5283203125,
        754.9302978515625
      ],
      "bbox_max": [
        -144.57403564453125,
        -1894.5,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -360.0,
        -1907.0894775390625,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -360.0,
        -1907.0894775390625,
        912.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015454292297363,
        -0.8651313185691833,
        0.0
      ],
      "plane_d": -1457.548095703125,
      "bbox_min": [
        -597.4422607421875,
        -2197.5283203125,
        754.9302978515625
      ],
      "bbox_max": [
        -144.57403564453125,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.6276550292969,
        -1935.9715576171875,
        780.2833251953125
      ],
      "bbox_max": [
        -419.5531921386719,
        -1928.0,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -433.427001953125,
        -1935.9715576171875,
        912.0
      ],
      "bbox_max": [
        -419.5531921386719,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.427001953125,
        -1935.9715576171875,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1933.5428466796875,
        920.9298095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -597.4422607421875,
        -2197.5283203125,
        754.9302978515625
      ],
      "bbox_max": [
        -144.57403564453125,
        -1895.00830078125,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -433.3038330078125,
        -1959.678955078125,
        755.1640625
      ],
      "bbox_max": [
        -198.0,
        -1905.1326904296875,
        871.5677490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -430.0,
        -1958.5277099609375,
        767.0492553710938
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        836.4241943359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -360.0,
        -1939.0,
        767.0492553710938
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        818.517333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1958.5277099609375,
        771.2595825195312
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        832.4524536132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -417.9999694824219,
        -1958.5277099609375,
        771.2595825195312
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        804.5498657226562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.0,
        771.2595825195312
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        804.1193237304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0,
        -1958.5277099609375,
        778.7999267578125
      ],
      "bbox_max": [
        -369.377197265625,
        -1950.0,
        802.4315795898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -414.0,
        -1953.6666259765625,
        778.9569702148438
      ],
      "bbox_max": [
        -414.0,
        -1950.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -414.0,
        -1957.38623046875,
        780.0
      ],
      "bbox_max": [
        -387.601806640625,
        -1950.0,
        802.4315795898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45812103152275085,
        0.0,
        -0.8888899087905884
      ],
      "plane_d": 878.4150390625,
      "bbox_min": [
        -412.0,
        -1957.38623046875,
        780.0
      ],
      "bbox_max": [
        -387.601806640625,
        -1950.0,
        801.3723754882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 412.0,
      "bbox_min": [
        -412.0,
        -1957.127685546875,
        780.0
      ],
      "bbox_max": [
        -388.1759033203125,
        -1950.0,
        801.3723754882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45812103152275085,
        0.0,
        0.8888899087905884
      ],
      "plane_d": -878.9483642578125,
      "bbox_min": [
        -404.0,
        -1957.127685546875,
        780.5999755859375
      ],
      "bbox_max": [
        -388.1759033203125,
        -1950.0,
        788.7554931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1959.678955078125,
        779.3433837890625
      ],
      "bbox_max": [
        -408.7575378417969,
        -1945.875,
        816.5027465820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1959.678955078125,
        779.3433837890625
      ],
      "bbox_max": [
        -408.7575378417969,
        -1950.0,
        806.9329833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -414.0,
        -1959.678955078125,
        779.3433837890625
      ],
      "bbox_max": [
        -408.7575378417969,
        -1953.6666259765625,
        793.9251708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 412.0,
      "bbox_min": [
        -412.0,
        -1959.21240234375,
        780.0
      ],
      "bbox_max": [
        -408.7575378417969,
        -1955.5,
        788.612548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -412.0,
        -1959.21240234375,
        780.0
      ],
      "bbox_max": [
        -408.7575378417969,
        -1955.5,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -300.0,
        -1940.111328125,
        755.1640625
      ],
      "bbox_max": [
        -198.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        -1940.111328125,
        765.0
      ],
      "bbox_max": [
        -290.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -300.0,
        -1937.9560546875,
        770.0
      ],
      "bbox_max": [
        -290.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -1939.397216796875,
        755.1640625
      ],
      "bbox_max": [
        -198.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -272.0,
        -1937.178955078125,
        755.1640625
      ],
      "bbox_max": [
        -198.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0,
      "bbox_min": [
        -198.0,
        -1920.808349609375,
        755.36376953125
      ],
      "bbox_max": [
        -198.0,
        -1920.0,
        757.638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.476491779088974,
        -0.7905871868133545,
        0.3846135139465332
      ],
      "plane_d": -1664.8924560546875,
      "bbox_min": [
        -597.4422607421875,
        -2197.5283203125,
        754.9302978515625
      ],
      "bbox_max": [
        -144.57403564453125,
        -1895.00830078125,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4577594995498657,
        -0.8173955082893372,
        0.3497438430786133
      ],
      "plane_d": -1698.0321044921875,
      "bbox_min": [
        -597.4422607421875,
        -2061.258056640625,
        778.7999267578125
      ],
      "bbox_max": [
        -370.3376159667969,
        -1912.418212890625,
        886.0947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47970375418663025,
        -0.768060028553009,
        0.42422646284103394
      ],
      "plane_d": -1652.64599609375,
      "bbox_min": [
        -597.4422607421875,
        -2061.258056640625,
        778.7999267578125
      ],
      "bbox_max": [
        -370.3376159667969,
        -1912.418212890625,
        886.0947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -597.4422607421875,
        -2061.258056640625,
        778.7999267578125
      ],
      "bbox_max": [
        -370.3376159667969,
        -1935.971435546875,
        880.5703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -433.3038635253906,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -370.3376159667969,
        -1935.971435546875,
        880.5703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -370.3376159667969,
        -1950.0,
        830.8653564453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 412.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -370.3376159667969,
        -1950.0,
        830.8652954101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        780.9847412109375
      ],
      "bbox_max": [
        -412.0,
        -1972.0,
        788.121337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -412.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -370.3376159667969,
        -1950.0,
        811.5064086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -412.0,
        -1972.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        811.5064086914062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.45812103152275085,
        0.0,
        0.8888899087905884
      ],
      "plane_d": -878.9483642578125,
      "bbox_min": [
        -412.0,
        -1972.0,
        780.0
      ],
      "bbox_max": [
        -380.99658203125,
        -1950.0,
        811.5064086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -1959.9998779296875,
      "bbox_min": [
        -405.16424560546875,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -392.371826171875,
        -1960.0,
        786.4166870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1970.0,
      "bbox_min": [
        -405.16424560546875,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -404.2237854003906,
        -1970.0,
        780.3477783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.4000244140625,
      "bbox_min": [
        -412.0,
        -1972.0,
        780.0
      ],
      "bbox_max": [
        -396.3738708496094,
        -1950.0,
        811.5064086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        0.0,
        -0.8804711103439331
      ],
      "plane_d": 902.4287109375,
      "bbox_min": [
        -404.0,
        -1956.593994140625,
        807.4000244140625
      ],
      "bbox_max": [
        -396.3738708496094,
        -1950.0,
        811.5064086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1970.0,
      "bbox_min": [
        -412.0,
        -1972.0,
        780.0
      ],
      "bbox_max": [
        -404.489501953125,
        -1970.0,
        789.7544555664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -412.0,
        -1972.0,
        780.42041015625
      ],
      "bbox_max": [
        -408.11614990234375,
        -1972.0,
        785.503662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -371.0,
      "bbox_min": [
        -371.0,
        -1950.0345458984375,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        780.0711059570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -433.3038635253906,
        -1950.0,
        802.4315185546875
      ],
      "bbox_max": [
        -414.0,
        -1935.971435546875,
        880.5703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        802.4315185546875
      ],
      "bbox_max": [
        -414.0,
        -1950.0,
        842.9549560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        832.4523315429688
      ],
      "bbox_max": [
        -422.5,
        -1935.971435546875,
        880.5703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -430.0,
        -1939.0,
        832.4523315429688
      ],
      "bbox_max": [
        -422.5,
        -1939.0,
        871.35107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703570008277893,
        -0.7688688039779663,
        0.433133989572525
      ],
      "plane_d": -1666.133544921875,
      "bbox_min": [
        -435.970703125,
        -1950.0,
        833.3432006835938
      ],
      "bbox_max": [
        -379.35919189453125,
        -1912.418212890625,
        886.0947875976562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -435.970703125,
        -1950.0,
        833.3432006835938
      ],
      "bbox_max": [
        -414.0,
        -1935.971435546875,
        880.78662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        871.35107421875
      ],
      "bbox_max": [
        -430.0,
        -1935.971435546875,
        880.6351318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1945.1715087890625,
        851.69677734375
      ],
      "bbox_max": [
        -422.5,
        -1939.0,
        863.5265502929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1950.0,
        833.3432006835938
      ],
      "bbox_max": [
        -414.0,
        -1942.0526123046875,
        858.107666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -433.3038635253906,
        -1949.5487060546875,
        844.80126953125
      ],
      "bbox_max": [
        -422.5,
        -1935.971435546875,
        886.0947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        871.6712036132812
      ],
      "bbox_max": [
        -430.0,
        -1935.971435546875,
        886.0947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -418.30963134765625,
        -1976.85595703125,
        780.0
      ],
      "bbox_max": [
        -402.8489074707031,
        -1969.2301025390625,
        788.12158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1970.0,
      "bbox_min": [
        -405.9512634277344,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -402.8489074707031,
        -1969.2301025390625,
        782.260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -404.2236633300781,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -402.8489074707031,
        -1969.2301025390625,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -418.30963134765625,
        -1976.85595703125,
        781.6093139648438
      ],
      "bbox_max": [
        -414.0,
        -1972.0,
        788.12158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -433.3038635253906,
        -2197.5283203125,
        754.9302978515625
      ],
      "bbox_max": [
        -144.57403564453125,
        -1895.00830078125,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -300.0,
        -1950.6944580078125,
        755.7633666992188
      ],
      "bbox_max": [
        -159.68482971191406,
        -1905.971923828125,
        840.3576049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -300.0,
        -1950.6171875,
        755.7633666992188
      ],
      "bbox_max": [
        -170.86631774902344,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -300.0,
        -1946.1907958984375,
        765.0
      ],
      "bbox_max": [
        -170.86631774902344,
        -1925.915771484375,
        770.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        -1945.209228515625,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1937.9560546875,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0,
      "bbox_min": [
        -286.0,
        -1950.6171875,
        755.7633666992188
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 184.0,
      "bbox_min": [
        -184.0,
        -1929.1463623046875,
        762.6154174804688
      ],
      "bbox_max": [
        -184.0,
        -1924.322509765625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -286.0,
        -1950.6171875,
        756.974365234375
      ],
      "bbox_max": [
        -272.0,
        -1933.719482421875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -1948.6893310546875,
        759.2422485351562
      ],
      "bbox_max": [
        -286.0,
        -1936.9154052734375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -230.068359375,
        -1948.4483642578125,
        765.0
      ],
      "bbox_max": [
        -159.68482971191406,
        -1905.971923828125,
        840.3576049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -224.7386016845703,
        -1948.4483642578125,
        765.0
      ],
      "bbox_max": [
        -188.77719116210938,
        -1942.791748046875,
        770.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -224.35549926757812,
        -1948.4483642578125,
        765.0
      ],
      "bbox_max": [
        -208.4135284423828,
        -1947.18994140625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -247.49603271484375,
        -1951.145751953125,
        765.0
      ],
      "bbox_max": [
        -150.88079833984375,
        -1905.971923828125,
        840.3576049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -247.49603271484375,
        -1951.145751953125,
        765.0
      ],
      "bbox_max": [
        -191.51014709472656,
        -1944.8116455078125,
        770.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -245.41371154785156,
        -1951.145751953125,
        765.0
      ],
      "bbox_max": [
        -209.6251220703125,
        -1948.08544921875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -433.3038635253906,
        -2197.5283203125,
        758.3905029296875
      ],
      "bbox_max": [
        -144.57403564453125,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -433.3038635253906,
        -1972.0,
        758.3905029296875
      ],
      "bbox_max": [
        -144.57403564453125,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -433.3038635253906,
        -1972.0,
        773.1744384765625
      ],
      "bbox_max": [
        -369.0,
        -1926.017333984375,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 412.0,
      "bbox_min": [
        -414.0011291503906,
        -1972.0,
        773.1744384765625
      ],
      "bbox_max": [
        -369.0,
        -1926.017333984375,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -414.0011291503906,
        -1950.0,
        831.3602905273438
      ],
      "bbox_max": [
        -412.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -414.0011291503906,
        -1950.0,
        831.3602905273438
      ],
      "bbox_max": [
        -412.0,
        -1939.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703570008277893,
        -0.7688688039779663,
        0.433133989572525
      ],
      "plane_d": -1666.133544921875,
      "bbox_min": [
        -414.0011291503906,
        -1945.5858154296875,
        840.4337158203125
      ],
      "bbox_max": [
        -412.0,
        -1943.82080078125,
        843.802490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1938.9998779296875,
      "bbox_min": [
        -414.0,
        -1939.0,
        894.0
      ],
      "bbox_max": [
        -412.0,
        -1939.0,
        912.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -412.0,
        -1972.0,
        773.1744384765625
      ],
      "bbox_max": [
        -369.0,
        -1926.017333984375,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1970.0,
      "bbox_min": [
        -412.0,
        -1972.0,
        773.1744384765625
      ],
      "bbox_max": [
        -369.0,
        -1926.017333984375,
        912.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -398.4129943847656,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1970.0,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -412.0,
        -1970.0,
        773.1744384765625
      ],
      "bbox_max": [
        -369.0,
        -1926.017333984375,
        912.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -399.8562316894531,
        -1970.0,
        773.8579711914062
      ],
      "bbox_max": [
        -369.0,
        -1950.0,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3979502022266388,
        -0.8249621391296387,
        0.40133896470069885
      ],
      "plane_d": -1778.3778076171875,
      "bbox_min": [
        -398.94171142578125,
        -1969.27099609375,
        773.8579711914062
      ],
      "bbox_max": [
        -372.4520263671875,
        -1957.908935546875,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -412.0,
        -1964.195068359375,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1945.5858154296875,
        840.4337158203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -412.0,
        -1950.0,
        818.3564453125
      ],
      "bbox_max": [
        -398.885498046875,
        -1945.5858154296875,
        840.4337158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45812103152275085,
        0.0,
        0.8888899087905884
      ],
      "plane_d": -878.9483642578125,
      "bbox_min": [
        -412.0,
        -1964.195068359375,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        812.8729858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45812103152275085,
        0.0,
        -0.8888899087905884
      ],
      "plane_d": 878.4150390625,
      "bbox_min": [
        -392.7138671875,
        -1960.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -1959.9998779296875,
      "bbox_min": [
        -392.7138671875,
        -1960.0,
        785.9929809570312
      ],
      "bbox_max": [
        -376.8359680175781,
        -1950.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -794.0,
      "bbox_min": [
        -378.0,
        -1950.9443359375,
        794.0
      ],
      "bbox_max": [
        -376.8359680175781,
        -1950.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -371.0,
      "bbox_min": [
        -378.0,
        -1954.5487060546875,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 793.4000244140625,
      "bbox_min": [
        -378.0,
        -1951.2822265625,
        793.4000244140625
      ],
      "bbox_max": [
        -375.904052734375,
        -1950.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -794.0,
      "bbox_min": [
        -376.8359680175781,
        -1950.232177734375,
        794.0
      ],
      "bbox_max": [
        -376.4563903808594,
        -1950.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        0.0,
        -0.8804711103439331
      ],
      "plane_d": 902.4287109375,
      "bbox_min": [
        -412.0,
        -1964.195068359375,
        807.4000244140625
      ],
      "bbox_max": [
        -393.8359375,
        -1950.0,
        812.8729858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.4000244140625,
      "bbox_min": [
        -412.0,
        -1964.195068359375,
        807.4000244140625
      ],
      "bbox_max": [
        -404.0,
        -1956.593994140625,
        807.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        912.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1938.9998779296875,
      "bbox_min": [
        -412.0,
        -1939.0,
        892.0
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        912.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -371.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1950.0,
        836.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -371.0,
        -1970.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1954.0013427734375,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1962.0,
      "bbox_min": [
        -371.0,
        -1968.0,
        780.0
      ],
      "bbox_max": [
        -369.0,
        -1962.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1968.0,
      "bbox_min": [
        -371.0,
        -1968.0,
        780.0
      ],
      "bbox_max": [
        -369.0,
        -1962.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 788.5,
      "bbox_min": [
        -371.0,
        -1968.0,
        780.0
      ],
      "bbox_max": [
        -369.0,
        -1962.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -371.0,
        -1968.0,
        780.0
      ],
      "bbox_max": [
        -369.0,
        -1962.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        -0.0,
        -0.8804711103439331
      ],
      "plane_d": 544.00927734375,
      "bbox_min": [
        -412.0,
        -1970.0,
        778.7999267578125
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        835.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 821.4000244140625,
      "bbox_min": [
        -378.0,
        -1970.0,
        821.4000244140625
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        821.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        778.7999267578125
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        835.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -395.15228271484375,
        -1970.0,
        778.7999267578125
      ],
      "bbox_max": [
        -371.0,
        -1955.224853515625,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        -0.0,
        -0.8804711103439331
      ],
      "plane_d": 519.3560791015625,
      "bbox_min": [
        -412.0,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1960.0,
        835.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        -0.0,
        0.8804711103439331
      ],
      "plane_d": -519.88427734375,
      "bbox_min": [
        -412.0,
        -1970.0,
        789.630859375
      ],
      "bbox_max": [
        -371.0,
        -1960.0,
        835.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 793.4000244140625,
      "bbox_min": [
        -378.0,
        -1970.0,
        789.630859375
      ],
      "bbox_max": [
        -371.0,
        -1960.0,
        793.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        0.0,
        0.6000000238418579
      ],
      "plane_d": -771.0999755859375,
      "bbox_min": [
        -371.46435546875,
        -1969.5,
        789.630859375
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        790.3082275390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1962.0,
      "bbox_min": [
        -371.46435546875,
        -1968.0,
        789.630859375
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        790.3082275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1960.5,
      "bbox_min": [
        -371.46435546875,
        -1960.5,
        789.630859375
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        790.3082275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1968.0,
      "bbox_min": [
        -371.46435546875,
        -1968.0,
        789.630859375
      ],
      "bbox_max": [
        -371.0,
        -1968.0,
        790.3082275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 835.4000244140625,
      "bbox_min": [
        -412.0,
        -1970.0,
        790.2307739257812
      ],
      "bbox_max": [
        -371.0,
        -1960.0,
        835.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -794.0,
      "bbox_min": [
        -378.0,
        -1970.0,
        790.2307739257812
      ],
      "bbox_max": [
        -371.0,
        -1960.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 793.4000244140625,
      "bbox_min": [
        -376.8858947753906,
        -1970.0,
        790.2307739257812
      ],
      "bbox_max": [
        -371.0,
        -1960.0,
        793.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        0.0,
        0.6000000238418579
      ],
      "plane_d": -771.0999755859375,
      "bbox_min": [
        -371.14385986328125,
        -1969.5,
        790.2307739257812
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1962.0,
      "bbox_min": [
        -371.14385986328125,
        -1968.0,
        790.2307739257812
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1960.5,
      "bbox_min": [
        -371.14385986328125,
        -1960.5,
        790.2307739257812
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1968.0,
      "bbox_min": [
        -371.14385986328125,
        -1968.0,
        790.2307739257812
      ],
      "bbox_max": [
        -371.0,
        -1968.0,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.4000244140625,
      "bbox_min": [
        -412.0,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1960.0,
        807.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1962.0,
      "bbox_min": [
        -372.5,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        789.880859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1960.5,
      "bbox_min": [
        -372.5,
        -1962.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        789.880859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -372.5,
      "bbox_min": [
        -372.5,
        -1962.0,
        780.0
      ],
      "bbox_max": [
        -371.46435546875,
        -1960.5,
        789.880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        0.0,
        0.6000000238418579
      ],
      "plane_d": -771.0999755859375,
      "bbox_min": [
        -372.5,
        -1962.0,
        788.5
      ],
      "bbox_max": [
        -371.46435546875,
        -1960.5,
        789.880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1968.0,
      "bbox_min": [
        -372.5,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1968.0,
        789.880859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -372.5,
      "bbox_min": [
        -372.5,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -371.46435546875,
        -1968.0,
        789.880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        0.0,
        0.6000000238418579
      ],
      "plane_d": -771.0999755859375,
      "bbox_min": [
        -372.5,
        -1969.5,
        788.5
      ],
      "bbox_max": [
        -371.46435546875,
        -1968.0,
        789.880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        0.0,
        -0.8804711103439331
      ],
      "plane_d": 902.4287109375,
      "bbox_min": [
        -412.0,
        -1960.0,
        788.4193115234375
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        835.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 835.4000244140625,
      "bbox_min": [
        -412.0,
        -1960.0,
        807.4000244140625
      ],
      "bbox_max": [
        -404.0,
        -1950.0,
        835.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.4000244140625,
      "bbox_min": [
        -405.142578125,
        -1960.0,
        807.4000244140625
      ],
      "bbox_max": [
        -404.0,
        -1959.301025390625,
        807.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45812103152275085,
        0.0,
        0.8888899087905884
      ],
      "plane_d": -878.9483642578125,
      "bbox_min": [
        -388.03863525390625,
        -1960.0,
        788.4193115234375
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45812103152275085,
        0.0,
        -0.8888899087905884
      ],
      "plane_d": 878.4150390625,
      "bbox_min": [
        -387.6640625,
        -1960.0,
        788.4193115234375
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -794.0,
      "bbox_min": [
        -378.0,
        -1960.0,
        794.0
      ],
      "bbox_max": [
        -376.8359680175781,
        -1950.232177734375,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -794.0,
      "bbox_min": [
        -378.0,
        -1960.0,
        793.4000244140625
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 793.4000244140625,
      "bbox_min": [
        -378.0,
        -1960.0,
        793.4000244140625
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        793.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -433.3038635253906,
        -1950.0,
        833.3432006835938
      ],
      "bbox_max": [
        -414.0,
        -1928.0,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -433.3038635253906,
        -1950.0,
        843.8737182617188
      ],
      "bbox_max": [
        -414.0,
        -1928.0,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -422.5,
        -1939.0,
        892.0
      ],
      "bbox_max": [
        -414.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -422.5,
        -1939.0,
        892.0
      ],
      "bbox_max": [
        -414.0,
        -1939.0,
        912.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        866.4844970703125
      ],
      "bbox_max": [
        -422.5,
        -1929.7083740234375,
        927.2045288085938
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        875.7760620117188
      ],
      "bbox_max": [
        -422.5,
        -1929.7083740234375,
        927.2045288085938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        912.0
      ],
      "bbox_max": [
        -422.5,
        -1929.7083740234375,
        927.2045288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1934.0562744140625,
        920.089599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        758.3905029296875
      ],
      "bbox_max": [
        -144.57403564453125,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -369.0,
        -1939.0,
        795.794677734375
      ],
      "bbox_max": [
        -147.15283203125,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        802.872802734375
      ],
      "bbox_max": [
        -348.0,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6160963773727417,
        -0.6721051335334778,
        0.41073092818260193
      ],
      "plane_d": -1456.00390625,
      "bbox_min": [
        -369.0,
        -1939.0,
        802.872802734375
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -369.0,
        -1939.0,
        802.872802734375
      ],
      "bbox_max": [
        -360.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -369.0,
        -1939.0,
        802.872802734375
      ],
      "bbox_max": [
        -366.6459655761719,
        -1936.5960693359375,
        809.6964111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -208.44378662109375,
        -1939.0,
        795.794677734375
      ],
      "bbox_max": [
        -147.15283203125,
        -1914.585693359375,
        835.1259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        758.3905029296875
      ],
      "bbox_max": [
        -144.57403564453125,
        -1939.0,
        820.2978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -144.57403564453125,
        -1939.0,
        820.2978515625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1942.57666015625,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -369.0,
        -1972.0,
        770.4967041015625
      ],
      "bbox_max": [
        -144.57403564453125,
        -1939.0,
        820.2978515625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -369.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -144.57403564453125,
        -1939.0,
        820.2978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -349.0,
        -1960.0,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -6.685392236249754e-06,
        2.4760717565186496e-07,
        -1.0
      ],
      "plane_d": 778.798095703125,
      "bbox_min": [
        -369.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -349.0,
        -1960.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.44721364974975586,
        0.0
      ],
      "plane_d": 1194.0604248046875,
      "bbox_min": [
        -355.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -349.0,
        -1960.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1962.0,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1960.5,
      "bbox_min": [
        -369.0,
        -1962.0,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 367.5,
      "bbox_min": [
        -369.0,
        -1962.0,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.800000011920929,
        -0.0,
        0.6000000238418579
      ],
      "plane_d": -179.10000610351562,
      "bbox_min": [
        -369.0,
        -1962.0,
        788.5
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1969.5,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1968.0,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1968.0,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1968.0,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 367.5,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1968.0,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.800000011920929,
        -0.0,
        0.6000000238418579
      ],
      "plane_d": -179.10000610351562,
      "bbox_min": [
        -369.0,
        -1969.5,
        788.5
      ],
      "bbox_max": [
        -367.5,
        -1968.0,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -1972.0,
        758.3905029296875
      ],
      "bbox_max": [
        -272.0,
        -1946.173095703125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -272.0,
        -1972.0,
        758.3905029296875
      ],
      "bbox_max": [
        -272.0,
        -1947.1368408203125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -414.0006103515625,
        -2197.5283203125,
        760.6438598632812
      ],
      "bbox_max": [
        -228.29660034179688,
        -1972.0,
        865.8857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -414.0006103515625,
        -2197.5283203125,
        765.0
      ],
      "bbox_max": [
        -228.29660034179688,
        -1972.0,
        865.8857421875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -300.0,
        -2023.7220458984375,
        769.916259765625
      ],
      "bbox_max": [
        -298.2779235839844,
        -2022.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -325.0,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1972.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1634.8309326171875,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1972.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1168.1405029296875,
      "bbox_min": [
        -325.0,
        -1977.0,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1972.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -414.0006103515625,
        -2197.5283203125,
        770.0
      ],
      "bbox_max": [
        -251.7324981689453,
        -1972.0,
        865.8857421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -414.0006103515625,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        788.12158203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1977.0,
      "bbox_min": [
        -366.0,
        -1987.0,
        778.7999267578125
      ],
      "bbox_max": [
        -317.39141845703125,
        -1972.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4179060757160187,
        0.0,
        0.9084903001785278
      ],
      "plane_d": -574.8924560546875,
      "bbox_min": [
        -320.0,
        -1987.0,
        778.800048828125
      ],
      "bbox_max": [
        -317.39141845703125,
        -1977.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        -0.5547002553939819,
        0.0
      ],
      "plane_d": -1398.3994140625,
      "bbox_min": [
        -366.0,
        -1977.0,
        778.7999267578125
      ],
      "bbox_max": [
        -346.5,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.44721364974975586,
        0.0
      ],
      "plane_d": 1194.0604248046875,
      "bbox_min": [
        -349.0,
        -1977.0,
        778.7999267578125
      ],
      "bbox_max": [
        -346.5,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40273821353912354,
        0.0,
        -0.9153153300285339
      ],
      "plane_d": 583.9713745117188,
      "bbox_min": [
        -324.0,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -300.0,
        -1977.0,
        778.8001098632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4179060757160187,
        0.0,
        0.9084903001785278
      ],
      "plane_d": -574.8924560546875,
      "bbox_min": [
        -320.0,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -300.0,
        -1977.0,
        778.8001098632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 1976.9998779296875,
      "bbox_min": [
        -320.0,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -300.0,
        -1977.0,
        778.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -300.0,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -300.0,
        -1977.0,
        770.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1978.400146484375,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1977.400146484375,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -324.0,
      "bbox_min": [
        -324.0,
        -1978.400146484375,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1977.400146484375,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 323.0,
      "bbox_min": [
        -324.0,
        -1978.400146484375,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1977.400146484375,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1977.400146484375,
      "bbox_min": [
        -324.0,
        -1977.400146484375,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1977.400146484375,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -324.0,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1985.60009765625,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1986.60009765625,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1985.60009765625,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 323.0,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1985.60009765625,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1985.60009765625,
      "bbox_min": [
        -324.0,
        -1985.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1985.60009765625,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -414.0006103515625,
        -1975.16845703125,
        780.0999145507812
      ],
      "bbox_max": [
        -405.90997314453125,
        -1972.0,
        788.12158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -271.8732604980469,
        -2197.5283203125,
        858.15380859375
      ],
      "bbox_max": [
        -251.7324981689453,
        -2179.60009765625,
        865.8857421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8180076479911804,
        0.18297654390335083,
        0.5453283786773682
      ],
      "plane_d": -291.77178955078125,
      "bbox_min": [
        -271.8732604980469,
        -2197.5283203125,
        858.15380859375
      ],
      "bbox_max": [
        -268.0,
        -2181.5,
        865.8857421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9739686846733093,
        0.19277054071426392,
        0.11926654726266861
      ],
      "plane_d": 54.74974822998047,
      "bbox_min": [
        -271.8732604980469,
        -2191.251220703125,
        858.15380859375
      ],
      "bbox_max": [
        -270.0,
        -2181.5,
        862.4619140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -261.0,
        -2181.5,
        860.92041015625
      ],
      "bbox_max": [
        -254.63604736328125,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        -0.5900004506111145
      ],
      "plane_d": 2268.16015625,
      "bbox_min": [
        -261.0,
        -2181.5,
        860.92041015625
      ],
      "bbox_max": [
        -258.4679870605469,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        860.92041015625
      ],
      "bbox_max": [
        -261.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -1994.18603515625,
        760.6438598632812
      ],
      "bbox_max": [
        -272.0,
        -1972.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -272.0,
        -1994.18603515625,
        760.6438598632812
      ],
      "bbox_max": [
        -272.0,
        -1972.0,
        765.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}